(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as n0, getPartnerDevApiHeaders as t0, WidgetContextProvider as r0, makeExecuteQuery as i0, makeUseLazyQuery as a0, makeUseQuery as o0, makeUseMutation as s0, validateApiHostName as Mb, useTracking as _n, useWidgetContext as fn, hasDownstreamApiForbiddenError as Am, hasDownstreamApiAuthorizationError as Lm, DisplayErrors as Fn, useCopyWithDelay as or, defaultDateFormat as xt, displayAttributeValue as uo, OAuthSettings as Yr, useWidgetSettingsMutations as ea, useWidgetSettingsQuery as na, PartnerSettingsWrapper as ta, handleWidgetSubmit as ra, MisconfigurationBanner as ia, WidgetSettingsFormFooter as aa, useData as Vm, PartnerHookFormSecretText as zm, isDownstreamApiNotFoundError as l0, isDownstreamApiAuthorizationError as Bb, KlaviyoSubscribeSetting as c0, isDownstreamApiPermissionError as d0, capitalizeFirstCharacter as qb, humanizeKey as u0, hasDownstreamApiTooManyRequestsError as m0, hasDownstreamApiPermissionError as Hb, PartnerHookFormBasicAuth as p0, hasDownstreamApiNotFoundError as yo, getCountryNameFromCountryCode as f0, IntegrationModal as Wb, useInboundOAuthContext as h0, getWidgetConfigurationByIdQuery as y0, createWidgetConfigurationMutation as g0, updateWidgetConfigurationMutation as v0, deleteWidgetConfigurationMutation as k0 } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Fe, { useMemo as Bn, useState as se, useEffect as Le, useRef as vi, useCallback as ot, useReducer as b0, useLayoutEffect as x0, useContext as Um, createContext as Kb, isValidElement as _0, createElement as S0, Fragment as N0 } from "react";
import { Text as A, FlexBox as b, Spinner as dn, Icon as me, Tooltip as We, List as Ye, Badge as Pn, Button as Kn, IconButton as nr, Switch as tm, FieldLabel as j0, FieldWrapper as hn, InputText as Nr, InputSelectionList as ni, FormGrid as ht, FormField as we, Tag as An, NavigationButton as Et, Select as wr, CollapseCard as mr, Box as Zn, Modal as Tt, ModalHead as $t, ModalBody as Dt, ModalFoot as Pt, Textarea as rm, TagsInput as qs, Image as oa, Banner as Hs, Divider as Mm, SelectionList as dt, FieldText as pr, FieldTextarea as w0, CopyToClipboardButton as C0, getSelectionListContext as F0, Avatar as Bm, Timestamp as I0, Attachment as E0, EmptyState as _s, Table as Jn, Checkbox as sf, TextWithHighlight as T0, ErrorBoundaryContext as Gb, FieldSwitch as Yb } from "@dixa/lib-shared-habla";
import rt from "classnames";
import { ApolloLink as qm, Observable as Qb, ApolloClient as $0, InMemoryCache as D0, createHttpLink as R0, ApolloProvider as O0, useApolloClient as P0, ApolloConsumer as A0, NetworkStatus as er, isApolloError as Jb, ApolloError as Xb, gql as Ws, useQuery as L0, useMutation as lf } from "@apollo/client";
import V0 from "cross-fetch";
import { config as mo } from "lib-shared-backend-config";
import Ln from "moment";
import "moment-timezone";
import { __rest as z0, __assign as fl } from "tslib";
import { useLocation as U0 } from "react-router-dom";
function Hm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Eo = { exports: {} }, fa = {};
var cf;
function M0() {
  if (cf) return fa;
  cf = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return fa.Fragment = r, fa.jsx = s, fa.jsxs = s, fa;
}
var ha = {};
var df;
function B0() {
  return df || (df = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c, P));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ha.Fragment = i, ha.jsx = Rn, ha.jsxs = Mn;
  })()), ha;
}
var uf;
function q0() {
  return uf || (uf = 1, process.env.NODE_ENV === "production" ? Eo.exports = M0() : Eo.exports = B0()), Eo.exports;
}
var ze = q0();
function Zb(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: H0 } = Object.prototype, { getPrototypeOf: Ks } = Object, { iterator: Gs, toStringTag: ex } = Symbol, Ys = /* @__PURE__ */ ((e) => (n) => {
  const r = H0.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Cr = (e) => (e = e.toLowerCase(), (n) => Ys(n) === e), Qs = (e) => (n) => typeof n === e, { isArray: sa } = Array, Yi = Qs("undefined");
function go(e) {
  return e !== null && !Yi(e) && e.constructor !== null && !Yi(e.constructor) && Jt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const nx = Cr("ArrayBuffer");
function W0(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && nx(e.buffer), n;
}
const K0 = Qs("string"), Jt = Qs("function"), tx = Qs("number"), vo = (e) => e !== null && typeof e == "object", G0 = (e) => e === !0 || e === !1, ss = (e) => {
  if (Ys(e) !== "object")
    return !1;
  const n = Ks(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(ex in e) && !(Gs in e);
}, Y0 = (e) => {
  if (!vo(e) || go(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Q0 = Cr("Date"), J0 = Cr("File"), X0 = (e) => !!(e && typeof e.uri < "u"), Z0 = (e) => e && typeof e.getParts < "u", eN = Cr("Blob"), nN = Cr("FileList"), tN = (e) => vo(e) && Jt(e.pipe);
function rN() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const mf = rN(), pf = typeof mf.FormData < "u" ? mf.FormData : void 0, iN = (e) => {
  if (!e) return !1;
  if (pf && e instanceof pf) return !0;
  const n = Ks(e);
  if (!n || n === Object.prototype || !Jt(e.append)) return !1;
  const r = Ys(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && Jt(e.toString) && e.toString() === "[object FormData]";
}, aN = Cr("URLSearchParams"), [oN, sN, lN, cN] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Cr), dN = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ko(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), sa(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (go(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function rx(e, n) {
  if (go(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const fi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ix = (e) => !Yi(e) && e !== fi;
function im() {
  const { caseless: e, skipUndefined: n } = ix(this) && this || {}, r = {}, i = (a, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const s = e && rx(r, o) || o;
    ss(r[s]) && ss(a) ? r[s] = im(r[s], a) : ss(a) ? r[s] = im({}, a) : sa(a) ? r[s] = a.slice() : (!n || !Yi(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && ko(arguments[a], i);
  return r;
}
const uN = (e, n, r, { allOwnKeys: i } = {}) => (ko(
  n,
  (a, o) => {
    r && Jt(a) ? Object.defineProperty(e, o, {
      value: Zb(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), mN = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), pN = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, fN = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Ks(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, hN = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, yN = (e) => {
  if (!e) return null;
  if (sa(e)) return e;
  let n = e.length;
  if (!tx(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, gN = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ks(Uint8Array)), vN = (e, n) => {
  const i = (e && e[Gs]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, kN = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, bN = Cr("HTMLFormElement"), xN = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), ff = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), _N = Cr("RegExp"), ax = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  ko(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, SN = (e) => {
  ax(e, (n, r) => {
    if (Jt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Jt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, NN = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return sa(e) ? i(e) : i(String(e).split(n)), r;
}, jN = () => {
}, wN = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function CN(e) {
  return !!(e && Jt(e.append) && e[ex] === "FormData" && e[Gs]);
}
const FN = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (vo(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (go(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = sa(i) ? [] : {};
        return ko(i, (s, l) => {
          const d = r(s, a + 1);
          !Yi(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, IN = Cr("AsyncFunction"), EN = (e) => e && (vo(e) || Jt(e)) && Jt(e.then) && Jt(e.catch), ox = ((e, n) => e ? setImmediate : n ? ((r, i) => (fi.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === fi && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), fi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", Jt(fi.postMessage)), TN = typeof queueMicrotask < "u" ? queueMicrotask.bind(fi) : typeof process < "u" && process.nextTick || ox, $N = (e) => e != null && Jt(e[Gs]), ke = {
  isArray: sa,
  isArrayBuffer: nx,
  isBuffer: go,
  isFormData: iN,
  isArrayBufferView: W0,
  isString: K0,
  isNumber: tx,
  isBoolean: G0,
  isObject: vo,
  isPlainObject: ss,
  isEmptyObject: Y0,
  isReadableStream: oN,
  isRequest: sN,
  isResponse: lN,
  isHeaders: cN,
  isUndefined: Yi,
  isDate: Q0,
  isFile: J0,
  isReactNativeBlob: X0,
  isReactNative: Z0,
  isBlob: eN,
  isRegExp: _N,
  isFunction: Jt,
  isStream: tN,
  isURLSearchParams: aN,
  isTypedArray: gN,
  isFileList: nN,
  forEach: ko,
  merge: im,
  extend: uN,
  trim: dN,
  stripBOM: mN,
  inherits: pN,
  toFlatObject: fN,
  kindOf: Ys,
  kindOfTest: Cr,
  endsWith: hN,
  toArray: yN,
  forEachEntry: vN,
  matchAll: kN,
  isHTMLForm: bN,
  hasOwnProperty: ff,
  hasOwnProp: ff,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ax,
  freezeMethods: SN,
  toObjectSet: NN,
  toCamelCase: xN,
  noop: jN,
  toFiniteNumber: wN,
  findKey: rx,
  global: fi,
  isContextDefined: ix,
  isSpecCompliantForm: CN,
  toJSONObject: FN,
  isAsyncFn: IN,
  isThenable: EN,
  setImmediate: ox,
  asap: TN,
  isIterable: $N
};
let yn = class sx extends Error {
  static from(n, r, i, a, o, s) {
    const l = new sx(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ke.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
yn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
yn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
yn.ECONNABORTED = "ECONNABORTED";
yn.ETIMEDOUT = "ETIMEDOUT";
yn.ERR_NETWORK = "ERR_NETWORK";
yn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
yn.ERR_DEPRECATED = "ERR_DEPRECATED";
yn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
yn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
yn.ERR_CANCELED = "ERR_CANCELED";
yn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
yn.ERR_INVALID_URL = "ERR_INVALID_URL";
yn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const DN = null;
function am(e) {
  return ke.isPlainObject(e) || ke.isArray(e);
}
function lx(e) {
  return ke.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function hl(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = lx(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function RN(e) {
  return ke.isArray(e) && !e.some(am);
}
const ON = ke.toFlatObject(ke, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Js(e, n, r) {
  if (!ke.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ke.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(N, w) {
      return !ke.isUndefined(w[N]);
    }
  );
  const i = r.metaTokens, a = r.visitor || f, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? 100 : r.maxDepth, m = l && ke.isSpecCompliantForm(n);
  if (!ke.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(S) {
    if (S === null) return "";
    if (ke.isDate(S))
      return S.toISOString();
    if (ke.isBoolean(S))
      return S.toString();
    if (!m && ke.isBlob(S))
      throw new yn("Blob is not supported. Use a Buffer instead.");
    return ke.isArrayBuffer(S) || ke.isTypedArray(S) ? m && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  function f(S, N, w) {
    let y = S;
    if (ke.isReactNative(n) && ke.isReactNativeBlob(S))
      return n.append(hl(w, N, o), u(S)), !1;
    if (S && !w && typeof S == "object") {
      if (ke.endsWith(N, "{}"))
        N = i ? N : N.slice(0, -2), S = JSON.stringify(S);
      else if (ke.isArray(S) && RN(S) || (ke.isFileList(S) || ke.endsWith(N, "[]")) && (y = ke.toArray(S)))
        return N = lx(N), y.forEach(function(T, F) {
          !(ke.isUndefined(T) || T === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? hl([N], F, o) : s === null ? N : N + "[]",
            u(T)
          );
        }), !1;
    }
    return am(S) ? !0 : (n.append(hl(w, N, o), u(S)), !1);
  }
  const h = [], g = Object.assign(ON, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: am
  });
  function C(S, N, w = 0) {
    if (!ke.isUndefined(S)) {
      if (w > d)
        throw new yn(
          "Object is too deeply nested (" + w + " levels). Max depth: " + d,
          yn.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (h.indexOf(S) !== -1)
        throw Error("Circular reference detected in " + N.join("."));
      h.push(S), ke.forEach(S, function(V, T) {
        (!(ke.isUndefined(V) || V === null) && a.call(n, V, ke.isString(T) ? T.trim() : T, N, g)) === !0 && C(V, N ? N.concat(T) : [T], w + 1);
      }), h.pop();
    }
  }
  if (!ke.isObject(e))
    throw new TypeError("data must be an object");
  return C(e), n;
}
function hf(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Wm(e, n) {
  this._pairs = [], e && Js(e, this, n);
}
const cx = Wm.prototype;
cx.append = function(n, r) {
  this._pairs.push([n, r]);
};
cx.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, hf);
  } : hf;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function PN(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function dx(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || PN, a = ke.isFunction(r) ? {
    serialize: r
  } : r, o = a && a.serialize;
  let s;
  if (o ? s = o(n, a) : s = ke.isURLSearchParams(n) ? n.toString() : new Wm(n, a).toString(i), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class yf {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ke.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Km = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, AN = typeof URLSearchParams < "u" ? URLSearchParams : Wm, LN = typeof FormData < "u" ? FormData : null, VN = typeof Blob < "u" ? Blob : null, zN = {
  isBrowser: !0,
  classes: {
    URLSearchParams: AN,
    FormData: LN,
    Blob: VN
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Gm = typeof window < "u" && typeof document < "u", om = typeof navigator == "object" && navigator || void 0, UN = Gm && (!om || ["ReactNative", "NativeScript", "NS"].indexOf(om.product) < 0), MN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", BN = Gm && window.location.href || "http://localhost", qN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Gm,
  hasStandardBrowserEnv: UN,
  hasStandardBrowserWebWorkerEnv: MN,
  navigator: om,
  origin: BN
}, Symbol.toStringTag, { value: "Module" })), Rt = {
  ...qN,
  ...zN
};
function HN(e, n) {
  return Js(e, new Rt.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Rt.isNode && ke.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function WN(e) {
  return ke.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function KN(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function ux(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ke.isArray(a) ? a.length : s, d ? (ke.hasOwnProp(a, s) ? a[s] = ke.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!a[s] || !ke.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ke.isArray(a[s]) && (a[s] = KN(a[s])), !l);
  }
  if (ke.isFormData(e) && ke.isFunction(e.entries)) {
    const r = {};
    return ke.forEachEntry(e, (i, a) => {
      n(WN(i), a, r, 0);
    }), r;
  }
  return null;
}
const Ii = (e, n) => e != null && ke.hasOwnProp(e, n) ? e[n] : void 0;
function GN(e, n, r) {
  if (ke.isString(e))
    try {
      return (n || JSON.parse)(e), ke.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const bo = {
  transitional: Km,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ke.isObject(n);
      if (o && ke.isHTMLForm(n) && (n = new FormData(n)), ke.isFormData(n))
        return a ? JSON.stringify(ux(n)) : n;
      if (ke.isArrayBuffer(n) || ke.isBuffer(n) || ke.isStream(n) || ke.isFile(n) || ke.isBlob(n) || ke.isReadableStream(n))
        return n;
      if (ke.isArrayBufferView(n))
        return n.buffer;
      if (ke.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = Ii(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return HN(n, d).toString();
        if ((l = ke.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = Ii(this, "env"), u = m && m.FormData;
          return Js(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), GN(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Ii(this, "transitional") || bo.transitional, i = r && r.forcedJSONParsing, a = Ii(this, "responseType"), o = a === "json";
      if (ke.isResponse(n) || ke.isReadableStream(n))
        return n;
      if (n && ke.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Ii(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? yn.from(d, yn.ERR_BAD_RESPONSE, this, null, Ii(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Rt.classes.FormData,
    Blob: Rt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ke.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  bo.headers[e] = {};
});
const YN = ke.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), QN = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && YN[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, gf = Symbol("internals"), JN = /[^\x09\x20-\x7E\x80-\xFF]/g;
function XN(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
function ya(e) {
  return e && String(e).trim().toLowerCase();
}
function ZN(e) {
  return XN(e.replace(JN, ""));
}
function ls(e) {
  return e === !1 || e == null ? e : ke.isArray(e) ? e.map(ls) : ZN(String(e));
}
function ej(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const nj = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function yl(e, n, r, i, a) {
  if (ke.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ke.isString(n)) {
    if (ke.isString(i))
      return n.indexOf(i) !== -1;
    if (ke.isRegExp(i))
      return i.test(n);
  }
}
function tj(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function rj(e, n) {
  const r = ke.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Xt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = ya(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ke.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = ls(l));
    }
    const s = (l, d) => ke.forEach(l, (m, u) => o(m, u, d));
    if (ke.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ke.isString(n) && (n = n.trim()) && !nj(n))
      s(QN(n), r);
    else if (ke.isObject(n) && ke.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ke.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ke.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = ya(n), n) {
      const i = ke.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return ej(a);
        if (ke.isFunction(r))
          return r.call(this, a, i);
        if (ke.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = ya(n), n) {
      const i = ke.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || yl(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = ya(s), s) {
        const l = ke.findKey(i, s);
        l && (!r || yl(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || yl(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ke.forEach(this, (a, o) => {
      const s = ke.findKey(i, o);
      if (s) {
        r[s] = ls(a), delete r[o];
        return;
      }
      const l = n ? tj(o) : String(o).trim();
      l !== o && delete r[o], r[l] = ls(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ke.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ke.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[gf] = this[gf] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = ya(s);
      i[l] || (rj(a, s), i[l] = !0);
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Xt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ke.reduceDescriptors(Xt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ke.freezeMethods(Xt);
function gl(e, n) {
  const r = this || bo, i = n || r, a = Xt.from(i.headers);
  let o = i.data;
  return ke.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function mx(e) {
  return !!(e && e.__CANCEL__);
}
let xo = class extends yn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", yn.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function px(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(
    new yn(
      "Request failed with status code " + r.status,
      [yn.ERR_BAD_REQUEST, yn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
      r.config,
      r.request,
      r
    )
  );
}
function ij(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function aj(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const g = u && m - u;
    return g ? Math.round(h * 1e3 / g) : void 0;
  };
}
function oj(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const Ss = (e, n, r = 3) => {
  let i = 0;
  const a = aj(50, 250);
  return oj((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, vf = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, kf = (e) => (...n) => ke.asap(() => e(...n)), sj = Rt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Rt.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Rt.origin),
  Rt.navigator && /(msie|trident)/i.test(Rt.navigator.userAgent)
) : () => !0, lj = Rt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ke.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), ke.isString(i) && l.push(`path=${i}`), ke.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ke.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return n ? decodeURIComponent(n[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function cj(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function dj(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function fx(e, n, r) {
  let i = !cj(n);
  return e && (i || r === !1) ? dj(e, n) : n;
}
const bf = (e) => e instanceof Xt ? { ...e } : e;
function Si(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(m, u, f, h) {
    return ke.isPlainObject(m) && ke.isPlainObject(u) ? ke.merge.call({ caseless: h }, m, u) : ke.isPlainObject(u) ? ke.merge({}, u) : ke.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ke.isUndefined(u)) {
      if (!ke.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ke.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ke.isUndefined(u)) {
      if (!ke.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (ke.hasOwnProp(n, f))
      return i(m, u);
    if (ke.hasOwnProp(e, f))
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(bf(m), bf(u), f, !0)
  };
  return ke.forEach(Object.keys({ ...e, ...n }), function(u) {
    if (u === "__proto__" || u === "constructor" || u === "prototype") return;
    const f = ke.hasOwnProp(d, u) ? d[u] : a, h = ke.hasOwnProp(e, u) ? e[u] : void 0, g = ke.hasOwnProp(n, u) ? n[u] : void 0, C = f(h, g, u);
    ke.isUndefined(C) && f !== l || (r[u] = C);
  }), r;
}
const hx = (e) => {
  const n = Si({}, e), r = (h) => ke.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Xt.from(l), n.url = dx(
    fx(m, f, u),
    e.params,
    e.paramsSerializer
  ), d && l.set(
    "Authorization",
    "Basic " + btoa(
      (d.username || "") + ":" + (d.password ? unescape(encodeURIComponent(d.password)) : "")
    )
  ), ke.isFormData(i)) {
    if (Rt.hasStandardBrowserEnv || Rt.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (ke.isFunction(i.getHeaders)) {
      const h = i.getHeaders(), g = ["content-type", "content-length"];
      Object.entries(h).forEach(([C, S]) => {
        g.includes(C.toLowerCase()) && l.set(C, S);
      });
    }
  }
  if (Rt.hasStandardBrowserEnv && (ke.isFunction(a) && (a = a(n)), a === !0 || a == null && sj(n.url))) {
    const g = o && s && lj.read(s);
    g && l.set(o, g);
  }
  return n;
}, uj = typeof XMLHttpRequest < "u", mj = uj && function(e) {
  return new Promise(function(r, i) {
    const a = hx(e);
    let o = a.data;
    const s = Xt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, g, C;
    function S() {
      g && g(), C && C(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let N = new XMLHttpRequest();
    N.open(a.method.toUpperCase(), a.url, !0), N.timeout = a.timeout;
    function w() {
      if (!N)
        return;
      const V = Xt.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), F = {
        data: !l || l === "text" || l === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: V,
        config: e,
        request: N
      };
      px(
        function(U) {
          r(U), S();
        },
        function(U) {
          i(U), S();
        },
        F
      ), N = null;
    }
    "onloadend" in N ? N.onloadend = w : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, N.onabort = function() {
      N && (i(new yn("Request aborted", yn.ECONNABORTED, e, N)), N = null);
    }, N.onerror = function(T) {
      const F = T && T.message ? T.message : "Network Error", $ = new yn(F, yn.ERR_NETWORK, e, N);
      $.event = T || null, i($), N = null;
    }, N.ontimeout = function() {
      let T = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const F = a.transitional || Km;
      a.timeoutErrorMessage && (T = a.timeoutErrorMessage), i(
        new yn(
          T,
          F.clarifyTimeoutError ? yn.ETIMEDOUT : yn.ECONNABORTED,
          e,
          N
        )
      ), N = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in N && ke.forEach(s.toJSON(), function(T, F) {
      N.setRequestHeader(F, T);
    }), ke.isUndefined(a.withCredentials) || (N.withCredentials = !!a.withCredentials), l && l !== "json" && (N.responseType = a.responseType), m && ([h, C] = Ss(m, !0), N.addEventListener("progress", h)), d && N.upload && ([f, g] = Ss(d), N.upload.addEventListener("progress", f), N.upload.addEventListener("loadend", g)), (a.cancelToken || a.signal) && (u = (V) => {
      N && (i(!V || V.type ? new xo(null, e, N) : V), N.abort(), N = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const y = ij(a.url);
    if (y && Rt.protocols.indexOf(y) === -1) {
      i(
        new yn(
          "Unsupported protocol " + y + ":",
          yn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    N.send(o || null);
  });
}, pj = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(
          u instanceof yn ? u : new xo(u instanceof Error ? u.message : u)
        );
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new yn(`timeout of ${n}ms exceeded`, yn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ke.asap(l), d;
  }
}, fj = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, hj = async function* (e, n) {
  for await (const r of yj(e))
    yield* fj(r, n);
}, yj = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, xf = (e, n, r, i) => {
  const a = hj(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, _f = 64 * 1024, { isFunction: To } = ke, gj = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ke.global), { ReadableStream: Sf, TextEncoder: Nf } = ke.global, jf = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, vj = (e) => {
  e = ke.merge.call(
    {
      skipUndefined: !0
    },
    gj,
    e
  );
  const { fetch: n, Request: r, Response: i } = e, a = n ? To(n) : typeof fetch == "function", o = To(r), s = To(i);
  if (!a)
    return !1;
  const l = a && To(Sf), d = a && (typeof Nf == "function" ? /* @__PURE__ */ ((C) => (S) => C.encode(S))(new Nf()) : async (C) => new Uint8Array(await new r(C).arrayBuffer())), m = o && l && jf(() => {
    let C = !1;
    const S = new r(Rt.origin, {
      body: new Sf(),
      method: "POST",
      get duplex() {
        return C = !0, "half";
      }
    }), N = S.headers.has("Content-Type");
    return S.body != null && S.body.cancel(), C && !N;
  }), u = s && l && jf(() => ke.isReadableStream(new i("").body)), f = {
    stream: u && ((C) => C.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((C) => {
    !f[C] && (f[C] = (S, N) => {
      let w = S && S[C];
      if (w)
        return w.call(S);
      throw new yn(
        `Response type '${C}' is not supported`,
        yn.ERR_NOT_SUPPORT,
        N
      );
    });
  });
  const h = async (C) => {
    if (C == null)
      return 0;
    if (ke.isBlob(C))
      return C.size;
    if (ke.isSpecCompliantForm(C))
      return (await new r(Rt.origin, {
        method: "POST",
        body: C
      }).arrayBuffer()).byteLength;
    if (ke.isArrayBufferView(C) || ke.isArrayBuffer(C))
      return C.byteLength;
    if (ke.isURLSearchParams(C) && (C = C + ""), ke.isString(C))
      return (await d(C)).byteLength;
  }, g = async (C, S) => {
    const N = ke.toFiniteNumber(C.getContentLength());
    return N ?? h(S);
  };
  return async (C) => {
    let {
      url: S,
      method: N,
      data: w,
      signal: y,
      cancelToken: V,
      timeout: T,
      onDownloadProgress: F,
      onUploadProgress: $,
      responseType: U,
      headers: Q,
      withCredentials: X = "same-origin",
      fetchOptions: ae
    } = hx(C), J = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let B = pj(
      [y, V && V.toAbortSignal()],
      T
    ), O = null;
    const q = B && B.unsubscribe && (() => {
      B.unsubscribe();
    });
    let ee;
    try {
      if ($ && m && N !== "get" && N !== "head" && (ee = await g(Q, w)) !== 0) {
        let be = new r(S, {
          method: "POST",
          body: w,
          duplex: "half"
        }), Ie;
        if (ke.isFormData(w) && (Ie = be.headers.get("content-type")) && Q.setContentType(Ie), be.body) {
          const [G, He] = vf(
            ee,
            Ss(kf($))
          );
          w = xf(be.body, _f, G, He);
        }
      }
      ke.isString(X) || (X = X ? "include" : "omit");
      const ve = o && "credentials" in r.prototype;
      if (ke.isFormData(w)) {
        const be = Q.getContentType();
        be && /^multipart\/form-data/i.test(be) && !/boundary=/i.test(be) && Q.delete("content-type");
      }
      const de = {
        ...ae,
        signal: B,
        method: N.toUpperCase(),
        headers: Q.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: ve ? X : void 0
      };
      O = o && new r(S, de);
      let le = await (o ? J(O, ae) : J(S, de));
      const pe = u && (U === "stream" || U === "response");
      if (u && (F || pe && q)) {
        const be = {};
        ["status", "statusText", "headers"].forEach((qe) => {
          be[qe] = le[qe];
        });
        const Ie = ke.toFiniteNumber(le.headers.get("content-length")), [G, He] = F && vf(
          Ie,
          Ss(kf(F), !0)
        ) || [];
        le = new i(
          xf(le.body, _f, G, () => {
            He && He(), q && q();
          }),
          be
        );
      }
      U = U || "text";
      let W = await f[ke.findKey(f, U) || "text"](
        le,
        C
      );
      return !pe && q && q(), await new Promise((be, Ie) => {
        px(be, Ie, {
          data: W,
          headers: Xt.from(le.headers),
          status: le.status,
          statusText: le.statusText,
          config: C,
          request: O
        });
      });
    } catch (ve) {
      throw q && q(), ve && ve.name === "TypeError" && /Load failed|fetch/i.test(ve.message) ? Object.assign(
        new yn(
          "Network Error",
          yn.ERR_NETWORK,
          C,
          O,
          ve && ve.response
        ),
        {
          cause: ve.cause || ve
        }
      ) : yn.from(ve, ve && ve.code, C, O, ve && ve.response);
    }
  };
}, kj = /* @__PURE__ */ new Map(), yx = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = kj;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : vj(n)), u = m;
  return m;
};
yx();
const Ym = {
  http: DN,
  xhr: mj,
  fetch: {
    get: yx
  }
};
ke.forEach(Ym, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const wf = (e) => `- ${e}`, bj = (e) => ke.isFunction(e) || e === null || e === !1;
function xj(e, n) {
  e = ke.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !bj(i) && (a = Ym[(l = String(i)).toLowerCase()], a === void 0))
      throw new yn(`Unknown adapter '${l}'`);
    if (a && (ke.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(wf).join(`
`) : " " + wf(s[0]) : "as no adapter specified";
    throw new yn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const gx = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: xj,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Ym
};
function vl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new xo(null, e);
}
function Cf(e) {
  return vl(e), e.headers = Xt.from(e.headers), e.data = gl.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), gx.getAdapter(e.adapter || bo.adapter, e)(e).then(
    function(i) {
      return vl(e), i.data = gl.call(e, e.transformResponse, i), i.headers = Xt.from(i.headers), i;
    },
    function(i) {
      return mx(i) || (vl(e), i && i.response && (i.response.data = gl.call(
        e,
        e.transformResponse,
        i.response
      ), i.response.headers = Xt.from(i.response.headers))), Promise.reject(i);
    }
  );
}
const vx = "1.15.2", Xs = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Xs[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Ff = {};
Xs.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + vx + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new yn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        yn.ERR_DEPRECATED
      );
    return r && !Ff[s] && (Ff[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Xs.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function _j(e, n, r) {
  if (typeof e != "object")
    throw new yn("options must be an object", yn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new yn(
          "option " + o + " must be " + d,
          yn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new yn("Unknown option " + o, yn.ERR_BAD_OPTION);
  }
}
const cs = {
  assertOptions: _j,
  validators: Xs
}, lr = cs.validators;
let ki = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new yf(),
      response: new yf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = Si(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && cs.assertOptions(
      i,
      {
        silentJSONParsing: lr.transitional(lr.boolean),
        forcedJSONParsing: lr.transitional(lr.boolean),
        clarifyTimeoutError: lr.transitional(lr.boolean),
        legacyInterceptorReqResOrdering: lr.transitional(lr.boolean)
      },
      !1
    ), a != null && (ke.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : cs.assertOptions(
      a,
      {
        encode: lr.function,
        serialize: lr.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), cs.assertOptions(
      r,
      {
        baseUrl: lr.spelling("baseURL"),
        withXsrfToken: lr.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ke.merge(o.common, o[r.method]);
    o && ke.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (C) => {
      delete o[C];
    }), r.headers = Xt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(S) {
      if (typeof S.runWhen == "function" && S.runWhen(r) === !1)
        return;
      d = d && S.synchronous;
      const N = r.transitional || Km;
      N && N.legacyInterceptorReqResOrdering ? l.unshift(S.fulfilled, S.rejected) : l.push(S.fulfilled, S.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(S) {
      m.push(S.fulfilled, S.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const C = [Cf.bind(this), void 0];
      for (C.unshift(...l), C.push(...m), h = C.length, u = Promise.resolve(r); f < h; )
        u = u.then(C[f++], C[f++]);
      return u;
    }
    h = l.length;
    let g = r;
    for (; f < h; ) {
      const C = l[f++], S = l[f++];
      try {
        g = C(g);
      } catch (N) {
        S.call(this, N);
        break;
      }
    }
    try {
      u = Cf.call(this, g);
    } catch (C) {
      return Promise.reject(C);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = Si(this.defaults, n);
    const r = fx(n.baseURL, n.url, n.allowAbsoluteUrls);
    return dx(r, n.params, n.paramsSerializer);
  }
};
ke.forEach(["delete", "get", "head", "options"], function(n) {
  ki.prototype[n] = function(r, i) {
    return this.request(
      Si(i || {}, {
        method: n,
        url: r,
        data: (i || {}).data
      })
    );
  };
});
ke.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        Si(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  ki.prototype[n] = r(), ki.prototype[n + "Form"] = r(!0);
});
let Sj = class kx {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new xo(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new kx(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function Nj(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function jj(e) {
  return ke.isObject(e) && e.isAxiosError === !0;
}
const sm = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(sm).forEach(([e, n]) => {
  sm[n] = e;
});
function bx(e) {
  const n = new ki(e), r = Zb(ki.prototype.request, n);
  return ke.extend(r, ki.prototype, n, { allOwnKeys: !0 }), ke.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return bx(Si(e, a));
  }, r;
}
const ft = bx(bo);
ft.Axios = ki;
ft.CanceledError = xo;
ft.CancelToken = Sj;
ft.isCancel = mx;
ft.VERSION = vx;
ft.toFormData = Js;
ft.AxiosError = yn;
ft.Cancel = ft.CanceledError;
ft.all = function(n) {
  return Promise.all(n);
};
ft.spread = Nj;
ft.isAxiosError = jj;
ft.mergeConfig = Si;
ft.AxiosHeaders = Xt;
ft.formToJSON = (e) => ux(ke.isHTMLForm(e) ? new FormData(e) : e);
ft.getAdapter = gx.getAdapter;
ft.HttpStatusCode = sm;
ft.default = ft;
const {
  Axios: EB,
  AxiosError: TB,
  CanceledError: $B,
  isCancel: DB,
  CancelToken: RB,
  VERSION: OB,
  all: PB,
  Cancel: AB,
  isAxiosError: wj,
  spread: LB,
  toFormData: VB,
  AxiosHeaders: zB,
  HttpStatusCode: UB,
  formToJSON: MB,
  getAdapter: BB,
  mergeConfig: qB
} = ft;
class Cj {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const If = new Cj();
function Fj(e, n) {
  return Ef(e), Ef(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Ef(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const Ij = Object.prototype.toString;
function Ej(e, n) {
  return Ij.call(e) === `[object ${n}]`;
}
function Tj(e) {
  return Ej(e, "Object");
}
function $j(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Za = "8.36.0", Gr = globalThis;
function Qm(e, n, r) {
  const i = r || Gr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Za] = a[Za] || {};
  return o[e] || (o[e] = n());
}
const xx = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Dj = "Sentry Logger ", Tf = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], $f = {};
function _x(e) {
  if (!("console" in Gr))
    return e();
  const n = Gr.console, r = {}, i = Object.keys($f);
  i.forEach((a) => {
    const o = $f[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function Rj() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return xx ? Tf.forEach((r) => {
    n[r] = (...i) => {
      e && _x(() => {
        Gr.console[r](`${Dj}[${r}]:`, ...i);
      });
    };
  }) : Tf.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const ds = Qm("logger", Rj);
function Oj(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    xx && ds.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Sx = 1e3;
function Jm() {
  return Date.now() / Sx;
}
function Pj() {
  const { performance: e } = Gr;
  if (!e || !e.now)
    return Jm;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Sx;
}
const Aj = Pj();
(() => {
  const { performance: e } = Gr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function qi() {
  const e = Gr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Df() {
  return {
    traceId: qi(),
    spanId: qi().substring(16)
  };
}
function Xm() {
  return Zm(Gr), Gr;
}
function Zm(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Za, n[Za] = n[Za] || {};
}
function Lj(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || Aj(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : qi()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const lm = "_sentrySpan";
function Rf(e, n) {
  n ? Oj(e, lm, n) : delete e[lm];
}
function Of(e) {
  return e[lm];
}
const Vj = 100;
class ep {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Df();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new ep();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Rf(n, Of(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Lj(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Qi ? [r.getScopeData(), r.getRequestSession()] : Tj(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Rf(this, void 0), this._attachments = [], this._propagationContext = Df(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : Vj;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Jm(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Of(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : qi();
    if (!this._client)
      return ds.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : qi();
    if (!this._client)
      return ds.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : qi();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (ds.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Qi = ep;
function zj() {
  return Qm("defaultCurrentScope", () => new Qi());
}
function Uj() {
  return Qm("defaultIsolationScope", () => new Qi());
}
class Mj {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Qi();
    let a;
    r ? a = r : a = new Qi(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return $j(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Ji() {
  const e = Xm(), n = Zm(e);
  return n.stack = n.stack || new Mj(zj(), Uj());
}
function Bj(e) {
  return Ji().withScope(e);
}
function qj(e, n) {
  const r = Ji();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Pf(e) {
  return Ji().withScope(() => e(Ji().getIsolationScope()));
}
function Hj() {
  return {
    withIsolationScope: Pf,
    withScope: Bj,
    withSetScope: qj,
    withSetIsolationScope: (e, n) => Pf(n),
    getCurrentScope: () => Ji().getScope(),
    getIsolationScope: () => Ji().getIsolationScope()
  };
}
function Nx(e) {
  const n = Zm(e);
  return n.acs ? n.acs : Hj();
}
function np() {
  const e = Xm();
  return Nx(e).getCurrentScope();
}
function jx() {
  const e = Xm();
  return Nx(e).getIsolationScope();
}
function Wj() {
  return np().getClient();
}
function Kj(e) {
  if (e)
    return Gj(e) ? { captureContext: e } : Qj(e) ? {
      captureContext: e
    } : e;
}
function Gj(e) {
  return e instanceof Qi || typeof e == "function";
}
const Yj = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Qj(e) {
  return Object.keys(e).some((n) => Yj.includes(n));
}
function Af(e, n) {
  return np().captureException(e, Kj(n));
}
function Jj(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return np().captureMessage(e, r, i);
}
function Xj(e, n) {
  jx().setContext(e, n);
}
const Zj = 100;
function ui(e, n) {
  const r = Wj(), i = jx();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = Zj } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Jm(), ...e }, d = a ? _x(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var po;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(po || (po = {}));
function Hi(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const ew = mo.backendDomain ? {
  "backend-domain": mo.backendDomain
} : void 0;
function us() {
  const e = new URLSearchParams({
    noToken: "true",
    ...ew
  }).toString();
  document.location.href = `${mo.url.logIn}?${e}`;
}
const kl = "authData", bl = 30, nw = 600, xl = 5;
class tw {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= xl || this.clientServerTimeDiff <= -xl ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + nw, a = Hi(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > xl) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(kl, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(kl), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(kl);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - bl;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Hi(n), i = r.exp - bl;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - bl - this.estimatedServerTime()) * 1e3;
  }
}
const Nt = new tw();
async function rw(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Hi(o).exp : "None", l = await Zs.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Hi(m).exp : "None", h = u ? Hi(u).exp : "None", g = typeof s == "number" ? d - s : "Unknown", C = typeof f == "number" ? d - f : "Unknown", S = typeof h == "number" ? d - h : "Unknown", N = e.response.headers["x-dixa-rid"];
      Xj("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: g,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: C,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: S,
        xDixaRid: N,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    Jj("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: po.Platform,
        domain: n
      }
    });
  }
}
const _l = /* @__PURE__ */ new Map(), iw = 3;
function aw(e) {
  e.interceptors.response.use((n) => (_l.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case cm.Unauthorized:
          if (!Zs.isRefreshTokenExpired() && n.config) {
            ui({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = _l.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= iw)
              return _l.set(n.config.url, i + 1), e(n.config);
          }
          rw(n), console.error("401 unauthorized interceptor"), us();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const wx = ft.create();
aw(wx);
const zr = console.log;
async function Lf(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class ow extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function sw(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const lw = 5;
class cw {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      Nt.setAuthData(r);
    else {
      const i = Nt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new ow("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = Nt.getAccessToken();
    if (!n)
      return {};
    const r = Hi(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return Nt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = Nt.getAuthData();
    return r ? Nt.isAccessTokenExpired() ? (ui({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && Nt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return Nt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Nt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Nt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Nt.getAuthData();
    return n ? Nt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!If.isElectron())
      return !0;
    const n = await If.getVersion();
    return Fj(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = lw) {
    try {
      return await wx.post(`${mo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (zr("AUTH", "Network connection offline - waiting..."), ui({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Lf(5);
    n && (zr("AUTH", "Network connection restored"), ui({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = sw(this.retryCount);
    return zr("AUTH", `Retrying in ${i} seconds`), await Lf(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (Nt.isRefreshTokenExpired(r))
      return zr("AUTH", "Refresh token expired"), ui({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), Nt.removeAuthData(), us(), null;
    if (wj(n)) {
      if (n.message === "timeout exceeded")
        return zr("AUTH", "Timeout exceeded"), ui({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return zr("AUTH", "Network error"), ui({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return zr("AUTH", "Refresh token invalid (401)"), Nt.removeAuthData(), us(), null;
      Af(n, {
        level: "error",
        tags: {
          team: po.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (zr("AUTH", "Retries exhausted, logging out"), Af(n, {
      level: "error",
      tags: {
        team: po.Platform,
        errorSource: "authManager.refresh"
      }
    }), Nt.removeAuthData(), us(), null) : (zr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return Nt.accessTokenExpiresInMs();
  }
}
const Zs = new cw();
var cm;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(cm || (cm = {}));
const dw = new qm((e, n) => new Qb((r) => {
  Zs.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), uw = new qm(
  (e, n) => new Qb((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Zs.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...n0(mo.url.partnerIntegrations) && d?.access_token && t0(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), mw = new AbortController(), Cx = (e) => new $0({
  queryDeduplication: !1,
  cache: new D0(),
  link: qm.from([
    dw,
    uw,
    R0({
      uri: `${e}/graphql`,
      fetch: V0,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: mw.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), pw = ({
  configuration: e,
  children: n
}) => {
  const r = Bn(
    () => Cx(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ ze.jsx(O0, { client: r, children: n });
};
function fw() {
  try {
    return P0(), !0;
  } catch {
    return !1;
  }
}
const hw = ({
  configuration: e,
  children: n
}) => fw() ? n : /* @__PURE__ */ ze.jsx(pw, { configuration: e, children: n }), yw = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ ze.jsx(A0, { children: (o) => /* @__PURE__ */ ze.jsx(
  r0,
  {
    value: {
      useMutation: s0(e, n),
      useQuery: o0(e, n),
      useLazyQuery: a0(e, n),
      executeQuery: i0(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Fx = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ ze.jsx(hw, { configuration: r, children: s ? /* @__PURE__ */ ze.jsx(
    yw,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, gw = "_unmatchedHeader_qcj19_1", vw = {
  unmatchedHeader: gw
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Sl = { exports: {} }, ga = {}, Vf;
function kw() {
  if (Vf) return ga;
  Vf = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return ga.Fragment = r, ga.jsx = s, ga.jsxs = s, ga;
}
var $o = {}, zf;
function bw() {
  return zf || (zf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    $o.Fragment = i, $o.jsx = Rn, $o.jsxs = Mn;
  })()), $o;
}
var Uf;
function xw() {
  return Uf || (Uf = 1, process.env.NODE_ENV === "production" ? Sl.exports = kw() : Sl.exports = bw()), Sl.exports;
}
var oe = xw();
const _w = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, Sw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, Nw = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": _w,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": Sw
};
function Ix(e) {
  return Nw[e] ?? {};
}
const jw = Ix(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), ww = Ix(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), Cw = "_copyIcon_1wjfs_48", Fw = "_list_1wjfs_53", Iw = "_listItem_1wjfs_63", Ew = "_collapsible_1wjfs_72", Tw = "_collapsibleIsOpen_1wjfs_80", $w = "_collapsibleHeader_1wjfs_83", Dw = "_collapsibleIconTrue_1wjfs_86", Rw = "_collapsibleIconFalse_1wjfs_89", On = {
  copyIcon: Cw,
  list: Fw,
  listItem: Iw,
  collapsible: Ew,
  collapsibleIsOpen: Tw,
  collapsibleHeader: $w,
  collapsibleIconTrue: Dw,
  collapsibleIconFalse: Rw
}, Ow = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: rt(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ oe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(Ye, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(d).format(xt) })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(m).format(xt) })
          ] }) })
        ] })
      ]
    }
  );
}, Pw = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ oe.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(Ow, { app: r, openByDefault: i === 0 }, i))
  ] });
}, Aw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ oe.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: i }),
          uo(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Lw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            We,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  xt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  xt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Ns = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ oe.jsx(We, { content: n ? null : l(), children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(me, { size: 14, name: o(), color: s() }) }) });
}, Vw = "_wrapper_1xucg_1", zw = "_externalLink_1xucg_7", Nl = {
  wrapper: Vw,
  externalLink: zw
}, Uw = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = or(), { isCopied: i, copy: a } = or(), { isCopied: o, copy: s } = or(), { isCopied: l, copy: d } = or(), { isCopied: m, copy: u } = or();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: g,
    last_name: C,
    home_city: S,
    country: N,
    email: w,
    phone: y,
    dob: V,
    created_at: T,
    email_subscribe: F,
    push_subscribe: $
  } = e, U = 14, Q = `${g || ""} ${C || ""}`.trim() || "A customer has no name", X = `${S ? `${S} /` : ""} ${N || ""}`.trim(), ae = V ? Ln(V).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { className: Nl.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Nl.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-2", children: Q }),
          ae && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    T && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: Ln(T).format(xt) })
    ] }),
    X && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: U, name: "map-pin" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: X })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy location", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: U,
          name: o ? "done" : "copy",
          onClick: () => s(X),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    w && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: U, name: "mail" }),
        /* @__PURE__ */ oe.jsx("span", { className: Nl.externalLink, children: w })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy email", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: U,
          name: n ? "done" : "copy",
          onClick: () => r(w),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: U, name: "phone" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: U,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: U, name: "user" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ oe.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy Braze ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: U,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: U, name: "tag" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ oe.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy External ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: U,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    F && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: U, name: "sync" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(Ns, { state: F })
    ] }),
    $ && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: U, name: "bell" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(Ns, { isPush: !0, state: $ })
    ] })
  ] }) });
}, Mw = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: rt(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ oe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(Ye, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ oe.jsx(
              me,
              {
                size: a,
                className: rt({
                  [On.collapsibleIconTrue]: d,
                  [On.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ oe.jsx(We, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(We, { content: "For iOS", children: /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, Bw = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ oe.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(Mw, { device: r, openByDefault: i === 0 }, i))
  ] });
}, va = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, Do = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = _n(), { useMutation: a } = fn(), [o, s] = se(!1), [l] = a(
    ww,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: va[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ oe.jsx(We, { content: va[n].tooltipContent, children: /* @__PURE__ */ oe.jsx(
    Kn,
    {
      variant: "secondary",
      color: va[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(
          Ns,
          {
            noTooltip: !0,
            state: va[n].parameter
          }
        ),
        va[n].label
      ] })
    }
  ) });
}, qw = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: 14, name: "sync" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(Ns, { state: a })
    ] }) }) }),
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
        /* @__PURE__ */ oe.jsx(
          Do,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Do,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ oe.jsx(
        Do,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ oe.jsx(
        Do,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, Hw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            We,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  xt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  xt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Ww = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = _n(), { useMutation: i } = fn(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, g = n.updateEmailSubscriptionState ?? !1, C = n.displayCustomAttributes ?? !1, S = n.displayCustomEvents ?? !1, N = n.displayPuchases ?? !1, w = n.displayDevices ?? !1, y = n.displayApps ?? !1, V = !h && !g && !C && !S && !N, [T, { error: F }] = i(
    jw,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Q = U?.Braze?.exportUserDetails?.users?.[0];
        Q ? (o(Q), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), $ = async () => {
    u || f ? await T({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Le(() => {
    async function U() {
      m(!0), await $();
    }
    U().finally(() => m(!1));
  }, [u, f]), F) {
    const U = F.graphQLErrors;
    return Am({ errors: U }) ? /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Lm({ errors: U }) ? /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ oe.jsx(Fn, { error: F });
  }
  return d ? /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ oe.jsx(dn, {}) }) : V ? /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ oe.jsx(Uw, { customerDetails: a }),
        g && !!a && /* @__PURE__ */ oe.jsx(
          qw,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await $()
          }
        ),
        C && !!a && /* @__PURE__ */ oe.jsx(Aw, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ oe.jsx(Lw, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ oe.jsx(Hw, { customerDetails: a }),
        w && !!a && /* @__PURE__ */ oe.jsx(Bw, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ oe.jsx(Pw, { apps: a?.apps })
      ]
    }
  );
}, Kw = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Mb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function Gw() {
  var e = vi(!1), n = ot(function() {
    return e.current;
  }, []);
  return Le(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var Yw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = ot(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, Qw = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Mf = function(e) {
  return b0(Qw, e);
}, jl, Bf;
function Jw() {
  return Bf || (Bf = 1, jl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), jl;
}
var wl, qf;
function Xw() {
  if (qf) return wl;
  qf = 1;
  var e = Jw(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, g = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(S) {
        if (S.stopPropagation(), s.format)
          if (S.preventDefault(), typeof S.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var N = n[s.format] || n.default;
            window.clipboardData.setData(N, o);
          } else
            S.clipboardData.clearData(), S.clipboardData.setData(s.format, o);
        s.onCopy && (S.preventDefault(), s.onCopy(S.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      g = !0;
    } catch (S) {
      l && console.error("unable to copy using execCommand: ", S), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), g = !0;
      } catch (N) {
        l && console.error("unable to copy using clipboardData: ", N), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return g;
  }
  return wl = a, wl;
}
var Zw = Xw();
const eC = /* @__PURE__ */ Hm(Zw);
var Ex = function() {
  var e = Gw(), n = Yw({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = ot(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = eC(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function nC(e, n) {
  n === void 0 && (n = 0);
  var r = vi(!1), i = vi(), a = vi(e), o = ot(function() {
    return r.current;
  }, []), s = ot(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = ot(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Le(function() {
    a.current = e;
  }, [e]), Le(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Ni(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = nC(e, n), a = i[0], o = i[1], s = i[2];
  return Le(s, r), [a, o];
}
var tC = function(e) {
  Le(e, []);
}, rC = function(e, n) {
  var r = vi(function() {
  });
  Le(function() {
    r.current = e;
  }), Le(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, iC = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = Bn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return fl(fl({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = z0(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = fl({ get: ot(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, aC = function(e) {
  var n = vi(e);
  n.current = e, tC(function() {
    return function() {
      return n.current();
    };
  });
}, _o = (e) => e.type === "checkbox", hi = (e) => e instanceof Date, Bt = (e) => e == null;
const Tx = (e) => typeof e == "object";
var ut = (e) => !Bt(e) && !Array.isArray(e) && Tx(e) && !hi(e), $x = (e) => ut(e) && e.target ? _o(e.target) ? e.target.checked : e.target.value : e, oC = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Dx = (e, n) => e.has(oC(n)), sC = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ut(n) && n.hasOwnProperty("isPrototypeOf");
}, tp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ct(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(tp && (e instanceof Blob || i)) && (r || ut(e)))
    if (n = r ? [] : {}, !r && !sC(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ct(e[a]));
  else
    return e;
  return n;
}
var el = (e) => Array.isArray(e) ? e.filter(Boolean) : [], st = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !ut(e))
    return r;
  const i = el(n.split(/[,[\].]+?/)).reduce((a, o) => Bt(a) ? a : a[o], e);
  return st(i) || i === e ? st(e[n]) ? r : e[n] : i;
}, rr = (e) => typeof e == "boolean", rp = (e) => /^\w*$/.test(e), Rx = (e) => el(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, r) => {
  let i = -1;
  const a = rp(n) ? [n] : Rx(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ut(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const js = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, vr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ur = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Ox = Fe.createContext(null), Lr = () => Fe.useContext(Ox), ip = (e) => {
  const { children: n, ...r } = e;
  return Fe.createElement(Ox.Provider, { value: r }, n);
};
var Px = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== vr.all && (n._proxyFormState[s] = !i || vr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function lC(e) {
  const n = Lr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Fe.useState(r._formState), d = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Fe.useRef(a);
  return m.current = a, Fe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Fe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Fe.useMemo(() => Px(s, r, d.current, !1), [s, r]);
}
var Dr = (e) => typeof e == "string", Ax = (e, n, r, i, a) => Dr(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function ms(e) {
  const n = Lr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Fe.useRef(i), d = Fe.useRef(a);
  l.current = i, Fe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Ax(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Fe.useState(r._getWatch(i, a));
  return Fe.useEffect(() => r._removeUnmounted()), m;
}
function ap(e) {
  const n = Lr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Dx(a._names.array, r), l = ms({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = lC({
    control: a,
    name: r,
    exact: !0
  }), m = Fe.useRef(e), u = Fe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...rr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Fe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = Fe.useCallback((N) => u.current.onChange({
    target: {
      value: $x(N),
      name: r
    },
    type: js.CHANGE
  }), [r]), g = Fe.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: js.BLUR
  }), [r, a._formValues]), C = Fe.useCallback((N) => {
    const w = Je(a._fields, r);
    w && N && (w._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = Fe.useMemo(() => ({
    name: r,
    value: l,
    ...rr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: g,
    ref: C
  }), [r, i, d.disabled, h, g, C, l]);
  return Fe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...rr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (y, V) => {
      const T = Je(a._fields, y);
      T && T._f && (T._f.mount = V);
    };
    if (w(r, !0), N) {
      const y = Ct(Je(a._options.defaultValues, r));
      Gn(a._defaultValues, r, y), st(Je(a._formValues, r)) && Gn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : w(r, !1);
    };
  }, [r, a, s, o]), Fe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Fe.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Wt = (e) => e.render(ap(e));
var cC = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, eo = (e) => Array.isArray(e) ? e : [e], Hf = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, dm = (e) => Bt(e) || !Tx(e);
function ti(e, n) {
  if (dm(e) || dm(n))
    return e === n;
  if (hi(e) && hi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (hi(o) && hi(s) || ut(o) && ut(s) || Array.isArray(o) && Array.isArray(s) ? !ti(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var zt = (e) => ut(e) && !Object.keys(e).length, op = (e) => e.type === "file", kr = (e) => typeof e == "function", ws = (e) => {
  if (!tp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Lx = (e) => e.type === "select-multiple", sp = (e) => e.type === "radio", dC = (e) => sp(e) || _o(e), Cl = (e) => ws(e) && e.isConnected;
function uC(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = st(e) ? i++ : e[n[i++]];
  return e;
}
function mC(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !st(e[n]))
      return !1;
  return !0;
}
function vt(e, n) {
  const r = Array.isArray(n) ? n : rp(n) ? [n] : Rx(n), i = r.length === 1 ? e : uC(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ut(i) && zt(i) || Array.isArray(i) && mC(i)) && vt(e, r.slice(0, -1)), e;
}
var Vx = (e) => {
  for (const n in e)
    if (kr(e[n]))
      return !0;
  return !1;
};
function Cs(e, n = {}) {
  const r = Array.isArray(e);
  if (ut(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ut(e[i]) && !Vx(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Cs(e[i], n[i])) : Bt(e[i]) || (n[i] = !0);
  return n;
}
function zx(e, n, r) {
  const i = Array.isArray(e);
  if (ut(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ut(e[a]) && !Vx(e[a]) ? st(n) || dm(r[a]) ? r[a] = Array.isArray(e[a]) ? Cs(e[a], []) : { ...Cs(e[a]) } : zx(e[a], Bt(n) ? {} : n[a], r[a]) : r[a] = !ti(e[a], n[a]);
  return r;
}
var ka = (e, n) => zx(e, n, Cs(n));
const Wf = {
  value: !1,
  isValid: !1
}, Kf = { value: !0, isValid: !0 };
var Ux = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !st(e[0].attributes.value) ? st(e[0].value) || e[0].value === "" ? Kf : { value: e[0].value, isValid: !0 } : Kf
    ) : Wf;
  }
  return Wf;
}, Mx = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => st(e) ? e : n ? e === "" ? NaN : e && +e : r && Dr(e) ? new Date(e) : i ? i(e) : e;
const Gf = {
  isValid: !1,
  value: null
};
var Bx = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Gf) : Gf;
function Yf(e) {
  const n = e.ref;
  return op(n) ? n.files : sp(n) ? Bx(e.refs).value : Lx(n) ? [...n.selectedOptions].map(({ value: r }) => r) : _o(n) ? Ux(e.refs).value : Mx(st(n.value) ? e.ref.value : n.value, e);
}
var pC = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Fs = (e) => e instanceof RegExp, ba = (e) => st(e) ? e : Fs(e) ? e.source : ut(e) ? Fs(e.value) ? e.value.source : e.value : e, Qf = (e) => ({
  isOnSubmit: !e || e === vr.onSubmit,
  isOnBlur: e === vr.onBlur,
  isOnChange: e === vr.onChange,
  isOnAll: e === vr.all,
  isOnTouch: e === vr.onTouched
});
const Jf = "AsyncFunction";
var fC = (e) => !!e && !!e.validate && !!(kr(e.validate) && e.validate.constructor.name === Jf || ut(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Jf)), hC = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Xf = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const no = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (no(l, n))
          break;
      } else if (ut(l) && no(l, n))
        break;
    }
  }
};
function Zf(e, n, r) {
  const i = Je(e, r);
  if (i || rp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var yC = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return zt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || vr.all));
}, gC = (e, n, r) => !e || !n || e === n || eo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), vC = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, kC = (e, n) => !el(Je(e, n)).length && vt(e, n), bC = (e, n, r) => {
  const i = eo(Je(e, r));
  return Gn(i, "root", n[r]), Gn(e, r, i), e;
}, ps = (e) => Dr(e);
function eh(e, n, r = "validate") {
  if (ps(e) || Array.isArray(e) && e.every(ps) || rr(e) && !e)
    return {
      type: r,
      message: ps(e) ? e : "",
      ref: n
    };
}
var Ei = (e) => ut(e) && !Fs(e) ? e : {
  value: e,
  message: ""
}, nh = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: g, validate: C, name: S, valueAsNumber: N, mount: w } = e._f, y = Je(r, S);
  if (!w || n.has(S))
    return {};
  const V = l ? l[0] : s, T = (B) => {
    a && V.reportValidity && (V.setCustomValidity(rr(B) ? "" : B || ""), V.reportValidity());
  }, F = {}, $ = sp(s), U = _o(s), Q = $ || U, X = (N || op(s)) && st(s.value) && st(y) || ws(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = cC.bind(null, S, i, F), J = (B, O, q, ee = Ur.maxLength, ve = Ur.minLength) => {
    const de = B ? O : q;
    F[S] = {
      type: B ? ee : ve,
      message: de,
      ref: s,
      ...ae(B ? ee : ve, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Q && (X || Bt(y)) || rr(y) && !y || U && !Ux(l).isValid || $ && !Bx(l).isValid)) {
    const { value: B, message: O } = ps(d) ? { value: !!d, message: d } : Ei(d);
    if (B && (F[S] = {
      type: Ur.required,
      message: O,
      ref: V,
      ...ae(Ur.required, O)
    }, !i))
      return T(O), F;
  }
  if (!X && (!Bt(f) || !Bt(h))) {
    let B, O;
    const q = Ei(h), ee = Ei(f);
    if (!Bt(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      Bt(q.value) || (B = ve > q.value), Bt(ee.value) || (O = ve < ee.value);
    } else {
      const ve = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      Dr(q.value) && y && (B = le ? de(y) > de(q.value) : pe ? y > q.value : ve > new Date(q.value)), Dr(ee.value) && y && (O = le ? de(y) < de(ee.value) : pe ? y < ee.value : ve < new Date(ee.value));
    }
    if ((B || O) && (J(!!B, q.message, ee.message, Ur.max, Ur.min), !i))
      return T(F[S].message), F;
  }
  if ((m || u) && !X && (Dr(y) || o && Array.isArray(y))) {
    const B = Ei(m), O = Ei(u), q = !Bt(B.value) && y.length > +B.value, ee = !Bt(O.value) && y.length < +O.value;
    if ((q || ee) && (J(q, B.message, O.message), !i))
      return T(F[S].message), F;
  }
  if (g && !X && Dr(y)) {
    const { value: B, message: O } = Ei(g);
    if (Fs(B) && !y.match(B) && (F[S] = {
      type: Ur.pattern,
      message: O,
      ref: s,
      ...ae(Ur.pattern, O)
    }, !i))
      return T(O), F;
  }
  if (C) {
    if (kr(C)) {
      const B = await C(y, r), O = eh(B, V);
      if (O && (F[S] = {
        ...O,
        ...ae(Ur.validate, O.message)
      }, !i))
        return T(O.message), F;
    } else if (ut(C)) {
      let B = {};
      for (const O in C) {
        if (!zt(B) && !i)
          break;
        const q = eh(await C[O](y, r), V, O);
        q && (B = {
          ...q,
          ...ae(O, q.message)
        }, T(q.message), i && (F[S] = B));
      }
      if (!zt(B) && (F[S] = {
        ref: V,
        ...B
      }, !i))
        return F;
    }
  }
  return T(!0), F;
};
const xC = {
  mode: vr.onSubmit,
  reValidateMode: vr.onChange,
  shouldFocusError: !0
};
function _C(e = {}) {
  let n = {
    ...xC,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: kr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ut(n.defaultValues) || ut(n.values) ? Ct(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ct(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Hf(),
    state: Hf()
  }, g = Qf(n.mode), C = Qf(n.reValidateMode), S = n.criteriaMode === vr.all, N = (x) => (D) => {
    clearTimeout(m), m = setTimeout(x, D);
  }, w = async (x) => {
    if (!n.disabled && (u.isValid || f.isValid || x)) {
      const D = n.resolver ? zt((await X()).errors) : await J(i, !0);
      D !== r.isValid && h.state.next({
        isValid: D
      });
    }
  }, y = (x, D) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((x || Array.from(l.mount)).forEach((H) => {
      H && (D ? Gn(r.validatingFields, H, D) : vt(r.validatingFields, H));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !zt(r.validatingFields)
    }));
  }, V = (x, D = [], H, Y, R = !0, z = !0) => {
    if (Y && H && !n.disabled) {
      if (s.action = !0, z && Array.isArray(Je(i, x))) {
        const ie = H(Je(i, x), Y.argA, Y.argB);
        R && Gn(i, x, ie);
      }
      if (z && Array.isArray(Je(r.errors, x))) {
        const ie = H(Je(r.errors, x), Y.argA, Y.argB);
        R && Gn(r.errors, x, ie), kC(r.errors, x);
      }
      if ((u.touchedFields || f.touchedFields) && z && Array.isArray(Je(r.touchedFields, x))) {
        const ie = H(Je(r.touchedFields, x), Y.argA, Y.argB);
        R && Gn(r.touchedFields, x, ie);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = ka(a, o)), h.state.next({
        name: x,
        isDirty: O(x, D),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Gn(o, x, D);
  }, T = (x, D) => {
    Gn(r.errors, x, D), h.state.next({
      errors: r.errors
    });
  }, F = (x) => {
    r.errors = x, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (x, D, H, Y) => {
    const R = Je(i, x);
    if (R) {
      const z = Je(o, x, st(H) ? Je(a, x) : H);
      st(z) || Y && Y.defaultChecked || D ? Gn(o, x, D ? z : Yf(R._f)) : ve(x, z), s.mount && w();
    }
  }, U = (x, D, H, Y, R) => {
    let z = !1, ie = !1;
    const ue = {
      name: x
    };
    if (!n.disabled) {
      if (!H || Y) {
        (u.isDirty || f.isDirty) && (ie = r.isDirty, r.isDirty = ue.isDirty = O(), z = ie !== ue.isDirty);
        const Se = ti(Je(a, x), D);
        ie = !!Je(r.dirtyFields, x), Se ? vt(r.dirtyFields, x) : Gn(r.dirtyFields, x, !0), ue.dirtyFields = r.dirtyFields, z = z || (u.dirtyFields || f.dirtyFields) && ie !== !Se;
      }
      if (H) {
        const Se = Je(r.touchedFields, x);
        Se || (Gn(r.touchedFields, x, H), ue.touchedFields = r.touchedFields, z = z || (u.touchedFields || f.touchedFields) && Se !== H);
      }
      z && R && h.state.next(ue);
    }
    return z ? ue : {};
  }, Q = (x, D, H, Y) => {
    const R = Je(r.errors, x), z = (u.isValid || f.isValid) && rr(D) && r.isValid !== D;
    if (n.delayError && H ? (d = N(() => T(x, H)), d(n.delayError)) : (clearTimeout(m), d = null, H ? Gn(r.errors, x, H) : vt(r.errors, x)), (H ? !ti(R, H) : R) || !zt(Y) || z) {
      const ie = {
        ...Y,
        ...z && rr(D) ? { isValid: D } : {},
        errors: r.errors,
        name: x
      };
      r = {
        ...r,
        ...ie
      }, h.state.next(ie);
    }
  }, X = async (x) => {
    y(x, !0);
    const D = await n.resolver(o, n.context, pC(x || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(x), D;
  }, ae = async (x) => {
    const { errors: D } = await X(x);
    if (x)
      for (const H of x) {
        const Y = Je(D, H);
        Y ? Gn(r.errors, H, Y) : vt(r.errors, H);
      }
    else
      r.errors = D;
    return D;
  }, J = async (x, D, H = {
    valid: !0
  }) => {
    for (const Y in x) {
      const R = x[Y];
      if (R) {
        const { _f: z, ...ie } = R;
        if (z) {
          const ue = l.array.has(z.name), Se = R._f && fC(R._f);
          Se && u.validatingFields && y([Y], !0);
          const nn = await nh(R, l.disabled, o, S, n.shouldUseNativeValidation && !D, ue);
          if (Se && u.validatingFields && y([Y]), nn[z.name] && (H.valid = !1, D))
            break;
          !D && (Je(nn, z.name) ? ue ? bC(r.errors, nn, z.name) : Gn(r.errors, z.name, nn[z.name]) : vt(r.errors, z.name));
        }
        !zt(ie) && await J(ie, D, H);
      }
    }
    return H.valid;
  }, B = () => {
    for (const x of l.unMount) {
      const D = Je(i, x);
      D && (D._f.refs ? D._f.refs.every((H) => !Cl(H)) : !Cl(D._f.ref)) && Ue(x);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (x, D) => !n.disabled && (x && D && Gn(o, x, D), !ti(Ie(), a)), q = (x, D, H) => Ax(x, l, {
    ...s.mount ? o : st(D) ? a : Dr(x) ? { [x]: D } : D
  }, H, D), ee = (x) => el(Je(s.mount ? o : a, x, n.shouldUnregister ? Je(a, x, []) : [])), ve = (x, D, H = {}) => {
    const Y = Je(i, x);
    let R = D;
    if (Y) {
      const z = Y._f;
      z && (!z.disabled && Gn(o, x, Mx(D, z)), R = ws(z.ref) && Bt(D) ? "" : D, Lx(z.ref) ? [...z.ref.options].forEach((ie) => ie.selected = R.includes(ie.value)) : z.refs ? _o(z.ref) ? z.refs.length > 1 ? z.refs.forEach((ie) => (!ie.defaultChecked || !ie.disabled) && (ie.checked = Array.isArray(R) ? !!R.find((ue) => ue === ie.value) : R === ie.value)) : z.refs[0] && (z.refs[0].checked = !!R) : z.refs.forEach((ie) => ie.checked = ie.value === R) : op(z.ref) ? z.ref.value = "" : (z.ref.value = R, z.ref.type || h.state.next({
        name: x,
        values: Ct(o)
      })));
    }
    (H.shouldDirty || H.shouldTouch) && U(x, R, H.shouldTouch, H.shouldDirty, !0), H.shouldValidate && be(x);
  }, de = (x, D, H) => {
    for (const Y in D) {
      const R = D[Y], z = `${x}.${Y}`, ie = Je(i, z);
      (l.array.has(x) || ut(R) || ie && !ie._f) && !hi(R) ? de(z, R, H) : ve(z, R, H);
    }
  }, le = (x, D, H = {}) => {
    const Y = Je(i, x), R = l.array.has(x), z = Ct(D);
    Gn(o, x, z), R ? (h.array.next({
      name: x,
      values: Ct(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && H.shouldDirty && h.state.next({
      name: x,
      dirtyFields: ka(a, o),
      isDirty: O(x, z)
    })) : Y && !Y._f && !Bt(z) ? de(x, z, H) : ve(x, z, H), Xf(x, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? x : void 0,
      values: Ct(o)
    });
  }, pe = async (x) => {
    s.mount = !0;
    const D = x.target;
    let H = D.name, Y = !0;
    const R = Je(i, H), z = (ie) => {
      Y = Number.isNaN(ie) || hi(ie) && isNaN(ie.getTime()) || ti(ie, Je(o, H, ie));
    };
    if (R) {
      let ie, ue;
      const Se = D.type ? Yf(R._f) : $x(x), nn = x.type === js.BLUR || x.type === js.FOCUS_OUT, pn = !hC(R._f) && !n.resolver && !Je(r.errors, H) && !R._f.deps || vC(nn, Je(r.touchedFields, H), r.isSubmitted, C, g), tn = Xf(H, l, nn);
      Gn(o, H, Se), nn ? (R._f.onBlur && R._f.onBlur(x), d && d(0)) : R._f.onChange && R._f.onChange(x);
      const ln = U(H, Se, nn), mn = !zt(ln) || tn;
      if (!nn && h.state.next({
        name: H,
        type: x.type,
        values: Ct(o)
      }), pn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? nn && w() : nn || w()), mn && h.state.next({ name: H, ...tn ? {} : ln });
      if (!nn && tn && h.state.next({ ...r }), n.resolver) {
        const { errors: cn } = await X([H]);
        if (z(Se), Y) {
          const xn = Zf(r.errors, i, H), en = Zf(cn, i, xn.name || H);
          ie = en.error, H = en.name, ue = zt(cn);
        }
      } else
        y([H], !0), ie = (await nh(R, l.disabled, o, S, n.shouldUseNativeValidation))[H], y([H]), z(Se), Y && (ie ? ue = !1 : (u.isValid || f.isValid) && (ue = await J(i, !0)));
      Y && (R._f.deps && be(R._f.deps), Q(H, ue, ie, ln));
    }
  }, W = (x, D) => {
    if (Je(r.errors, D) && x.focus)
      return x.focus(), 1;
  }, be = async (x, D = {}) => {
    let H, Y;
    const R = eo(x);
    if (n.resolver) {
      const z = await ae(st(x) ? x : R);
      H = zt(z), Y = x ? !R.some((ie) => Je(z, ie)) : H;
    } else x ? (Y = (await Promise.all(R.map(async (z) => {
      const ie = Je(i, z);
      return await J(ie && ie._f ? { [z]: ie } : ie);
    }))).every(Boolean), !(!Y && !r.isValid) && w()) : Y = H = await J(i);
    return h.state.next({
      ...!Dr(x) || (u.isValid || f.isValid) && H !== r.isValid ? {} : { name: x },
      ...n.resolver || !x ? { isValid: H } : {},
      errors: r.errors
    }), D.shouldFocus && !Y && no(i, W, x ? R : l.mount), Y;
  }, Ie = (x) => {
    const D = {
      ...s.mount ? o : a
    };
    return st(x) ? D : Dr(x) ? Je(D, x) : x.map((H) => Je(D, H));
  }, G = (x, D) => ({
    invalid: !!Je((D || r).errors, x),
    isDirty: !!Je((D || r).dirtyFields, x),
    error: Je((D || r).errors, x),
    isValidating: !!Je(r.validatingFields, x),
    isTouched: !!Je((D || r).touchedFields, x)
  }), He = (x) => {
    x && eo(x).forEach((D) => vt(r.errors, D)), h.state.next({
      errors: x ? r.errors : {}
    });
  }, qe = (x, D, H) => {
    const Y = (Je(i, x, { _f: {} })._f || {}).ref, R = Je(r.errors, x) || {}, { ref: z, message: ie, type: ue, ...Se } = R;
    Gn(r.errors, x, {
      ...Se,
      ...D,
      ref: Y
    }), h.state.next({
      name: x,
      errors: r.errors,
      isValid: !1
    }), H && H.shouldFocus && Y && Y.focus && Y.focus();
  }, Oe = (x, D) => kr(x) ? h.state.subscribe({
    next: (H) => x(q(void 0, D), H)
  }) : q(x, D, !0), Be = (x) => h.state.subscribe({
    next: (D) => {
      gC(x.name, D.name, x.exact) && yC(D, x.formState || u, Pe, x.reRenderRoot) && x.callback({
        values: { ...o },
        ...r,
        ...D
      });
    }
  }).unsubscribe, $e = (x) => (s.mount = !0, f = {
    ...f,
    ...x.formState
  }, Be({
    ...x,
    formState: f
  })), Ue = (x, D = {}) => {
    for (const H of x ? eo(x) : l.mount)
      l.mount.delete(H), l.array.delete(H), D.keepValue || (vt(i, H), vt(o, H)), !D.keepError && vt(r.errors, H), !D.keepDirty && vt(r.dirtyFields, H), !D.keepTouched && vt(r.touchedFields, H), !D.keepIsValidating && vt(r.validatingFields, H), !n.shouldUnregister && !D.keepDefaultValue && vt(a, H);
    h.state.next({
      values: Ct(o)
    }), h.state.next({
      ...r,
      ...D.keepDirty ? { isDirty: O() } : {}
    }), !D.keepIsValid && w();
  }, Re = ({ disabled: x, name: D }) => {
    (rr(x) && s.mount || x || l.disabled.has(D)) && (x ? l.disabled.add(D) : l.disabled.delete(D));
  }, an = (x, D = {}) => {
    let H = Je(i, x);
    const Y = rr(D.disabled) || rr(n.disabled);
    return Gn(i, x, {
      ...H || {},
      _f: {
        ...H && H._f ? H._f : { ref: { name: x } },
        name: x,
        mount: !0,
        ...D
      }
    }), l.mount.add(x), H ? Re({
      disabled: rr(D.disabled) ? D.disabled : n.disabled,
      name: x
    }) : $(x, !0, D.value), {
      ...Y ? { disabled: D.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!D.required,
        min: ba(D.min),
        max: ba(D.max),
        minLength: ba(D.minLength),
        maxLength: ba(D.maxLength),
        pattern: ba(D.pattern)
      } : {},
      name: x,
      onChange: pe,
      onBlur: pe,
      ref: (R) => {
        if (R) {
          an(x, D), H = Je(i, x);
          const z = st(R.value) && R.querySelectorAll && R.querySelectorAll("input,select,textarea")[0] || R, ie = dC(z), ue = H._f.refs || [];
          if (ie ? ue.find((Se) => Se === z) : z === H._f.ref)
            return;
          Gn(i, x, {
            _f: {
              ...H._f,
              ...ie ? {
                refs: [
                  ...ue.filter(Cl),
                  z,
                  ...Array.isArray(Je(a, x)) ? [{}] : []
                ],
                ref: { type: z.type, name: x }
              } : { ref: z }
            }
          }), $(x, !1, void 0, z);
        } else
          H = Je(i, x, {}), H._f && (H._f.mount = !1), (n.shouldUnregister || D.shouldUnregister) && !(Dx(l.array, x) && s.action) && l.unMount.add(x);
      }
    };
  }, Ee = () => n.shouldFocusError && no(i, W, l.mount), Ke = (x) => {
    rr(x) && (h.state.next({ disabled: x }), no(i, (D, H) => {
      const Y = Je(i, H);
      Y && (D.disabled = Y._f.disabled || x, Array.isArray(Y._f.refs) && Y._f.refs.forEach((R) => {
        R.disabled = Y._f.disabled || x;
      }));
    }, 0, !1));
  }, Qe = (x, D) => async (H) => {
    let Y;
    H && (H.preventDefault && H.preventDefault(), H.persist && H.persist());
    let R = Ct(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: z, values: ie } = await X();
      r.errors = z, R = ie;
    } else
      await J(i);
    if (l.disabled.size)
      for (const z of l.disabled)
        Gn(R, z, void 0);
    if (vt(r.errors, "root"), zt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await x(R, H);
      } catch (z) {
        Y = z;
      }
    } else
      D && await D({ ...r.errors }, H), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: zt(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, fe = (x, D = {}) => {
    Je(i, x) && (st(D.defaultValue) ? le(x, Ct(Je(a, x))) : (le(x, D.defaultValue), Gn(a, x, Ct(D.defaultValue))), D.keepTouched || vt(r.touchedFields, x), D.keepDirty || (vt(r.dirtyFields, x), r.isDirty = D.defaultValue ? O(x, Ct(Je(a, x))) : O()), D.keepError || (vt(r.errors, x), u.isValid && w()), h.state.next({ ...r }));
  }, ye = (x, D = {}) => {
    const H = x ? Ct(x) : a, Y = Ct(H), R = zt(x), z = R ? a : Y;
    if (D.keepDefaultValues || (a = H), !D.keepValues) {
      if (D.keepDirtyValues) {
        const ie = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(ka(a, o))
        ]);
        for (const ue of Array.from(ie))
          Je(r.dirtyFields, ue) ? Gn(z, ue, Je(o, ue)) : le(ue, Je(z, ue));
      } else {
        if (tp && st(x))
          for (const ie of l.mount) {
            const ue = Je(i, ie);
            if (ue && ue._f) {
              const Se = Array.isArray(ue._f.refs) ? ue._f.refs[0] : ue._f.ref;
              if (ws(Se)) {
                const nn = Se.closest("form");
                if (nn) {
                  nn.reset();
                  break;
                }
              }
            }
          }
        for (const ie of l.mount)
          le(ie, Je(z, ie));
      }
      o = Ct(z), h.array.next({
        values: { ...z }
      }), h.state.next({
        values: { ...z }
      });
    }
    l = {
      mount: D.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!D.keepIsValid || !!D.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: D.keepSubmitCount ? r.submitCount : 0,
      isDirty: R ? !1 : D.keepDirty ? r.isDirty : !!(D.keepDefaultValues && !ti(x, a)),
      isSubmitted: D.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: R ? {} : D.keepDirtyValues ? D.keepDefaultValues && o ? ka(a, o) : r.dirtyFields : D.keepDefaultValues && x ? ka(a, x) : D.keepDirty ? r.dirtyFields : {},
      touchedFields: D.keepTouched ? r.touchedFields : {},
      errors: D.keepErrors ? r.errors : {},
      isSubmitSuccessful: D.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, De = (x, D) => ye(kr(x) ? x(o) : x, D), Ve = (x, D = {}) => {
    const H = Je(i, x), Y = H && H._f;
    if (Y) {
      const R = Y.refs ? Y.refs[0] : Y.ref;
      R.focus && (R.focus(), D.shouldSelect && kr(R.select) && R.select());
    }
  }, Pe = (x) => {
    r = {
      ...r,
      ...x
    };
  }, E = {
    control: {
      register: an,
      unregister: Ue,
      getFieldState: G,
      handleSubmit: Qe,
      setError: qe,
      _subscribe: Be,
      _runSchema: X,
      _getWatch: q,
      _getDirty: O,
      _setValid: w,
      _setFieldArray: V,
      _setDisabledField: Re,
      _setErrors: F,
      _getFieldArray: ee,
      _reset: ye,
      _resetDefaultValues: () => kr(n.defaultValues) && n.defaultValues().then((x) => {
        De(x, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ke,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(x) {
        s = x;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(x) {
        l = x;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(x) {
        n = {
          ...n,
          ...x
        };
      }
    },
    subscribe: $e,
    trigger: be,
    register: an,
    handleSubmit: Qe,
    watch: Oe,
    setValue: le,
    getValues: Ie,
    reset: De,
    resetField: fe,
    clearErrors: He,
    unregister: Ue,
    setError: qe,
    setFocus: Ve,
    getFieldState: G
  };
  return {
    ...E,
    formControl: E
  };
}
function St(e = {}) {
  const n = Fe.useRef(void 0), r = Fe.useRef(void 0), [i, a] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: kr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: kr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : _C(e),
    formState: i
  }, e.formControl && e.defaultValues && !kr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Fe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Fe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Fe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Fe.useEffect(() => {
    e.values && !ti(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Fe.useEffect(() => {
    e.errors && !zt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Fe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Fe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Px(i, o), n.current;
}
var Ro = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Fl = { exports: {} }, xa = {}, th;
function SC() {
  if (th) return xa;
  th = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return xa.Fragment = r, xa.jsx = s, xa.jsxs = s, xa;
}
var Oo = {}, rh;
function NC() {
  return rh || (rh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Oo.Fragment = i, Oo.jsx = Rn, Oo.jsxs = Mn;
  })()), Oo;
}
var ih;
function jC() {
  return ih || (ih = 1, process.env.NODE_ENV === "production" ? Fl.exports = SC() : Fl.exports = NC()), Fl.exports;
}
var bi = jC();
function wC(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Il, ah;
function ai() {
  if (ah) return Il;
  ah = 1;
  var e = Array.isArray;
  return Il = e, Il;
}
var El, oh;
function Hx() {
  if (oh) return El;
  oh = 1;
  var e = typeof Ro == "object" && Ro && Ro.Object === Object && Ro;
  return El = e, El;
}
var Tl, sh;
function Vr() {
  if (sh) return Tl;
  sh = 1;
  var e = Hx(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Tl = r, Tl;
}
var $l, lh;
function So() {
  if (lh) return $l;
  lh = 1;
  var e = Vr(), n = e.Symbol;
  return $l = n, $l;
}
var Dl, ch;
function CC() {
  if (ch) return Dl;
  ch = 1;
  var e = So(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Dl = o, Dl;
}
var Rl, dh;
function FC() {
  if (dh) return Rl;
  dh = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Rl = r, Rl;
}
var Ol, uh;
function la() {
  if (uh) return Ol;
  uh = 1;
  var e = So(), n = CC(), r = FC(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Ol = s, Ol;
}
var Pl, mh;
function ji() {
  if (mh) return Pl;
  mh = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Pl = e, Pl;
}
var Al, ph;
function lp() {
  if (ph) return Al;
  ph = 1;
  var e = la(), n = ji(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Al = i, Al;
}
var Ll, fh;
function IC() {
  if (fh) return Ll;
  fh = 1;
  var e = ai(), n = lp(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Ll = a, Ll;
}
var Vl, hh;
function ca() {
  if (hh) return Vl;
  hh = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Vl = e, Vl;
}
var zl, yh;
function Wx() {
  if (yh) return zl;
  yh = 1;
  var e = la(), n = ca(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return zl = s, zl;
}
var Ul, gh;
function EC() {
  if (gh) return Ul;
  gh = 1;
  var e = Vr(), n = e["__core-js_shared__"];
  return Ul = n, Ul;
}
var Ml, vh;
function TC() {
  if (vh) return Ml;
  vh = 1;
  var e = EC(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Ml = r, Ml;
}
var Bl, kh;
function Kx() {
  if (kh) return Bl;
  kh = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Bl = r, Bl;
}
var ql, bh;
function $C() {
  if (bh) return ql;
  bh = 1;
  var e = Wx(), n = TC(), r = ca(), i = Kx(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var g = e(h) ? u : o;
    return g.test(i(h));
  }
  return ql = f, ql;
}
var Hl, xh;
function DC() {
  if (xh) return Hl;
  xh = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Hl = e, Hl;
}
var Wl, _h;
function wi() {
  if (_h) return Wl;
  _h = 1;
  var e = $C(), n = DC();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Wl = r, Wl;
}
var Kl, Sh;
function nl() {
  if (Sh) return Kl;
  Sh = 1;
  var e = wi(), n = e(Object, "create");
  return Kl = n, Kl;
}
var Gl, Nh;
function RC() {
  if (Nh) return Gl;
  Nh = 1;
  var e = nl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Gl = n, Gl;
}
var Yl, jh;
function OC() {
  if (jh) return Yl;
  jh = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Yl = e, Yl;
}
var Ql, wh;
function PC() {
  if (wh) return Ql;
  wh = 1;
  var e = nl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Ql = a, Ql;
}
var Jl, Ch;
function AC() {
  if (Ch) return Jl;
  Ch = 1;
  var e = nl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Jl = i, Jl;
}
var Xl, Fh;
function LC() {
  if (Fh) return Xl;
  Fh = 1;
  var e = nl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Xl = r, Xl;
}
var Zl, Ih;
function VC() {
  if (Ih) return Zl;
  Ih = 1;
  var e = RC(), n = OC(), r = PC(), i = AC(), a = LC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Zl = o, Zl;
}
var ec, Eh;
function zC() {
  if (Eh) return ec;
  Eh = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return ec = e, ec;
}
var nc, Th;
function Gx() {
  if (Th) return nc;
  Th = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return nc = e, nc;
}
var tc, $h;
function tl() {
  if ($h) return tc;
  $h = 1;
  var e = Gx();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return tc = n, tc;
}
var rc, Dh;
function UC() {
  if (Dh) return rc;
  Dh = 1;
  var e = tl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return rc = i, rc;
}
var ic, Rh;
function MC() {
  if (Rh) return ic;
  Rh = 1;
  var e = tl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return ic = n, ic;
}
var ac, Oh;
function BC() {
  if (Oh) return ac;
  Oh = 1;
  var e = tl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return ac = n, ac;
}
var oc, Ph;
function qC() {
  if (Ph) return oc;
  Ph = 1;
  var e = tl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return oc = n, oc;
}
var sc, Ah;
function rl() {
  if (Ah) return sc;
  Ah = 1;
  var e = zC(), n = UC(), r = MC(), i = BC(), a = qC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, sc = o, sc;
}
var lc, Lh;
function cp() {
  if (Lh) return lc;
  Lh = 1;
  var e = wi(), n = Vr(), r = e(n, "Map");
  return lc = r, lc;
}
var cc, Vh;
function HC() {
  if (Vh) return cc;
  Vh = 1;
  var e = VC(), n = rl(), r = cp();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return cc = i, cc;
}
var dc, zh;
function WC() {
  if (zh) return dc;
  zh = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return dc = e, dc;
}
var uc, Uh;
function il() {
  if (Uh) return uc;
  Uh = 1;
  var e = WC();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return uc = n, uc;
}
var mc, Mh;
function KC() {
  if (Mh) return mc;
  Mh = 1;
  var e = il();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return mc = n, mc;
}
var pc, Bh;
function GC() {
  if (Bh) return pc;
  Bh = 1;
  var e = il();
  function n(r) {
    return e(this, r).get(r);
  }
  return pc = n, pc;
}
var fc, qh;
function YC() {
  if (qh) return fc;
  qh = 1;
  var e = il();
  function n(r) {
    return e(this, r).has(r);
  }
  return fc = n, fc;
}
var hc, Hh;
function QC() {
  if (Hh) return hc;
  Hh = 1;
  var e = il();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return hc = n, hc;
}
var yc, Wh;
function Yx() {
  if (Wh) return yc;
  Wh = 1;
  var e = HC(), n = KC(), r = GC(), i = YC(), a = QC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, yc = o, yc;
}
var gc, Kh;
function JC() {
  if (Kh) return gc;
  Kh = 1;
  var e = Yx(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, gc = r, gc;
}
var vc, Gh;
function XC() {
  if (Gh) return vc;
  Gh = 1;
  var e = JC(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return vc = r, vc;
}
var kc, Yh;
function ZC() {
  if (Yh) return kc;
  Yh = 1;
  var e = XC(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return kc = i, kc;
}
var bc, Qh;
function Qx() {
  if (Qh) return bc;
  Qh = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return bc = e, bc;
}
var xc, Jh;
function e1() {
  if (Jh) return xc;
  Jh = 1;
  var e = So(), n = Qx(), r = ai(), i = lp(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return xc = s, xc;
}
var _c, Xh;
function n1() {
  if (Xh) return _c;
  Xh = 1;
  var e = e1();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return _c = n, _c;
}
var Sc, Zh;
function da() {
  if (Zh) return Sc;
  Zh = 1;
  var e = ai(), n = IC(), r = ZC(), i = n1();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Sc = a, Sc;
}
var Nc, ey;
function al() {
  if (ey) return Nc;
  ey = 1;
  var e = lp();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Nc = n, Nc;
}
var jc, ny;
function Jx() {
  if (ny) return jc;
  ny = 1;
  var e = da(), n = al();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return jc = r, jc;
}
var wc, ty;
function Xx() {
  if (ty) return wc;
  ty = 1;
  var e = wi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return wc = n, wc;
}
var Cc, ry;
function Zx() {
  if (ry) return Cc;
  ry = 1;
  var e = Xx();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Cc = n, Cc;
}
var Fc, iy;
function dp() {
  if (iy) return Fc;
  iy = 1;
  var e = Zx(), n = Gx(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Fc = a, Fc;
}
var Ic, ay;
function up() {
  if (ay) return Ic;
  ay = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Ic = r, Ic;
}
var Ec, oy;
function t1() {
  if (oy) return Ec;
  oy = 1;
  var e = dp(), n = da(), r = up(), i = ca(), a = al();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, g = s; g != null && ++u < f; ) {
      var C = a(l[u]), S = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var N = g[C];
        S = m ? m(N, C, g) : void 0, S === void 0 && (S = i(N) ? N : r(l[u + 1]) ? [] : {});
      }
      e(g, C, S), g = g[C];
    }
    return s;
  }
  return Ec = o, Ec;
}
var Tc, sy;
function r1() {
  if (sy) return Tc;
  sy = 1;
  var e = Jx(), n = t1(), r = da();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Tc = i, Tc;
}
var $c, ly;
function i1() {
  if (ly) return $c;
  ly = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return $c = e, $c;
}
var Dc, cy;
function a1() {
  if (cy) return Dc;
  cy = 1;
  var e = la(), n = ji(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Dc = i, Dc;
}
var Rc, dy;
function mp() {
  if (dy) return Rc;
  dy = 1;
  var e = a1(), n = ji(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Rc = o, Rc;
}
var Oc, uy;
function pp() {
  if (uy) return Oc;
  uy = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Oc = n, Oc;
}
var Pc, my;
function o1() {
  if (my) return Pc;
  my = 1;
  var e = da(), n = mp(), r = ai(), i = up(), a = pp(), o = al();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var g = o(d[u]);
      if (!(h = l != null && m(l, g)))
        break;
      l = l[g];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(g, f) && (r(l) || n(l)));
  }
  return Pc = s, Pc;
}
var Ac, py;
function s1() {
  if (py) return Ac;
  py = 1;
  var e = i1(), n = o1();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Ac = r, Ac;
}
var Lc, fy;
function l1() {
  if (fy) return Lc;
  fy = 1;
  var e = r1(), n = s1();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Lc = r, Lc;
}
var Vc, hy;
function fp() {
  if (hy) return Vc;
  hy = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Vc = e, Vc;
}
var zc, yy;
function c1() {
  if (yy) return zc;
  yy = 1;
  var e = So(), n = mp(), r = ai(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return zc = a, zc;
}
var Uc, gy;
function d1() {
  if (gy) return Uc;
  gy = 1;
  var e = fp(), n = c1();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Uc = r, Uc;
}
var Mc, vy;
function u1() {
  if (vy) return Mc;
  vy = 1;
  var e = d1();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Mc = n, Mc;
}
var Bc, ky;
function m1() {
  if (ky) return Bc;
  ky = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Bc = e, Bc;
}
var qc, by;
function p1() {
  if (by) return qc;
  by = 1;
  var e = m1(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return qc = r, qc;
}
var Hc, xy;
function f1() {
  if (xy) return Hc;
  xy = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Hc = e, Hc;
}
var Wc, _y;
function e_() {
  if (_y) return Wc;
  _y = 1;
  function e(n) {
    return n;
  }
  return Wc = e, Wc;
}
var Kc, Sy;
function h1() {
  if (Sy) return Kc;
  Sy = 1;
  var e = f1(), n = Xx(), r = e_(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Kc = i, Kc;
}
var Gc, Ny;
function y1() {
  if (Ny) return Gc;
  Ny = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Gc = i, Gc;
}
var Yc, jy;
function g1() {
  if (jy) return Yc;
  jy = 1;
  var e = h1(), n = y1(), r = n(e);
  return Yc = r, Yc;
}
var Qc, wy;
function n_() {
  if (wy) return Qc;
  wy = 1;
  var e = u1(), n = p1(), r = g1();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Qc = i, Qc;
}
var Jc, Cy;
function v1() {
  if (Cy) return Jc;
  Cy = 1;
  var e = l1(), n = n_(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Jc = r, Jc;
}
var k1 = v1();
const t_ = /* @__PURE__ */ qx(k1), b1 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function r_(e) {
  const n = t_(e, b1);
  return {
    controller: ap(n),
    controllerProps: n
  };
}
const x1 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function i_(e) {
  const { controller: n, controllerProps: r } = r_(e), i = {
    ...t_(e, x1),
    required: wC(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Xc, Fy;
function _1() {
  if (Fy) return Xc;
  Fy = 1;
  var e = rl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Xc = n, Xc;
}
var Zc, Iy;
function S1() {
  if (Iy) return Zc;
  Iy = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Zc = e, Zc;
}
var ed, Ey;
function N1() {
  if (Ey) return ed;
  Ey = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return ed = e, ed;
}
var nd, Ty;
function j1() {
  if (Ty) return nd;
  Ty = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return nd = e, nd;
}
var td, $y;
function w1() {
  if ($y) return td;
  $y = 1;
  var e = rl(), n = cp(), r = Yx(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return td = a, td;
}
var rd, Dy;
function C1() {
  if (Dy) return rd;
  Dy = 1;
  var e = rl(), n = _1(), r = S1(), i = N1(), a = j1(), o = w1();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, rd = s, rd;
}
var id, Ry;
function F1() {
  if (Ry) return id;
  Ry = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return id = e, id;
}
var ad, Oy;
function No() {
  if (Oy) return ad;
  Oy = 1;
  var e = dp(), n = Zx();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return ad = r, ad;
}
var od, Py;
function I1() {
  if (Py) return od;
  Py = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return od = e, od;
}
var fs = { exports: {} }, sd, Ay;
function E1() {
  if (Ay) return sd;
  Ay = 1;
  function e() {
    return !1;
  }
  return sd = e, sd;
}
fs.exports;
var Ly;
function a_() {
  return Ly || (Ly = 1, (function(e, n) {
    var r = Vr(), i = E1(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(fs, fs.exports)), fs.exports;
}
var ld, Vy;
function T1() {
  if (Vy) return ld;
  Vy = 1;
  var e = la(), n = pp(), r = ji(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", g = "[object Set]", C = "[object String]", S = "[object WeakMap]", N = "[object ArrayBuffer]", w = "[object DataView]", y = "[object Float32Array]", V = "[object Float64Array]", T = "[object Int8Array]", F = "[object Int16Array]", $ = "[object Int32Array]", U = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", X = "[object Uint16Array]", ae = "[object Uint32Array]", J = {};
  J[y] = J[V] = J[T] = J[F] = J[$] = J[U] = J[Q] = J[X] = J[ae] = !0, J[i] = J[a] = J[N] = J[o] = J[w] = J[s] = J[l] = J[d] = J[m] = J[u] = J[f] = J[h] = J[g] = J[C] = J[S] = !1;
  function B(O) {
    return r(O) && n(O.length) && !!J[e(O)];
  }
  return ld = B, ld;
}
var cd, zy;
function hp() {
  if (zy) return cd;
  zy = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return cd = e, cd;
}
var hs = { exports: {} };
hs.exports;
var Uy;
function yp() {
  return Uy || (Uy = 1, (function(e, n) {
    var r = Hx(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(hs, hs.exports)), hs.exports;
}
var dd, My;
function $1() {
  if (My) return dd;
  My = 1;
  var e = T1(), n = hp(), r = yp(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return dd = a, dd;
}
var ud, By;
function o_() {
  if (By) return ud;
  By = 1;
  var e = I1(), n = mp(), r = ai(), i = a_(), a = up(), o = $1(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), g = !f && !h && i(m), C = !f && !h && !g && o(m), S = f || h || g || C, N = S ? e(m.length, String) : [], w = N.length;
    for (var y in m)
      (u || l.call(m, y)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      g && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, w))) && N.push(y);
    return N;
  }
  return ud = d, ud;
}
var md, qy;
function gp() {
  if (qy) return md;
  qy = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return md = n, md;
}
var pd, Hy;
function s_() {
  if (Hy) return pd;
  Hy = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return pd = e, pd;
}
var fd, Wy;
function D1() {
  if (Wy) return fd;
  Wy = 1;
  var e = s_(), n = e(Object.keys, Object);
  return fd = n, fd;
}
var hd, Ky;
function R1() {
  if (Ky) return hd;
  Ky = 1;
  var e = gp(), n = D1(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return hd = a, hd;
}
var yd, Gy;
function l_() {
  if (Gy) return yd;
  Gy = 1;
  var e = Wx(), n = pp();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return yd = r, yd;
}
var gd, Yy;
function vp() {
  if (Yy) return gd;
  Yy = 1;
  var e = o_(), n = R1(), r = l_();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return gd = i, gd;
}
var vd, Qy;
function O1() {
  if (Qy) return vd;
  Qy = 1;
  var e = No(), n = vp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return vd = r, vd;
}
var kd, Jy;
function P1() {
  if (Jy) return kd;
  Jy = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return kd = e, kd;
}
var bd, Xy;
function A1() {
  if (Xy) return bd;
  Xy = 1;
  var e = ca(), n = gp(), r = P1(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return bd = o, bd;
}
var xd, Zy;
function kp() {
  if (Zy) return xd;
  Zy = 1;
  var e = o_(), n = A1(), r = l_();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return xd = i, xd;
}
var _d, eg;
function L1() {
  if (eg) return _d;
  eg = 1;
  var e = No(), n = kp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return _d = r, _d;
}
var ys = { exports: {} };
ys.exports;
var ng;
function V1() {
  return ng || (ng = 1, (function(e, n) {
    var r = Vr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(ys, ys.exports)), ys.exports;
}
var Sd, tg;
function z1() {
  if (tg) return Sd;
  tg = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Sd = e, Sd;
}
var Nd, rg;
function U1() {
  if (rg) return Nd;
  rg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Nd = e, Nd;
}
var jd, ig;
function c_() {
  if (ig) return jd;
  ig = 1;
  function e() {
    return [];
  }
  return jd = e, jd;
}
var wd, ag;
function bp() {
  if (ag) return wd;
  ag = 1;
  var e = U1(), n = c_(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return wd = o, wd;
}
var Cd, og;
function M1() {
  if (og) return Cd;
  og = 1;
  var e = No(), n = bp();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Cd = r, Cd;
}
var Fd, sg;
function xp() {
  if (sg) return Fd;
  sg = 1;
  var e = s_(), n = e(Object.getPrototypeOf, Object);
  return Fd = n, Fd;
}
var Id, lg;
function d_() {
  if (lg) return Id;
  lg = 1;
  var e = fp(), n = xp(), r = bp(), i = c_(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Id = o, Id;
}
var Ed, cg;
function B1() {
  if (cg) return Ed;
  cg = 1;
  var e = No(), n = d_();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Ed = r, Ed;
}
var Td, dg;
function u_() {
  if (dg) return Td;
  dg = 1;
  var e = fp(), n = ai();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Td = r, Td;
}
var $d, ug;
function q1() {
  if (ug) return $d;
  ug = 1;
  var e = u_(), n = bp(), r = vp();
  function i(a) {
    return e(a, r, n);
  }
  return $d = i, $d;
}
var Dd, mg;
function m_() {
  if (mg) return Dd;
  mg = 1;
  var e = u_(), n = d_(), r = kp();
  function i(a) {
    return e(a, r, n);
  }
  return Dd = i, Dd;
}
var Rd, pg;
function H1() {
  if (pg) return Rd;
  pg = 1;
  var e = wi(), n = Vr(), r = e(n, "DataView");
  return Rd = r, Rd;
}
var Od, fg;
function W1() {
  if (fg) return Od;
  fg = 1;
  var e = wi(), n = Vr(), r = e(n, "Promise");
  return Od = r, Od;
}
var Pd, hg;
function K1() {
  if (hg) return Pd;
  hg = 1;
  var e = wi(), n = Vr(), r = e(n, "Set");
  return Pd = r, Pd;
}
var Ad, yg;
function G1() {
  if (yg) return Ad;
  yg = 1;
  var e = wi(), n = Vr(), r = e(n, "WeakMap");
  return Ad = r, Ad;
}
var Ld, gg;
function _p() {
  if (gg) return Ld;
  gg = 1;
  var e = H1(), n = cp(), r = W1(), i = K1(), a = G1(), o = la(), s = Kx(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", g = s(e), C = s(n), S = s(r), N = s(i), w = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != m || i && y(new i()) != u || a && y(new a()) != f) && (y = function(V) {
    var T = o(V), F = T == d ? V.constructor : void 0, $ = F ? s(F) : "";
    if ($)
      switch ($) {
        case g:
          return h;
        case C:
          return l;
        case S:
          return m;
        case N:
          return u;
        case w:
          return f;
      }
    return T;
  }), Ld = y, Ld;
}
var Vd, vg;
function Y1() {
  if (vg) return Vd;
  vg = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Vd = r, Vd;
}
var zd, kg;
function Q1() {
  if (kg) return zd;
  kg = 1;
  var e = Vr(), n = e.Uint8Array;
  return zd = n, zd;
}
var Ud, bg;
function Sp() {
  if (bg) return Ud;
  bg = 1;
  var e = Q1();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Ud = n, Ud;
}
var Md, xg;
function J1() {
  if (xg) return Md;
  xg = 1;
  var e = Sp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Md = n, Md;
}
var Bd, _g;
function X1() {
  if (_g) return Bd;
  _g = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Bd = n, Bd;
}
var qd, Sg;
function Z1() {
  if (Sg) return qd;
  Sg = 1;
  var e = So(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return qd = i, qd;
}
var Hd, Ng;
function eF() {
  if (Ng) return Hd;
  Ng = 1;
  var e = Sp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Hd = n, Hd;
}
var Wd, jg;
function nF() {
  if (jg) return Wd;
  jg = 1;
  var e = Sp(), n = J1(), r = X1(), i = Z1(), a = eF(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", g = "[object ArrayBuffer]", C = "[object DataView]", S = "[object Float32Array]", N = "[object Float64Array]", w = "[object Int8Array]", y = "[object Int16Array]", V = "[object Int32Array]", T = "[object Uint8Array]", F = "[object Uint8ClampedArray]", $ = "[object Uint16Array]", U = "[object Uint32Array]";
  function Q(X, ae, J) {
    var B = X.constructor;
    switch (ae) {
      case g:
        return e(X);
      case o:
      case s:
        return new B(+X);
      case C:
        return n(X, J);
      case S:
      case N:
      case w:
      case y:
      case V:
      case T:
      case F:
      case $:
      case U:
        return a(X, J);
      case l:
        return new B();
      case d:
      case f:
        return new B(X);
      case m:
        return r(X);
      case u:
        return new B();
      case h:
        return i(X);
    }
  }
  return Wd = Q, Wd;
}
var Kd, wg;
function tF() {
  if (wg) return Kd;
  wg = 1;
  var e = ca(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Kd = r, Kd;
}
var Gd, Cg;
function rF() {
  if (Cg) return Gd;
  Cg = 1;
  var e = tF(), n = xp(), r = gp();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Gd = i, Gd;
}
var Yd, Fg;
function iF() {
  if (Fg) return Yd;
  Fg = 1;
  var e = _p(), n = ji(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Yd = i, Yd;
}
var Qd, Ig;
function aF() {
  if (Ig) return Qd;
  Ig = 1;
  var e = iF(), n = hp(), r = yp(), i = r && r.isMap, a = i ? n(i) : e;
  return Qd = a, Qd;
}
var Jd, Eg;
function oF() {
  if (Eg) return Jd;
  Eg = 1;
  var e = _p(), n = ji(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Jd = i, Jd;
}
var Xd, Tg;
function sF() {
  if (Tg) return Xd;
  Tg = 1;
  var e = oF(), n = hp(), r = yp(), i = r && r.isSet, a = i ? n(i) : e;
  return Xd = a, Xd;
}
var Zd, $g;
function lF() {
  if ($g) return Zd;
  $g = 1;
  var e = C1(), n = F1(), r = dp(), i = O1(), a = L1(), o = V1(), s = z1(), l = M1(), d = B1(), m = q1(), u = m_(), f = _p(), h = Y1(), g = nF(), C = rF(), S = ai(), N = a_(), w = aF(), y = ca(), V = sF(), T = vp(), F = kp(), $ = 1, U = 2, Q = 4, X = "[object Arguments]", ae = "[object Array]", J = "[object Boolean]", B = "[object Date]", O = "[object Error]", q = "[object Function]", ee = "[object GeneratorFunction]", ve = "[object Map]", de = "[object Number]", le = "[object Object]", pe = "[object RegExp]", W = "[object Set]", be = "[object String]", Ie = "[object Symbol]", G = "[object WeakMap]", He = "[object ArrayBuffer]", qe = "[object DataView]", Oe = "[object Float32Array]", Be = "[object Float64Array]", $e = "[object Int8Array]", Ue = "[object Int16Array]", Re = "[object Int32Array]", an = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Ke = "[object Uint16Array]", Qe = "[object Uint32Array]", fe = {};
  fe[X] = fe[ae] = fe[He] = fe[qe] = fe[J] = fe[B] = fe[Oe] = fe[Be] = fe[$e] = fe[Ue] = fe[Re] = fe[ve] = fe[de] = fe[le] = fe[pe] = fe[W] = fe[be] = fe[Ie] = fe[an] = fe[Ee] = fe[Ke] = fe[Qe] = !0, fe[O] = fe[q] = fe[G] = !1;
  function ye(De, Ve, Pe, un, E, x) {
    var D, H = Ve & $, Y = Ve & U, R = Ve & Q;
    if (Pe && (D = E ? Pe(De, un, E, x) : Pe(De)), D !== void 0)
      return D;
    if (!y(De))
      return De;
    var z = S(De);
    if (z) {
      if (D = h(De), !H)
        return s(De, D);
    } else {
      var ie = f(De), ue = ie == q || ie == ee;
      if (N(De))
        return o(De, H);
      if (ie == le || ie == X || ue && !E) {
        if (D = Y || ue ? {} : C(De), !H)
          return Y ? d(De, a(D, De)) : l(De, i(D, De));
      } else {
        if (!fe[ie])
          return E ? De : {};
        D = g(De, ie, H);
      }
    }
    x || (x = new e());
    var Se = x.get(De);
    if (Se)
      return Se;
    x.set(De, D), V(De) ? De.forEach(function(tn) {
      D.add(ye(tn, Ve, Pe, tn, De, x));
    }) : w(De) && De.forEach(function(tn, ln) {
      D.set(ln, ye(tn, Ve, Pe, ln, De, x));
    });
    var nn = R ? Y ? u : m : Y ? F : T, pn = z ? void 0 : nn(De);
    return n(pn || De, function(tn, ln) {
      pn && (ln = tn, tn = De[ln]), r(D, ln, ye(tn, Ve, Pe, ln, De, x));
    }), D;
  }
  return Zd = ye, Zd;
}
var eu, Dg;
function cF() {
  if (Dg) return eu;
  Dg = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return eu = e, eu;
}
var nu, Rg;
function dF() {
  if (Rg) return nu;
  Rg = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return nu = e, nu;
}
var tu, Og;
function uF() {
  if (Og) return tu;
  Og = 1;
  var e = Jx(), n = dF();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return tu = r, tu;
}
var ru, Pg;
function mF() {
  if (Pg) return ru;
  Pg = 1;
  var e = da(), n = cF(), r = uF(), i = al(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return ru = s, ru;
}
var iu, Ag;
function pF() {
  if (Ag) return iu;
  Ag = 1;
  var e = la(), n = xp(), r = ji(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return iu = m, iu;
}
var au, Lg;
function fF() {
  if (Lg) return au;
  Lg = 1;
  var e = pF();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return au = n, au;
}
var ou, Vg;
function hF() {
  if (Vg) return ou;
  Vg = 1;
  var e = Qx(), n = lF(), r = mF(), i = da(), a = No(), o = fF(), s = n_(), l = m_(), d = 1, m = 2, u = 4, f = s(function(h, g) {
    var C = {};
    if (h == null)
      return C;
    var S = !1;
    g = e(g, function(w) {
      return w = i(w, h), S || (S = w.length > 1), w;
    }), a(h, l(h), C), S && (C = n(C, d | m | u, o));
    for (var N = g.length; N--; )
      r(C, g[N]);
    return C;
  });
  return ou = f, ou;
}
hF();
const jr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = i_(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ bi.jsx(hn, { ...a, children: /* @__PURE__ */ bi.jsx(
    ni,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: hn.getStatus(a.meta),
      children: e
    }
  ) });
};
var yF = e_();
const gF = /* @__PURE__ */ qx(yF), at = ({
  transformValue: e = gF,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = r_(a);
  return /* @__PURE__ */ bi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ bi.jsx(
      tm,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ bi.jsx(j0, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, nt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = i_(e);
  return /* @__PURE__ */ bi.jsx(hn, { ...i, children: /* @__PURE__ */ bi.jsx(
    Nr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: hn.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var su = { exports: {} }, _a = {}, zg;
function vF() {
  if (zg) return _a;
  zg = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return _a.Fragment = r, _a.jsx = s, _a.jsxs = s, _a;
}
var Po = {}, Ug;
function kF() {
  return Ug || (Ug = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Po.Fragment = i, Po.jsx = Rn, Po.jsxs = Mn;
  })()), Po;
}
var Mg;
function bF() {
  return Mg || (Mg = 1, process.env.NODE_ENV === "production" ? su.exports = vF() : su.exports = kF()), su.exports;
}
var he = bF();
const xF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, _F = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, SF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, NF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, jF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, wF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, CF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, FF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, IF = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SF,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": NF,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": jF,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": xF,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": _F,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": wF,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": CF,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": FF
};
function ua(e) {
  return IF[e] ?? {};
}
const EF = ua(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), TF = ua(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), $F = ua(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Bg = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, dr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, DF = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), qg = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, um = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ he.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ he.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ he.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ he.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ he.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ he.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ he.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ he.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ he.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ he.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ he.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ he.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function RF({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: g, showModal: C, executeQuery: S } = fn(), { track: N } = _n(), {
    loading: w,
    data: y,
    error: V,
    store: T
  } = Vm(e ?? null), F = y?.github?.issues || [], $ = y?.github?.pullRequests || [], [U, Q] = se(!1), [X, ae] = se();
  Le(
    () => h(V || X || void 0),
    [V, X]
  ), Le(
    () => {
      !w && (F?.length || $?.length) ? (a(F), s($), B(F, $)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const J = async (pe, W) => {
    await T(pe).then(() => {
      g({
        icon: "check-circle-filled",
        severity: "success",
        title: W.success.title,
        text: W.success.text
      });
    }).catch((be) => {
      g({
        title: W.error.title,
        text: `${W.error.text} ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (pe, W) => {
    if (!pe?.length && !W?.length) {
      d([]), u([]);
      return;
    }
    const be = (pe || []).map(
      (He) => S(TF, {
        owner: He.owner,
        repositoryName: He.repository,
        issueNumber: He.number
      })
    ), Ie = (W || []).map(
      (He) => S($F, {
        owner: He.owner,
        repositoryName: He.repository,
        prNumber: He.number
      })
    ), G = [...be, ...Ie];
    Q(!0), Promise.all(G).then((He) => {
      const qe = [], Oe = [];
      He.forEach((Be) => {
        const $e = Be?.data?.GitHub;
        if (!$e) {
          d([]), u([]);
          return;
        }
        Object.keys($e).forEach((Ue) => {
          if (Ue.startsWith("repository")) {
            const Re = $e[Ue];
            Object.keys(Re).forEach((an) => {
              const Ee = Re[an], Ke = {
                number: Ee?.number,
                owner: Ee?.repository?.owner?.login,
                repository: Ee?.repository?.name
              };
              an.startsWith("issue") && qe.push({
                ...Ee,
                type: "ISSUE",
                key: Ke
              }), an.startsWith("pullRequest") && Oe.push({
                ...Ee,
                type: "PR",
                key: Ke
              });
            });
          }
        });
      }), d(qe), u(Oe);
    }).catch(ae).finally(() => {
      Q(!1);
    });
  }, O = ({ key: pe, type: W }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = y && (F.length || $.length) ? y : r, Ie = W === "ISSUE" ? "issues" : "pullRequests";
    be.github[Ie] = Array.from(
      new Set(be.github[Ie]).add(pe)
    ), J(be, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${dr(
          pe
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${dr(pe)} failed. Please try again.`
      }
    });
  }, q = async ({ key: pe, type: W }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = y && (F.length || $.length) ? y : r, Ie = W === "ISSUE" ? "issues" : "pullRequests";
    be.github[Ie] = Array.from(
      new Set(be.github[Ie]).add(pe)
    ), await T(be).catch((G) => {
      g({
        title: "Linking failed",
        text: `Linking ${pe} failed. Please try again. ${G.message && " (" + G.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: pe, type: W }) => {
    N("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const be = W === "ISSUE" ? "issue" : "pull request";
    C({
      headline: `Unlink ${be} ${dr(pe)}?`,
      text: `You are about to unlink the ${be} ${dr(
        pe
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${be}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ie = W === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const G = {
          ...y,
          github: {
            ...y?.github,
            [Ie]: y?.github?.[Ie].filter(
              (He) => He.number !== pe.number || He.owner !== pe.owner || He.repository !== pe.repository
            )
          }
        };
        N("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), J(G, {
          success: {
            title: `GitHub ${be} unlinked`,
            text: `You unlinked the GitHub ${be} ${dr(
              pe
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${dr(pe)} failed.`
          }
        });
      },
      onCancel: () => {
        N("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ve = () => {
    N("github:unlink:all:clicked", {
      githubOrganization: n
    }), C({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        N("github:unlink:all:confirmed", {
          githubOrganization: n
        }), J(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        N("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, de = F.filter(
    (pe) => !i?.includes(pe)
  ) || [], le = $.filter(
    (pe) => !o?.includes(pe)
  ) || [];
  return {
    linkGithubItem: O,
    linkGithubItemQuietly: q,
    unlinkGithubItem: ee,
    loadGithubItems: B,
    removeDanglingGithubItemLinks: () => {
      const pe = {
        ...y,
        github: {
          ...y?.github,
          issues: F.filter(
            (W) => !de.includes(W)
          ) || [],
          pullRequests: $.filter(
            (W) => !le.includes(W)
          ) || []
        }
      };
      T(pe);
    },
    unlinkAllGithubItems: ve,
    isLoadingGithubItemLinks: w,
    danglingIssueLinks: de,
    danglingPullRequestLinks: le,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const OF = "_contentWrapper_1vx3c_1", PF = "_contentWrapperHeadline_1vx3c_4", AF = "_contentWrapperBody_1vx3c_11", LF = "_contentWrapperAssigneeIcon_1vx3c_15", VF = "_contentWrapperStatusTag_1vx3c_20", Mr = {
  contentWrapper: OF,
  contentWrapperHeadline: PF,
  contentWrapperBody: AF,
  contentWrapperAssigneeIcon: LF,
  contentWrapperStatusTag: VF
}, p_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
  e && /* @__PURE__ */ he.jsxs(Zn, { className: Mr.contentWrapper, children: [
    /* @__PURE__ */ he.jsx(Zn, { className: Mr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ he.jsx(Zn, { className: Mr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ he.jsxs(Zn, { className: Mr.contentWrapper, children: [
    /* @__PURE__ */ he.jsx(Zn, { className: Mr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ he.jsx(Zn, { className: Mr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ he.jsxs(Zn, { margin: "100 0", children: [
        /* @__PURE__ */ he.jsx(
          "img",
          {
            className: Mr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ he.jsx(Zn, { className: Mr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ he.jsx(
      An,
      {
        className: Mr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), zF = "_collapse_1bdjy_1", UF = "_collapseHeader_1bdjy_10", MF = "_collapseHeaderKey_1bdjy_31", BF = "_collapseHeaderKeyIcon_1bdjy_36", qF = "_collapseHeaderKeyLink_1bdjy_41", HF = "_collapseHeaderIcon_1bdjy_44", WF = "_collapseHeaderTitle_1bdjy_49", KF = "_collapseContent_1bdjy_57", GF = "_collapseContentButtonSpacer_1bdjy_60", YF = "_collapseContentButtonLink_1bdjy_63", Fr = {
  collapse: zF,
  collapseHeader: UF,
  collapseHeaderKey: MF,
  collapseHeaderKeyIcon: BF,
  collapseHeaderKeyLink: qF,
  collapseHeaderIcon: HF,
  collapseHeaderTitle: WF,
  collapseContent: KF,
  collapseContentButtonSpacer: GF,
  collapseContentButtonLink: YF
}, QF = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = _n(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ he.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: g,
      repository: C,
      type: S,
      state: N,
      assignees: w,
      labels: y
    } = d, V = a[m];
    return /* @__PURE__ */ he.jsxs(
      mr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: V,
        className: Fr.collapse,
        children: [
          /* @__PURE__ */ he.jsx(mr.Header, { className: Fr.collapseHeader, children: /* @__PURE__ */ he.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ he.jsx(Zn, { children: /* @__PURE__ */ he.jsxs(Zn, { as: "span", className: Fr.collapseHeaderKey, children: [
                  um(
                    S,
                    N,
                    Fr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ he.jsxs(
                    "a",
                    {
                      href: Bg(f),
                      className: Fr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (T) => {
                        T.stopPropagation();
                      },
                      children: [
                        dr(f),
                        /* @__PURE__ */ he.jsx(
                          me,
                          {
                            className: Fr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ he.jsx(Zn, { className: Fr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ he.jsx(mr.Content, { className: Fr.collapseContent, children: /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ he.jsx(
              p_,
              {
                description: g,
                assignees: w,
                labels: y
              }
            ),
            /* @__PURE__ */ he.jsxs(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Fr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: C?.owner.login,
                    repository: d.repository.name
                  },
                  type: S
                }),
                children: [
                  "Unlink ",
                  qg(S)
                ]
              }
            ),
            /* @__PURE__ */ he.jsxs(
              Et,
              {
                slotEnd: /* @__PURE__ */ he.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: Fr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Bg(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  qg(S),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ he.jsx(he.Fragment, {}) });
}, JF = "_result_1uaom_1", XF = "_resultName_1uaom_21", ZF = "_resultItemIcon_1uaom_29", eI = "_resultDescription_1uaom_34", nI = "_resultLinkIcon_1uaom_46", tI = "_tooltip_1uaom_55", rI = "_tooltipName_1uaom_61", iI = "_tooltipTag_1uaom_71", Br = {
  result: JF,
  resultName: XF,
  resultItemIcon: ZF,
  resultDescription: eI,
  resultLinkIcon: nI,
  tooltip: tI,
  tooltipName: rI,
  tooltipTag: iI
}, aI = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ he.jsx(
    We,
    {
      className: Br.tooltip,
      content: /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ he.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ he.jsxs(Zn, { as: "span", className: Br.tooltipName, children: [
                um(a, o, Br.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ he.jsx(An, { className: Br.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ he.jsx(
          p_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ he.jsxs(
        "button",
        {
          className: Br.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ he.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ he.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ he.jsxs(Zn, { as: "span", className: Br.resultName, children: [
                    um(a, o, Br.resultItemIcon),
                    dr(r)
                  ] }) }),
                  /* @__PURE__ */ he.jsx(Zn, { className: Br.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ he.jsx(
              me,
              {
                className: Br.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, oI = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ he.jsx(
  Et,
  {
    slotEnd: /* @__PURE__ */ he.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), Is = "[a-zA-z0-9_.-]+", f_ = "[0-9]+", sI = new RegExp(
  `(${Is})/(${Is})/(?:issues|pull)/(${f_})`,
  "i"
), Hg = new RegExp(`^${sI.source}$`), Wg = new RegExp(
  `https://github.com/(${Is})/(${Is})/(?:issues|pull)/(${f_})`,
  "i"
), lI = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Bn(() => r?.map(($) => $.id) || [], [r]), o = Bn(() => i?.map(($) => $.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = fn(), [m, u] = se(), [f, { loading: h, error: g, data: C, networkStatus: S }] = d(EF, {
    notifyOnNetworkStatusChange: !0
  });
  Ni(
    () => {
      !h && m && S === er.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), Le(() => {
    let $ = C?.GitHub?.issues?.nodes || [], U = C?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && ($ = $.filter((Q) => !a.includes(Q.id))), o.length > 0 && (U = U.filter(
      (Q) => !o.includes(Q.id)
    )), l([
      ...$.map((Q) => ({
        ...Q,
        type: "ISSUE",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      })),
      ...U.map((Q) => ({
        ...Q,
        type: "PR",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      }))
    ]);
  }, [C, a, o]);
  function N($) {
    const U = $?.trim();
    if (Hg.test(U)) {
      const [Q, X, ae, J] = U.match(Hg) || [];
      return X !== n ? void 0 : {
        owner: n,
        repository: ae,
        number: parseInt(J)
      };
    }
    if (Wg.test(U)) {
      const [Q, X, ae, J] = U.match(Wg) || [];
      return X !== n ? void 0 : {
        owner: n,
        repository: ae,
        number: parseInt(J)
      };
    }
  }
  const w = ($) => {
    e({
      key: DF($),
      type: $.type
    }), u(void 0);
  }, y = ($) => {
    const U = N($);
    u(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${$}`
    );
  }, V = () => {
    u(void 0);
  }, T = ({ className: $, searched: U }) => /* @__PURE__ */ he.jsx(
    oI,
    {
      className: $,
      searched: U,
      githubOrganization: n
    }
  ), F = ({ item: $, onSelect: U }) => /* @__PURE__ */ he.jsx(aI, { item: $, onSelect: U });
  return !h && g ? /* @__PURE__ */ he.jsx(Fn, { error: g }) : /* @__PURE__ */ he.jsx(
    wr,
    {
      items: s?.map(($) => ({ name: $.title, ...$ })),
      loading: h,
      onSearch: y,
      onSelect: w,
      onClear: V,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: T,
      itemComponent: F,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, cI = "_itemButton_3sxfy_1", dI = "_result_3sxfy_6", uI = "_resultName_3sxfy_30", mI = "_resultCheckIcon_3sxfy_38", pI = "_resultAssigneeIcon_3sxfy_41", Sa = {
  itemButton: cI,
  result: dI,
  resultName: uI,
  resultCheckIcon: mI,
  resultAssigneeIcon: pI
}, h_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ he.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ he.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Sa.itemButton,
        children: /* @__PURE__ */ he.jsxs(b, { className: Sa.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ he.jsx(Zn, { margin: "100 0", children: /* @__PURE__ */ he.jsx(
            "img",
            {
              className: Sa.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ he.jsx(Zn, { className: Sa.resultName, children: e.name }),
          n && /* @__PURE__ */ he.jsx(Zn, { className: Sa.resultCheckIcon, children: /* @__PURE__ */ he.jsx(me, { name: "done" }) })
        ] })
      }
    )
  }
), fI = ua(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), hI = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = fn(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: g, networkStatus: C }] = a(
    fI,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Ni(
    () => {
      !f && l && l.length >= m && C === er.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Le(() => {
    const S = g?.GitHub?.organization?.teams || { edges: [] }, N = [];
    S?.edges?.forEach((w) => {
      const y = w?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((V) => {
        const T = V?.node;
        T && (T?.id && N.find((F) => F.id === T.id) || N.push(T));
      });
    }), s(
      N.sort((w, y) => {
        const V = w.name?.toLowerCase() || w.login?.toLowerCase(), T = y.name?.toLowerCase() || y.login?.toLowerCase();
        return V.localeCompare(T, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [g]), !f && h ? /* @__PURE__ */ he.jsx(Fn, { error: h }) : /* @__PURE__ */ he.jsx(
    wr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: S, name: N, login: w, avatarUrl: y }) => ({
        id: S,
        name: N || w,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (S) => d(S),
      onChange: (S, N) => {
        const w = S.id;
        i ? (N && !n.find(
          (y) => y.id === w
        ) && n.push(S), N || (n = n.filter(
          (y) => y.id !== w
        ))) : n = N ? [S] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: S, onSelect: N, checked: w }) => /* @__PURE__ */ he.jsx(
        h_,
        {
          item: S,
          checked: w,
          onSelectItem: N
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, yI = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ he.jsx(Nr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ he.jsx(
        wr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ he.jsx(
        qs,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ he.jsx(Nr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ he.jsx(
        wr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ he.jsx(Nr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ he.jsx(rm, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ he.jsx(
        hI,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ he.jsx(he.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, gI = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ he.jsx(he.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ he.jsx(
  Wt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ he.jsx(
      hn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: yI({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), vI = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ he.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ he.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ he.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ he.jsx(me, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ he.jsx(hn, { label: "GitHub issue link", children: /* @__PURE__ */ he.jsx(
          Nr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, kI = "_modalBody_1hk1o_1", bI = "_modalBodyFormFields_1hk1o_4", lu = {
  modalBody: kI,
  modalBodyFormFields: bI
}, xI = ua(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), _I = ua(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), SI = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], NI = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = fn(), { track: d } = _n(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: g
  } = St(), [C, S] = se(""), [N, w] = se([]), [y, V] = se(), [T, F] = se(!1), [$, U] = se(!1), [Q, X] = Ex(), [
    ae,
    {
      loading: J,
      error: B,
      networkStatus: O
    }
  ] = s(xI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ie) => {
      w(
        Ie.GitHub.search?.edges?.map((G) => G?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), w([]);
    }
  });
  Ni(
    () => {
      !J && C && O === er.ready ? ae({
        variables: {
          query: C,
          maxResults: 10
        }
      }) : w([]);
    },
    500,
    [C]
  );
  const [q, { error: ee }] = l(
    _I,
    {
      onError: (Ie) => {
        F(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ie);
      },
      onCompleted: (Ie) => {
        F(!1);
        const G = Ie.GitHub.createIssue?.issue;
        V(G), o({
          title: "Success",
          text: `GitHub issue '${G.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: G.repository.name,
          number: G.number
        });
      }
    }
  ), ve = (Ie) => {
    S(`org:${a} ${Ie}`);
  }, de = (Ie, G) => {
    G(Ie), S("");
  }, le = () => {
    S("");
  }, pe = (Ie) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), F(!0), q({
      variables: {
        input: {
          repositoryId: Ie.repository.id,
          title: Ie.title,
          body: Ie.body,
          assigneeIds: Ie.assignees?.length > 0 ? Ie.assignees.map((G) => G.id) : void 0
        }
      }
    });
  };
  Le(() => {
    const Ie = $ ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ie);
  }, [$]);
  const W = () => {
    S(""), w([]), V(void 0), F(!1), U(!1);
  }, be = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), W(), h(), n();
  };
  return /* @__PURE__ */ he.jsxs(
    Tt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: be,
      children: [
        /* @__PURE__ */ he.jsx(
          $t,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: be
          }
        ),
        /* @__PURE__ */ he.jsxs(Dt, { className: lu.modalBody, children: [
          !J && B && /* @__PURE__ */ he.jsx(Fn, { error: B }),
          !T && ee && /* @__PURE__ */ he.jsx(Fn, { error: ee }),
          y ? /* @__PURE__ */ he.jsx(
            vI,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: $,
              setIssueLinkCopied: U,
              copyToClipboard: X
            }
          ) : /* @__PURE__ */ he.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(pe),
              children: /* @__PURE__ */ he.jsxs(ht, { children: [
                /* @__PURE__ */ he.jsx(we, { children: /* @__PURE__ */ he.jsx(hn, { label: "Repository", required: !0, children: /* @__PURE__ */ he.jsx(
                  Wt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ie, value: G } }) => /* @__PURE__ */ he.jsx(
                      wr,
                      {
                        className: lu.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: J,
                        onSearch: ve,
                        onSelect: (He) => de(He, Ie),
                        onClear: le,
                        selectedItems: [G],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: B ? "No repositories found" : "No repositories available",
                        items: N || [],
                        itemComponent: ({ item: He, onSelect: qe, checked: Oe }) => /* @__PURE__ */ he.jsx(
                          h_,
                          {
                            item: He,
                            checked: Oe,
                            onSelectItem: qe
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ he.jsx(we, { className: lu.modalBodyFormFields, children: /* @__PURE__ */ he.jsx(
                  gI,
                  {
                    control: m,
                    errors: f,
                    getValues: g,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: SI
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ he.jsx(
          Pt,
          {
            confirmOnClick: y ? be : u(pe),
            confirmProps: {
              isLoading: T,
              loadingIndicator: /* @__PURE__ */ he.jsx(dn, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : be
          }
        )
      ]
    }
  );
}, jI = "_wrapper_19v8w_1", wI = "_inputWrapper_19v8w_6", CI = "_buttonLink_19v8w_19", FI = "_noItemsFound_19v8w_23", II = "_createIssueButton_19v8w_28", Ti = {
  wrapper: jI,
  inputWrapper: wI,
  buttonLink: CI,
  noItemsFound: FI,
  createIssueButton: II
}, EI = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = _n(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: g,
    danglingIssueLinks: C,
    danglingPullRequestLinks: S,
    isLoadingGithubItems: N,
    issues: w,
    pullRequests: y,
    error: V
  } = RF({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), T = (X) => d({ key: X, type: "ISSUE" }), F = !(!!w?.length).valueOf() && !(!!y?.length).valueOf() && !(!!C?.length).valueOf() && !(!!S?.length).valueOf(), $ = !g && !N && !!C?.length && !!S?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Q = !!w?.length || !!y?.length;
  return !N && V ? /* @__PURE__ */ he.jsx(Fn, { error: V, retry: () => u() }) : /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
    /* @__PURE__ */ he.jsxs(b, { className: Ti.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ he.jsxs(b, { className: Ti.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
          /* @__PURE__ */ he.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Ti.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ he.jsx("div", { className: Ti.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ he.jsx(
          lI,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: w,
            linkedPullRequests: y
          }
        )
      ] }),
      N ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ he.jsx(dn, { "data-testid": "github-widget-item-spinner" }) }) : Q ? /* @__PURE__ */ he.jsx(
        QF,
        {
          items: [...w, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ he.jsx(A.Paragraph, { align: "center", className: Ti.noItemsFound, children: "No linked items found." }),
      $ && /* @__PURE__ */ he.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ he.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ he.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              C.map((X) => /* @__PURE__ */ he.jsx(
                An,
                {
                  onDelete: () => m({
                    key: X,
                    type: "ISSUE"
                  }),
                  children: dr(X)
                },
                dr(X)
              )),
              S.map((X) => /* @__PURE__ */ he.jsx(
                An,
                {
                  onDelete: () => m({ key: X, type: "PR" }),
                  children: dr(X)
                },
                dr(X)
              ))
            ] }),
            /* @__PURE__ */ he.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Q && /* @__PURE__ */ he.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: F,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ he.jsx(
        Et,
        {
          slotEnd: /* @__PURE__ */ he.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: Ti.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ he.jsx(
      NI,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: T,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, TI = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Yr
  }
], Kg = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], si = "GITHUB", $I = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, DI = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = St({
    mode: "onChange",
    defaultValues: $I
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = ea({
    integrationId: e,
    integrationType: si,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: V
  } = na({
    integrationId: e,
    fieldDefinitions: Kg,
    form: l,
    onMisconfigured: C
  }), [T, F] = se(s ? [] : null);
  Le(() => {
    F(s ? [] : null);
  }, [e, s]), Le(() => {
    V && T === null && F(V.renderConditions ?? []);
  }, [V, T]);
  const $ = o && T !== null, U = (X) => ra(X, {
    fieldDefinitions: Kg,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: $ ? T : void 0
  }), Q = l.watch("name");
  return /* @__PURE__ */ he.jsxs(
    ta,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ he.jsx(ia, { cause: g }),
        /* @__PURE__ */ he.jsxs(ht, { children: [
          /* @__PURE__ */ he.jsx(we, { children: /* @__PURE__ */ he.jsx(hn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ he.jsx(
            at,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(we, { span: 3, children: /* @__PURE__ */ he.jsx(
            nt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ he.jsx(we, { span: 3 }),
          /* @__PURE__ */ he.jsx(we, { span: 3, children: /* @__PURE__ */ he.jsx(
            nt,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ he.jsx(we, { span: 3 }),
          /* @__PURE__ */ he.jsx(we, { span: 3, children: /* @__PURE__ */ he.jsx(hn, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ he.jsx(
            at,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(we, { span: 3 }),
          /* @__PURE__ */ he.jsx(we, { span: 3, children: /* @__PURE__ */ he.jsx(hn, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ he.jsx(
            at,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(we, { span: 3 }),
          /* @__PURE__ */ he.jsx(we, { span: 3, children: /* @__PURE__ */ he.jsx(hn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ he.jsx(
            at,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(we, { span: 3 }),
          !s && e && /* @__PURE__ */ he.jsx(
            Yr,
            {
              configuration: n,
              integrationId: e,
              integrationType: si,
              label: "Authorize with OAuth"
            }
          ),
          $ && /* @__PURE__ */ he.jsx(we, { children: o({
            value: T,
            onChange: F,
            configurationKey: V?.id
          }) })
        ] }),
        /* @__PURE__ */ he.jsx(
          aa,
          {
            integrationType: si,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ he.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ he.jsx(
                me,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ he.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ he.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  si,
                  " integration, all links between Dixa and ",
                  si,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ he.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  si,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ he.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  si,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var cu = { exports: {} }, Na = {}, Gg;
function RI() {
  if (Gg) return Na;
  Gg = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Na.Fragment = r, Na.jsx = s, Na.jsxs = s, Na;
}
var Ao = {}, Yg;
function OI() {
  return Yg || (Yg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ao.Fragment = i, Ao.jsx = Rn, Ao.jsxs = Mn;
  })()), Ao;
}
var Qg;
function PI() {
  return Qg || (Qg = 1, process.env.NODE_ENV === "production" ? cu.exports = RI() : cu.exports = OI()), cu.exports;
}
var xe = PI(), Ja = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Ja || {}), mi = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(mi || {}), Gt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Gt || {});
const AI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, LI = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": AI
};
function VI(e) {
  return LI[e] ?? {};
}
const zI = VI(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Jg = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, y_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, UI = "_listItem_16pij_4", MI = "_clickableIcon_16pij_15", fo = {
  listItem: UI,
  clickableIcon: MI
}, g_ = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ xe.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ xe.jsx(me, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ xe.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ xe.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: fo.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ xe.jsx(
              me,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ xe.jsx(Ye, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: g } = l, C = l.currency ?? r;
      return /* @__PURE__ */ xe.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ xe.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ xe.jsx(A.Paragraph, { children: u }),
            /* @__PURE__ */ xe.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: y_(f / 100, C) })
          ] }),
          contentRight: h && /* @__PURE__ */ xe.jsx(oa, { src: h, alt: m ?? "Product image" }),
          className: fo.listItem
        },
        `item-${d}-${g}`
      );
    }) })
  ] }) });
}, BI = "_boxWrapper_89s7l_1", qI = "_trackButton_89s7l_10", Xg = {
  boxWrapper: BI,
  trackButton: qI
}, HI = {
  [Gt.StepUnknown]: "Unknown",
  [Gt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Gt.StepPreparedByMerchant]: "Prepared by merchant",
  [Gt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Gt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Gt.StepOnRoute]: "On route",
  [Gt.StepDeliveredToPickupPoint]: "At pickup point",
  [Gt.StepDeliveredToConsumer]: "Delivered to customer",
  [Gt.StepDeliveredToMerchant]: "Returned to merchant",
  [Gt.StepReturnRequested]: "Return requested",
  [Gt.StepSentBack]: "Sent back",
  [Gt.StepTerminated]: "Terminated",
  [Gt.StepAwaitingSupplier]: "Awaiting supplier"
}, WI = {
  [mi.Delivery]: "Home delivery",
  [mi.Pickup]: "Pickup point",
  [mi.Instore]: "In-store pickup",
  [mi.Mailbox]: "Mailbox",
  [mi.Inwarehouse]: "Warehouse",
  [mi.Unknown]: "Unknown"
}, KI = {
  [Ja.Outbound]: "From merchant to customer",
  [Ja.Return]: "Return from customer to merchant",
  [Ja.Unspecified]: "Unspecified",
  [Ja.UnknownDirectionType]: "Unknown"
}, GI = (e) => e ? HI[e] ?? e : "", YI = (e) => e ? WI[e] ?? e : "", QI = (e) => e ? KI[e] ?? e : "", JI = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, XI = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = or();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, g = m || l || i, C = a?.filter((T) => T?.time !== ""), S = GI(C?.[0]?.step), N = YI(u), w = QI(f), y = JI(e.location?.address), V = 14;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Xg.boxWrapper,
      children: [
        /* @__PURE__ */ xe.jsx(A.Heading, { variant: "heading-4", children: g }),
        /* @__PURE__ */ xe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ xe.jsx(
              me,
              {
                size: V,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsx(We, { content: "Copy tracking ID", children: /* @__PURE__ */ xe.jsx(
            me,
            {
              size: V,
              name: n ? "done" : "copy",
              className: fo.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        S && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: V, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: S })
          ] })
        ] }),
        w && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: V, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: w })
          ] })
        ] }),
        h && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: V, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ xe.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              Jg(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Jg(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: V, name: "info", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        y && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: V, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ xe.jsx(g_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ xe.jsxs(
          Et,
          {
            variant: "secondary",
            className: Xg.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
            children: [
              "Track on ",
              g ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, ZI = "_order_135ze_1", eE = "_orderIsOpen_135ze_9", nE = "_orderHeader_135ze_12", du = {
  order: ZI,
  orderIsOpen: eE,
  orderHeader: nE
}, Zg = "No order number found", tE = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = or(), { isCopied: s, copy: l } = or();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), g = d?.currency || "", C = d?.prices?.total?.price ?? 0, S = y_(C / 100, g), N = 14, w = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      className: rt(du.order, {
        [du.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: du.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  w
                ] }),
                h ? /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: /* @__PURE__ */ xe.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: Zg })
              ] }),
              /* @__PURE__ */ xe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ xe.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ xe.jsx(me, { size: N, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ xe.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: Zg }) })
              ] })
            ] }),
            h && /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsx(We, { content: "Copy order number", children: /* @__PURE__ */ xe.jsx(
              me,
              {
                size: N,
                name: s ? "done" : "copy",
                className: fo.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ xe.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ xe.jsx(
                me,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsx(We, { content: "Copy tracking ID", children: /* @__PURE__ */ xe.jsx(
              me,
              {
                size: N,
                name: a ? "done" : "copy",
                className: fo.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ xe.jsx(me, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ xe.jsx(me, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", children: S })
            ] })
          ] }),
          /* @__PURE__ */ xe.jsx(
            g_,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((y) => y),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ xe.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ xe.jsx(Pn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ xe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((y, V) => /* @__PURE__ */ xe.jsx(
              XI,
              {
                parcel: y
              },
              `parcel-${V}-${y?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, rE = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, ev = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, iE = (e) => [...e].sort(
  (n, r) => ev(r) - ev(n)
), aE = ({
  customerEmail: e
}) => {
  const { useQuery: n } = fn(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(zI, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? l0({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? Bb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Le(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      iE(
        rE(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(dn, {}) }) : m || !d && !l ? /* @__PURE__ */ xe.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ xe.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ xe.jsx(Fn, { error: l }) : /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ xe.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ xe.jsx(Pn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ xe.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ xe.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ xe.jsx(
      tE,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, oE = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ xe.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ xe.jsx(aE, { customerEmail: n })
    }
  );
}, sE = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
], nv = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], lE = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, cE = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = St({
    mode: "onChange",
    defaultValues: lE
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: g
  } = ea({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: w,
    widgetConfiguration: y
  } = na({
    integrationId: e,
    fieldDefinitions: nv,
    form: s,
    onMisconfigured: g
  }), [V, T] = se(o ? [] : null);
  Le(() => {
    T(o ? [] : null);
  }, [e, o]), Le(() => {
    y && V === null && T(y.renderConditions ?? []);
  }, [y, V]);
  const F = a && V !== null, $ = (Q) => ra(Q, {
    fieldDefinitions: nv,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: F ? V : void 0
  }), U = s.watch("name");
  return /* @__PURE__ */ xe.jsxs(
    ta,
    {
      form: s,
      integrationId: e,
      onValidSubmit: $,
      error: S ?? f,
      onRetry: S ? w : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ xe.jsx(ia, { cause: h }),
        /* @__PURE__ */ xe.jsxs(ht, { children: [
          /* @__PURE__ */ xe.jsx(we, { children: /* @__PURE__ */ xe.jsx(hn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ xe.jsx(
            at,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(we, { span: 3, children: /* @__PURE__ */ xe.jsx(
            nt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(we, { span: 3 }),
          /* @__PURE__ */ xe.jsx(we, { span: 3, children: /* @__PURE__ */ xe.jsx(hn, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ xe.jsx(
            at,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(we, { span: 3 }),
          /* @__PURE__ */ xe.jsx(we, { span: 3, children: /* @__PURE__ */ xe.jsx(
            nt,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(we, { span: 3 }),
          /* @__PURE__ */ xe.jsx(we, { span: 3, children: /* @__PURE__ */ xe.jsx(
            zm,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(we, { span: 3 }),
          F && /* @__PURE__ */ xe.jsx(we, { children: a({
            value: V,
            onChange: T,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ xe.jsx(
          aa,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var uu = { exports: {} }, ja = {}, tv;
function dE() {
  if (tv) return ja;
  tv = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return ja.Fragment = r, ja.jsx = s, ja.jsxs = s, ja;
}
var Lo = {}, rv;
function uE() {
  return rv || (rv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Lo.Fragment = i, Lo.jsx = Rn, Lo.jsxs = Mn;
  })()), Lo;
}
var iv;
function mE() {
  return iv || (iv = 1, process.env.NODE_ENV === "production" ? uu.exports = dE() : uu.exports = uE()), uu.exports;
}
var ge = mE();
const Np = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Np(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, pE = "_jiraCode_h30p6_1", fE = "_jiraCodeInline_h30p6_8", mu = {
  jiraCode: pE,
  jiraCodeInline: fE
}, v_ = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ ge.jsx(ge.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ ge.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ ge.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ ge.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ ge.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ ge.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ ge.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ ge.jsx("pre", { children: /* @__PURE__ */ ge.jsx("code", { className: mu.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ ge.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ ge.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ ge.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ ge.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ ge.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ ge.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ ge.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ ge.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ ge.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ ge.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ ge.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ ge.jsx("code", { className: rt(mu.jiraCode, mu.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, Es = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ ge.jsx(me, { size: r, name: "question", className: n }) : /* @__PURE__ */ ge.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, hE = "_collapse_m2gjh_1", yE = "_collapseHeader_m2gjh_10", gE = "_collapseHeaderLink_m2gjh_31", vE = "_collapseHeaderStatus_m2gjh_40", kE = "_collapseHeaderTitle_m2gjh_51", bE = "_collapseContent_m2gjh_59", xE = "_collapseContentHeadline_m2gjh_62", _E = "_collapseContentButtonSpacer_m2gjh_68", SE = "_collapseContentButtonLink_m2gjh_71", NE = "_collapseContentStatusTag_m2gjh_74", jE = "_collapseContentDescription_m2gjh_77", gr = {
  collapse: hE,
  collapseHeader: yE,
  collapseHeaderLink: gE,
  collapseHeaderStatus: vE,
  collapseHeaderTitle: kE,
  collapseContent: bE,
  collapseContentHeadline: xE,
  collapseContentButtonSpacer: _E,
  collapseContentButtonLink: SE,
  collapseContentStatusTag: NE,
  collapseContentDescription: jE
}, k_ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, wE = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = _n(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ge.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, g = k_({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), C = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ ge.jsxs(
      mr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: C,
        className: gr.collapse,
        children: [
          /* @__PURE__ */ ge.jsx(mr.Header, { className: gr.collapseHeader, children: /* @__PURE__ */ ge.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ge.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ ge.jsx(Es, { width: 16, iconUrl: g }),
                    /* @__PURE__ */ ge.jsx(
                      "a",
                      {
                        className: gr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (S) => {
                          S.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ ge.jsx(me, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ ge.jsx("span", { className: gr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ ge.jsx(An, { className: gr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ ge.jsx("div", { className: gr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ ge.jsx(mr.Content, { className: gr.collapseContent, children: /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ge.jsx("div", { className: gr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ ge.jsx(Zn, { className: gr.collapseContentDescription, children: u ? Np(u, v_) : "" }),
            /* @__PURE__ */ ge.jsx(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: gr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ ge.jsx(
              Et,
              {
                slotEnd: /* @__PURE__ */ ge.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: gr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ ge.jsx(ge.Fragment, {}) });
}, CE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, FE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, IE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, EE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, TE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, $E = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, DE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, RE = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': CE,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": FE,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": IE,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": EE,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': TE,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': $E,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": DE
};
function Ci(e) {
  return RE[e] ?? {};
}
const b_ = Ci(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), OE = Ci(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), PE = Ci(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), AE = Ci(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), LE = Ci(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), VE = Ci(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), zE = Ci(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), jp = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), UE = new RegExp(`^${jp.source}$`), ME = new RegExp(`/${jp.source}$`), av = new RegExp(
  `.+?[&?]selectedIssue=(${jp.source})[&?]?.*`
);
function x_(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = _n(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: g } = fn(), {
    loading: C,
    data: S,
    error: N,
    store: w
  } = Vm(e ?? null), [
    y,
    { loading: V, error: T, data: F }
  ] = h(b_, {
    notifyOnNetworkStatusChange: !0
  });
  Le(() => {
    const le = F?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    le?.length && (s(le), a(le.map((pe) => pe?.key).filter(Boolean)));
  }, [F]), Le(
    () => d(N || T || void 0),
    [N, T]
  ), Le(
    () => {
      C || B();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S?.jira?.issues, C]
  );
  const $ = async (le, pe) => {
    await w(le).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: pe.success.title,
        text: pe.success.text
      });
    }).catch((W) => {
      u({
        title: pe.error.title,
        text: `${pe.error.text} ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = g(OE, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Q = (le, pe) => {
    const W = window.location.href, be = pe ? W.replace(
      e?.toString() ?? "",
      pe?.toString()
    ) : W, Ie = pe ? `# ${pe}` : `# ${e}`;
    U({
      variables: {
        issueKey: le,
        title: Ie,
        url: be,
        globalId: `system=${be}`
      }
    });
  }, [X] = g(PE, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ae = (le) => {
    const pe = window.location.href;
    X({
      variables: {
        issueKey: le,
        globalId: `system=${pe}`
      }
    });
  }, J = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), B = () => {
    S && S.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${S?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, O = async (le, pe) => {
    m("jira:issue:link:clicked", J(le));
    const W = S?.jira?.issues ? S : r;
    W.jira.issues = Array.from(
      new Set(W.jira.issues).add(le)
    ), await w(W, pe?.toString()).then(() => Q(le, pe)).catch((be) => {
      u({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, q = (le) => {
    m("jira:issue:link:clicked", J(le));
    const pe = S?.jira?.issues ? S : r;
    pe.jira.issues = Array.from(
      new Set(pe.jira.issues).add(le)
    ), $(pe, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => Q(le));
  }, ee = (le) => {
    m("jira:issue:unlink:clicked", J(le)), f({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", J(le));
        const pe = {
          ...S,
          jira: {
            ...S?.jira,
            issues: S?.jira?.issues.filter((W) => W !== le) || []
          }
        };
        $(pe, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => ae(le));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", J(le))
    });
  }, ve = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((le) => le?.key && ae(le.key)), $(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, de = S?.jira?.issues?.filter(
    (le) => !i?.includes(le)
  ) || [];
  return {
    linkIssue: q,
    linkIssueQuietly: O,
    unlinkIssue: ee,
    loadIssues: B,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const le = {
        ...S,
        jira: {
          ...S?.jira,
          issues: S?.jira?.issues.filter(
            (pe) => !de.includes(pe)
          ) || []
        }
      };
      w(le);
    },
    unlinkAllIssues: ve,
    maybeExtractIssueKey: (le) => {
      const pe = le.replace(/\s/g, "");
      if (UE.test(pe))
        return pe;
      if (av.test(le))
        return le.match(av)?.[1];
      if (le.startsWith(n) && ME.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: C,
    danglingIssueLinks: de,
    isLoadingIssues: V,
    issues: o,
    error: l
  };
}
function BE(e = !1, n) {
  const [r, i] = se(e);
  return Le(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const qE = "_result_axxxc_48", HE = "_resultName_axxxc_68", WE = "_resultNameIcon_axxxc_76", KE = "_resultDescription_axxxc_81", GE = "_resultLinkIcon_axxxc_93", YE = "_tooltip_axxxc_102", QE = "_tooltipContent_axxxc_108", JE = "_tooltipName_axxxc_115", XE = "_tooltipNameIcon_axxxc_120", ZE = "_tooltipDescription_axxxc_125", eT = "_tooltipSummary_axxxc_133", nT = "_tooltipTag_axxxc_137", cr = {
  result: qE,
  resultName: HE,
  resultNameIcon: WE,
  resultDescription: KE,
  resultLinkIcon: GE,
  tooltip: YE,
  tooltipContent: QE,
  tooltipName: JE,
  tooltipNameIcon: XE,
  tooltipDescription: ZE,
  tooltipSummary: eT,
  tooltipTag: nT
}, tT = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = k_({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ ge.jsx(
    We,
    {
      disabled: i,
      className: cr.tooltip,
      content: /* @__PURE__ */ ge.jsxs("div", { className: cr.tooltipContent, children: [
        /* @__PURE__ */ ge.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ ge.jsxs("span", { className: cr.tooltipName, children: [
                /* @__PURE__ */ ge.jsx(
                  Es,
                  {
                    width: 16,
                    iconUrl: h,
                    className: cr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ ge.jsx(An, { className: cr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ ge.jsx("div", { className: cr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ ge.jsx("div", { className: cr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ge.jsxs(
        "button",
        {
          ...a,
          className: cr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ ge.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ge.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ge.jsxs("span", { className: cr.resultName, children: [
                    /* @__PURE__ */ ge.jsx(
                      Es,
                      {
                        width: 16,
                        iconUrl: h,
                        className: cr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ ge.jsx("div", { className: cr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ ge.jsx(
              me,
              {
                className: cr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, rT = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ ge.jsx(
  Et,
  {
    slotEnd: /* @__PURE__ */ ge.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), iT = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = fn(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: g }] = a(b_, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: C } = x_(null, n);
  Ni(
    () => {
      !u && l && g === er.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Le(() => {
    const T = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      T.map((F) => ({
        id: F?.key ?? "",
        name: F?.key ?? "",
        description: F?.fields.summary,
        status: F?.fields.status,
        issuetype: F?.fields.issuetype,
        text: F?.fields.description ? Np(F?.fields.description, v_) : /* @__PURE__ */ ge.jsx(ge.Fragment, {})
      }))
    );
  }, [h]);
  const S = (T) => {
    e(T.id), d("");
  }, N = (T) => {
    const F = T.trim(), $ = C(F);
    if ($) {
      const U = $.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${U}'`);
    } else F !== "" && d(
      `text ~ '${F}'${r ? " and project = " + r : ""}`
    );
  }, w = () => {
    d("");
  }, y = (T) => /* @__PURE__ */ ge.jsx(rT, { ...T, jiraInstanceUrl: n }), V = (T) => /* @__PURE__ */ ge.jsx(
    tT,
    {
      ...T,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ ge.jsx(Fn, { error: f }) : /* @__PURE__ */ ge.jsx(
    wr,
    {
      items: o,
      loading: u,
      onSearch: N,
      onSelect: S,
      onClear: w,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: V,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, aT = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return Le(() => {
    r(i);
  }, [i]), /* @__PURE__ */ ge.jsx(
    wr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, oT = "_itemButton_1hl53_1", sT = "_result_1hl53_6", lT = "_resultIcon_1hl53_26", cT = "_resultName_1hl53_30", dT = "_resultCheckIcon_1hl53_38", wa = {
  itemButton: oT,
  result: sT,
  resultIcon: lT,
  resultName: cT,
  resultCheckIcon: dT
}, mm = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ ge.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ ge.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: wa.itemButton,
          children: /* @__PURE__ */ ge.jsxs(b, { className: wa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ ge.jsx(
              Es,
              {
                width: 36,
                iconUrl: o || "",
                className: wa.resultIcon
              }
            ),
            /* @__PURE__ */ ge.jsx(Zn, { className: wa.resultName, children: e.name }),
            n && /* @__PURE__ */ ge.jsx(Zn, { className: wa.resultCheckIcon, children: /* @__PURE__ */ ge.jsx(me, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, uT = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = fn(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: g, networkStatus: C }] = a(zE, {
    notifyOnNetworkStatusChange: !0
  });
  return Ni(
    () => {
      !f && l && l.length >= m && C === er.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Le(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((S) => {
      if (S?.data?.Jira.findUsers?.length === 1) {
        const N = S?.data?.Jira?.findUsers[0];
        r(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), Le(() => {
    const S = g?.Jira?.findUsers || [];
    s(
      S.filter(({ active: N }) => N).map(({ accountId: N, displayName: w, avatarUrls: y, active: V }) => ({
        id: N,
        name: w,
        avatarUrls: y,
        active: V
      }))
    );
  }, [g]), !f && h ? /* @__PURE__ */ ge.jsx(Fn, { error: h }) : /* @__PURE__ */ ge.jsx(
    wr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (S) => d(S),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: S, onSelect: N, checked: w }) => /* @__PURE__ */ ge.jsx(
        mm,
        {
          item: S,
          checked: w,
          onSelectItem: N,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, ov = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = Ex();
  return Le(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx(me, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ ge.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ ge.jsx(We, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ ge.jsx(
      nr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, mT = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ ge.jsx(ov, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ ge.jsx(Nr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ ge.jsx(rm, { onChange: n, value: r }) : /* @__PURE__ */ ge.jsx(Nr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ ge.jsx(rm, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ ge.jsx(Nr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ ge.jsx(
        uT,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ ge.jsx(
        wr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ ge.jsx(aT, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ ge.jsx(ov, { field: e });
  }
}, pT = ["description", "reporter", "summary"], fT = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ge.jsx(ge.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || pT.includes(o)
).map((o) => /* @__PURE__ */ ge.jsx(
  Wt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ge.jsx(
      hn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: mT({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), hT = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ ge.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ ge.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ ge.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ ge.jsx(me, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ ge.jsx(hn, { label: "Jira issue link", children: /* @__PURE__ */ ge.jsx(
        Nr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), yT = "_modalBody_1hk1o_1", gT = "_modalBodyFormFields_1hk1o_4", sv = {
  modalBody: yT,
  modalBodyFormFields: gT
}, vT = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), kT = (e) => e?.custom?.split(":")?.[1] || null, bT = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, xT = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = bT(a, n), l = kT(s) ?? a;
        return r.includes(l) ? i[a] = vT(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, _T = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [g, C] = se([]), [S, N] = se([]), [w, y] = se(!1), [V, T] = se(!1), [F, $] = se({}), { track: U } = _n(), { isCopied: Q, copyToClipboard: X } = BE(), ae = Bn(() => i?.conversationId, [e]), { useMutation: J, useLazyQuery: B, showNotification: O } = fn(), {
    control: q,
    handleSubmit: ee,
    formState: { errors: ve },
    reset: de,
    setValue: le,
    getValues: pe
  } = St({
    defaultValues: s
  }), W = S.length > 0, be = `${a}/browse`, Ie = Object.keys(F).length > 0, [G, { loading: He, error: qe }] = B(AE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ye) => {
      d(ye.Jira.getAllProjects);
    },
    onError: (ye) => {
      O({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", ye), d([]);
    }
  }), [
    Oe,
    { loading: Be, error: $e }
  ] = B(LE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ye) => {
      h(0);
      const De = ye?.Jira?.getCreateIssueMeta?.projects[0];
      if (De) {
        const Ve = De?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        C(Ve || []), le(
          "issuetype",
          Ve.length > 0 ? Ve[0] : void 0
        );
      } else
        O({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), C([]), N([]);
    },
    onError: (ye) => {
      O({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", ye), C([]), N([]), h(0);
    }
  }), [Ue, { error: Re }] = J(
    VE,
    {
      onError: () => {
        y(!1), O({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (ye) => {
        if (y(!1), ye?.Jira && "key" in ye.Jira.createIssue)
          u(ye?.Jira?.createIssue), O({
            title: "Success",
            text: `Jira issue '${ye.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: ye.Jira.createIssue.key
          }), ae && r(
            ye.Jira.createIssue.key,
            ae
          );
        else if ("errorMessages" in ye.Jira.createIssue || "errors" in ye.Jira.createIssue) {
          const De = ye?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", De), O({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), an = (ye) => {
    y(!0), $({}), Ue({
      variables: {
        input: xT(ye, S)
      }
    });
  };
  Le(() => {
    if (e)
      try {
        G();
      } catch (ye) {
        console.warn("Error when fetching initial projects", ye);
      }
  }, [e]), Le(() => {
    const ye = V ? window.setTimeout(() => T(!1), 2e3) : void 0;
    return () => window.clearTimeout(ye);
  }, [V]), Le(() => {
    if (g?.length > 0) {
      le("issuetype", g[f]);
      const ye = g[f]?.fields?.additionalProperties;
      if (ye?.length > 0) {
        const De = ye.map(
          ({ value: E }) => E
        ), Ve = (o ? De.sort(({ name: E }, { name: x }) => E.localeCompare(x)) : De).sort(
          ({ required: E }, { required: x }) => Number(x) - Number(E)
        ), { project: Pe, issuetype: un } = pe();
        de({ project: Pe, issuetype: un }), N(Ve);
      }
    } else
      N([]), le("issuetype", void 0);
  }, [g, le, f]), Le(() => {
    if (Re && Jb(Re)) {
      if (Re?.graphQLErrors?.length > 0) {
        const { graphQLErrors: ye } = Re, De = ye[0].extensions?.integration?.responseBody;
        try {
          const Ve = JSON.parse(De);
          if (Ve?.errors) {
            const Pe = Object.keys(Ve.errors).reduce(
              (un, E) => ({
                ...un,
                [E]: {
                  type: "required",
                  message: Ve.errors[E],
                  ref: {
                    name: E
                  }
                }
              }),
              {}
            );
            $(Pe);
          }
        } catch {
        }
      }
    } else
      $({});
  }, [Re]);
  const Ee = () => {
    d([]), N([]), C([]), u(void 0), h(0), y(!1), $({});
  }, Ke = () => {
    Ee(), de(s), n();
  }, Qe = (ye) => {
    ye && Oe({
      variables: {
        projectKey: ye
      }
    });
  }, fe = (ye) => {
    const De = g.map((Ve) => Ve.id).indexOf(ye);
    h(De ?? 0);
  };
  return /* @__PURE__ */ ge.jsxs(
    Tt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Ke,
      children: [
        /* @__PURE__ */ ge.jsx(
          $t,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Ke
          }
        ),
        /* @__PURE__ */ ge.jsxs(Dt, { className: sv.modalBody, children: [
          !He && qe && /* @__PURE__ */ ge.jsx(Fn, { error: qe, retry: G }),
          !Be && $e && /* @__PURE__ */ ge.jsx(
            Fn,
            {
              error: $e,
              retry: Oe
            }
          ),
          !w && Ie && /* @__PURE__ */ ge.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ge.jsx(
            Hs,
            {
              variant: "warning",
              description: /* @__PURE__ */ ge.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ ge.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ ge.jsx(
                      Kn,
                      {
                        icon: Q ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => X(JSON.stringify(S, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ ge.jsx(
            hT,
            {
              createdIssue: m,
              issueBaseLink: be,
              issueLinkCopied: V,
              setIssueLinkCopied: T,
              copyToClipboard: X
            }
          ) : /* @__PURE__ */ ge.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(an),
              children: /* @__PURE__ */ ge.jsxs(ht, { children: [
                /* @__PURE__ */ ge.jsx(we, { span: 3, children: /* @__PURE__ */ ge.jsx(hn, { label: "Project", required: !0, children: /* @__PURE__ */ ge.jsx(
                  Wt,
                  {
                    control: q,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: ye, value: De } }) => /* @__PURE__ */ ge.jsx(
                      wr,
                      {
                        searchable: !0,
                        loading: He,
                        onSelect: (Ve) => {
                          Qe(Ve.key), ye(Ve);
                        },
                        selectedItems: [De],
                        placeholder: "Select Jira project",
                        emptyMessage: qe ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: un }) => /* @__PURE__ */ ge.jsx(
                          mm,
                          {
                            item: Ve,
                            checked: un,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ge.jsx(we, { span: 3, children: /* @__PURE__ */ ge.jsx(hn, { label: "Issue type", required: !0, children: /* @__PURE__ */ ge.jsx(
                  Wt,
                  {
                    control: q,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: ye, value: De } }) => /* @__PURE__ */ ge.jsx(
                      wr,
                      {
                        disabled: g.length === 0,
                        loading: Be,
                        onSelect: (Ve) => {
                          fe(Ve.id), ye(Ve);
                        },
                        selectedItems: [De],
                        placeholder: g.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: $e ? "No issues found" : "No issues available",
                        items: g,
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: un }) => /* @__PURE__ */ ge.jsx(
                          mm,
                          {
                            item: Ve,
                            checked: un,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                W && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ ge.jsx(we, { className: sv.modalBodyFormFields, children: /* @__PURE__ */ ge.jsx(
                  fT,
                  {
                    control: q,
                    errors: { ...ve, ...F },
                    getValues: pe,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: S
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ge.jsx(
          Pt,
          {
            confirmOnClick: m ? Ke : ee(an),
            confirmProps: {
              disabled: !W,
              isLoading: w,
              loadingIndicator: /* @__PURE__ */ ge.jsx(dn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Ke
          }
        )
      ]
    }
  );
}, ST = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, NT = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, jT = "_wrapper_1bylq_1", wT = "_inputWrapper_1bylq_6", CT = "_inputSeparator_1bylq_18", FT = "_buttonLink_1bylq_23", IT = "_noIssuesFound_1bylq_27", Ca = {
  wrapper: jT,
  inputWrapper: wT,
  inputSeparator: CT,
  buttonLink: FT,
  noIssuesFound: IT
}, ET = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = _n(), i = ST(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: g,
    isLoadingIssueLinks: C,
    isLoadingIssues: S,
    issues: N,
    error: w
  } = x_(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, V = !!n?.enableSortIssueTypeByLabel, T = !!(N?.length || g?.length), F = !!n?.enableRemoveAllLinks && T, $ = !C && !S && g?.length > 0 && !!n?.showDanglingLinks;
  return !S && w ? /* @__PURE__ */ ge.jsx(Fn, { error: w, retry: () => f() }) : /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsxs(b, { className: Ca.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ge.jsxs(b, { className: Ca.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
          /* @__PURE__ */ ge.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ge.jsx("div", { className: Ca.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ge.jsx(
          iT,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      S ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(dn, { "data-testid": "jira-widget-issue-spinner" }) }) : N?.length ? /* @__PURE__ */ ge.jsx(
        wE,
        {
          issues: N,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ ge.jsx(A.Paragraph, { align: "center", className: Ca.noIssuesFound, children: "No linked issues found" }),
      F && N?.length > 0 && /* @__PURE__ */ ge.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: !N?.length && !g?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      $ && /* @__PURE__ */ ge.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ge.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ ge.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: g.map((U) => /* @__PURE__ */ ge.jsx(An, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ ge.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ ge.jsx(
        Et,
        {
          slotEnd: /* @__PURE__ */ ge.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: Ca.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ ge.jsx(
      _T,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: V
      }
    )
  ] });
}, lv = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => NT(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Yr
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var pu = { exports: {} }, Fa = {}, cv;
function TT() {
  if (cv) return Fa;
  cv = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Fa.Fragment = r, Fa.jsx = s, Fa.jsxs = s, Fa;
}
var Vo = {}, dv;
function $T() {
  return dv || (dv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Vo.Fragment = i, Vo.jsx = Rn, Vo.jsxs = Mn;
  })()), Vo;
}
var uv;
function DT() {
  return uv || (uv = 1, process.env.NODE_ENV === "production" ? pu.exports = TT() : pu.exports = $T()), pu.exports;
}
var Ce = DT();
function RT({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = fn(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return Le(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((C) => {
        const S = setTimeout(C, r);
        d([...l, S]);
      });
      const g = await s({
        variables: h
      });
      u.push(g);
    }
    o(u);
  }, a];
}
var __ = /* @__PURE__ */ ((e) => (e.List = "list", e))(__ || {}), pm = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(pm || {}), fm = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(fm || {}), hm = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(hm || {});
const OT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, PT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, AT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, LT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, VT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, zT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, UT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, MT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, BT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, qT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, HT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, WT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, KT = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": OT,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": PT,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": LT,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": VT,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": AT,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": zT,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": UT,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": MT,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": BT,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": qT,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": HT,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": WT
};
function Qr(e) {
  return KT[e] ?? {};
}
const GT = Qr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), YT = Qr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), QT = Qr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), JT = Qr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), XT = Qr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), ZT = Qr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), e$ = Qr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), n$ = Qr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), t$ = Qr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function ym(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function mv(e) {
  return ym(e) && e?.attributes?.event_properties?.$message;
}
function r$(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function pv(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function i$(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function a$(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function o$(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function s$(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function l$(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function c$(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function fv(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function d$(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function u$(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const m$ = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function p$(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function f$(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function h$({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = fn(), { track: a } = _n(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [g, C] = se(
    null
  ), [S, N] = se([]), {
    data: w,
    error: y,
    loading: V,
    networkStatus: T
  } = i(QT, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    F,
    {
      data: $,
      error: U,
      loading: Q,
      networkStatus: X
    }
  ] = r(GT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Le(() => {
    if (w && !V && T === er.ready) {
      const ae = i$(w);
      s(
        ae.find((J) => J?.attributes?.name === "Received Email")?.id || null
      ), d(
        ae.find((J) => J?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ae.find((J) => J?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ae.find((J) => J?.attributes?.name === "Bounced Email")?.id || null
      ), C(
        ae.find((J) => J?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), C(null);
  }, [w]), Le(() => {
    o && l && m && f && g && !Q && X === er.ready ? F({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${g}")`,
        pageSize: n
      }
    }) : N([]);
  }, [
    o,
    l,
    m,
    f,
    g
  ]), Le(() => {
    if (!Q && $) {
      const ae = a$($), J = s$(
        $
      ).map(
        (de) => de?.attributes?.event_properties.$message
      ), B = l$(
        $
      ).map(
        (de) => de?.attributes?.event_properties.$message
      );
      ae.forEach((de) => {
        const le = de.attributes?.event_properties.$message;
        de.opened = J.includes(le), de.clicked = B.includes(le);
      });
      const O = o$($), q = c$($), ee = [
        ...ae,
        ...q,
        ...O
      ].sort((de, le) => {
        const pe = pv(de), W = pv(le);
        return pe == null && W == null ? 0 : pe == null ? 1 : W == null ? -1 : W - pe;
      }).slice(0, n);
      N(ee);
      const ve = ee.map((de) => de.id);
      a("klaviyo:messages:received", {
        emailsReceived: ae.filter(
          (de) => ve.includes(de.id)
        ).length,
        emailsBounced: q.filter(
          (de) => ve.includes(de.id)
        ).length,
        smsReceived: O.filter(
          (de) => ve.includes(de.id)
        ).length,
        total: ve.length
      });
    } else
      N([]);
  }, [Q, $]), Bn(
    () => ({
      receivedMessages: S,
      isLoading: V || Q,
      error: y || U
    }),
    [
      S,
      V,
      Q,
      y,
      U
    ]
  );
}
function y$({ profileId: e }) {
  const { useQuery: n } = fn(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(XT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Le(() => {
    l && o(l);
  }, [l]), Le(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Bn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function g$({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = _n(), { useLazyQuery: i } = fn(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(JT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Le(() => {
    if (!f && m) {
      const g = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, C = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(g, C);
    }
  }, [f, m]);
  const h = (g, C) => {
    const S = g?.data?.length === 1 && g.data[0]?.id || void 0, N = C?.data?.length === 1 && C.data[0]?.id || void 0, w = S || N, y = !S || !N || S === N;
    if (w && y) {
      o(S || N), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${S}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return Bn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const hv = 800, v$ = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, k$ = 3, b$ = 1.5, x$ = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = k$,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = se(0), [d, m] = se(n || hv), [u, f] = se(r || v$), [h, g] = se(!1), [C, S] = se(!1), N = a || !!r, w = N ? o(u) : n || hv, [y, V] = se(w);
  rC(
    async () => {
      const U = s + 1, Q = b$ ** U;
      l(U), V(
        (N ? o(u) : d) * Q
      ), await e().then(() => {
        S(!0), $();
      });
    },
    h ? y : null
  ), aC(() => $());
  const T = ot(() => {
    l(0), V(w);
  }, [w]), F = ot(
    (U = {}) => {
      const { delay: Q, delayRange: X } = U;
      S(!1), T(), X && (f(X), V(o(X))), Q && (m(Q), V(Q)), g(!0);
    },
    [T]
  ), $ = ot(() => {
    g(!1), T();
  }, [T]);
  return Le(() => {
    s >= i && $();
  }, [s, i, $]), Bn(
    () => ({ isRunning: h, isSuccessful: C, start: F, stop: $ }),
    [h, C, F, $]
  );
}, _$ = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, S$ = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function N$({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = fn(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? ZT : e$,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: g,
    stop: C
  } = x$({
    query: u,
    useDelayRange: !0
  }), S = m || h;
  return Le(() => {
    if (d)
      if (m0({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const N = _$(d);
          g({
            ...N && {
              delayRange: S$(N)
            }
          });
        }
      } else
        s(d);
  }, [d]), Le(() => {
    if (!m && l?.Klaviyo) {
      let N = {}, w = {};
      n === "lists" && (N = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (w = l?.Klaviyo?.get_segments_for_profile), (N?.data || w?.data) && (C(), a(
        (n === "lists" ? N?.data : w?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Bn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: g,
      isLoading: S,
      error: o,
      networkStatus: f
    }),
    [i, S, o, f, g]
  );
}
const j$ = "_notificationText_1polx_1", wp = {
  notificationText: j$
}, ol = ({ error: e }) => {
  const { track: n } = _n();
  let r = e;
  if (Jb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && Bb({ error: i[0] }), o = i.length === 1 && d0({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Ce.jsx(Fn, { error: e });
  }
  return /* @__PURE__ */ Ce.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Ce.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ Ce.jsx(me, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, w$ = "_message_1vrar_48", C$ = "_messageIsOpen_1vrar_56", F$ = "_messageHeader_1vrar_59", I$ = "_messageLabel_1vrar_65", E$ = "_messageText_1vrar_68", Wi = {
  message: w$,
  messageIsOpen: C$,
  messageHeader: F$,
  messageLabel: I$,
  messageText: E$
}, T$ = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && d$(e.flowMessage);
  return /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
    /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", className: Wi.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Ce.jsx(dn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Ce.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Ce.jsx(b, { children: /* @__PURE__ */ Ce.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: Wi.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", className: Wi.messageText, children: i })
        ]
      }
    )
  ] });
}, $$ = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Ce.jsx(b, { children: /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Ce.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, D$ = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Bn(
    () => () => l ? Ln(l).format(m) : d ? Ln.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", g = f && e.opened, C = f && e.clicked, S = f && o?.event_properties.Subject, N = h && o?.event_properties["Message Name"], w = f ? "mail" : "sms";
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: rt(Wi.message, {
        [Wi.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Ce.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Wi.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Ce.jsx(me, { size: 16, name: w }),
                  " ",
                  m$(s),
                  u && /* @__PURE__ */ Ce.jsx(Pn, { size: "small", variant: "info", children: u })
                ] }),
                S && S,
                N && N
              ] }),
              /* @__PURE__ */ Ce.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Ce.jsx(Mm, {}),
          r$(e) && /* @__PURE__ */ Ce.jsx(b, { children: /* @__PURE__ */ Ce.jsx(Pn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Ce.jsx(An, { children: /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ce.jsx(
                  me,
                  {
                    size: 16,
                    color: g ? "green.400" : "red.400",
                    name: g ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Ce.jsx(An, { children: /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ce.jsx(
                  me,
                  {
                    size: 16,
                    color: C ? "green.400" : "red.400",
                    name: C ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Ce.jsx(T$, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Ce.jsx($$, { event: e })
        ] })
      ]
    }
  );
}, R$ = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, O$ = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = h$({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = RT({
    query: YT,
    options: R$,
    delayMs: 1e3
  }), [m, u] = se([]);
  Le(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((g) => ym(g)).map((g) => mv(g));
      h.length > 0 && (i(!0), l(
        h.map((g) => ({
          messageId: g
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Le(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && ym(h) && !h.flowMessage) {
          const g = mv(h), C = d.find((N) => (N.data && fv(N.data))?.id === g), S = C?.data && fv(C.data);
          if (S)
            return {
              ...u$(h),
              flowMessage: S
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: f.map((h, g) => h.graphQLErrors ? /* @__PURE__ */ Ce.jsx(
    Fn,
    {
      error: h
    },
    `lastMessagesError${g}`
  ) : /* @__PURE__ */ Ce.jsx(
    ol,
    {
      error: h
    },
    `lastMessagesError${g}`
  )) }) : /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ce.jsx(dn, {}) }) : /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, g) => /* @__PURE__ */ Ce.jsx(
      D$,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: g === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: wp.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, P$ = "_list_ld0hf_1", A$ = "_listItem_ld0hf_4", Kr = {
  list: P$,
  listItem: A$
}, L$ = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ Ce.jsx(Ye, { className: Kr.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: u0(a) }),
          /* @__PURE__ */ Ce.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: uo(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, yv = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = N$({ profileId: e, query: n });
  Le(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ Ce.jsx(ol, { error: o }) : s ? /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsx(dn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: u.map(
    ({ attributes: f, type: h }, g) => /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Ce.jsx(An, { children: qb(h) })
    ] }) }, g)
  ) }) : r && !a ? /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(me, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Ce.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Ce.jsx(We, { content: "Refresh lists and segments", children: /* @__PURE__ */ Ce.jsx(Kn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Ce.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, V$ = 0.7, z$ = 0.3, U$ = (e) => e >= V$ ? { variant: "error", label: "High risk" } : e >= z$ ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, M$ = (e) => /* @__PURE__ */ Ce.jsx(A.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), B$ = (e) => {
  const n = U$(e);
  return /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ Ce.jsx(Pn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ Ce.jsx(A.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, q$ = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: M$(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: uo(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: B$(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: uo(o)
      }
    ] : []
  ];
}, H$ = ({
  profile: e
}) => {
  const n = q$(e);
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ Ce.jsx(Ye, { className: Kr.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ Ce.jsx(A.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, W$ = "_tagHover_kzbzk_1", K$ = "_channelUnsubscribed_kzbzk_6", gv = {
  tagHover: W$,
  channelUnsubscribed: K$
}, vv = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Ce.jsx(
    We,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Ce.jsx(
        An,
        {
          className: gv.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Ce.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: rt({
                [gv.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Ce.jsx(dn, { size: 16 }) : /* @__PURE__ */ Ce.jsx(me, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, G$ = "_subscriptionError_1qhhx_1", Y$ = {
  subscriptionError: G$
}, Q$ = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = _n(), [g, C] = iC({
    channel: null,
    request: null
  }), S = p$(n), N = f$(n), w = !!e, { useMutation: y } = fn(), [V] = y(
    n$
  ), [T] = y(
    t$
  ), F = (Q) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Q }), C.setAll({
      channel: Q,
      request: "subscribed"
    }), ((X) => V({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: pm.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...X === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: fm.Subscribed
                        }
                      }
                    },
                    ...X === "SMS" && {
                      sms: {
                        marketing: {
                          consent: fm.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: __.List,
              id: e
            }
          }
        }
      }
    }))(Q).then(
      (X) => U({
        channel: Q,
        mutationResponse: X,
        isSubscriptionRequest: !0
      })
    ).catch(
      (X) => U({
        channel: Q,
        mutationErrorResponse: X,
        isSubscriptionRequest: !0
      })
    );
  }, $ = (Q) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Q }), C.setAll({
      channel: Q,
      request: "unsubscribed"
    }), T({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: pm.Profile,
                attributes: {
                  ...Q === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Q === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: hm.Unsubscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: hm.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (X) => U({
        channel: Q,
        mutationResponse: X,
        isSubscriptionRequest: !1
      })
    ).catch(
      (X) => U({
        channel: Q,
        mutationErrorResponse: X,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Q,
    mutationResponse: X,
    mutationErrorResponse: ae,
    isSubscriptionRequest: J
  }) => {
    const B = ae?.networkError, O = B ? B?.statusCode : NaN, q = X?.errors, ee = !!q && Hb({
      errors: q
    });
    O === 202 ? (h(
      J ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Q }
    ), await o()) : ee ? (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${J ? "opt-in" : "opt-out"}.`
    )) : (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: B?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${J ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return Le(() => {
    if (g.request === "subscribed") {
      const Q = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${g.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      g.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Q), C.reset()), g.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Q), C.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ Ce.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(
            vv,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: S,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: w,
              handleAction: () => {
                l(!0), f(void 0), S ? $("EMAIL") : F("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            vv,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: N,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: w,
              handleAction: () => {
                m(!0), f(void 0), N ? $("SMS") : F("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ Ce.jsx(b, { className: Y$.subscriptionError, children: u })
      ] })
    }
  );
}, J$ = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: g
  } = y$({ profileId: e });
  return f ? /* @__PURE__ */ Ce.jsx(ol, { error: f }) : h ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ce.jsx(dn, {}) }) : !u && !h ? /* @__PURE__ */ Ce.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: wp.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Ce.jsxs(Ye, { className: Kr.list, children: [
        i && /* @__PURE__ */ Ce.jsx(yv, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Ce.jsx(
          yv,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ Ce.jsx(
      Q$,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: g,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ Ce.jsx(H$, { profile: u }),
    u && s && /* @__PURE__ */ Ce.jsx(L$, { profile: u }),
    /* @__PURE__ */ Ce.jsx(
      O$,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, X$ = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: g,
    error: C
  } = g$({ email: r, phoneNumber: i });
  return x0(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : g ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ce.jsx(dn, {}) }) : C ? /* @__PURE__ */ Ce.jsx(ol, { error: C }) : f ? /* @__PURE__ */ Ce.jsx(
    J$,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ Ce.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: wp.notificationText,
      children: "No profile ID found"
    }
  );
}, Z$ = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: c0
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], eD = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Yr
  }
], nD = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function tD(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const rD = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, iD = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, aD = {};
function kv(e, n) {
  return (aD.jsx ? iD : rD).test(e);
}
const oD = /[ \t\n\f\r]/g;
function sD(e) {
  return typeof e == "object" ? e.type === "text" ? bv(e.value) : !1 : bv(e);
}
function bv(e) {
  return e.replace(oD, "") === "";
}
class jo {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
jo.prototype.property = {};
jo.prototype.normal = {};
jo.prototype.space = null;
function S_(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new jo(r, i, n);
}
function gm(e) {
  return e.toLowerCase();
}
class hr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
hr.prototype.space = null;
hr.prototype.boolean = !1;
hr.prototype.booleanish = !1;
hr.prototype.overloadedBoolean = !1;
hr.prototype.number = !1;
hr.prototype.commaSeparated = !1;
hr.prototype.spaceSeparated = !1;
hr.prototype.commaOrSpaceSeparated = !1;
hr.prototype.mustUseProperty = !1;
hr.prototype.defined = !1;
let lD = 0;
const In = Fi(), yt = Fi(), N_ = Fi(), Me = Fi(), Xn = Fi(), Ki = Fi(), tr = Fi();
function Fi() {
  return 2 ** ++lD;
}
const vm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: In,
  booleanish: yt,
  commaOrSpaceSeparated: tr,
  commaSeparated: Ki,
  number: Me,
  overloadedBoolean: N_,
  spaceSeparated: Xn
}, Symbol.toStringTag, { value: "Module" })), fu = Object.keys(vm);
class Cp extends hr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), xv(this, "space", a), typeof i == "number")
      for (; ++o < fu.length; ) {
        const s = fu[o];
        xv(this, fu[o], (i & vm[s]) === vm[s]);
      }
  }
}
Cp.prototype.defined = !0;
function xv(e, n, r) {
  r && (e[n] = r);
}
const cD = {}.hasOwnProperty;
function ma(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (cD.call(e.properties, i)) {
      const a = e.properties[i], o = new Cp(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[gm(i)] = i, r[gm(o.attribute)] = i;
    }
  return new jo(n, r, e.space);
}
const j_ = ma({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), w_ = ma({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function C_(e, n) {
  return n in e ? e[n] : n;
}
function F_(e, n) {
  return C_(e, n.toLowerCase());
}
const I_ = ma({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: F_,
  properties: { xmlns: null, xmlnsXLink: null }
}), E_ = ma({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: yt,
    ariaAutoComplete: null,
    ariaBusy: yt,
    ariaChecked: yt,
    ariaColCount: Me,
    ariaColIndex: Me,
    ariaColSpan: Me,
    ariaControls: Xn,
    ariaCurrent: null,
    ariaDescribedBy: Xn,
    ariaDetails: null,
    ariaDisabled: yt,
    ariaDropEffect: Xn,
    ariaErrorMessage: null,
    ariaExpanded: yt,
    ariaFlowTo: Xn,
    ariaGrabbed: yt,
    ariaHasPopup: null,
    ariaHidden: yt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Xn,
    ariaLevel: Me,
    ariaLive: null,
    ariaModal: yt,
    ariaMultiLine: yt,
    ariaMultiSelectable: yt,
    ariaOrientation: null,
    ariaOwns: Xn,
    ariaPlaceholder: null,
    ariaPosInSet: Me,
    ariaPressed: yt,
    ariaReadOnly: yt,
    ariaRelevant: null,
    ariaRequired: yt,
    ariaRoleDescription: Xn,
    ariaRowCount: Me,
    ariaRowIndex: Me,
    ariaRowSpan: Me,
    ariaSelected: yt,
    ariaSetSize: Me,
    ariaSort: null,
    ariaValueMax: Me,
    ariaValueMin: Me,
    ariaValueNow: Me,
    ariaValueText: null,
    role: null
  }
}), dD = ma({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: F_,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Ki,
    acceptCharset: Xn,
    accessKey: Xn,
    action: null,
    allow: null,
    allowFullScreen: In,
    allowPaymentRequest: In,
    allowUserMedia: In,
    alt: null,
    as: null,
    async: In,
    autoCapitalize: null,
    autoComplete: Xn,
    autoFocus: In,
    autoPlay: In,
    blocking: Xn,
    capture: null,
    charSet: null,
    checked: In,
    cite: null,
    className: Xn,
    cols: Me,
    colSpan: null,
    content: null,
    contentEditable: yt,
    controls: In,
    controlsList: Xn,
    coords: Me | Ki,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: In,
    defer: In,
    dir: null,
    dirName: null,
    disabled: In,
    download: N_,
    draggable: yt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: In,
    formTarget: null,
    headers: Xn,
    height: Me,
    hidden: In,
    high: Me,
    href: null,
    hrefLang: null,
    htmlFor: Xn,
    httpEquiv: Xn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: In,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: In,
    itemId: null,
    itemProp: Xn,
    itemRef: Xn,
    itemScope: In,
    itemType: Xn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: In,
    low: Me,
    manifest: null,
    max: null,
    maxLength: Me,
    media: null,
    method: null,
    min: null,
    minLength: Me,
    multiple: In,
    muted: In,
    name: null,
    nonce: null,
    noModule: In,
    noValidate: In,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: In,
    optimum: Me,
    pattern: null,
    ping: Xn,
    placeholder: null,
    playsInline: In,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: In,
    referrerPolicy: null,
    rel: Xn,
    required: In,
    reversed: In,
    rows: Me,
    rowSpan: Me,
    sandbox: Xn,
    scope: null,
    scoped: In,
    seamless: In,
    selected: In,
    shadowRootClonable: In,
    shadowRootDelegatesFocus: In,
    shadowRootMode: null,
    shape: null,
    size: Me,
    sizes: null,
    slot: null,
    span: Me,
    spellCheck: yt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Me,
    step: null,
    style: null,
    tabIndex: Me,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: In,
    useMap: null,
    value: yt,
    width: Me,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Xn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Me,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Me,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: In,
    // Lists. Use CSS to reduce space between items instead
    declare: In,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Me,
    // `<img>` and `<object>`
    leftMargin: Me,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Me,
    // `<body>`
    marginWidth: Me,
    // `<body>`
    noResize: In,
    // `<frame>`
    noHref: In,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: In,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: In,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Me,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: yt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Me,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Me,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: In,
    disableRemotePlayback: In,
    prefix: null,
    property: null,
    results: Me,
    security: null,
    unselectable: null
  }
}), uD = ma({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: C_,
  properties: {
    about: tr,
    accentHeight: Me,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Me,
    amplitude: Me,
    arabicForm: null,
    ascent: Me,
    attributeName: null,
    attributeType: null,
    azimuth: Me,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Me,
    by: null,
    calcMode: null,
    capHeight: Me,
    className: Xn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Me,
    diffuseConstant: Me,
    direction: null,
    display: null,
    dur: null,
    divisor: Me,
    dominantBaseline: null,
    download: In,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Me,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Me,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Me,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Ki,
    g2: Ki,
    glyphName: Ki,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Me,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Me,
    horizOriginX: Me,
    horizOriginY: Me,
    id: null,
    ideographic: Me,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Me,
    k: Me,
    k1: Me,
    k2: Me,
    k3: Me,
    k4: Me,
    kernelMatrix: tr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Me,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Me,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Me,
    overlineThickness: Me,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Me,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Xn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Me,
    pointsAtY: Me,
    pointsAtZ: Me,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: tr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: tr,
    rev: tr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: tr,
    requiredFeatures: tr,
    requiredFonts: tr,
    requiredFormats: tr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Me,
    specularExponent: Me,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Me,
    strikethroughThickness: Me,
    string: null,
    stroke: null,
    strokeDashArray: tr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Me,
    strokeOpacity: Me,
    strokeWidth: null,
    style: null,
    surfaceScale: Me,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: tr,
    tabIndex: Me,
    tableValues: null,
    target: null,
    targetX: Me,
    targetY: Me,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: tr,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Me,
    underlineThickness: Me,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Me,
    values: null,
    vAlphabetic: Me,
    vMathematical: Me,
    vectorEffect: null,
    vHanging: Me,
    vIdeographic: Me,
    version: null,
    vertAdvY: Me,
    vertOriginX: Me,
    vertOriginY: Me,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Me,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), mD = /^data[-\w.:]+$/i, _v = /-[a-z]/g, pD = /[A-Z]/g;
function fD(e, n) {
  const r = gm(n);
  let i = n, a = hr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && mD.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(_v, yD);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!_v.test(o)) {
        let s = o.replace(pD, hD);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Cp;
  }
  return new a(i, n);
}
function hD(e) {
  return "-" + e.toLowerCase();
}
function yD(e) {
  return e.charAt(1).toUpperCase();
}
const gD = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, vD = S_([w_, j_, I_, E_, dD], "html"), Fp = S_([w_, j_, I_, E_, uD], "svg");
function kD(e) {
  return e.join(" ").trim();
}
var $i = {}, hu, Sv;
function bD() {
  if (Sv) return hu;
  Sv = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", g = "declaration";
  hu = function(S, N) {
    if (typeof S != "string")
      throw new TypeError("First argument must be a string");
    if (!S) return [];
    N = N || {};
    var w = 1, y = 1;
    function V(O) {
      var q = O.match(n);
      q && (w += q.length);
      var ee = O.lastIndexOf(d);
      y = ~ee ? O.length - ee : y + O.length;
    }
    function T() {
      var O = { line: w, column: y };
      return function(q) {
        return q.position = new F(O), Q(), q;
      };
    }
    function F(O) {
      this.start = O, this.end = { line: w, column: y }, this.source = N.source;
    }
    F.prototype.content = S;
    function $(O) {
      var q = new Error(
        N.source + ":" + w + ":" + y + ": " + O
      );
      if (q.reason = O, q.filename = N.source, q.line = w, q.column = y, q.source = S, !N.silent) throw q;
    }
    function U(O) {
      var q = O.exec(S);
      if (q) {
        var ee = q[0];
        return V(ee), S = S.slice(ee.length), q;
      }
    }
    function Q() {
      U(r);
    }
    function X(O) {
      var q;
      for (O = O || []; q = ae(); )
        q !== !1 && O.push(q);
      return O;
    }
    function ae() {
      var O = T();
      if (!(m != S.charAt(0) || u != S.charAt(1))) {
        for (var q = 2; f != S.charAt(q) && (u != S.charAt(q) || m != S.charAt(q + 1)); )
          ++q;
        if (q += 2, f === S.charAt(q - 1))
          return $("End of comment missing");
        var ee = S.slice(2, q - 2);
        return y += 2, V(ee), S = S.slice(q), y += 2, O({
          type: h,
          comment: ee
        });
      }
    }
    function J() {
      var O = T(), q = U(i);
      if (q) {
        if (ae(), !U(a)) return $("property missing ':'");
        var ee = U(o), ve = O({
          type: g,
          property: C(q[0].replace(e, f)),
          value: ee ? C(ee[0].replace(e, f)) : f
        });
        return U(s), ve;
      }
    }
    function B() {
      var O = [];
      X(O);
      for (var q; q = J(); )
        q !== !1 && (O.push(q), X(O));
      return O;
    }
    return Q(), B();
  };
  function C(S) {
    return S ? S.replace(l, f) : f;
  }
  return hu;
}
var Nv;
function xD() {
  if (Nv) return $i;
  Nv = 1;
  var e = $i && $i.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty($i, "__esModule", { value: !0 }), $i.default = r;
  var n = e(bD());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return $i;
}
var _D = xD();
const jv = /* @__PURE__ */ Hm(_D), SD = jv.default || jv, T_ = $_("end"), Ip = $_("start");
function $_(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function ND(e) {
  const n = Ip(e), r = T_(e);
  if (n && r)
    return { start: n, end: r };
}
function to(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? wv(e.position) : "start" in e || "end" in e ? wv(e) : "line" in e || "column" in e ? km(e) : "";
}
function km(e) {
  return Cv(e && e.line) + ":" + Cv(e && e.column);
}
function wv(e) {
  return km(e && e.start) + "-" + km(e && e.end);
}
function Cv(e) {
  return e && typeof e == "number" ? e : 1;
}
class At extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = to(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
At.prototype.file = "";
At.prototype.name = "";
At.prototype.reason = "";
At.prototype.message = "";
At.prototype.stack = "";
At.prototype.column = void 0;
At.prototype.line = void 0;
At.prototype.ancestors = void 0;
At.prototype.cause = void 0;
At.prototype.fatal = void 0;
At.prototype.place = void 0;
At.prototype.ruleId = void 0;
At.prototype.source = void 0;
const Ep = {}.hasOwnProperty, jD = /* @__PURE__ */ new Map(), wD = /[A-Z]/g, CD = /-([a-z])/g, FD = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), ID = /* @__PURE__ */ new Set(["td", "th"]), D_ = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function ED(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = LD(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = AD(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Fp : vD,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = R_(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function R_(e, n, r) {
  if (n.type === "element")
    return TD(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return $D(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return RD(e, n, r);
  if (n.type === "mdxjsEsm")
    return DD(e, n);
  if (n.type === "root")
    return OD(e, n, r);
  if (n.type === "text")
    return PD(e, n);
}
function TD(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Fp, e.schema = a), e.ancestors.push(n);
  const o = P_(e, n.tagName, !1), s = VD(e, n);
  let l = $p(e, n);
  return FD.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !sD(d) : !0;
  })), O_(e, s, o, n), Tp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function $D(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  ho(e, n.position);
}
function DD(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  ho(e, n.position);
}
function RD(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Fp, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : P_(e, n.name, !0), s = zD(e, n), l = $p(e, n);
  return O_(e, s, o, n), Tp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function OD(e, n, r) {
  const i = {};
  return Tp(i, $p(e, n)), e.create(n, e.Fragment, i, r);
}
function PD(e, n) {
  return n.value;
}
function O_(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function Tp(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function AD(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function LD(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = Ip(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function VD(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Ep.call(n.properties, a)) {
      const o = UD(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && ID.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function zD(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        ho(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          ho(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function $p(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : jD;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = R_(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function UD(e, n, r) {
  const i = fD(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? tD(r) : kD(r)), i.property === "style") {
      let a = typeof r == "object" ? r : MD(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = BD(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? gD[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function MD(e, n) {
  const r = {};
  try {
    SD(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new At("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = D_ + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(CD, HD)), r[s] = o;
  }
}
function P_(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = kv(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = kv(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Ep.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  ho(e);
}
function ho(e, n) {
  const r = new At(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = D_ + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function BD(e) {
  const n = {};
  let r;
  for (r in e)
    Ep.call(e, r) && (n[qD(r)] = e[r]);
  return n;
}
function qD(e) {
  let n = e.replace(wD, WD);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function HD(e, n) {
  return n.toUpperCase();
}
function WD(e) {
  return "-" + e.toLowerCase();
}
const yu = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, KD = {};
function GD(e, n) {
  const r = KD, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return A_(e, i, a);
}
function A_(e, n, r) {
  if (YD(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Fv(e.children, n, r);
  }
  return Array.isArray(e) ? Fv(e, n, r) : "";
}
function Fv(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = A_(e[a], n, r);
  return i.join("");
}
function YD(e) {
  return !!(e && typeof e == "object");
}
const Iv = document.createElement("i");
function Dp(e) {
  const n = "&" + e + ";";
  Iv.innerHTML = n;
  const r = Iv.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Ar(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function ur(e, n) {
  return e.length > 0 ? (Ar(e, e.length, 0, n), e) : n;
}
const Ev = {}.hasOwnProperty;
function QD(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    JD(n, e[r]);
  return n;
}
function JD(e, n) {
  let r;
  for (r in n) {
    const a = (Ev.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        Ev.call(a, s) || (a[s] = []);
        const l = o[s];
        XD(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function XD(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Ar(e, 0, 0, i);
}
function L_(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function Gi(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Tr = oi(/[A-Za-z]/), sr = oi(/[\dA-Za-z]/), ZD = oi(/[#-'*+\--9=?A-Z^-~]/);
function bm(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const xm = oi(/\d/), eR = oi(/[\dA-Fa-f]/), nR = oi(/[!-/:-@[-`{-~]/);
function bn(e) {
  return e !== null && e < -2;
}
function Zt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const tR = oi(new RegExp("\\p{P}|\\p{S}", "u")), rR = oi(/\s/);
function oi(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function pa(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && sr(e.charCodeAt(r + 1)) && sr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function et(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const iR = {
  tokenize: aR
};
function aR(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return bn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const oR = {
  tokenize: sR
}, Tv = {
  tokenize: lR
};
function sR(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(V) {
    if (i < r.length) {
      const T = r[i];
      return n.containerState = T[1], e.attempt(T[0].continuation, d, m)(V);
    }
    return m(V);
  }
  function d(V) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const T = n.events.length;
      let F = T, $;
      for (; F--; )
        if (n.events[F][0] === "exit" && n.events[F][1].type === "chunkFlow") {
          $ = n.events[F][1].end;
          break;
        }
      w(i);
      let U = T;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...$
        }, U++;
      return Ar(n.events, F + 1, 0, n.events.slice(T)), n.events.length = U, m(V);
    }
    return l(V);
  }
  function m(V) {
    if (i === r.length) {
      if (!a)
        return h(V);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return C(V);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Tv, u, f)(V);
  }
  function u(V) {
    return a && y(), w(i), h(V);
  }
  function f(V) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, C(V);
  }
  function h(V) {
    return n.containerState = {}, e.attempt(Tv, g, C)(V);
  }
  function g(V) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(V);
  }
  function C(V) {
    if (V === null) {
      a && y(), w(0), e.consume(V);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), S(V);
  }
  function S(V) {
    if (V === null) {
      N(e.exit("chunkFlow"), !0), w(0), e.consume(V);
      return;
    }
    return bn(V) ? (e.consume(V), N(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(V), S);
  }
  function N(V, T) {
    const F = n.sliceStream(V);
    if (T && F.push(null), V.previous = o, o && (o.next = V), o = V, a.defineSkip(V.start), a.write(F), n.parser.lazy[V.start.line]) {
      let $ = a.events.length;
      for (; $--; )
        if (
          // The token starts before the line ending…
          a.events[$][1].start.offset < s && // …and either is not ended yet…
          (!a.events[$][1].end || // …or ends after it.
          a.events[$][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Q = U, X, ae;
      for (; Q--; )
        if (n.events[Q][0] === "exit" && n.events[Q][1].type === "chunkFlow") {
          if (X) {
            ae = n.events[Q][1].end;
            break;
          }
          X = !0;
        }
      for (w(i), $ = U; $ < n.events.length; )
        n.events[$][1].end = {
          ...ae
        }, $++;
      Ar(n.events, Q + 1, 0, n.events.slice(U)), n.events.length = $;
    }
  }
  function w(V) {
    let T = r.length;
    for (; T-- > V; ) {
      const F = r[T];
      n.containerState = F[1], F[0].exit.call(n, e);
    }
    r.length = V;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function lR(e, n, r) {
  return et(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function $v(e) {
  if (e === null || Zt(e) || rR(e))
    return 1;
  if (tR(e))
    return 2;
}
function Rp(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const _m = {
  name: "attention",
  resolveAll: cR,
  tokenize: dR
};
function cR(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Dv(f, -d), Dv(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = ur(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = ur(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = ur(m, Rp(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = ur(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = ur(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Ar(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function dR(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = $v(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = $v(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function Dv(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const uR = {
  name: "autolink",
  tokenize: mR
};
function mR(e, n, r) {
  let i = 0;
  return a;
  function a(g) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(g) {
    return Tr(g) ? (e.consume(g), s) : g === 64 ? r(g) : m(g);
  }
  function s(g) {
    return g === 43 || g === 45 || g === 46 || sr(g) ? (i = 1, l(g)) : m(g);
  }
  function l(g) {
    return g === 58 ? (e.consume(g), i = 0, d) : (g === 43 || g === 45 || g === 46 || sr(g)) && i++ < 32 ? (e.consume(g), l) : (i = 0, m(g));
  }
  function d(g) {
    return g === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), n) : g === null || g === 32 || g === 60 || bm(g) ? r(g) : (e.consume(g), d);
  }
  function m(g) {
    return g === 64 ? (e.consume(g), u) : ZD(g) ? (e.consume(g), m) : r(g);
  }
  function u(g) {
    return sr(g) ? f(g) : r(g);
  }
  function f(g) {
    return g === 46 ? (e.consume(g), i = 0, u) : g === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(g);
  }
  function h(g) {
    if ((g === 45 || sr(g)) && i++ < 63) {
      const C = g === 45 ? h : f;
      return e.consume(g), C;
    }
    return r(g);
  }
}
const sl = {
  partial: !0,
  tokenize: pR
};
function pR(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? et(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || bn(o) ? n(o) : r(o);
  }
}
const V_ = {
  continuation: {
    tokenize: hR
  },
  exit: yR,
  name: "blockQuote",
  tokenize: fR
};
function fR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function hR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? et(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(V_, n, r)(s);
  }
}
function yR(e) {
  e.exit("blockQuote");
}
const z_ = {
  name: "characterEscape",
  tokenize: gR
};
function gR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return nR(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const U_ = {
  name: "characterReference",
  tokenize: vR
};
function vR(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = sr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = eR, u) : (e.enter("characterReferenceValue"), o = 7, s = xm, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === sr && !Dp(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Rv = {
  partial: !0,
  tokenize: bR
}, Ov = {
  concrete: !0,
  name: "codeFenced",
  tokenize: kR
};
function kR(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: F
  };
  let o = 0, s = 0, l;
  return d;
  function d($) {
    return m($);
  }
  function m($) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = $, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u($);
  }
  function u($) {
    return $ === l ? (s++, e.consume($), u) : s < 3 ? r($) : (e.exit("codeFencedFenceSequence"), zn($) ? et(e, f, "whitespace")($) : f($));
  }
  function f($) {
    return $ === null || bn($) ? (e.exit("codeFencedFence"), i.interrupt ? n($) : e.check(Rv, S, T)($)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h($));
  }
  function h($) {
    return $ === null || bn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f($)) : zn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, g, "whitespace")($)) : $ === 96 && $ === l ? r($) : (e.consume($), h);
  }
  function g($) {
    return $ === null || bn($) ? f($) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C($));
  }
  function C($) {
    return $ === null || bn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f($)) : $ === 96 && $ === l ? r($) : (e.consume($), C);
  }
  function S($) {
    return e.attempt(a, T, N)($);
  }
  function N($) {
    return e.enter("lineEnding"), e.consume($), e.exit("lineEnding"), w;
  }
  function w($) {
    return o > 0 && zn($) ? et(e, y, "linePrefix", o + 1)($) : y($);
  }
  function y($) {
    return $ === null || bn($) ? e.check(Rv, S, T)($) : (e.enter("codeFlowValue"), V($));
  }
  function V($) {
    return $ === null || bn($) ? (e.exit("codeFlowValue"), y($)) : (e.consume($), V);
  }
  function T($) {
    return e.exit("codeFenced"), n($);
  }
  function F($, U, Q) {
    let X = 0;
    return ae;
    function ae(ee) {
      return $.enter("lineEnding"), $.consume(ee), $.exit("lineEnding"), J;
    }
    function J(ee) {
      return $.enter("codeFencedFence"), zn(ee) ? et($, B, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : B(ee);
    }
    function B(ee) {
      return ee === l ? ($.enter("codeFencedFenceSequence"), O(ee)) : Q(ee);
    }
    function O(ee) {
      return ee === l ? (X++, $.consume(ee), O) : X >= s ? ($.exit("codeFencedFenceSequence"), zn(ee) ? et($, q, "whitespace")(ee) : q(ee)) : Q(ee);
    }
    function q(ee) {
      return ee === null || bn(ee) ? ($.exit("codeFencedFence"), U(ee)) : Q(ee);
    }
  }
}
function bR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const gu = {
  name: "codeIndented",
  tokenize: _R
}, xR = {
  partial: !0,
  tokenize: SR
};
function _R(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), et(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : bn(m) ? e.attempt(xR, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || bn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function SR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : bn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : et(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : bn(s) ? a(s) : r(s);
  }
}
const NR = {
  name: "codeText",
  previous: wR,
  resolve: jR,
  tokenize: CR
};
function jR(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function wR(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function CR(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : bn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || bn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class FR {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && Ia(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Ia(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Ia(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        Ia(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Ia(this.left, r.reverse());
      }
  }
}
function Ia(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function M_(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new FR(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, IR(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Ar(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function IR(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, g = r, C = 0, S = 0;
  const N = [S];
  for (; g; ) {
    for (; e.get(++a)[1] !== g; )
      ;
    o.push(a), g._tokenizer || (u = i.sliceStream(g), g.next || u.push(null), f && s.defineSkip(g.start), g._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), g._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = g, g = g.next;
  }
  for (g = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (S = h + 1, N.push(S), g._tokenizer = void 0, g.previous = void 0, g = g.next);
  for (s.events = [], g ? (g._tokenizer = void 0, g.previous = void 0) : N.pop(), h = N.length; h--; ) {
    const w = l.slice(N[h], N[h + 1]), y = o.pop();
    d.push([y, y + w.length - 1]), e.splice(y, 2, w);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[C + d[h][0]] = C + d[h][1], C += d[h][1] - d[h][0] - 1;
  return m;
}
const ER = {
  resolve: $R,
  tokenize: DR
}, TR = {
  partial: !0,
  tokenize: RR
};
function $R(e) {
  return M_(e), e;
}
function DR(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : bn(l) ? e.check(TR, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function RR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || bn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function B_(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(w) {
    return w === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(w), e.exit(o), h) : w === null || w === 32 || w === 41 || bm(w) ? r(w) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), S(w));
  }
  function h(w) {
    return w === 62 ? (e.enter(o), e.consume(w), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), g(w));
  }
  function g(w) {
    return w === 62 ? (e.exit("chunkString"), e.exit(l), h(w)) : w === null || w === 60 || bn(w) ? r(w) : (e.consume(w), w === 92 ? C : g);
  }
  function C(w) {
    return w === 60 || w === 62 || w === 92 ? (e.consume(w), g) : g(w);
  }
  function S(w) {
    return !u && (w === null || w === 41 || Zt(w)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(w)) : u < m && w === 40 ? (e.consume(w), u++, S) : w === 41 ? (e.consume(w), u--, S) : w === null || w === 32 || w === 40 || bm(w) ? r(w) : (e.consume(w), w === 92 ? N : S);
  }
  function N(w) {
    return w === 40 || w === 41 || w === 92 ? (e.consume(w), S) : S(w);
  }
}
function q_(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(g) {
    return e.enter(i), e.enter(a), e.consume(g), e.exit(a), e.enter(o), u;
  }
  function u(g) {
    return l > 999 || g === null || g === 91 || g === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    g === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(g) : g === 93 ? (e.exit(o), e.enter(a), e.consume(g), e.exit(a), e.exit(i), n) : bn(g) ? (e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(g));
  }
  function f(g) {
    return g === null || g === 91 || g === 93 || bn(g) || l++ > 999 ? (e.exit("chunkString"), u(g)) : (e.consume(g), d || (d = !zn(g)), g === 92 ? h : f);
  }
  function h(g) {
    return g === 91 || g === 92 || g === 93 ? (e.consume(g), l++, f) : f(g);
  }
}
function H_(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : bn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), et(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || bn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function ro(e, n) {
  let r;
  return i;
  function i(a) {
    return bn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? et(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const OR = {
  name: "definition",
  tokenize: AR
}, PR = {
  partial: !0,
  tokenize: LR
};
function AR(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(g) {
    return e.enter("definition"), s(g);
  }
  function s(g) {
    return q_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(g);
  }
  function l(g) {
    return a = Gi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), g === 58 ? (e.enter("definitionMarker"), e.consume(g), e.exit("definitionMarker"), d) : r(g);
  }
  function d(g) {
    return Zt(g) ? ro(e, m)(g) : m(g);
  }
  function m(g) {
    return B_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(g);
  }
  function u(g) {
    return e.attempt(PR, f, f)(g);
  }
  function f(g) {
    return zn(g) ? et(e, h, "whitespace")(g) : h(g);
  }
  function h(g) {
    return g === null || bn(g) ? (e.exit("definition"), i.parser.defined.push(a), n(g)) : r(g);
  }
}
function LR(e, n, r) {
  return i;
  function i(l) {
    return Zt(l) ? ro(e, a)(l) : r(l);
  }
  function a(l) {
    return H_(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? et(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || bn(l) ? n(l) : r(l);
  }
}
const VR = {
  name: "hardBreakEscape",
  tokenize: zR
};
function zR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return bn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const UR = {
  name: "headingAtx",
  resolve: MR,
  tokenize: BR
};
function MR(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Ar(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function BR(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Zt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || bn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? et(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Zt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const qR = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Pv = ["pre", "script", "style", "textarea"], HR = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: GR,
  tokenize: YR
}, WR = {
  partial: !0,
  tokenize: JR
}, KR = {
  partial: !0,
  tokenize: QR
};
function GR(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function YR(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(G) {
    return u(G);
  }
  function u(G) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(G), f;
  }
  function f(G) {
    return G === 33 ? (e.consume(G), h) : G === 47 ? (e.consume(G), o = !0, S) : G === 63 ? (e.consume(G), a = 3, i.interrupt ? n : W) : Tr(G) ? (e.consume(G), s = String.fromCharCode(G), N) : r(G);
  }
  function h(G) {
    return G === 45 ? (e.consume(G), a = 2, g) : G === 91 ? (e.consume(G), a = 5, l = 0, C) : Tr(G) ? (e.consume(G), a = 4, i.interrupt ? n : W) : r(G);
  }
  function g(G) {
    return G === 45 ? (e.consume(G), i.interrupt ? n : W) : r(G);
  }
  function C(G) {
    const He = "CDATA[";
    return G === He.charCodeAt(l++) ? (e.consume(G), l === He.length ? i.interrupt ? n : B : C) : r(G);
  }
  function S(G) {
    return Tr(G) ? (e.consume(G), s = String.fromCharCode(G), N) : r(G);
  }
  function N(G) {
    if (G === null || G === 47 || G === 62 || Zt(G)) {
      const He = G === 47, qe = s.toLowerCase();
      return !He && !o && Pv.includes(qe) ? (a = 1, i.interrupt ? n(G) : B(G)) : qR.includes(s.toLowerCase()) ? (a = 6, He ? (e.consume(G), w) : i.interrupt ? n(G) : B(G)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(G) : o ? y(G) : V(G));
    }
    return G === 45 || sr(G) ? (e.consume(G), s += String.fromCharCode(G), N) : r(G);
  }
  function w(G) {
    return G === 62 ? (e.consume(G), i.interrupt ? n : B) : r(G);
  }
  function y(G) {
    return zn(G) ? (e.consume(G), y) : ae(G);
  }
  function V(G) {
    return G === 47 ? (e.consume(G), ae) : G === 58 || G === 95 || Tr(G) ? (e.consume(G), T) : zn(G) ? (e.consume(G), V) : ae(G);
  }
  function T(G) {
    return G === 45 || G === 46 || G === 58 || G === 95 || sr(G) ? (e.consume(G), T) : F(G);
  }
  function F(G) {
    return G === 61 ? (e.consume(G), $) : zn(G) ? (e.consume(G), F) : V(G);
  }
  function $(G) {
    return G === null || G === 60 || G === 61 || G === 62 || G === 96 ? r(G) : G === 34 || G === 39 ? (e.consume(G), d = G, U) : zn(G) ? (e.consume(G), $) : Q(G);
  }
  function U(G) {
    return G === d ? (e.consume(G), d = null, X) : G === null || bn(G) ? r(G) : (e.consume(G), U);
  }
  function Q(G) {
    return G === null || G === 34 || G === 39 || G === 47 || G === 60 || G === 61 || G === 62 || G === 96 || Zt(G) ? F(G) : (e.consume(G), Q);
  }
  function X(G) {
    return G === 47 || G === 62 || zn(G) ? V(G) : r(G);
  }
  function ae(G) {
    return G === 62 ? (e.consume(G), J) : r(G);
  }
  function J(G) {
    return G === null || bn(G) ? B(G) : zn(G) ? (e.consume(G), J) : r(G);
  }
  function B(G) {
    return G === 45 && a === 2 ? (e.consume(G), ve) : G === 60 && a === 1 ? (e.consume(G), de) : G === 62 && a === 4 ? (e.consume(G), be) : G === 63 && a === 3 ? (e.consume(G), W) : G === 93 && a === 5 ? (e.consume(G), pe) : bn(G) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(WR, Ie, O)(G)) : G === null || bn(G) ? (e.exit("htmlFlowData"), O(G)) : (e.consume(G), B);
  }
  function O(G) {
    return e.check(KR, q, Ie)(G);
  }
  function q(G) {
    return e.enter("lineEnding"), e.consume(G), e.exit("lineEnding"), ee;
  }
  function ee(G) {
    return G === null || bn(G) ? O(G) : (e.enter("htmlFlowData"), B(G));
  }
  function ve(G) {
    return G === 45 ? (e.consume(G), W) : B(G);
  }
  function de(G) {
    return G === 47 ? (e.consume(G), s = "", le) : B(G);
  }
  function le(G) {
    if (G === 62) {
      const He = s.toLowerCase();
      return Pv.includes(He) ? (e.consume(G), be) : B(G);
    }
    return Tr(G) && s.length < 8 ? (e.consume(G), s += String.fromCharCode(G), le) : B(G);
  }
  function pe(G) {
    return G === 93 ? (e.consume(G), W) : B(G);
  }
  function W(G) {
    return G === 62 ? (e.consume(G), be) : G === 45 && a === 2 ? (e.consume(G), W) : B(G);
  }
  function be(G) {
    return G === null || bn(G) ? (e.exit("htmlFlowData"), Ie(G)) : (e.consume(G), be);
  }
  function Ie(G) {
    return e.exit("htmlFlow"), n(G);
  }
}
function QR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return bn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function JR(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(sl, n, r);
  }
}
const XR = {
  name: "htmlText",
  tokenize: ZR
};
function ZR(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(W) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(W), d;
  }
  function d(W) {
    return W === 33 ? (e.consume(W), m) : W === 47 ? (e.consume(W), F) : W === 63 ? (e.consume(W), V) : Tr(W) ? (e.consume(W), Q) : r(W);
  }
  function m(W) {
    return W === 45 ? (e.consume(W), u) : W === 91 ? (e.consume(W), o = 0, C) : Tr(W) ? (e.consume(W), y) : r(W);
  }
  function u(W) {
    return W === 45 ? (e.consume(W), g) : r(W);
  }
  function f(W) {
    return W === null ? r(W) : W === 45 ? (e.consume(W), h) : bn(W) ? (s = f, de(W)) : (e.consume(W), f);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), g) : f(W);
  }
  function g(W) {
    return W === 62 ? ve(W) : W === 45 ? h(W) : f(W);
  }
  function C(W) {
    const be = "CDATA[";
    return W === be.charCodeAt(o++) ? (e.consume(W), o === be.length ? S : C) : r(W);
  }
  function S(W) {
    return W === null ? r(W) : W === 93 ? (e.consume(W), N) : bn(W) ? (s = S, de(W)) : (e.consume(W), S);
  }
  function N(W) {
    return W === 93 ? (e.consume(W), w) : S(W);
  }
  function w(W) {
    return W === 62 ? ve(W) : W === 93 ? (e.consume(W), w) : S(W);
  }
  function y(W) {
    return W === null || W === 62 ? ve(W) : bn(W) ? (s = y, de(W)) : (e.consume(W), y);
  }
  function V(W) {
    return W === null ? r(W) : W === 63 ? (e.consume(W), T) : bn(W) ? (s = V, de(W)) : (e.consume(W), V);
  }
  function T(W) {
    return W === 62 ? ve(W) : V(W);
  }
  function F(W) {
    return Tr(W) ? (e.consume(W), $) : r(W);
  }
  function $(W) {
    return W === 45 || sr(W) ? (e.consume(W), $) : U(W);
  }
  function U(W) {
    return bn(W) ? (s = U, de(W)) : zn(W) ? (e.consume(W), U) : ve(W);
  }
  function Q(W) {
    return W === 45 || sr(W) ? (e.consume(W), Q) : W === 47 || W === 62 || Zt(W) ? X(W) : r(W);
  }
  function X(W) {
    return W === 47 ? (e.consume(W), ve) : W === 58 || W === 95 || Tr(W) ? (e.consume(W), ae) : bn(W) ? (s = X, de(W)) : zn(W) ? (e.consume(W), X) : ve(W);
  }
  function ae(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || sr(W) ? (e.consume(W), ae) : J(W);
  }
  function J(W) {
    return W === 61 ? (e.consume(W), B) : bn(W) ? (s = J, de(W)) : zn(W) ? (e.consume(W), J) : X(W);
  }
  function B(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? r(W) : W === 34 || W === 39 ? (e.consume(W), a = W, O) : bn(W) ? (s = B, de(W)) : zn(W) ? (e.consume(W), B) : (e.consume(W), q);
  }
  function O(W) {
    return W === a ? (e.consume(W), a = void 0, ee) : W === null ? r(W) : bn(W) ? (s = O, de(W)) : (e.consume(W), O);
  }
  function q(W) {
    return W === null || W === 34 || W === 39 || W === 60 || W === 61 || W === 96 ? r(W) : W === 47 || W === 62 || Zt(W) ? X(W) : (e.consume(W), q);
  }
  function ee(W) {
    return W === 47 || W === 62 || Zt(W) ? X(W) : r(W);
  }
  function ve(W) {
    return W === 62 ? (e.consume(W), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(W);
  }
  function de(W) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), le;
  }
  function le(W) {
    return zn(W) ? et(e, pe, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : pe(W);
  }
  function pe(W) {
    return e.enter("htmlTextData"), s(W);
  }
}
const Op = {
  name: "labelEnd",
  resolveAll: rO,
  resolveTo: iO,
  tokenize: aO
}, eO = {
  tokenize: oO
}, nO = {
  tokenize: sO
}, tO = {
  tokenize: lO
};
function rO(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Ar(e, 0, e.length, r), e;
}
function iO(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = ur(l, e.slice(o + 1, o + i + 3)), l = ur(l, [["enter", u, n]]), l = ur(l, Rp(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = ur(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = ur(l, e.slice(s + 1)), l = ur(l, [["exit", d, n]]), Ar(e, o, e.length, l), e;
}
function aO(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Gi(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(eO, u, s ? u : f)(h) : h === 91 ? e.attempt(nO, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(tO, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function oO(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Zt(f) ? ro(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : B_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Zt(f) ? ro(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? H_(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Zt(f) ? ro(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function sO(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return q_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Gi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function lO(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const cO = {
  name: "labelStartImage",
  resolveAll: Op.resolveAll,
  tokenize: dO
};
function dO(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const uO = {
  name: "labelStartLink",
  resolveAll: Op.resolveAll,
  tokenize: mO
};
function mO(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const vu = {
  name: "lineEnding",
  tokenize: pO
};
function pO(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
}
const gs = {
  name: "thematicBreak",
  tokenize: fO
};
function fO(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || bn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? et(e, l, "whitespace")(m) : l(m));
  }
}
const Yt = {
  continuation: {
    tokenize: vO
  },
  exit: bO,
  name: "list",
  tokenize: gO
}, hO = {
  partial: !0,
  tokenize: xO
}, yO = {
  partial: !0,
  tokenize: kO
};
function gO(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(g) {
    const C = i.containerState.type || (g === 42 || g === 43 || g === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !i.containerState.marker || g === i.containerState.marker : xm(g)) {
      if (i.containerState.type || (i.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), g === 42 || g === 45 ? e.check(gs, r, m)(g) : m(g);
      if (!i.interrupt || g === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(g);
    }
    return r(g);
  }
  function d(g) {
    return xm(g) && ++s < 10 ? (e.consume(g), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? g === i.containerState.marker : g === 41 || g === 46) ? (e.exit("listItemValue"), m(g)) : r(g);
  }
  function m(g) {
    return e.enter("listItemMarker"), e.consume(g), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || g, e.check(
      sl,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(hO, h, f)
    );
  }
  function u(g) {
    return i.containerState.initialBlankLine = !0, o++, h(g);
  }
  function f(g) {
    return zn(g) ? (e.enter("listItemPrefixWhitespace"), e.consume(g), e.exit("listItemPrefixWhitespace"), h) : r(g);
  }
  function h(g) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(g);
  }
}
function vO(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(sl, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, et(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(yO, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, et(e, e.attempt(Yt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function kO(e, n, r) {
  const i = this;
  return et(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function bO(e) {
  e.exit(this.containerState.type);
}
function xO(e, n, r) {
  const i = this;
  return et(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const Av = {
  name: "setextUnderline",
  resolveTo: _O,
  tokenize: SO
};
function _O(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function SO(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? et(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || bn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const NO = {
  tokenize: jO
};
function jO(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    sl,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, et(e, e.attempt(this.parser.constructs.flow, a, e.attempt(ER, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const wO = {
  resolveAll: K_()
}, CO = W_("string"), FO = W_("text");
function W_(e) {
  return {
    resolveAll: K_(e === "text" ? IO : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const g = f[h];
          if (!g.previous || g.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function K_(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function IO(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const EO = {
  42: Yt,
  43: Yt,
  45: Yt,
  48: Yt,
  49: Yt,
  50: Yt,
  51: Yt,
  52: Yt,
  53: Yt,
  54: Yt,
  55: Yt,
  56: Yt,
  57: Yt,
  62: V_
}, TO = {
  91: OR
}, $O = {
  [-2]: gu,
  [-1]: gu,
  32: gu
}, DO = {
  35: UR,
  42: gs,
  45: [Av, gs],
  60: HR,
  61: Av,
  95: gs,
  96: Ov,
  126: Ov
}, RO = {
  38: U_,
  92: z_
}, OO = {
  [-5]: vu,
  [-4]: vu,
  [-3]: vu,
  33: cO,
  38: U_,
  42: _m,
  60: [uR, XR],
  91: uO,
  92: [VR, z_],
  93: Op,
  95: _m,
  96: NR
}, PO = {
  null: [_m, wO]
}, AO = {
  null: [42, 95]
}, LO = {
  null: []
}, VO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: AO,
  contentInitial: TO,
  disable: LO,
  document: EO,
  flow: DO,
  flowInitial: $O,
  insideSpan: PO,
  string: RO,
  text: OO
}, Symbol.toStringTag, { value: "Module" }));
function zO(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: U(F),
    check: U($),
    consume: y,
    enter: V,
    exit: T,
    interrupt: U($, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: S,
    events: [],
    now: C,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: g,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(J) {
    return s = ur(s, J), N(), s[s.length - 1] !== null ? [] : (Q(n, 0), m.events = Rp(o, m.events, m), m.events);
  }
  function h(J, B) {
    return MO(g(J), B);
  }
  function g(J) {
    return UO(s, J);
  }
  function C() {
    const {
      _bufferIndex: J,
      _index: B,
      line: O,
      column: q,
      offset: ee
    } = i;
    return {
      _bufferIndex: J,
      _index: B,
      line: O,
      column: q,
      offset: ee
    };
  }
  function S(J) {
    a[J.line] = J.column, ae();
  }
  function N() {
    let J;
    for (; i._index < s.length; ) {
      const B = s[i._index];
      if (typeof B == "string")
        for (J = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === J && i._bufferIndex < B.length; )
          w(B.charCodeAt(i._bufferIndex));
      else
        w(B);
    }
  }
  function w(J) {
    u = u(J);
  }
  function y(J) {
    bn(J) ? (i.line++, i.column = 1, i.offset += J === -3 ? 2 : 1, ae()) : J !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = J;
  }
  function V(J, B) {
    const O = B || {};
    return O.type = J, O.start = C(), m.events.push(["enter", O, m]), l.push(O), O;
  }
  function T(J) {
    const B = l.pop();
    return B.end = C(), m.events.push(["exit", B, m]), B;
  }
  function F(J, B) {
    Q(J, B.from);
  }
  function $(J, B) {
    B.restore();
  }
  function U(J, B) {
    return O;
    function O(q, ee, ve) {
      let de, le, pe, W;
      return Array.isArray(q) ? (
        /* c8 ignore next 1 */
        Ie(q)
      ) : "tokenize" in q ? (
        // Looks like a construct.
        Ie([
          /** @type {Construct} */
          q
        ])
      ) : be(q);
      function be(Oe) {
        return Be;
        function Be($e) {
          const Ue = $e !== null && Oe[$e], Re = $e !== null && Oe.null, an = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Ue) ? Ue : Ue ? [Ue] : [],
            ...Array.isArray(Re) ? Re : Re ? [Re] : []
          ];
          return Ie(an)($e);
        }
      }
      function Ie(Oe) {
        return de = Oe, le = 0, Oe.length === 0 ? ve : G(Oe[le]);
      }
      function G(Oe) {
        return Be;
        function Be($e) {
          return W = X(), pe = Oe, Oe.partial || (m.currentConstruct = Oe), Oe.name && m.parser.constructs.disable.null.includes(Oe.name) ? qe() : Oe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            B ? Object.assign(Object.create(m), B) : m,
            d,
            He,
            qe
          )($e);
        }
      }
      function He(Oe) {
        return J(pe, W), ee;
      }
      function qe(Oe) {
        return W.restore(), ++le < de.length ? G(de[le]) : ve;
      }
    }
  }
  function Q(J, B) {
    J.resolveAll && !o.includes(J) && o.push(J), J.resolve && Ar(m.events, B, m.events.length - B, J.resolve(m.events.slice(B), m)), J.resolveTo && (m.events = J.resolveTo(m.events, m));
  }
  function X() {
    const J = C(), B = m.previous, O = m.currentConstruct, q = m.events.length, ee = Array.from(l);
    return {
      from: q,
      restore: ve
    };
    function ve() {
      i = J, m.previous = B, m.currentConstruct = O, m.events.length = q, l = ee, ae();
    }
  }
  function ae() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function UO(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function MO(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function BO(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      QD([VO, ...(e || {}).extensions || []])
    ),
    content: a(iR),
    defined: [],
    document: a(oR),
    flow: a(NO),
    lazy: {},
    string: a(CO),
    text: a(FO)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return zO(i, o, l);
    }
  }
}
function qO(e) {
  for (; !M_(e); )
    ;
  return e;
}
const Lv = /[\0\t\n\r]/g;
function HO() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, g;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Lv.lastIndex = f, m = Lv.exec(o), h = m && m.index !== void 0 ? m.index : o.length, g = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (g === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), g) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const WO = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function KO(e) {
  return e.replace(WO, GO);
}
function GO(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return L_(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Dp(r) || e;
}
const G_ = {}.hasOwnProperty;
function YO(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), QO(r)(qO(BO(r).document().write(HO()(e, n, !0))));
}
function QO(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: X,
      autolinkEmail: X,
      atxHeading: o(fe),
      blockQuote: o(Re),
      characterEscape: X,
      characterReference: X,
      codeFenced: o(an),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(an, s),
      codeText: o(Ee, s),
      codeTextData: X,
      data: X,
      codeFlowValue: X,
      definition: o(Ke),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Qe),
      hardBreakEscape: o(ye),
      hardBreakTrailing: o(ye),
      htmlFlow: o(De, s),
      htmlFlowData: X,
      htmlText: o(De, s),
      htmlTextData: X,
      image: o(Ve),
      label: s,
      link: o(Pe),
      listItem: o(E),
      listItemValue: h,
      listOrdered: o(un, f),
      listUnordered: o(un),
      paragraph: o(x),
      reference: G,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(fe),
      strong: o(D),
      thematicBreak: o(Y)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: F,
      autolink: d(),
      autolinkEmail: Ue,
      autolinkProtocol: $e,
      blockQuote: d(),
      characterEscapeValue: ae,
      characterReferenceMarkerHexadecimal: qe,
      characterReferenceMarkerNumeric: qe,
      characterReferenceValue: Oe,
      characterReference: Be,
      codeFenced: d(N),
      codeFencedFence: S,
      codeFencedFenceInfo: g,
      codeFencedFenceMeta: C,
      codeFlowValue: ae,
      codeIndented: d(w),
      codeText: d(ee),
      codeTextData: ae,
      data: ae,
      definition: d(),
      definitionDestinationString: T,
      definitionLabelString: y,
      definitionTitleString: V,
      emphasis: d(),
      hardBreakEscape: d(B),
      hardBreakTrailing: d(B),
      htmlFlow: d(O),
      htmlFlowData: ae,
      htmlText: d(q),
      htmlTextData: ae,
      image: d(de),
      label: pe,
      labelText: le,
      lineEnding: J,
      link: d(ve),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: He,
      resourceDestinationString: W,
      resourceTitleString: be,
      resource: Ie,
      setextHeading: d(Q),
      setextHeadingLineSequence: U,
      setextHeadingText: $,
      strong: d(),
      thematicBreak: d()
    }
  };
  Y_(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(R) {
    let z = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [z],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, ue = [];
    let Se = -1;
    for (; ++Se < R.length; )
      if (R[Se][1].type === "listOrdered" || R[Se][1].type === "listUnordered")
        if (R[Se][0] === "enter")
          ue.push(Se);
        else {
          const nn = ue.pop();
          Se = a(R, nn, Se);
        }
    for (Se = -1; ++Se < R.length; ) {
      const nn = n[R[Se][0]];
      G_.call(nn, R[Se][1].type) && nn[R[Se][1].type].call(Object.assign({
        sliceSerialize: R[Se][2].sliceSerialize
      }, ie), R[Se][1]);
    }
    if (ie.tokenStack.length > 0) {
      const nn = ie.tokenStack[ie.tokenStack.length - 1];
      (nn[1] || Vv).call(ie, void 0, nn[0]);
    }
    for (z.position = {
      start: Zr(R.length > 0 ? R[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Zr(R.length > 0 ? R[R.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Se = -1; ++Se < n.transforms.length; )
      z = n.transforms[Se](z) || z;
    return z;
  }
  function a(R, z, ie) {
    let ue = z - 1, Se = -1, nn = !1, pn, tn, ln, mn;
    for (; ++ue <= ie; ) {
      const cn = R[ue];
      switch (cn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          cn[0] === "enter" ? Se++ : Se--, mn = void 0;
          break;
        }
        case "lineEndingBlank": {
          cn[0] === "enter" && (pn && !mn && !Se && !ln && (ln = ue), mn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          mn = void 0;
      }
      if (!Se && cn[0] === "enter" && cn[1].type === "listItemPrefix" || Se === -1 && cn[0] === "exit" && (cn[1].type === "listUnordered" || cn[1].type === "listOrdered")) {
        if (pn) {
          let xn = ue;
          for (tn = void 0; xn--; ) {
            const en = R[xn];
            if (en[1].type === "lineEnding" || en[1].type === "lineEndingBlank") {
              if (en[0] === "exit") continue;
              tn && (R[tn][1].type = "lineEndingBlank", nn = !0), en[1].type = "lineEnding", tn = xn;
            } else if (!(en[1].type === "linePrefix" || en[1].type === "blockQuotePrefix" || en[1].type === "blockQuotePrefixWhitespace" || en[1].type === "blockQuoteMarker" || en[1].type === "listItemIndent")) break;
          }
          ln && (!tn || ln < tn) && (pn._spread = !0), pn.end = Object.assign({}, tn ? R[tn][1].start : cn[1].end), R.splice(tn || ue, 0, ["exit", pn, cn[2]]), ue++, ie++;
        }
        if (cn[1].type === "listItemPrefix") {
          const xn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, cn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          pn = xn, R.splice(ue, 0, ["enter", xn, cn[2]]), ue++, ie++, ln = void 0, mn = !0;
        }
      }
    }
    return R[z][1]._spread = nn, ie;
  }
  function o(R, z) {
    return ie;
    function ie(ue) {
      l.call(this, R(ue), ue), z && z.call(this, ue);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(R, z, ie) {
    this.stack[this.stack.length - 1].children.push(R), this.stack.push(R), this.tokenStack.push([z, ie || void 0]), R.position = {
      start: Zr(z.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(R) {
    return z;
    function z(ie) {
      R && R.call(this, ie), m.call(this, ie);
    }
  }
  function m(R, z) {
    const ie = this.stack.pop(), ue = this.tokenStack.pop();
    if (ue)
      ue[0].type !== R.type && (z ? z.call(this, R, ue[0]) : (ue[1] || Vv).call(this, R, ue[0]));
    else throw new Error("Cannot close `" + R.type + "` (" + to({
      start: R.start,
      end: R.end
    }) + "): it’s not open");
    ie.position.end = Zr(R.end);
  }
  function u() {
    return GD(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(R) {
    if (this.data.expectingFirstListItemValue) {
      const z = this.stack[this.stack.length - 2];
      z.start = Number.parseInt(this.sliceSerialize(R), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function g() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.lang = R;
  }
  function C() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.meta = R;
  }
  function S() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function N() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R.replace(/(\r?\n|\r)$/g, "");
  }
  function y(R) {
    const z = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = z, ie.identifier = Gi(this.sliceSerialize(R)).toLowerCase();
  }
  function V() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = R;
  }
  function T() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = R;
  }
  function F(R) {
    const z = this.stack[this.stack.length - 1];
    if (!z.depth) {
      const ie = this.sliceSerialize(R).length;
      z.depth = ie;
    }
  }
  function $() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(R) {
    const z = this.stack[this.stack.length - 1];
    z.depth = this.sliceSerialize(R).codePointAt(0) === 61 ? 1 : 2;
  }
  function Q() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function X(R) {
    const ie = this.stack[this.stack.length - 1].children;
    let ue = ie[ie.length - 1];
    (!ue || ue.type !== "text") && (ue = H(), ue.position = {
      start: Zr(R.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(ue)), this.stack.push(ue);
  }
  function ae(R) {
    const z = this.stack.pop();
    z.value += this.sliceSerialize(R), z.position.end = Zr(R.end);
  }
  function J(R) {
    const z = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = z.children[z.children.length - 1];
      ie.position.end = Zr(R.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(z.type) && (X.call(this, R), ae.call(this, R));
  }
  function B() {
    this.data.atHardBreak = !0;
  }
  function O() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function q() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function ee() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function ve() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = z, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function de() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = z, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function le(R) {
    const z = this.sliceSerialize(R), ie = this.stack[this.stack.length - 2];
    ie.label = KO(z), ie.identifier = Gi(z).toLowerCase();
  }
  function pe() {
    const R = this.stack[this.stack.length - 1], z = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const ue = R.children;
      ie.children = ue;
    } else
      ie.alt = z;
  }
  function W() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = R;
  }
  function be() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = R;
  }
  function Ie() {
    this.data.inReference = void 0;
  }
  function G() {
    this.data.referenceType = "collapsed";
  }
  function He(R) {
    const z = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = z, ie.identifier = Gi(this.sliceSerialize(R)).toLowerCase(), this.data.referenceType = "full";
  }
  function qe(R) {
    this.data.characterReferenceType = R.type;
  }
  function Oe(R) {
    const z = this.sliceSerialize(R), ie = this.data.characterReferenceType;
    let ue;
    ie ? (ue = L_(z, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ue = Dp(z);
    const Se = this.stack[this.stack.length - 1];
    Se.value += ue;
  }
  function Be(R) {
    const z = this.stack.pop();
    z.position.end = Zr(R.end);
  }
  function $e(R) {
    ae.call(this, R);
    const z = this.stack[this.stack.length - 1];
    z.url = this.sliceSerialize(R);
  }
  function Ue(R) {
    ae.call(this, R);
    const z = this.stack[this.stack.length - 1];
    z.url = "mailto:" + this.sliceSerialize(R);
  }
  function Re() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function an() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ee() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ke() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Qe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function fe() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ye() {
    return {
      type: "break"
    };
  }
  function De() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ve() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function un(R) {
    return {
      type: "list",
      ordered: R.type === "listOrdered",
      start: null,
      spread: R._spread,
      children: []
    };
  }
  function E(R) {
    return {
      type: "listItem",
      spread: R._spread,
      checked: null,
      children: []
    };
  }
  function x() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function D() {
    return {
      type: "strong",
      children: []
    };
  }
  function H() {
    return {
      type: "text",
      value: ""
    };
  }
  function Y() {
    return {
      type: "thematicBreak"
    };
  }
}
function Zr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Y_(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? Y_(e, i) : JO(e, i);
  }
}
function JO(e, n) {
  let r;
  for (r in n)
    if (G_.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Vv(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + to({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + to({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + to({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function XO(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return YO(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function ZO(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function eP(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function nP(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function tP(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function rP(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function iP(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = pa(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function aP(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function oP(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function Q_(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function sP(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Q_(e, n);
  const a = { src: pa(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function lP(e, n) {
  const r = { src: pa(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function cP(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function dP(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Q_(e, n);
  const a = { href: pa(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function uP(e, n) {
  const r = { href: pa(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function mP(e, n, r) {
  const i = e.all(n), a = r ? pP(r) : J_(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function pP(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = J_(r[i]);
  }
  return n;
}
function J_(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function fP(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function hP(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function yP(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function gP(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function vP(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Ip(n.children[1]), d = T_(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function kP(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, g = s ? s[d] : void 0;
    g && (h.align = g);
    let C = { type: "element", tagName: o, properties: h, children: [] };
    f && (C.children = e.all(f), e.patch(f, C), C = e.applyData(f, C)), m.push(C);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function bP(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const zv = 9, Uv = 32;
function xP(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Mv(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Mv(n.slice(a), a > 0, !1)), o.join("");
}
function Mv(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === zv || o === Uv; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === zv || o === Uv; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function _P(e, n) {
  const r = { type: "text", value: xP(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function SP(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const NP = {
  blockquote: ZO,
  break: eP,
  code: nP,
  delete: tP,
  emphasis: rP,
  footnoteReference: iP,
  heading: aP,
  html: oP,
  imageReference: sP,
  image: lP,
  inlineCode: cP,
  linkReference: dP,
  link: uP,
  listItem: mP,
  list: fP,
  paragraph: hP,
  // @ts-expect-error: root is different, but hard to type.
  root: yP,
  strong: gP,
  table: vP,
  tableCell: bP,
  tableRow: kP,
  text: _P,
  thematicBreak: SP,
  toml: zo,
  yaml: zo,
  definition: zo,
  footnoteDefinition: zo
};
function zo() {
}
const X_ = -1, ll = 0, Ts = 1, $s = 2, Pp = 3, Ap = 4, Lp = 5, Vp = 6, Z_ = 7, eS = 8, Bv = typeof self == "object" ? self : globalThis, jP = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case ll:
      case X_:
        return r(s, a);
      case Ts: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case $s: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case Pp:
        return r(new Date(s), a);
      case Ap: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case Lp: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case Vp: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case Z_: {
        const { name: l, message: d } = s;
        return r(new Bv[l](d), a);
      }
      case eS:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Bv[o](s), a);
  };
  return i;
}, qv = (e) => jP(/* @__PURE__ */ new Map(), e)(0), Di = "", { toString: wP } = {}, { keys: CP } = Object, Ea = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [ll, n];
  const r = wP.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [Ts, Di];
    case "Object":
      return [$s, Di];
    case "Date":
      return [Pp, Di];
    case "RegExp":
      return [Ap, Di];
    case "Map":
      return [Lp, Di];
    case "Set":
      return [Vp, Di];
  }
  return r.includes("Array") ? [Ts, r] : r.includes("Error") ? [Z_, r] : [$s, r];
}, Uo = ([e, n]) => e === ll && (n === "function" || n === "symbol"), FP = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = Ea(s);
    switch (l) {
      case ll: {
        let u = s;
        switch (d) {
          case "bigint":
            l = eS, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([X_], s);
        }
        return a([l, u], s);
      }
      case Ts: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case $s: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of CP(s))
          (e || !Uo(Ea(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case Pp:
        return a([l, s.toISOString()], s);
      case Ap: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case Lp: {
        const u = [], f = a([l, u], s);
        for (const [h, g] of s)
          (e || !(Uo(Ea(h)) || Uo(Ea(g)))) && u.push([o(h), o(g)]);
        return f;
      }
      case Vp: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !Uo(Ea(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Hv = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return FP(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, Ds = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? qv(Hv(e, n)) : structuredClone(e)
) : (e, n) => qv(Hv(e, n));
function IP(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function EP(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function TP(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || IP, i = e.options.footnoteBackLabel || EP, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = pa(f.toLowerCase());
    let g = 0;
    const C = [], S = e.footnoteCounts.get(f);
    for (; S !== void 0 && ++g <= S; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let y = typeof r == "string" ? r : r(d, g);
      typeof y == "string" && (y = { type: "text", value: y }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (g > 1 ? "-" + g : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, g),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const N = u[u.length - 1];
    if (N && N.type === "element" && N.tagName === "p") {
      const y = N.children[N.children.length - 1];
      y && y.type === "text" ? y.value += " " : N.children.push({ type: "text", value: " " }), N.children.push(...C);
    } else
      u.push(...C);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, w), l.push(w);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...Ds(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const nS = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return OP;
    if (typeof e == "function")
      return cl(e);
    if (typeof e == "object")
      return Array.isArray(e) ? $P(e) : DP(e);
    if (typeof e == "string")
      return RP(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function $P(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = nS(e[r]);
  return cl(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function DP(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return cl(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function RP(e) {
  return cl(n);
  function n(r) {
    return r && r.type === e;
  }
}
function cl(e) {
  return n;
  function n(r, i, a) {
    return !!(PP(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function OP() {
  return !0;
}
function PP(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const tS = [], AP = !0, Wv = !1, LP = "skip";
function VP(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = nS(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const g = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (g ? "<" + g + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let g = tS, C, S, N;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (g = zP(r(d, u)), g[0] === Wv))
        return g;
      if ("children" in d && d.children) {
        const w = (
          /** @type {UnistParent} */
          d
        );
        if (w.children && g[0] !== LP)
          for (S = (i ? w.children.length : -1) + s, N = u.concat(w); S > -1 && S < w.children.length; ) {
            const y = w.children[S];
            if (C = l(y, S, N)(), C[0] === Wv)
              return C;
            S = typeof C[1] == "number" ? C[1] : S + s;
          }
      }
      return g;
    }
  }
}
function zP(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [AP, e] : e == null ? tS : [e];
}
function rS(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), VP(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const Sm = {}.hasOwnProperty, UP = {};
function MP(e, n) {
  const r = n || UP, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...NP, ...r.handlers }, l = {
    all: m,
    applyData: qP,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: BP,
    wrap: WP
  };
  return rS(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, g = l.handlers[h];
    if (Sm.call(l.handlers, h) && g)
      return g(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: S, ...N } = u, w = Ds(N);
        return w.children = l.all(u), w;
      }
      return Ds(u);
    }
    return (l.options.unknownHandler || HP)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let g = -1;
      for (; ++g < h.length; ) {
        const C = l.one(h[g], u);
        if (C) {
          if (g && h[g - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = Kv(C.value)), !Array.isArray(C) && C.type === "element")) {
            const S = C.children[0];
            S && S.type === "text" && (S.value = Kv(S.value));
          }
          Array.isArray(C) ? f.push(...C) : f.push(C);
        }
      }
    }
    return f;
  }
}
function BP(e, n) {
  e.position && (n.position = ND(e));
}
function qP(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, Ds(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function HP(e, n) {
  const r = n.data || {}, i = "value" in n && !(Sm.call(r, "hProperties") || Sm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function WP(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Kv(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Gv(e, n) {
  const r = MP(e, n), i = r.one(e, void 0), a = TP(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function KP(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Gv(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Gv(r, { file: i, ...e || n })
    );
  };
}
function Yv(e) {
  if (e)
    throw e;
}
var ku, Qv;
function GP() {
  if (Qv) return ku;
  Qv = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return ku = function d() {
    var m, u, f, h, g, C, S = arguments[0], N = 1, w = arguments.length, y = !1;
    for (typeof S == "boolean" && (y = S, S = arguments[1] || {}, N = 2), (S == null || typeof S != "object" && typeof S != "function") && (S = {}); N < w; ++N)
      if (m = arguments[N], m != null)
        for (u in m)
          f = l(S, u), h = l(m, u), S !== h && (y && h && (o(h) || (g = a(h))) ? (g ? (g = !1, C = f && a(f) ? f : []) : C = f && o(f) ? f : {}, s(S, { name: u, newValue: d(y, C, h) })) : typeof h < "u" && s(S, { name: u, newValue: h }));
    return S;
  }, ku;
}
var YP = GP();
const bu = /* @__PURE__ */ Hm(YP);
function Nm(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function QP() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? JP(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function JP(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Ir = { basename: XP, dirname: ZP, extname: eA, join: nA, sep: "/" };
function XP(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  wo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function ZP(e) {
  if (wo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function eA(e) {
  wo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function nA(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    wo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : tA(r);
}
function tA(e) {
  wo(e);
  const n = e.codePointAt(0) === 47;
  let r = rA(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function rA(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function wo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const iA = { cwd: aA };
function aA() {
  return "/";
}
function jm(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function oA(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!jm(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return sA(e);
}
function sA(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const xu = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class iS {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? jm(n) ? r = { path: n } : typeof n == "string" || lA(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : iA.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < xu.length; ) {
      const o = xu[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      xu.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Ir.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Su(n, "basename"), _u(n, "basename"), this.path = Ir.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Ir.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Jv(this.basename, "dirname"), this.path = Ir.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Ir.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (_u(n, "extname"), Jv(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ir.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    jm(n) && (n = oA(n)), Su(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Ir.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Su(n, "stem"), _u(n, "stem"), this.path = Ir.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new At(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function _u(e, n) {
  if (e && e.includes(Ir.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Ir.sep + "`"
    );
}
function Su(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Jv(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function lA(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const cA = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), dA = {}.hasOwnProperty;
class zp extends cA {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = QP();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new zp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(bu(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (wu("data", this.frozen), this.namespace[n] = r, this) : dA.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (wu("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = Mo(n), i = this.parser || this.Parser;
    return Nu("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Nu("process", this.parser || this.Parser), ju("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = Mo(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const g = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), C = i.stringify(g, h);
        pA(C) ? h.value = C : h.result = C, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Nu("processSync", this.parser || this.Parser), ju("processSync", this.compiler || this.Compiler), this.process(n, a), Zv("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Yv(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Xv(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = Mo(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const g = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(g) : i(void 0, g, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Zv("runSync", "run", i), a;
    function o(s, l) {
      Yv(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = Mo(r), a = this.compiler || this.Compiler;
    return ju("stringify", a), Xv(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (wu("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = bu(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [g, ...C] = u;
        const S = i[h][1];
        Nm(S) && Nm(g) && (g = bu(!0, S, g)), i[h] = [m, g, ...C];
      }
    }
  }
}
const uA = new zp().freeze();
function Nu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function ju(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function wu(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Xv(e) {
  if (!Nm(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Zv(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Mo(e) {
  return mA(e) ? e : new iS(e);
}
function mA(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function pA(e) {
  return typeof e == "string" || fA(e);
}
function fA(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const hA = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", ek = [], nk = { allowDangerousHtml: !0 }, yA = /^(https?|ircs?|mailto|xmpp)$/i, gA = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function vA(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || ek, d = e.remarkPlugins || ek, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...nk } : nk, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || kA, g = uA().use(XO).use(d).use(KP, m).use(l), C = new iS();
  typeof i == "string" && (C.value = i);
  for (const y of gA)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + hA + y.id, void 0);
  const S = g.parse(C);
  let N = g.runSync(S, C);
  return a && (N = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      N.type === "root" ? N.children : [N]
    )
  }), rS(N, w), ED(N, {
    Fragment: ze.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: ze.jsx,
    jsxs: ze.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function w(y, V, T) {
    if (y.type === "raw" && T && typeof V == "number")
      return u ? T.children.splice(V, 1) : T.children[V] = { type: "text", value: y.value }, V;
    if (y.type === "element") {
      let F;
      for (F in yu)
        if (Object.hasOwn(yu, F) && Object.hasOwn(y.properties, F)) {
          const $ = y.properties[F], U = yu[F];
          (U === null || U.includes(y.tagName)) && (y.properties[F] = h(String($ || ""), F, y));
        }
    }
    if (y.type === "element") {
      let F = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!F && r && typeof V == "number" && (F = !r(y, V, T)), F && T && typeof V == "number")
        return f && y.children ? T.children.splice(V, 1, ...y.children) : T.children.splice(V, 1), V;
    }
  }
}
function kA(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    yA.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Cu = { exports: {} }, Ta = {}, tk;
function bA() {
  if (tk) return Ta;
  tk = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ta.Fragment = r, Ta.jsx = s, Ta.jsxs = s, Ta;
}
var Bo = {}, rk;
function xA() {
  return rk || (rk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Bo.Fragment = i, Bo.jsx = Rn, Bo.jsxs = Mn;
  })()), Bo;
}
var ik;
function _A() {
  return ik || (ik = 1, process.env.NODE_ENV === "production" ? Cu.exports = bA() : Cu.exports = xA()), Cu.exports;
}
var re = _A();
const SA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, NA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, jA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, wA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, CA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, FA = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": SA,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": NA,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": jA,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": wA,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": CA
};
function Co(e) {
  return FA[e] ?? {};
}
const IA = Co(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), EA = Co(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), qo = ({
  title: e,
  children: n
}) => /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), TA = "_issueAvatar_kc0sw_1", $A = "_issueField_kc0sw_9", DA = "_issueDescription_kc0sw_12", Ho = {
  issueAvatar: TA,
  issueField: $A,
  issueDescription: DA
}, aS = ({ issue: e }) => /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
  /* @__PURE__ */ re.jsx(qo, { title: "Assignee", children: /* @__PURE__ */ re.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Ho.issueAvatar,
      children: [
        /* @__PURE__ */ re.jsx(
          Bm,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ re.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ re.jsx(qo, { title: "Team", children: /* @__PURE__ */ re.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Ho.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ re.jsx(qo, { title: "Project", children: /* @__PURE__ */ re.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Ho.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ re.jsx(qo, { title: "Description", children: /* @__PURE__ */ re.jsx(vA, { className: Ho.issueDescription, children: e.description }) })
] }), RA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), OA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), PA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), AA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), LA = /* @__PURE__ */ re.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), oS = {
  0: RA,
  1: LA,
  2: AA,
  3: PA,
  4: OA
}, VA = (e) => e in oS, Rs = ({ priority: e }) => VA(e) ? oS[e] : /* @__PURE__ */ re.jsx(An, { "data-testid": "defaultPriorityTag", children: e }), zA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), UA = (e, n) => /* @__PURE__ */ re.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ re.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ re.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), MA = (e, n) => /* @__PURE__ */ re.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ re.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ re.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), BA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), qA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), HA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), wm = {
  backlog: (e, n) => zA(e, n),
  unstarted: (e, n) => UA(e, n),
  started: (e, n) => MA(e, n),
  done: (e, n) => BA(e, n),
  canceled: (e, n) => qA(e, n),
  completed: (e, n) => HA(e, n)
}, WA = (e) => e in wm, Os = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => WA(e) ? wm[e](n, r) : wm.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), KA = "_wrapper_e0qj3_1", GA = "_resultTitle_e0qj3_21", YA = "_resultTooltipTitle_e0qj3_28", QA = "_resultLinkIcon_e0qj3_31", $a = {
  wrapper: KA,
  resultTitle: GA,
  resultTooltipTitle: YA,
  resultLinkIcon: QA
}, JA = ({
  issue: e
}) => {
  const [n, r] = se(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Um(F0()), o = ot(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ re.jsx(
    We,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", className: $a.wrapper, children: [
        /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ re.jsx(
              Os,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ re.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ re.jsx(Rs, { priority: e.priority })
          ] }),
          /* @__PURE__ */ re.jsx(An, { children: e.state.name })
        ] }),
        /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ re.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: $a.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ re.jsx(aS, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ re.jsx(
        dt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: $a.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ re.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ re.jsx(
                    Os,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ re.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ re.jsx(Rs, { priority: e.priority })
                ] }),
                /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "4", className: $a.resultTitle, children: e.title }),
                n && /* @__PURE__ */ re.jsx(
                  me,
                  {
                    className: $a.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, XA = "_loader_13xpk_1", ZA = "_dropdown_13xpk_8", e2 = "_loadMore_13xpk_13", Fu = {
  loader: XA,
  dropdown: ZA,
  loadMore: e2
}, n2 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = fn(), [f, { data: h, loading: g, networkStatus: C }] = u(
    IA,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Ni(
    () => {
      !g && s !== "" && C === er.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Le(() => {
    g || o([]);
  }, [s]), Le(() => {
    if (h && Object.keys(h).length > 0) {
      const N = h.Linear.searchIssues.edges.map(
        ({ node: T }) => T
      ), w = a.filter(
        (T) => !n.find((F) => F.id === T.id)
      ), y = w.filter(
        (T) => !N.find(
          (F) => F.id === T.id
        )
      ), V = N.filter(
        (T) => !n.find((F) => F.id === T.id)
      );
      n.length > 0 ? o(
        d ? [...y, ...V] : V
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...w, ...N] : N
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const S = () => {
    !g && s !== "" && C === er.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ re.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ re.jsxs(
    ni,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (N) => N?.title,
      onChange: (N) => e(N.selectedValues[0]),
      dropdownProps: { className: Fu.dropdown },
      filter: {
        value: s,
        onChange: (N) => {
          const w = N.target.value;
          l(w);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((N) => /* @__PURE__ */ re.jsx(JA, { issue: N }, N.id)),
        r?.hasNextPage && !g && s !== "" && a.length && /* @__PURE__ */ re.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => S(),
            className: Fu.loadMore,
            children: /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        g && s !== "" && /* @__PURE__ */ re.jsx(b, { justifyContent: "center", className: Fu.loader, children: /* @__PURE__ */ re.jsx(dn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !g && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, t2 = "_collapse_su0f9_1", r2 = "_collapseHeader_su0f9_8", i2 = "_collapseContent_su0f9_31", a2 = "_url_su0f9_35", o2 = "_externalLink_su0f9_51", s2 = "_emptyState_su0f9_55", ei = {
  collapse: t2,
  collapseHeader: r2,
  collapseContent: i2,
  url: a2,
  externalLink: o2,
  emptyState: s2
}, l2 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = _n();
  return n ? /* @__PURE__ */ re.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ re.jsx(dn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ re.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: ei.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ re.jsx(
          Et,
          {
            slotEnd: /* @__PURE__ */ re.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: ei.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ re.jsxs(
            mr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: ei.collapse,
              children: [
                /* @__PURE__ */ re.jsx(mr.Header, { className: ei.collapseHeader, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ re.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ re.jsx(We, { content: /* @__PURE__ */ re.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(
                        Os,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ re.jsxs(
                        A.ExternalLink,
                        {
                          className: ei.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ re.jsx(me, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ re.jsx(We, { content: /* @__PURE__ */ re.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(Rs, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ re.jsx(An, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ re.jsx(mr.Content, { className: ei.collapseContent, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ re.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ re.jsx(An, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ re.jsx(aS, { issue: u }),
                  /* @__PURE__ */ re.jsx(
                    Kn,
                    {
                      slotStart: /* @__PURE__ */ re.jsx(me, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ re.jsxs(
                    Et,
                    {
                      slotEnd: /* @__PURE__ */ re.jsx(me, { name: "external-link" }),
                      variant: "tertiary",
                      className: ei.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ re.jsx(
          Kn,
          {
            slotStart: /* @__PURE__ */ re.jsx(me, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ re.jsx(
          Et,
          {
            slotEnd: /* @__PURE__ */ re.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: ei.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, c2 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, sS = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => sS(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, d2 = "_modalBody_iv3ua_1", u2 = "_error_iv3ua_5", m2 = "_dropdown_iv3ua_16", Ri = {
  modalBody: d2,
  error: u2,
  dropdown: m2
}, p2 = Co(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), f2 = Co(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), h2 = Co(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), y2 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = fn(), { control: m, handleSubmit: u, reset: f } = St(), [h, g] = se([]), [C, S] = se(), [N, w] = se([]), [y, V] = se(), [T, F] = se([]), [$, U] = se(), [Q, X] = se([]), [ae, J] = se(), [B, O] = se([]), [q, ee] = se(), [ve, de] = se(!1), { useMutation: le } = fn(), { track: pe } = _n(), [W, { loading: be }] = le(
    p2,
    {
      onError: () => {
        de(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ee) => {
        const Ke = {
          identifier: Ee.Linear?.issueCreate?.issue?.identifier,
          url: Ee.Linear?.issueCreate?.issue?.url
        };
        Ee.Linear && Ee.Linear?.issueCreate?.issue?.id && (a(Ee.Linear?.issueCreate?.issue?.id), Ue(Ke), de(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ee.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), pe("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ie,
    { data: G, loading: He, error: qe }
  ] = l(f2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Ke = Ee.Linear.teams.edges.map(
        ({ node: Qe }) => Qe
      );
      g(Ke), X(Ee.Linear.issuePriorityValues), s(`${j2}${Ee.Linear.organization.urlKey}`);
    }
  }), [Oe, { data: Be, loading: $e }] = l(h2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Ke = Ee?.Linear?.team?.projects?.edges?.map(
        ({ node: ye }) => ye
      );
      w(Ke);
      const Qe = Ee?.Linear?.team?.states?.edges?.map(
        ({ node: ye }) => ye
      );
      F(Qe);
      const fe = Ee?.Linear?.team?.templates?.edges?.map(
        ({ node: ye }) => ye
      );
      O(
        fe.filter(
          (ye) => ye.type === "issue"
        )
      );
    }
  }), Ue = (Ee) => {
    r(!1), V(void 0), S(void 0), U(void 0), J(void 0), ee(void 0), Ee && (e(Ee), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Re = (Ee) => {
    G && !He && (W({
      variables: {
        issueTitle: Ee.title,
        issueDescription: Ee?.description,
        teamId: Ee.team.id,
        projectId: Ee?.project?.id,
        statusId: Ee?.status?.id,
        priority: Ee?.priority?.priority
      }
    }), de(!0));
  };
  Le(() => {
    n && Ie();
  }, [n]);
  const an = () => {
    pe("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ re.jsxs(
    Tt,
    {
      isOpen: n,
      onClose: () => {
        an(), Ue();
      },
      children: [
        /* @__PURE__ */ re.jsx(
          $t,
          {
            title: "Create new Linear issue",
            onClose: () => {
              an(), Ue();
            }
          }
        ),
        /* @__PURE__ */ re.jsx(
          Dt,
          {
            className: Ri.modalBody,
            "data-testid": "createIssueModalBody",
            children: qe ? /* @__PURE__ */ re.jsx(Fn, { error: qe }) : /* @__PURE__ */ re.jsx("form", { onSubmit: u(Re), id: "issueCreationForm", children: /* @__PURE__ */ re.jsxs(ht, { children: [
              /* @__PURE__ */ re.jsx(we, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ee, onChange: Ke },
                    fieldState: { error: Qe }
                  }) => /* @__PURE__ */ re.jsx(
                    hn,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Qe?.message ?? null
                      },
                      children: /* @__PURE__ */ re.jsx(
                        ni,
                        {
                          dropdownProps: { className: Ri.dropdown },
                          placeholder: "Select Linear team",
                          className: rt({ [Ri.error]: Qe }),
                          getItemTitleByValue: (fe) => fe?.name,
                          onChange: (fe) => {
                            V(void 0), U(void 0), J(void 0), ee(void 0), S(fe.selectedValues[0]), Oe({
                              variables: { teamId: fe.selectedValues[0].id }
                            }), Ke(fe.selectedValues[0]);
                          },
                          value: C ? [Ee] : void 0,
                          children: h?.map((fe) => /* @__PURE__ */ re.jsx(
                            dt.Item,
                            {
                              value: fe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(A.Paragraph, { children: fe.name })
                            },
                            fe.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(we, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ee, onChange: Ke } }) => {
                    const Qe = $e ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ re.jsx(hn, { label: "Project", children: /* @__PURE__ */ re.jsx(
                      ni,
                      {
                        dropdownProps: { className: Ri.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (fe) => fe?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Linear project" : "Select a Team first",
                        onChange: (fe) => {
                          V(fe.selectedValues[0]), Ke(fe.selectedValues[0]);
                        },
                        value: y ? [Ee] : Qe,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          $e && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(dn, { size: 24 })
                            }
                          ),
                          Be && !$e && N.map((fe) => /* @__PURE__ */ re.jsx(
                            dt.Item,
                            {
                              value: fe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(A.Paragraph, { children: fe.name })
                            },
                            fe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(we, { span: 6, children: /* @__PURE__ */ re.jsx(hn, { label: "Template", children: /* @__PURE__ */ re.jsx(
                ni,
                {
                  clearable: !0,
                  dropdownProps: { className: Ri.dropdown },
                  disabled: !C || $e,
                  placeholder: C ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ee) => Ee?.name,
                  onChange: (Ee) => {
                    if (Ee.selectedValues.length > 0) {
                      ee(Ee.selectedValues[0]);
                      const Ke = JSON.parse(
                        Ee.selectedValues[0].templateData
                      ), Qe = Q.filter(
                        (Ve) => Ve.priority === Ke.priority
                      );
                      J(
                        Qe ? Qe[0] : void 0
                      );
                      const fe = T.filter(
                        (Ve) => Ve.id === Ke.stateId
                      );
                      U(
                        fe ? fe[0] : void 0
                      );
                      const ye = N.filter(
                        (Ve) => Ve.id === Ke.projectId
                      );
                      V(
                        ye ? ye[0] : void 0
                      );
                      const De = Ke.description;
                      f({
                        title: Ke?.title,
                        priority: Qe[0],
                        status: fe[0],
                        project: ye[0],
                        description: De ? sS(De, c2) : "",
                        team: C
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: C
                      }), V(void 0), J(void 0), U(void 0), ee(void 0);
                  },
                  value: q ? [q] : void 0,
                  children: B?.map((Ee) => /* @__PURE__ */ re.jsx(
                    dt.Item,
                    {
                      value: Ee,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ re.jsx(A.Paragraph, { children: Ee.name })
                    },
                    Ee.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ re.jsx(we, { span: 6, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ee, value: Ke },
                    fieldState: { error: Qe }
                  }) => /* @__PURE__ */ re.jsx(
                    pr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Ke || "",
                        onChange: Ee
                      },
                      meta: {
                        error: Qe?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(we, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ee, onChange: Ke } }) => {
                    const Qe = $e ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(hn, { label: "Status", children: /* @__PURE__ */ re.jsx(
                      ni,
                      {
                        dropdownProps: { className: Ri.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (fe) => fe?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue status" : "Select a Team first",
                        onChange: (fe) => {
                          U(fe.selectedValues[0]), Ke(fe.selectedValues[0]);
                        },
                        value: $ ? [Ee] : Qe,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          $e && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(dn, { size: 24 })
                            }
                          ),
                          Be && !$e && T.map((fe) => /* @__PURE__ */ re.jsx(
                            dt.Item,
                            {
                              value: fe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      Os,
                                      {
                                        type: fe.type,
                                        color: fe.color,
                                        name: fe.name
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(A.Paragraph, { children: fe.name })
                                  ]
                                }
                              )
                            },
                            fe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(we, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ee, onChange: Ke } }) => {
                    const Qe = He ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(hn, { label: "Priority", children: /* @__PURE__ */ re.jsx(
                      ni,
                      {
                        clearable: !0,
                        getItemTitleByValue: (fe) => fe?.label,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue priority" : "Select a Team first",
                        onChange: (fe) => {
                          J(fe.selectedValues[0]), Ke(fe.selectedValues[0]);
                        },
                        value: ae ? [Ee] : Qe,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          $e && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(dn, { size: 24 })
                            }
                          ),
                          G && !He && Q.map((fe) => /* @__PURE__ */ re.jsx(
                            dt.Item,
                            {
                              value: fe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      Rs,
                                      {
                                        priority: fe.priority
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(A.Paragraph, { children: fe.label })
                                  ]
                                }
                              )
                            },
                            fe.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(we, { children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ee, value: Ke },
                    fieldState: { error: Qe }
                  }) => /* @__PURE__ */ re.jsx(
                    w0,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Ke || "",
                        onChange: Ee
                      },
                      meta: {
                        error: Qe?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ re.jsx(
          Pt,
          {
            confirmOnClick: u(Re),
            confirmProps: {
              disabled: be || !G,
              isLoading: ve || He || $e,
              loadingIndicator: /* @__PURE__ */ re.jsx(dn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              an(), Ue();
            }
          }
        )
      ]
    }
  );
}, g2 = "_modalWrapper_4kh9u_1", v2 = "_copyButton_4kh9u_6", k2 = "_copyWrapper_4kh9u_15", b2 = "_copyField_4kh9u_24", x2 = "_externalLink_4kh9u_47", _2 = "_externalLinkIcon_4kh9u_52", S2 = "_textWrapper_4kh9u_56", li = {
  modalWrapper: g2,
  copyButton: v2,
  copyWrapper: k2,
  copyField: b2,
  externalLink: x2,
  externalLinkIcon: _2,
  textWrapper: S2
}, N2 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ re.jsxs(
  Tt,
  {
    isOpen: !!n && e,
    className: li.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ re.jsx(
        $t,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ re.jsx(Dt, { children: /* @__PURE__ */ re.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ re.jsxs(A.Paragraph, { className: li.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ re.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: li.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ re.jsx(me, { name: "external-link", className: li.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ re.jsx(hn, { label: "Linear issue link", children: /* @__PURE__ */ re.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: li.copyWrapper,
                children: [
                  /* @__PURE__ */ re.jsx(
                    Nr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: li.copyField
                    }
                  ),
                  /* @__PURE__ */ re.jsx(
                    C0,
                    {
                      className: li.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ re.jsx(
        Pt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), j2 = "https://linear.app/", w2 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, g] = se(), { useLazyQuery: C } = fn(), [S, N] = se(""), w = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: V } = _n(), {
    loading: T,
    data: F,
    error: $,
    store: U
  } = Vm(e?.conversationId ?? null), [
    Q,
    {
      data: X,
      loading: ae,
      networkStatus: J,
      error: B
    }
  ] = C(EA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Le(() => {
    !T && !$ && F && F?.linear?.issues?.length > 0 ? (o(F.linear.issues), Q({
      variables: {
        linkedIssues: F.linear.issues
      }
    })) : !T && !$ && (i([]), o([]));
  }, [F, T, $]), Le(() => {
    X && X?.Linear && !ae && J === er.ready && Object.keys(X).length > 0 && i(X.Linear.issues?.edges?.map(({ node: de }) => de));
  }, [X, ae, J]);
  const O = (de) => {
    de && de?.team?.organization?.urlKey && V("linear:link:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: de.id
    });
    const le = (pe) => pe.id === de?.id;
    r.some((pe) => pe && le(pe)) || (F && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, de.id]
      }
    }));
  }, q = (de) => {
    const le = F?.linear.issues.filter((pe) => pe !== de) || [];
    V("linear:unlink:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: de
    }), i(r.filter(({ id: pe }) => pe !== de)), o(le), U({
      linear: {
        issues: le
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  }, ve = T || ae || !F && !$ || (F?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !T && !ae && (B || $) ? /* @__PURE__ */ re.jsx(Fn, { error: B || $ }) : /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ re.jsxs(
      Tt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ re.jsx(
            $t,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ re.jsx(Dt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ re.jsx(
            Pt,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      y2,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (de) => m(de),
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        addToLinkedIssueIds: (de) => {
          U({
            linear: {
              issues: [...a, de]
            }
          });
        },
        setCreatedIssue: (de) => g(de),
        organizationUrl: S,
        setOrganizationUrl: (de) => N(de)
      }
    ),
    /* @__PURE__ */ re.jsx(
      N2,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ re.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          w && /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
            /* @__PURE__ */ re.jsx(
              Kn,
              {
                variant: "primary",
                onClick: () => {
                  V("linear:create:new:issue:clicked", {
                    linearInstanceUrl: S
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ re.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ re.jsx(n2, { handleSelect: O, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      l2,
      {
        linkedIssues: r,
        isLoading: ve,
        handleUnlinkIssue: q,
        showUnlinkAllModal: (de) => l(de),
        showUnlinkAllButton: y,
        organizationUrl: S
      }
    )
  ] });
}, C2 = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Yr
  }
], ak = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], ci = "LINEAR", F2 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, I2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = St({
    mode: "onChange",
    defaultValues: F2
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = ea({
    integrationId: e,
    integrationType: ci,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: V
  } = na({
    integrationId: e,
    fieldDefinitions: ak,
    form: l,
    onMisconfigured: C
  }), [T, F] = se(s ? [] : null);
  Le(() => {
    F(s ? [] : null);
  }, [e, s]), Le(() => {
    V && T === null && F(V.renderConditions ?? []);
  }, [V, T]);
  const $ = o && T !== null, U = (X) => ra(X, {
    fieldDefinitions: ak,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: $ ? T : void 0
  }), Q = l.watch("name");
  return /* @__PURE__ */ re.jsxs(
    ta,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ re.jsx(ia, { cause: g }),
        /* @__PURE__ */ re.jsxs(ht, { children: [
          /* @__PURE__ */ re.jsx(we, { children: /* @__PURE__ */ re.jsx(hn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ re.jsx(
            at,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(we, { span: 3, children: /* @__PURE__ */ re.jsx(
            nt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(we, { span: 3 }),
          /* @__PURE__ */ re.jsx(we, { span: 3, children: /* @__PURE__ */ re.jsx(hn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ re.jsx(
            at,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(we, { span: 3 }),
          /* @__PURE__ */ re.jsx(we, { span: 3, children: /* @__PURE__ */ re.jsx(hn, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ re.jsx(
            at,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(we, { span: 3 }),
          !s && e && /* @__PURE__ */ re.jsx(
            Yr,
            {
              configuration: n,
              integrationId: e,
              integrationType: ci,
              label: "Authorize with OAuth"
            }
          ),
          $ && /* @__PURE__ */ re.jsx(we, { children: o({
            value: T,
            onChange: F,
            configurationKey: V?.id
          }) })
        ] }),
        /* @__PURE__ */ re.jsx(
          aa,
          {
            integrationType: ci,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ re.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ re.jsx(
                me,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ re.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  ci,
                  " integration, all links between Dixa and ",
                  ci,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ re.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  ci,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ re.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  ci,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Iu = { exports: {} }, Da = {}, ok;
function E2() {
  if (ok) return Da;
  ok = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Da.Fragment = r, Da.jsx = s, Da.jsxs = s, Da;
}
var Wo = {}, sk;
function T2() {
  return sk || (sk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Wo.Fragment = i, Wo.jsx = Rn, Wo.jsxs = Mn;
  })()), Wo;
}
var lk;
function $2() {
  return lk || (lk = 1, process.env.NODE_ENV === "production" ? Iu.exports = E2() : Iu.exports = T2()), Iu.exports;
}
var je = $2();
const D2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, R2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, O2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, P2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, A2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, L2 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": D2,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": R2,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": O2,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": P2,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": A2
};
function dl(e) {
  return L2[e] ?? {};
}
const V2 = dl(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), z2 = dl(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), U2 = dl(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), M2 = dl(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Eu(e = !1, n) {
  const [r, i] = se(e);
  return Le(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const B2 = "_wrapper_27vny_1", q2 = "_copyIcon_27vny_12", Ra = {
  wrapper: B2,
  copyIcon: q2
}, H2 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Eu(), { isCopied: i, copy: a } = Eu(), { isCopied: o, copy: s } = Eu();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: g,
    enrolled_at: C,
    referral_url: S
  } = e, N = f ? Ln(f).isSame(Date.now(), "day") : !1, { name: w, first_name: y, last_name: V } = m ?? {}, T = w ?? (`${y} ${V}`.trim() || "A customer has no name"), F = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ je.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(b, { className: Ra.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Ra.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ je.jsx(A.Heading, { variant: "heading-2", children: T }),
          N && /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Ln(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    g && /* @__PURE__ */ je.jsx(b, { gap: "200", children: /* @__PURE__ */ je.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Ln(C).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ je.jsx(me, { size: l, name: "mail" }),
        /* @__PURE__ */ je.jsx(A.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ je.jsx(
        me,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: Ra.copyIcon
        }
      ) })
    ] }),
    F && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ je.jsx(me, { size: l, name: "link" }),
        /* @__PURE__ */ je.jsx(We, { content: "Shopify shop", children: /* @__PURE__ */ je.jsx(
          A.ExternalLink,
          {
            href: F,
            target: "_blank",
            rel: "noreferrer",
            children: F.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ je.jsx(
        me,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(F),
          className: Ra.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ je.jsx(me, { size: l, name: "external-link" }),
        /* @__PURE__ */ je.jsx(We, { content: "Referral link", children: /* @__PURE__ */ je.jsx(
          A.ExternalLink,
          {
            href: S,
            target: "_blank",
            rel: "noreferrer",
            children: S.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ je.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: Ra.copyIcon
        }
      ) })
    ] })
  ] }) });
}, W2 = "_list_1q5b5_5", K2 = "_listItem_1q5b5_8", G2 = "_listItemEdit_1q5b5_15", Y2 = "_notificationText_1q5b5_19", Xi = {
  list: W2,
  listItem: K2,
  listItemEdit: G2,
  notificationText: Y2
}, Q2 = "_modalBody_1clhs_1", J2 = {
  modalBody: Q2
}, X2 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = fn(), { track: l } = _n(), [d, m] = se(n), [u, f] = se(""), [h, g] = se(), [C, { loading: S }] = o(
    U2,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), J();
      }
    }
  ), [N, { loading: w }] = o(M2), y = S || w, V = !!h, T = n === d ? "Change the value to update the points" : "", F = isNaN(d), $ = F ? "Points can not be empty" : "", U = d > n && d - n > 1e6, Q = U ? "Points can not exceed 1,000,000" : "", X = () => {
    if (!r) {
      g(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && C({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((B) => {
      const O = B?.networkError;
      (O ? O?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : (l("loyaltylion:add:points:failed"), g(["Failed to add points, try again later."]));
    }), d < n && N({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((B) => {
      B.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : "errors" in B && (l("loyaltylion:remove:points:failed"), g(
        B.errors?.map((O) => O.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), g(["Failed to remove points, try again later."]);
    });
  }, ae = () => {
    F && m(n), f(""), i();
  }, J = () => {
    a(), ae();
  };
  return /* @__PURE__ */ je.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: ae,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ je.jsx($t, { title: "Change points", onClose: ae }),
        /* @__PURE__ */ je.jsxs(Dt, { className: J2.modalBody, children: [
          /* @__PURE__ */ je.jsxs(ht, { children: [
            /* @__PURE__ */ je.jsx(we, { span: 6, children: /* @__PURE__ */ je.jsx(
              pr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Q || $,
                  warning: T
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (B) => m(B?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ je.jsx(we, { span: 6, children: /* @__PURE__ */ je.jsx(
              pr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (B) => f(B?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && V && /* @__PURE__ */ je.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ je.jsx(Ye, { children: h?.map((B, O) => /* @__PURE__ */ je.jsx(
            Ye.Item,
            {
              variant: "dense",
              title: B,
              contentLeft: /* @__PURE__ */ je.jsx(
                me,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            O
          )) }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          Pt,
          {
            confirmName: "Save",
            confirmOnClick: () => X(),
            confirmProps: {
              isLoading: y,
              disabled: F || U || n === d,
              loadingIndicator: /* @__PURE__ */ je.jsx(dn, { size: 16 })
            },
            cancelOnClick: ae
          }
        )
      ]
    }
  );
}, Z2 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ je.jsx(Ye.Text, { variant: "dense", className: Xi.listItem, children: /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(me, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ je.jsx(We, { content: "Edit points", children: /* @__PURE__ */ je.jsx(
        me,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Xi.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ je.jsx(Pn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, eL = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ je.jsx(Ye, { className: Xi.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: g }) => /* @__PURE__ */ je.jsx(
      Z2,
      {
        points: f,
        label: h,
        setIsModalOpen: g
      },
      u
    )) }),
    /* @__PURE__ */ je.jsx(
      X2,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, nL = "_reward_1wxia_1", tL = {
  reward: nL
}, rL = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ je.jsx(b, { gap: "100", flexDirection: "column", className: tL.reward, children: /* @__PURE__ */ je.jsx(We, { content: a ?? "No description", children: /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(me, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ je.jsxs(Pn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(me, { size: 14, name: "external-link" }),
      /* @__PURE__ */ je.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, iL = ({ customer: e }) => {
  const { useQuery: n } = fn(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(z2, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Le(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return yo({ errors: d }) ? /* @__PURE__ */ je.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Xi.notificationText,
        children: "No rewards found"
      }
    ) : Hb({ errors: d }) ? /* @__PURE__ */ je.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Xi.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ je.jsx(Fn, { error: s });
  }
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ je.jsx(dn, {}) }) : /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ je.jsx(rL, { reward: d }, d.id)) })
  ] });
}, aL = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ je.jsx(b, { alignItems: "start", children: /* @__PURE__ */ je.jsx(An, { children: /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(
        me,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ je.jsx(b, { alignItems: "start", children: /* @__PURE__ */ je.jsx(An, { children: /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(me, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ je.jsx(b, { alignItems: "start", children: /* @__PURE__ */ je.jsx(We, { content: "Insights segment", children: /* @__PURE__ */ je.jsx(An, { children: /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(me, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, oL = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = fn(), { track: i } = _n(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: g,
    data: C,
    refetch: S
  } = r(V2, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Le(() => {
    if (C && !h) {
      const N = (C?.LoyaltyLion?.getCustomers).customers;
      N && N.length > 0 && (o(N[0]), i("loyaltylion:customer:received"));
    }
  }, [C, h]), s?.email ? g ? yo({
    errors: g.graphQLErrors
  }) ? /* @__PURE__ */ je.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Xi.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ je.jsx(Fn, { error: g }) : h ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ je.jsx(dn, {}) }) : f ? /* @__PURE__ */ je.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ je.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ je.jsxs(je.Fragment, { children: [
        l && /* @__PURE__ */ je.jsx(H2, { customer: a }),
        d && /* @__PURE__ */ je.jsx(aL, { customer: a }),
        m && /* @__PURE__ */ je.jsx(
          eL,
          {
            customer: a,
            refetchCustomerData: S
          }
        ),
        u && /* @__PURE__ */ je.jsx(iL, { customer: a })
      ] }) : /* @__PURE__ */ je.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ je.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, sL = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], ck = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], dk = "LOYALTYLION", lL = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, cL = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = St({
    mode: "onChange",
    defaultValues: lL
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: g
  } = ea({
    integrationId: e,
    integrationType: dk,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: w,
    widgetConfiguration: y
  } = na({
    integrationId: e,
    fieldDefinitions: ck,
    form: s,
    onMisconfigured: g
  }), [V, T] = se(o ? [] : null);
  Le(() => {
    T(o ? [] : null);
  }, [e, o]), Le(() => {
    y && V === null && T(y.renderConditions ?? []);
  }, [y, V]);
  const F = a && V !== null, $ = (Q) => ra(Q, {
    fieldDefinitions: ck,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: F ? V : void 0
  }), U = s.watch("name");
  return /* @__PURE__ */ je.jsxs(
    ta,
    {
      form: s,
      integrationId: e,
      onValidSubmit: $,
      error: S ?? f,
      onRetry: S ? w : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ je.jsx(ia, { cause: h }),
        /* @__PURE__ */ je.jsxs(ht, { children: [
          /* @__PURE__ */ je.jsx(we, { children: /* @__PURE__ */ je.jsx(hn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ je.jsx(
            at,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(we, { span: 3, children: /* @__PURE__ */ je.jsx(
            nt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(we, { span: 3 }),
          /* @__PURE__ */ je.jsx(we, { span: 3, children: /* @__PURE__ */ je.jsx(
            p0,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ je.jsx(we, { span: 3 }),
          /* @__PURE__ */ je.jsx(we, { span: 3, children: /* @__PURE__ */ je.jsx(hn, { label: "Show customer summary", children: /* @__PURE__ */ je.jsx(
            at,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(we, { span: 3 }),
          /* @__PURE__ */ je.jsx(we, { span: 3, children: /* @__PURE__ */ je.jsx(hn, { label: "Show tags", children: /* @__PURE__ */ je.jsx(
            at,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(we, { span: 3 }),
          /* @__PURE__ */ je.jsx(we, { span: 3, children: /* @__PURE__ */ je.jsx(hn, { label: "Show points balance", children: /* @__PURE__ */ je.jsx(
            at,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(we, { span: 3 }),
          /* @__PURE__ */ je.jsx(we, { span: 3, children: /* @__PURE__ */ je.jsx(hn, { label: "Show available rewards", children: /* @__PURE__ */ je.jsx(
            at,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(we, { span: 3 }),
          F && /* @__PURE__ */ je.jsx(we, { children: a({
            value: V,
            onChange: T,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          aa,
          {
            integrationType: dk,
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Tu = { exports: {} }, Oa = {}, uk;
function dL() {
  if (uk) return Oa;
  uk = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Oa.Fragment = r, Oa.jsx = s, Oa.jsxs = s, Oa;
}
var Ko = {}, mk;
function uL() {
  return mk || (mk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ko.Fragment = i, Ko.jsx = Rn, Ko.jsxs = Mn;
  })()), Ko;
}
var pk;
function mL() {
  return pk || (pk = 1, process.env.NODE_ENV === "production" ? Tu.exports = dL() : Tu.exports = uL()), Tu.exports;
}
var rn = mL();
const pL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, fL = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": pL
};
function hL(e) {
  return fL[e] ?? {};
}
const {
  entries: lS,
  setPrototypeOf: fk,
  isFrozen: yL,
  getPrototypeOf: gL,
  getOwnPropertyDescriptor: vL
} = Object;
let {
  freeze: Kt,
  seal: fr,
  create: zi
} = Object, {
  apply: Cm,
  construct: Fm
} = typeof Reflect < "u" && Reflect;
Kt || (Kt = function(e) {
  return e;
});
fr || (fr = function(e) {
  return e;
});
Cm || (Cm = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
Fm || (Fm = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const Pa = gt(Array.prototype.forEach), kL = gt(Array.prototype.lastIndexOf), hk = gt(Array.prototype.pop), Aa = gt(Array.prototype.push), bL = gt(Array.prototype.splice), Vt = Array.isArray, Xa = gt(String.prototype.toLowerCase), $u = gt(String.prototype.toString), yk = gt(String.prototype.match), Oi = gt(String.prototype.replace), gk = gt(String.prototype.indexOf), xL = gt(String.prototype.trim), _L = gt(Number.prototype.toString), SL = gt(Boolean.prototype.toString), vk = typeof BigInt > "u" ? null : gt(BigInt.prototype.toString), kk = typeof Symbol > "u" ? null : gt(Symbol.prototype.toString), it = gt(Object.prototype.hasOwnProperty), La = gt(Object.prototype.toString), jt = gt(RegExp.prototype.test), Go = NL(TypeError);
function gt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return Cm(e, n, i);
  };
}
function NL(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Fm(e, r);
  };
}
function En(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Xa;
  if (fk && fk(e, null), !Vt(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (yL(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function jL(e) {
  for (let n = 0; n < e.length; n++)
    it(e, n) || (e[n] = null);
  return e;
}
function Qt(e) {
  const n = zi(null);
  for (const [r, i] of lS(e))
    it(e, r) && (Vt(i) ? n[r] = jL(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = Qt(i) : n[r] = i);
  return n;
}
function wL(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return _L(e);
    case "boolean":
      return SL(e);
    case "bigint":
      return vk ? vk(e) : "0";
    case "symbol":
      return kk ? kk(e) : "Symbol()";
    case "undefined":
      return La(e);
    case "function":
    case "object": {
      if (e === null)
        return La(e);
      const n = e, r = Ui(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : La(i);
      }
      return La(e);
    }
    default:
      return La(e);
  }
}
function Ui(e, n) {
  for (; e !== null; ) {
    const i = vL(e, n);
    if (i) {
      if (i.get)
        return gt(i.get);
      if (typeof i.value == "function")
        return gt(i.value);
    }
    e = gL(e);
  }
  function r() {
    return null;
  }
  return r;
}
function CL(e) {
  try {
    return jt(e, ""), !0;
  } catch {
    return !1;
  }
}
const bk = Kt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Du = Kt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Ru = Kt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), FL = Kt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ou = Kt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), IL = Kt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), xk = Kt(["#text"]), _k = Kt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Pu = Kt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Sk = Kt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Yo = Kt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), EL = fr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), TL = fr(/<%[\w\W]*|[\w\W]*%>/gm), $L = fr(/\$\{[\w\W]*/gm), DL = fr(/^data-[\-\w.\u00B7-\uFFFF]+$/), RL = fr(/^aria-[\-\w]+$/), cS = fr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), OL = fr(/^(?:\w+script|data):/i), PL = fr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), dS = fr(/^html$/i), AL = fr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Nk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: RL,
  ATTR_WHITESPACE: PL,
  CUSTOM_ELEMENT: AL,
  DATA_ATTR: DL,
  DOCTYPE_NAME: dS,
  ERB_EXPR: TL,
  IS_ALLOWED_URI: cS,
  IS_SCRIPT_OR_DATA: OL,
  MUSTACHE_EXPR: EL,
  TMPLIT_EXPR: $L
});
const Va = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, LL = function() {
  return typeof window > "u" ? null : window;
}, VL = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, jk = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function uS() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : LL();
  const n = (_) => uS(_);
  if (n.version = "3.4.2", n.removed = [], !e || !e.document || e.document.nodeType !== Va.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: g
  } = e, C = d.prototype, S = Ui(C, "cloneNode"), N = Ui(C, "remove"), w = Ui(C, "nextSibling"), y = Ui(C, "childNodes"), V = Ui(C, "parentNode");
  if (typeof s == "function") {
    const _ = r.createElement("template");
    _.content && _.content.ownerDocument && (r = _.content.ownerDocument);
  }
  let T, F = "";
  const {
    implementation: $,
    createNodeIterator: U,
    createDocumentFragment: Q,
    getElementsByTagName: X
  } = r, {
    importNode: ae
  } = i;
  let J = jk();
  n.isSupported = typeof lS == "function" && typeof V == "function" && $ && $.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: B,
    ERB_EXPR: O,
    TMPLIT_EXPR: q,
    DATA_ATTR: ee,
    ARIA_ATTR: ve,
    IS_SCRIPT_OR_DATA: de,
    ATTR_WHITESPACE: le,
    CUSTOM_ELEMENT: pe
  } = Nk;
  let {
    IS_ALLOWED_URI: W
  } = Nk, be = null;
  const Ie = En({}, [...bk, ...Du, ...Ru, ...Ou, ...xk]);
  let G = null;
  const He = En({}, [..._k, ...Pu, ...Sk, ...Yo]);
  let qe = Object.seal(zi(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Oe = null, Be = null;
  const $e = Object.seal(zi(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Ue = !0, Re = !0, an = !1, Ee = !0, Ke = !1, Qe = !0, fe = !1, ye = !1, De = !1, Ve = !1, Pe = !1, un = !1, E = !0, x = !1;
  const D = "user-content-";
  let H = !0, Y = !1, R = {}, z = null;
  const ie = En({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ue = null;
  const Se = En({}, ["audio", "video", "img", "source", "image", "track"]);
  let nn = null;
  const pn = En({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), tn = "http://www.w3.org/1998/Math/MathML", ln = "http://www.w3.org/2000/svg", mn = "http://www.w3.org/1999/xhtml";
  let cn = mn, xn = !1, en = null;
  const jn = En({}, [tn, ln, mn], $u);
  let Ae = En({}, ["mi", "mo", "mn", "ms", "mtext"]), on = En({}, ["annotation-xml"]);
  const sn = En({}, ["title", "style", "font", "a", "script"]);
  let vn = null;
  const qn = ["application/xhtml+xml", "text/html"], wn = "text/html";
  let kn = null, gn = null;
  const Cn = r.createElement("form"), Un = function(_) {
    return _ instanceof RegExp || _ instanceof Function;
  }, Vn = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (gn && gn === _)
      return;
    (!_ || typeof _ != "object") && (_ = {}), _ = Qt(_), vn = // eslint-disable-next-line unicorn/prefer-includes
    qn.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? wn : _.PARSER_MEDIA_TYPE, kn = vn === "application/xhtml+xml" ? $u : Xa, be = it(_, "ALLOWED_TAGS") && Vt(_.ALLOWED_TAGS) ? En({}, _.ALLOWED_TAGS, kn) : Ie, G = it(_, "ALLOWED_ATTR") && Vt(_.ALLOWED_ATTR) ? En({}, _.ALLOWED_ATTR, kn) : He, en = it(_, "ALLOWED_NAMESPACES") && Vt(_.ALLOWED_NAMESPACES) ? En({}, _.ALLOWED_NAMESPACES, $u) : jn, nn = it(_, "ADD_URI_SAFE_ATTR") && Vt(_.ADD_URI_SAFE_ATTR) ? En(Qt(pn), _.ADD_URI_SAFE_ATTR, kn) : pn, ue = it(_, "ADD_DATA_URI_TAGS") && Vt(_.ADD_DATA_URI_TAGS) ? En(Qt(Se), _.ADD_DATA_URI_TAGS, kn) : Se, z = it(_, "FORBID_CONTENTS") && Vt(_.FORBID_CONTENTS) ? En({}, _.FORBID_CONTENTS, kn) : ie, Oe = it(_, "FORBID_TAGS") && Vt(_.FORBID_TAGS) ? En({}, _.FORBID_TAGS, kn) : Qt({}), Be = it(_, "FORBID_ATTR") && Vt(_.FORBID_ATTR) ? En({}, _.FORBID_ATTR, kn) : Qt({}), R = it(_, "USE_PROFILES") ? _.USE_PROFILES && typeof _.USE_PROFILES == "object" ? Qt(_.USE_PROFILES) : _.USE_PROFILES : !1, Ue = _.ALLOW_ARIA_ATTR !== !1, Re = _.ALLOW_DATA_ATTR !== !1, an = _.ALLOW_UNKNOWN_PROTOCOLS || !1, Ee = _.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ke = _.SAFE_FOR_TEMPLATES || !1, Qe = _.SAFE_FOR_XML !== !1, fe = _.WHOLE_DOCUMENT || !1, Ve = _.RETURN_DOM || !1, Pe = _.RETURN_DOM_FRAGMENT || !1, un = _.RETURN_TRUSTED_TYPE || !1, De = _.FORCE_BODY || !1, E = _.SANITIZE_DOM !== !1, x = _.SANITIZE_NAMED_PROPS || !1, H = _.KEEP_CONTENT !== !1, Y = _.IN_PLACE || !1, W = CL(_.ALLOWED_URI_REGEXP) ? _.ALLOWED_URI_REGEXP : cS, cn = typeof _.NAMESPACE == "string" ? _.NAMESPACE : mn, Ae = it(_, "MATHML_TEXT_INTEGRATION_POINTS") && _.MATHML_TEXT_INTEGRATION_POINTS && typeof _.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Qt(_.MATHML_TEXT_INTEGRATION_POINTS) : En({}, ["mi", "mo", "mn", "ms", "mtext"]), on = it(_, "HTML_INTEGRATION_POINTS") && _.HTML_INTEGRATION_POINTS && typeof _.HTML_INTEGRATION_POINTS == "object" ? Qt(_.HTML_INTEGRATION_POINTS) : En({}, ["annotation-xml"]);
    const Z = it(_, "CUSTOM_ELEMENT_HANDLING") && _.CUSTOM_ELEMENT_HANDLING && typeof _.CUSTOM_ELEMENT_HANDLING == "object" ? Qt(_.CUSTOM_ELEMENT_HANDLING) : zi(null);
    if (qe = zi(null), it(Z, "tagNameCheck") && Un(Z.tagNameCheck) && (qe.tagNameCheck = Z.tagNameCheck), it(Z, "attributeNameCheck") && Un(Z.attributeNameCheck) && (qe.attributeNameCheck = Z.attributeNameCheck), it(Z, "allowCustomizedBuiltInElements") && typeof Z.allowCustomizedBuiltInElements == "boolean" && (qe.allowCustomizedBuiltInElements = Z.allowCustomizedBuiltInElements), Ke && (Re = !1), Pe && (Ve = !0), R && (be = En({}, xk), G = zi(null), R.html === !0 && (En(be, bk), En(G, _k)), R.svg === !0 && (En(be, Du), En(G, Pu), En(G, Yo)), R.svgFilters === !0 && (En(be, Ru), En(G, Pu), En(G, Yo)), R.mathMl === !0 && (En(be, Ou), En(G, Sk), En(G, Yo))), $e.tagCheck = null, $e.attributeCheck = null, it(_, "ADD_TAGS") && (typeof _.ADD_TAGS == "function" ? $e.tagCheck = _.ADD_TAGS : Vt(_.ADD_TAGS) && (be === Ie && (be = Qt(be)), En(be, _.ADD_TAGS, kn))), it(_, "ADD_ATTR") && (typeof _.ADD_ATTR == "function" ? $e.attributeCheck = _.ADD_ATTR : Vt(_.ADD_ATTR) && (G === He && (G = Qt(G)), En(G, _.ADD_ATTR, kn))), it(_, "ADD_URI_SAFE_ATTR") && Vt(_.ADD_URI_SAFE_ATTR) && En(nn, _.ADD_URI_SAFE_ATTR, kn), it(_, "FORBID_CONTENTS") && Vt(_.FORBID_CONTENTS) && (z === ie && (z = Qt(z)), En(z, _.FORBID_CONTENTS, kn)), it(_, "ADD_FORBID_CONTENTS") && Vt(_.ADD_FORBID_CONTENTS) && (z === ie && (z = Qt(z)), En(z, _.ADD_FORBID_CONTENTS, kn)), H && (be["#text"] = !0), fe && En(be, ["html", "head", "body"]), be.table && (En(be, ["tbody"]), delete Oe.tbody), _.TRUSTED_TYPES_POLICY) {
      if (typeof _.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Go('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof _.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Go('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      T = _.TRUSTED_TYPES_POLICY, F = T.createHTML("");
    } else
      T === void 0 && (T = VL(g, a)), T !== null && typeof F == "string" && (F = T.createHTML(""));
    Kt && Kt(_), gn = _;
  }, Sn = En({}, [...Du, ...Ru, ...FL]), Nn = En({}, [...Ou, ...IL]), Hn = function(_) {
    let Z = V(_);
    (!Z || !Z.tagName) && (Z = {
      namespaceURI: cn,
      tagName: "template"
    });
    const ce = Xa(_.tagName), _e = Xa(Z.tagName);
    return en[_.namespaceURI] ? _.namespaceURI === ln ? Z.namespaceURI === mn ? ce === "svg" : Z.namespaceURI === tn ? ce === "svg" && (_e === "annotation-xml" || Ae[_e]) : !!Sn[ce] : _.namespaceURI === tn ? Z.namespaceURI === mn ? ce === "math" : Z.namespaceURI === ln ? ce === "math" && on[_e] : !!Nn[ce] : _.namespaceURI === mn ? Z.namespaceURI === ln && !on[_e] || Z.namespaceURI === tn && !Ae[_e] ? !1 : !Nn[ce] && (sn[ce] || !Sn[ce]) : !!(vn === "application/xhtml+xml" && en[_.namespaceURI]) : !1;
  }, Dn = function(_) {
    Aa(n.removed, {
      element: _
    });
    try {
      V(_).removeChild(_);
    } catch {
      N(_);
    }
  }, Rn = function(_, Z) {
    try {
      Aa(n.removed, {
        attribute: Z.getAttributeNode(_),
        from: Z
      });
    } catch {
      Aa(n.removed, {
        attribute: null,
        from: Z
      });
    }
    if (Z.removeAttribute(_), _ === "is")
      if (Ve || Pe)
        try {
          Dn(Z);
        } catch {
        }
      else
        try {
          Z.setAttribute(_, "");
        } catch {
        }
  }, Mn = function(_) {
    let Z = null, ce = null;
    if (De)
      _ = "<remove></remove>" + _;
    else {
      const Ge = yk(_, /^[\r\n\t ]+/);
      ce = Ge && Ge[0];
    }
    vn === "application/xhtml+xml" && cn === mn && (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + "</body></html>");
    const _e = T ? T.createHTML(_) : _;
    if (cn === mn)
      try {
        Z = new h().parseFromString(_e, vn);
      } catch {
      }
    if (!Z || !Z.documentElement) {
      Z = $.createDocument(cn, "template", null);
      try {
        Z.documentElement.innerHTML = xn ? F : _e;
      } catch {
      }
    }
    const ne = Z.body || Z.documentElement;
    return _ && ce && ne.insertBefore(r.createTextNode(ce), ne.childNodes[0] || null), cn === mn ? X.call(Z, fe ? "html" : "body")[0] : fe ? Z.documentElement : ne;
  }, t = function(_) {
    return U.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(_) {
    return _ instanceof f && (typeof _.nodeName != "string" || typeof _.textContent != "string" || typeof _.removeChild != "function" || !(_.attributes instanceof u) || typeof _.removeAttribute != "function" || typeof _.setAttribute != "function" || typeof _.namespaceURI != "string" || typeof _.insertBefore != "function" || typeof _.hasChildNodes != "function");
  }, p = function(_) {
    return typeof l == "function" && _ instanceof l;
  };
  function v(_, Z, ce) {
    Pa(_, (_e) => {
      _e.call(n, Z, ce, gn);
    });
  }
  const P = function(_) {
    let Z = null;
    if (v(J.beforeSanitizeElements, _, null), c(_))
      return Dn(_), !0;
    const ce = kn(_.nodeName);
    if (v(J.uponSanitizeElement, _, {
      tagName: ce,
      allowedTags: be
    }), Qe && _.hasChildNodes() && !p(_.firstElementChild) && jt(/<[/\w!]/g, _.innerHTML) && jt(/<[/\w!]/g, _.textContent) || Qe && _.namespaceURI === mn && ce === "style" && p(_.firstElementChild) || _.nodeType === Va.progressingInstruction || Qe && _.nodeType === Va.comment && jt(/<[/\w]/g, _.data))
      return Dn(_), !0;
    if (Oe[ce] || !($e.tagCheck instanceof Function && $e.tagCheck(ce)) && !be[ce]) {
      if (!Oe[ce] && j(ce) && (qe.tagNameCheck instanceof RegExp && jt(qe.tagNameCheck, ce) || qe.tagNameCheck instanceof Function && qe.tagNameCheck(ce)))
        return !1;
      if (H && !z[ce]) {
        const _e = V(_) || _.parentNode, ne = y(_) || _.childNodes;
        if (ne && _e) {
          const Ge = ne.length;
          for (let $n = Ge - 1; $n >= 0; --$n) {
            const Tn = S(ne[$n], !0);
            _e.insertBefore(Tn, w(_));
          }
        }
      }
      return Dn(_), !0;
    }
    return _ instanceof d && !Hn(_) || (ce === "noscript" || ce === "noembed" || ce === "noframes") && jt(/<\/no(script|embed|frames)/i, _.innerHTML) ? (Dn(_), !0) : (Ke && _.nodeType === Va.text && (Z = _.textContent, Pa([B, O, q], (_e) => {
      Z = Oi(Z, _e, " ");
    }), _.textContent !== Z && (Aa(n.removed, {
      element: _.cloneNode()
    }), _.textContent = Z)), v(J.afterSanitizeElements, _, null), !1);
  }, L = function(_, Z, ce) {
    if (Be[Z] || E && (Z === "id" || Z === "name") && (ce in r || ce in Cn))
      return !1;
    const _e = G[Z] || $e.attributeCheck instanceof Function && $e.attributeCheck(Z, _);
    if (!(Re && !Be[Z] && jt(ee, Z)) && !(Ue && jt(ve, Z))) {
      if (!_e || Be[Z]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(j(_) && (qe.tagNameCheck instanceof RegExp && jt(qe.tagNameCheck, _) || qe.tagNameCheck instanceof Function && qe.tagNameCheck(_)) && (qe.attributeNameCheck instanceof RegExp && jt(qe.attributeNameCheck, Z) || qe.attributeNameCheck instanceof Function && qe.attributeNameCheck(Z, _)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          Z === "is" && qe.allowCustomizedBuiltInElements && (qe.tagNameCheck instanceof RegExp && jt(qe.tagNameCheck, ce) || qe.tagNameCheck instanceof Function && qe.tagNameCheck(ce)))
        ) return !1;
      } else if (!nn[Z] && !jt(W, Oi(ce, le, "")) && !((Z === "src" || Z === "xlink:href" || Z === "href") && _ !== "script" && gk(ce, "data:") === 0 && ue[_]) && !(an && !jt(de, Oi(ce, le, ""))) && ce)
        return !1;
    }
    return !0;
  }, I = En({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), j = function(_) {
    return !I[Xa(_)] && jt(pe, _);
  }, te = function(_) {
    v(J.beforeSanitizeAttributes, _, null);
    const {
      attributes: Z
    } = _;
    if (!Z || c(_))
      return;
    const ce = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: G,
      forceKeepAttr: void 0
    };
    let _e = Z.length;
    for (; _e--; ) {
      const ne = Z[_e], {
        name: Ge,
        namespaceURI: $n,
        value: Tn
      } = ne, Lt = kn(Ge), Xr = Tn;
      let _t = Ge === "value" ? Xr : xL(Xr);
      if (ce.attrName = Lt, ce.attrValue = _t, ce.keepAttr = !0, ce.forceKeepAttr = void 0, v(J.uponSanitizeAttribute, _, ce), _t = ce.attrValue, x && (Lt === "id" || Lt === "name") && gk(_t, D) !== 0 && (Rn(Ge, _), _t = D + _t), Qe && jt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, _t)) {
        Rn(Ge, _);
        continue;
      }
      if (Lt === "attributename" && yk(_t, "href")) {
        Rn(Ge, _);
        continue;
      }
      if (ce.forceKeepAttr)
        continue;
      if (!ce.keepAttr) {
        Rn(Ge, _);
        continue;
      }
      if (!Ee && jt(/\/>/i, _t)) {
        Rn(Ge, _);
        continue;
      }
      Ke && Pa([B, O, q], (e0) => {
        _t = Oi(_t, e0, " ");
      });
      const of = kn(_.nodeName);
      if (!L(of, Lt, _t)) {
        Rn(Ge, _);
        continue;
      }
      if (T && typeof g == "object" && typeof g.getAttributeType == "function" && !$n)
        switch (g.getAttributeType(of, Lt)) {
          case "TrustedHTML": {
            _t = T.createHTML(_t);
            break;
          }
          case "TrustedScriptURL": {
            _t = T.createScriptURL(_t);
            break;
          }
        }
      if (_t !== Xr)
        try {
          $n ? _.setAttributeNS($n, Ge, _t) : _.setAttribute(Ge, _t), c(_) ? Dn(_) : hk(n.removed);
        } catch {
          Rn(Ge, _);
        }
    }
    v(J.afterSanitizeAttributes, _, null);
  }, K = function(_) {
    let Z = null;
    const ce = t(_);
    for (v(J.beforeSanitizeShadowDOM, _, null); Z = ce.nextNode(); )
      v(J.uponSanitizeShadowNode, Z, null), P(Z), te(Z), Z.content instanceof o && K(Z.content);
    v(J.afterSanitizeShadowDOM, _, null);
  };
  return n.sanitize = function(_) {
    let Z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ce = null, _e = null, ne = null, Ge = null;
    if (xn = !_, xn && (_ = "<!-->"), typeof _ != "string" && !p(_) && (_ = wL(_), typeof _ != "string"))
      throw Go("dirty is not a string, aborting");
    if (!n.isSupported)
      return _;
    if (ye || Vn(Z), n.removed = [], typeof _ == "string" && (Y = !1), Y) {
      const Lt = _.nodeName;
      if (typeof Lt == "string") {
        const Xr = kn(Lt);
        if (!be[Xr] || Oe[Xr])
          throw Go("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (_ instanceof l)
      ce = Mn("<!---->"), _e = ce.ownerDocument.importNode(_, !0), _e.nodeType === Va.element && _e.nodeName === "BODY" || _e.nodeName === "HTML" ? ce = _e : ce.appendChild(_e);
    else {
      if (!Ve && !Ke && !fe && // eslint-disable-next-line unicorn/prefer-includes
      _.indexOf("<") === -1)
        return T && un ? T.createHTML(_) : _;
      if (ce = Mn(_), !ce)
        return Ve ? null : un ? F : "";
    }
    ce && De && Dn(ce.firstChild);
    const $n = t(Y ? _ : ce);
    for (; ne = $n.nextNode(); )
      P(ne), te(ne), ne.content instanceof o && K(ne.content);
    if (Y)
      return _;
    if (Ve) {
      if (Ke) {
        ce.normalize();
        let Lt = ce.innerHTML;
        Pa([B, O, q], (Xr) => {
          Lt = Oi(Lt, Xr, " ");
        }), ce.innerHTML = Lt;
      }
      if (Pe)
        for (Ge = Q.call(ce.ownerDocument); ce.firstChild; )
          Ge.appendChild(ce.firstChild);
      else
        Ge = ce;
      return (G.shadowroot || G.shadowrootmode) && (Ge = ae.call(i, Ge, !0)), Ge;
    }
    let Tn = fe ? ce.outerHTML : ce.innerHTML;
    return fe && be["!doctype"] && ce.ownerDocument && ce.ownerDocument.doctype && ce.ownerDocument.doctype.name && jt(dS, ce.ownerDocument.doctype.name) && (Tn = "<!DOCTYPE " + ce.ownerDocument.doctype.name + `>
` + Tn), Ke && Pa([B, O, q], (Lt) => {
      Tn = Oi(Tn, Lt, " ");
    }), T && un ? T.createHTML(Tn) : Tn;
  }, n.setConfig = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(_), ye = !0;
  }, n.clearConfig = function() {
    gn = null, ye = !1;
  }, n.isValidAttribute = function(_, Z, ce) {
    gn || Vn({});
    const _e = kn(_), ne = kn(Z);
    return L(_e, ne, ce);
  }, n.addHook = function(_, Z) {
    typeof Z == "function" && Aa(J[_], Z);
  }, n.removeHook = function(_, Z) {
    if (Z !== void 0) {
      const ce = kL(J[_], Z);
      return ce === -1 ? void 0 : bL(J[_], ce, 1)[0];
    }
    return hk(J[_]);
  }, n.removeHooks = function(_) {
    J[_] = [];
  }, n.removeAllHooks = function() {
    J = jk();
  }, n;
}
var zL = uS();
const UL = "_messageContainer_1rxr4_1", ML = "_chip_1rxr4_7", BL = "_chipLabel_1rxr4_10", qL = "_chipValue_1rxr4_13", Qo = {
  messageContainer: UL,
  chip: ML,
  chipLabel: BL,
  chipValue: qL
}, wk = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, HL = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Le(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ rn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ rn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ rn.jsx(We, { content: "Conversation Attributes", children: /* @__PURE__ */ rn.jsx(
        Bm,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ rn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ rn.jsx(An, { className: Qo.chip, children: /* @__PURE__ */ rn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ rn.jsxs(Zn, { className: Qo.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ rn.jsx(Zn, { className: Qo.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ rn.jsx(
      b,
      {
        className: Qo.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? wk[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? wk[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ rn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ rn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ rn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ rn.jsx(I0, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ rn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: zL.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ rn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ rn.jsx(
      E0,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ rn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, WL = "_conversation_1draa_1", KL = "_conversationSubLine_1draa_9", GL = "_modal_1draa_14", Au = {
  conversation: WL,
  conversationSubLine: KL,
  modal: GL
}, YL = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), QL = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), JL = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ rn.jsxs(b, { className: Au.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ rn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ rn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ rn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ rn.jsx(Pn, { size: "small", variant: "info", children: Ln(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ rn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Au.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ rn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ rn.jsx(An, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ rn.jsx(We, { content: "Show conversation preview", children: /* @__PURE__ */ rn.jsx(
        nr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ rn.jsxs(
      Tt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Au.modal,
        children: [
          /* @__PURE__ */ rn.jsx(
            $t,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ rn.jsx(Dt, { children: /* @__PURE__ */ rn.jsx(
            HL,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: YL(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: QL(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, XL = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Bn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ rn.jsx(
      JL,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ rn.jsxs(
      Kn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, ZL = hL(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), eV = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = fn(), { data: l, loading: d, error: m } = s(ZL, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Le(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ rn.jsx(Fn, { error: m }) : d ? /* @__PURE__ */ rn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ rn.jsx(dn, {}) }) : r?.length === 0 ? /* @__PURE__ */ rn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ rn.jsx(
    XL,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, nV = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Yr
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
], Ck = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], Lu = "MIUROS", tV = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, rV = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = St({
    mode: "onChange",
    defaultValues: tV
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = ea({
    integrationId: e,
    integrationType: Lu,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: V
  } = na({
    integrationId: e,
    fieldDefinitions: Ck,
    form: l,
    onMisconfigured: C
  }), [T, F] = se(s ? [] : null);
  Le(() => {
    F(s ? [] : null);
  }, [e, s]), Le(() => {
    V && T === null && F(V.renderConditions ?? []);
  }, [V, T]);
  const $ = o && T !== null, U = (X) => ra(X, {
    fieldDefinitions: Ck,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: $ ? T : void 0
  }), Q = l.watch("name");
  return /* @__PURE__ */ rn.jsxs(
    ta,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ rn.jsx(ia, { cause: g }),
        /* @__PURE__ */ rn.jsxs(ht, { children: [
          /* @__PURE__ */ rn.jsx(we, { children: /* @__PURE__ */ rn.jsx(hn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ rn.jsx(
            at,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ rn.jsx(we, { span: 3, children: /* @__PURE__ */ rn.jsx(
            nt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(we, { span: 3 }),
          /* @__PURE__ */ rn.jsx(we, { span: 3, children: /* @__PURE__ */ rn.jsx(
            nt,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(we, { span: 3 }),
          /* @__PURE__ */ rn.jsx(we, { span: 3, children: /* @__PURE__ */ rn.jsx(
            zm,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(we, { span: 3 }),
          /* @__PURE__ */ rn.jsx(we, { span: 3, children: /* @__PURE__ */ rn.jsx(
            nt,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (X) => !Number.isNaN(Number.parseInt(X, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(we, { span: 3 }),
          !s && e && /* @__PURE__ */ rn.jsx(
            Yr,
            {
              configuration: n,
              integrationId: e,
              integrationType: Lu,
              label: "Authorize"
            }
          ),
          $ && /* @__PURE__ */ rn.jsx(we, { children: o({
            value: T,
            onChange: F,
            configurationKey: V?.id
          }) })
        ] }),
        /* @__PURE__ */ rn.jsx(
          aa,
          {
            integrationType: Lu,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Vu = { exports: {} }, za = {}, Fk;
function iV() {
  if (Fk) return za;
  Fk = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return za.Fragment = r, za.jsx = s, za.jsxs = s, za;
}
var Jo = {}, Ik;
function aV() {
  return Ik || (Ik = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Jo.Fragment = i, Jo.jsx = Rn, Jo.jsxs = Mn;
  })()), Jo;
}
var Ek;
function oV() {
  return Ek || (Ek = 1, process.env.NODE_ENV === "production" ? Vu.exports = iV() : Vu.exports = aV()), Vu.exports;
}
var Ne = oV();
const sV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, lV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, cV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, dV = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": sV,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": lV,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": cV
};
function Up(e) {
  return dV[e] ?? {};
}
const uV = Up(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), mV = Up(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), pV = Up(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function Im(e = !1, n) {
  const [r, i] = se(e);
  return Le(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const fV = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, mS = "DD MMM YYYY @ HH:mm", hV = "_list_2c4dq_1", yV = "_listItem_2c4dq_4", gV = "_copyIcon_2c4dq_12", xi = {
  list: hV,
  listItem: yV,
  copyIcon: gV
}, Em = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = Im(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: g,
    country_code: C
  } = e ?? {}, S = `${d} ${m}`.trim() || void 0, N = `${h} ${g}`.trim() || void 0, w = [S, u, f, N, C].filter(
    Boolean
  );
  return /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ne.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ne.jsx(me, { size: l, name: n }),
      i ? /* @__PURE__ */ Ne.jsx(dn, { size: l }) : /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: w.map((y, V) => /* @__PURE__ */ Ne.jsx(Zn, { children: y }, V)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ne.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Ne.jsx(We, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: l,
          name: "exclamation",
          className: xi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ne.jsx(We, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(w.join(", ")),
          className: xi.copyIcon
        }
      ) })
    ] })
  ] });
}, vV = "_wrapper_1nher_1", kV = {
  wrapper: vV
}, bV = ({
  customer: e,
  store: n
}) => {
  const { track: r } = _n(), { isCopied: i, copy: a } = Im(), { isCopied: o, copy: s } = Im(), { useQuery: l } = fn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(mV, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, g = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, C = (h?.addresses?.length ?? 0) > 1;
  if (Le(() => {
    g && r("recharge:profile:received");
  }, [g, r]), u)
    return /* @__PURE__ */ Ne.jsx(Fn, { error: u });
  if (!e)
    return null;
  const {
    id: S,
    phone: N,
    email: w,
    first_name: y,
    last_name: V,
    created_at: T,
    has_valid_payment_method: F
  } = e, $ = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${S}` : null, Q = `${y || ""} ${V || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ne.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ne.jsxs(b, { className: kV.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(A.Heading, { variant: "heading-2", children: Q }),
    T && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: Ln(T).format(mS) })
    ] }),
    w && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(me, { size: $, name: "mail" }),
        /* @__PURE__ */ Ne.jsx(A.ExternalLink, { href: `mailto:${w}`, children: w })
      ] }),
      /* @__PURE__ */ Ne.jsx(We, { content: "Copy email", children: /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: $,
          name: i ? "done" : "copy",
          onClick: () => a(w),
          className: xi.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(me, { size: $, name: "phone" }),
        /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: N })
      ] }),
      /* @__PURE__ */ Ne.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: $,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: xi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ne.jsx(
      Em,
      {
        address: g,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: C
      }
    ),
    /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(me, { size: $, name: "credit-card" }),
        /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: $,
          name: F ? "check-circle" : "close-circle-filled",
          color: F ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ Ne.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ne.jsx(me, { size: $, name: "external-link" }),
      /* @__PURE__ */ Ne.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, xV = "_order_1dlaa_1", _V = "_orderIsOpen_1dlaa_9", SV = "_orderHeader_1dlaa_12", NV = "_note_1dlaa_16", Xo = {
  order: xV,
  orderIsOpen: _V,
  orderHeader: SV,
  note: NV
}, jV = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = _n(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: g,
    total_price: C,
    is_prepaid: S
  } = e, N = 14, w = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ne.jsxs(
    b,
    {
      className: rt(Xo.order, {
        [Xo.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ne.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Xo.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ne.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: Ln(f).format(mS) }) }),
                /* @__PURE__ */ Ne.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ne.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Ne.jsx(We, { content: "Note", children: /* @__PURE__ */ Ne.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Xo.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ne.jsx(me, { size: N, name: "activity" }),
            /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: fV(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ne.jsx(me, { size: N, name: "credit-card" }),
            /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: S ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ne.jsx(me, { size: N, name: "cog" }),
            /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ne.jsx(me, { size: N, name: "chart-bar" }),
            /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ne.jsxs(A.Paragraph, { variant: "4", children: [
                C,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ne.jsx(
            Em,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ne.jsx(
            Em,
            {
              address: g,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          w && /* @__PURE__ */ Ne.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(w, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ne.jsx(me, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, wV = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = _n(), { useQuery: i } = fn(), {
    loading: a,
    error: o,
    data: s
  } = i(pV, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Ne.jsx(Fn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ne.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Ne.jsx(Pn, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ne.jsx(dn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Ne.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ne.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Ne.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Ne.jsx(
        jV,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Ne.jsx(
        Et,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ne.jsx(me, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, CV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ne.jsxs(Ye, { className: xi.list, children: [
      /* @__PURE__ */ Ne.jsx(Ye.Text, { variant: "dense", className: xi.listItem, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ne.jsx(Ye.Text, { variant: "dense", className: xi.listItem, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, FV = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = fn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(uV, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const g = m.graphQLErrors;
    return Am({ errors: g }) ? /* @__PURE__ */ Ne.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Lm({ errors: g }) ? /* @__PURE__ */ Ne.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ne.jsx(Fn, { error: m });
  }
  return d ? /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ne.jsx(dn, {}) }) : f ? l ? /* @__PURE__ */ Ne.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ne.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Ne.jsx(bV, { customer: f, store: h }),
        o && /* @__PURE__ */ Ne.jsx(CV, { customer: f }),
        s && /* @__PURE__ */ Ne.jsx(wV, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Ne.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, IV = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Tk = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], EV = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, TV = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = St({
    mode: "onChange",
    defaultValues: EV
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: g
  } = ea({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: w,
    widgetConfiguration: y
  } = na({
    integrationId: e,
    fieldDefinitions: Tk,
    form: s,
    onMisconfigured: g
  }), [V, T] = se(o ? [] : null);
  Le(() => {
    T(o ? [] : null);
  }, [e, o]), Le(() => {
    y && V === null && T(y.renderConditions ?? []);
  }, [y, V]);
  const F = a && V !== null, $ = (Q) => ra(Q, {
    fieldDefinitions: Tk,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: F ? V : void 0
  }), U = s.watch("name");
  return /* @__PURE__ */ Ne.jsxs(
    ta,
    {
      form: s,
      integrationId: e,
      onValidSubmit: $,
      error: S ?? f,
      onRetry: S ? w : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ Ne.jsx(ia, { cause: h }),
        /* @__PURE__ */ Ne.jsxs(ht, { children: [
          /* @__PURE__ */ Ne.jsx(we, { children: /* @__PURE__ */ Ne.jsx(hn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ne.jsx(
            at,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3, children: /* @__PURE__ */ Ne.jsx(
            nt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3, children: /* @__PURE__ */ Ne.jsx(
            zm,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3, children: /* @__PURE__ */ Ne.jsx(hn, { label: "Displays details of a customer", children: /* @__PURE__ */ Ne.jsx(
            at,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3, children: /* @__PURE__ */ Ne.jsx(hn, { label: "Displays the subscription overview", children: /* @__PURE__ */ Ne.jsx(
            at,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3, children: /* @__PURE__ */ Ne.jsx(hn, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Ne.jsx(
            at,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(we, { span: 3 }),
          F && /* @__PURE__ */ Ne.jsx(we, { children: a({
            value: V,
            onChange: T,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ Ne.jsx(
          aa,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_yc0fe_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._order_yc0fe_6{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_yc0fe_6:hover,._orderIsOpen_yc0fe_14{border-color:var(--dixa-color-neutral-400)}._orderHeader_yc0fe_17{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var zu = { exports: {} }, Ua = {}, $k;
function $V() {
  if ($k) return Ua;
  $k = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ua.Fragment = r, Ua.jsx = s, Ua.jsxs = s, Ua;
}
var Zo = {}, Dk;
function DV() {
  return Dk || (Dk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Zo.Fragment = i, Zo.jsx = Rn, Zo.jsxs = Mn;
  })()), Zo;
}
var Rk;
function RV() {
  return Rk || (Rk = 1, process.env.NODE_ENV === "production" ? zu.exports = $V() : zu.exports = DV()), zu.exports;
}
var k = RV();
const Ok = "__PairingContext__", OV = () => globalThis[Ok] ?? (() => {
  const e = Kb({});
  return globalThis[Ok] = e, e;
})(), PV = OV(), AV = () => Um(PV), LV = "_banner_d9pot_1", VV = "_list_d9pot_8", Pk = {
  banner: LV,
  list: VV
}, Ak = "https://apps.shopify.com/dixa-dashboard", zV = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, pS = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = AV(), [i, a] = se(!1), [o, s] = se(null), l = zV[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? Ak,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Ak, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: Pk.banner, children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(me, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: Pk.list, children: l.listItems.map((u, f) => /* @__PURE__ */ k.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Kn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(dn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, UV = (e) => /* @__PURE__ */ k.jsx(pS, { ...e, bannerVariant: "install" }), MV = (e) => /* @__PURE__ */ k.jsx(pS, { ...e, bannerVariant: "migration" }), BV = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], qV = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], HV = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: UV
  }
], WV = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], Lk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: MV,
    additionalProperties: { renderAboveForm: !0 }
  }
], fS = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Vk = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Mb(e)
  },
  ...fS
];
var Mi = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Mi || {}), _i = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(_i || {}), $r = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))($r || {}), hS = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(hS || {}), pi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(pi || {}), Wr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Wr || {}), vs = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(vs || {}), yS = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(yS || {});
const KV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, GV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, YV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, QV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, JV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, XV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, ZV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, ez = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, nz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, tz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, rz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, iz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, az = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, oz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, sz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, lz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, cz = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": KV,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": GV,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": YV,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": QV,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": JV,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": XV,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": ZV,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": ez,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": nz,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": tz,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": rz,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": iz,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": az,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": oz,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": sz,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": lz
};
function yr(e) {
  return cz[e] ?? {};
}
const dz = yr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), uz = yr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), mz = yr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), pz = yr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Mp = yr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), fz = yr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), hz = yr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), yz = yr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), gz = yr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), vz = yr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), kz = yr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), bz = yr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), gS = Ws`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, xz = Ws`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, _z = ({
  conversationContext: e
}) => {
  const { useQuery: n } = fn(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(dz, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, Sz = () => {
  const { useLazyQuery: e } = fn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(uz);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Pr(e = !1, n) {
  const [r, i] = se(e);
  return Le(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const Nz = "_list_alvh6_1", jz = "_listItem_alvh6_4", wz = "_fullWidth_alvh6_15", Cz = "_boxWrapper_alvh6_19", Ot = {
  list: Nz,
  listItem: jz,
  fullWidth: wz,
  boxWrapper: Cz
}, Fz = "_modal_1vkwz_1", Iz = "_disabled_1vkwz_5", Uu = {
  modal: Fz,
  disabled: Iz
}, zk = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: _i.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: _i.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: _i.Unknown
  }
], Uk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: $r.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: $r.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: $r.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: $r.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: $r.Unsubscribed
  }
], Ez = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = _n(), { useMutation: l, showNotification: d } = fn(), [m, u] = se(), [f, h] = se(), [g, C] = Mf(!0), [S, N] = Mf(!0), w = !!m, y = e.customer?.email, V = e.customer?.phone_number, T = e.customer?.given_name, F = e.customer?.family_name, $ = {
    email: y ?? "",
    phone: V ?? "",
    firstName: T ?? "",
    lastName: F ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = St({
    defaultValues: $
  });
  Le(() => {
    f?.forEach((O) => {
      const q = O?.field?.[0];
      q && (U.setError(q, {
        type: "server",
        message: O.message
      }), U.setFocus(q));
    });
  }, [f, U]);
  const [Q, { error: X, reset: ae }] = l(kz, {
    onError: (O) => {
      u(O.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (O) => {
      const q = O?.Shopify?.customerCreate?.userErrors || [];
      q.length > 0 ? (h(q), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), J = ot(
    (O) => {
      a(!0), u(void 0), Q({
        variables: {
          input: {
            firstName: O.firstName,
            lastName: O.lastName,
            ...g && { email: O.email },
            ...S && { phone: O.phone },
            ...O.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: O.smsMarketingState,
                marketingOptInLevel: O.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Q, a, S, g]
  ), B = () => {
    r(!1), ae(), u(void 0), U.reset($);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: n, onClose: B, className: Uu.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: "Create new customer", onClose: B }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(ht, { children: [
      /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
        nt,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
        nt,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
        nt,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: g ? "Email is required" : void 0
          },
          componentProps: {
            className: rt({
              [Uu.disabled]: !g
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                tm,
                {
                  disabled: !S,
                  name: "hasEmail",
                  value: "email",
                  checked: g,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
        nt,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: S ? "Phone is required" : void 0
          },
          componentProps: {
            className: rt({
              [Uu.disabled]: !S
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                tm,
                {
                  disabled: !g,
                  name: "hasPhone",
                  value: "phone",
                  checked: S,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = Uk.find(
                (ee) => ee.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: Uk.map((O) => /* @__PURE__ */ k.jsx(dt.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = zk.find(
                (ee) => ee.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: zk.map((O) => /* @__PURE__ */ k.jsx(dt.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      w && /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(me, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(J),
        cancelOnClick: B,
        confirmName: X ? "Close" : "Save",
        cancelName: X ? void 0 : "Cancel"
      }
    )
  ] });
}, Tz = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(me, { size: 14, name: "user-plus", color: "green.500" }),
        className: Ot.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      Ez,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Bp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, Tm = "DD MMM YYYY @ HH:mm", $z = "_wrapper_10fld_1", Dz = "_copyIcon_10fld_7", es = {
  wrapper: $z,
  copyIcon: Dz
}, Rz = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Pr(), { isCopied: l, copy: d } = Pr(), { track: m } = _n();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: g,
    tags: C = [],
    verifiedEmail: S
  } = e, N = h?.emailAddress, w = g?.phoneNumber, y = Bp(u), V = `https://${n}/admin/customers/${y ?? ""}`, T = i && a === er.refetch, F = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: es.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        T ? /* @__PURE__ */ k.jsx(dn, { size: F }) : /* @__PURE__ */ k.jsx(We, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: F,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: es.copyIcon
          }
        ) })
      ] }),
      N && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(me, { size: F, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${N}`, children: N }),
          /* @__PURE__ */ k.jsx(
            We,
            {
              content: S ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                me,
                {
                  size: F,
                  color: S ? "green.500" : "red.500",
                  name: S ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(We, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: F,
            name: o ? "done" : "copy",
            onClick: () => s(N),
            className: es.copyIcon
          }
        ) })
      ] }),
      w && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(me, { size: F, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${w}`, children: w })
        ] }),
        /* @__PURE__ */ k.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: F,
            name: l ? "done" : "copy",
            onClick: () => d(w),
            className: es.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(me, { size: F, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: V,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    C.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: C.map(($) => /* @__PURE__ */ k.jsx(An, { children: $ }, `${u}-${$}`)) })
    ] })
  ] });
}, Oz = "_creationModal_pbe64_1", Pz = "_detailsModal_pbe64_5", Az = "_percentageSuffix_pbe64_9", Mu = {
  creationModal: Oz,
  detailsModal: Pz,
  percentageSuffix: Az
}, Lz = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, Vz = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: hS.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Mk = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], Bk = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], qk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], zz = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = or(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Ye, { children: [
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            me,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: Ln(e?.startsAt).format(xt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(hn, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      Nr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, Uz = "shopify-discount-code-form", Hk = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, Mz = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = _n(), { useMutation: i, showNotification: a } = fn(), [o, s] = se(
    []
  ), [l, d] = se(), m = St({
    mode: "all",
    defaultValues: Hk
  });
  Le(() => {
    o?.forEach((F) => {
      const $ = F?.field?.[1];
      $ && m.setError($, {
        type: "server",
        message: F.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), g = Bn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    C,
    {
      loading: S,
      error: N,
      reset: w
    }
  ] = i(bz, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (F) => {
      const $ = F?.Shopify?.discountCodeBasicCreate?.userErrors;
      if ($ && $.length > 0)
        s($);
      else {
        const U = F?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && d(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", Lz(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, V = (F) => {
    C({
      variables: {
        input: Vz(F)
      }
    });
  }, T = () => {
    m.reset(Hk), s([]), w(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: T,
      className: rt({
        [Mu.creationModal]: !u,
        [Mu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          $t,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: T
          }
        ),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          u && /* @__PURE__ */ k.jsx(zz, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Uz, onSubmit: m.handleSubmit(V), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              Hs,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(ht, { children: [
              /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
                nt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (F, $) => F === $,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (F) => {
                      const $ = Mk.find(
                        (U) => U.value === F
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $?.label }) });
                    }
                  },
                  children: Mk.map((F) => /* @__PURE__ */ k.jsx(dt.Item, { value: F.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: F.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: F.description })
                  ] }) }, F.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
                nt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (F) => {
                      if (F) {
                        if (h === "percentage" && (F < 0 || F > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && F < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Mu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
                nt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (F, $) => F === $,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (F) => {
                      const $ = Bk.find(
                        (U) => U.value === F
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $?.label }) });
                    }
                  },
                  children: Bk.map((F) => /* @__PURE__ */ k.jsx(dt.Item, { value: F.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: F.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: F.description })
                  ] }) }, F.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
                nt,
                {
                  name: "minimumRequirementValue",
                  label: g,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (F) => {
                      if (F && f !== "none" && F < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (F, $) => F === $,
                    getItemTitleByValue: (F) => {
                      const $ = qk.find(
                        (U) => U.value === F
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $?.label }) });
                    }
                  },
                  children: qk.map((F) => /* @__PURE__ */ k.jsx(dt.Item, { value: F.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: F.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: F.description })
                  ] }) }, F.value))
                }
              ) })
            ] })
          ] }),
          N && /* @__PURE__ */ k.jsx(Fn, { error: N })
        ] }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: S,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? T : m.handleSubmit(V),
            cancelOnClick: u ? void 0 : T
          }
        )
      ]
    }
  );
}, Bz = ({ code: e }) => {
  const { isCopied: n, copy: r } = Pr();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(me, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          nr,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, qz = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(Ye, { children: i.map((a) => /* @__PURE__ */ k.jsx(Ye.Item, { className: Ot.listItem, children: /* @__PURE__ */ k.jsx(Bz, { code: a.code }, a.id) }, a.id)) })
  ] });
}, Hz = "_modal_11d6e_1", Wz = "_modalBody_11d6e_4", Kz = "_codeContainer_11d6e_9", Bu = {
  modal: Hz,
  modalBody: Wz,
  codeContainer: Kz
}, Gz = [50, 100, 250], vS = 50, Yz = {
  maxNumberOfCodesToDisplay: vS
}, Qz = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = fn(), [i, a] = se(
    vS
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = St({
    mode: "all",
    defaultValues: Yz
  }), { loading: u, error: f } = r(fz, {
    variables: {
      first: i
    },
    onCompleted: (g) => {
      const C = g?.Shopify?.codeDiscountNodes?.nodes ?? [];
      C && C.length > 0 && s(C);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: e, onClose: h, className: Bu.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(Dt, { className: Bu.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(ht, { children: /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (g) => {
              a(g.selectedValues[0]);
            },
            getItemTitleByValue: (g) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: g }) })
          },
          children: Gz.map((g) => /* @__PURE__ */ k.jsx(dt.Item, { value: g, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: g }) }, g))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        _s,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((g) => /* @__PURE__ */ k.jsx("div", { className: Bu.codeContainer, children: /* @__PURE__ */ k.jsx(qz, { discountCode: g }) }, g.id))
    ] }),
    /* @__PURE__ */ k.jsx(Pt, { confirmName: "Close", confirmOnClick: h })
  ] });
}, Jz = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      Qz,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      Mz,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, Xz = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? qb(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Mi.Invalid:
      case Mi.NotSubscribed:
      case $r.NotSubscribed:
        return "red.500";
      case Mi.Pending:
      case $r.Pending:
      case Mi.Unsubscribed:
      case $r.Unsubscribed:
        return "orange.500";
      case Mi.Subscribed:
      case $r.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case _i.SingleOptIn:
      case _i.ConfirmedOptIn:
        return "green.500";
      case _i.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "info", children: Ln(l).format(Tm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(We, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(An, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(We, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(An, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(me, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "info", children: Ln(u).format(Tm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(We, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(An, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(We, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(An, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, Zz = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: yS.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, Wk = [
  {
    value: Wr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Wr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Wr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Wr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Wr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Wr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Wr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], Kk = [
  {
    value: vs.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: vs.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: vs.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], kS = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), Bi = (e) => e3(n3(e)), e3 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), n3 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, di = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  Wt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      pr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), t3 = "_modal_1wlra_1", r3 = {
  modal: t3
};
function Gk(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Yk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Qk = "shopify-shiping-address-form", i3 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = fn(), { track: f } = _n(), [h, g] = se(!1), [C, S] = se({}), N = !l, [
    w,
    { error: y, reset: V }
  ] = m(hz, {
    onError: () => {
      g(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (J) => {
      g(!1);
      const B = J?.Shopify?.orderUpdate?.userErrors;
      if (B != null && B.length > 0) {
        const O = B.reduce(
          (q, ee) => {
            const ve = ee.field;
            if (ve == null || ve.length === 0)
              return q;
            const de = ve[ve.length - 1];
            return de != null && (q[de] = ee.message), q;
          },
          {}
        );
        S(O);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ae();
    }
  }), T = ot(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: Yk.find(
        (J) => J === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: F, handleSubmit: $, formState: U, reset: Q } = St({
    mode: "all",
    defaultValues: T()
  }), X = $((J) => {
    if (N) {
      if (g(!0), !o || !a) {
        g(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: B, ...O } = J, q = {
        ...O,
        countryCode: B
      };
      w({
        variables: {
          input: {
            id: a,
            shippingAddress: q
          }
        }
      });
    } else
      l(J), ae();
  });
  Le(() => {
    r && Q(T());
  }, [r, n, Q, T]);
  const ae = () => {
    Q(T()), S({}), V(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: r,
      onClose: ae,
      className: r3.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx($t, { title: e, onClose: () => ae() }),
        /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Qk, onSubmit: X, children: [
          y && /* @__PURE__ */ k.jsx(Fn, { error: y }),
          /* @__PURE__ */ k.jsxs(ht, { children: [
            /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: F,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: F,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(we, { span: 6, children: /* @__PURE__ */ k.jsx(
              di,
              {
                control: F,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(we, { span: 6, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: F,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(we, { span: 6, children: /* @__PURE__ */ k.jsx(
              di,
              {
                control: F,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: F,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(we, { span: 3, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: F,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(we, { span: 6, children: /* @__PURE__ */ k.jsx(
              jr,
              {
                name: "countryCodeV2",
                control: F,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (J) => J ? Gk(J) : ""
                },
                children: Yk.filter((J) => s.includes(J)).map((J) => /* @__PURE__ */ k.jsx(dt.Item, { value: J, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: Gk(J) }) }, J))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: Qk,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
            },
            confirmOnClick: () => {
              y && ae();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ae();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, a3 = "_clickableIcon_33mqm_1", qu = {
  clickableIcon: a3
}, Jk = ({
  formFieldName: e,
  ...n
}) => {
  const r = Lr(), { field: i } = ap({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    $m,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, $m = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, g] = se(m), { isCopied: C, copy: S } = Pr(), { track: N } = _n(), w = 14, y = o && (!!r || !!l), V = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), T = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), F = n?.countryCodeV2 && f0(n.countryCodeV2), $ = ot(() => [
    T,
    n?.company,
    n?.address1,
    n?.address2,
    V,
    n?.province,
    F
  ].filter(Boolean).join(`
`), [n, T, V, F]);
  if (!n)
    return null;
  const U = () => {
    i && r && N("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { size: w, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => g(!h),
              className: qu.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  me,
                  {
                    size: w,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            T && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: T }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            V && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: V }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            F && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: F })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(We, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: w,
            name: "pen",
            onClick: () => U(),
            className: qu.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(We, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: w,
            name: C ? "done" : "copy",
            onClick: () => S($()),
            className: qu.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      i3,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, qp = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Lr(), i = ms({ control: r.control, name: "lineItems" }), a = ms({
    control: r.control,
    name: "billingAddress"
  }), o = ms({
    control: r.control,
    name: "shippingAddress"
  }), s = Bn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Bn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        Jk,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        Jk,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, o3 = "_productTableHeader_6h6pl_1", s3 = "_productImage_6h6pl_5", io = {
  productTableHeader: o3,
  productImage: s3
}, Hp = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, l3 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Lr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Hp(e);
  return /* @__PURE__ */ k.jsxs(Jn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        oa,
        {
          src: d,
          alt: e.title,
          className: io.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(
      nt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(nr, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, c3 = 300, Ma = 2, d3 = 25, u3 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = fn(), [i, a] = se(""), [o, s] = se([]), l = Lr(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Mp, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (S) => {
      const N = S?.Shopify?.products?.nodes || [];
      s(
        N.filter((w) => !!w).sort((w, y) => w.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  Ni(
    () => {
      i.trim().length >= Ma && !u && f === er.ready ? m({
        variables: {
          query: i.trim(),
          productCount: d3,
          mediaCount: 1
        }
      }) : i.trim().length < Ma && s([]);
    },
    c3,
    [i]
  ), Le(() => {
    if (!d) return;
    const S = o.find(
      (N) => N.id === d
    );
    S && e(S), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== er.ready, g = i.trim().length >= Ma, C = !o.length && !h && g;
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${Ma} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (S) => {
          const N = o.find(
            (w) => w.id === S
          );
          return N ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: N.title }) : null;
        },
        filter: {
          value: i,
          onChange: (S) => {
            a(S.target.value);
          }
        },
        onToggleDropdown: (S) => {
          !S && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(dt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }) }),
        !h && o.map((S) => {
          const N = S.totalInventory <= 0, w = Hp(S);
          return /* @__PURE__ */ k.jsx(
            dt.Item,
            {
              value: S.id,
              isDisabled: N,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  w && /* @__PURE__ */ k.jsx(
                    oa,
                    {
                      src: w,
                      alt: S.title,
                      className: io.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    T0,
                    {
                      text: S.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: S.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: N ? "Out of stock" : `${S.totalInventory} in stock` })
              ] })
            },
            S.id
          );
        }),
        C && /* @__PURE__ */ k.jsx(dt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          _s,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !g && !h && /* @__PURE__ */ k.jsx(dt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          _s,
          {
            title: "Search for products",
            description: `Type at least ${Ma} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Wp = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Lr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (N) => !o.includes(N?.id)
  ) : [], g = h.length > 0 && h.every(
    (N) => a.includes(N?.id)
  ), C = h.some(
    (N) => a.includes(N?.id)
  ) && !g, S = ot(
    (N) => {
      const w = m.getValues("lineItems"), y = w.findIndex(
        (V) => V?.id === N.id
      );
      if (y > -1) {
        const V = m.getValues(`lineItems.${y}.quantity`) || 0, T = [...w];
        T[y] = {
          ...T[y],
          quantity: V + 1
        }, m.setValue("lineItems", T);
      } else
        m.setValue("lineItems", [
          ...w,
          { ...N, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(u3, { onProductSelected: S }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Ot.boxWrapper,
        children: /* @__PURE__ */ k.jsx(dn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Ot.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          _s,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Jn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: io.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Jn.Thead, { className: io.productTableHeader, children: /* @__PURE__ */ k.jsxs(Jn.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(Jn.Th, { children: /* @__PURE__ */ k.jsx(
              sf,
              {
                checked: g,
                indeterminate: C,
                onChange: () => d?.(!g)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(Jn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Jn.Tbody, { children: u?.map((N, w) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                l3,
                {
                  product: N,
                  index: w,
                  onRemove: () => {
                    const B = u.filter(
                      (O, q) => q !== w
                    );
                    m.setValue("lineItems", B);
                  }
                },
                `${N?.id}-${w}`
              );
            const y = N, V = y.priceRangeV2.minVariantPrice.amount, T = y.priceRangeV2.minVariantPrice.currencyCode, F = `lineItems.${w}.quantity`, $ = m.watch(F) || 0, U = V * $, Q = Hp(y), X = a.includes(y.id), ae = o.includes(y.id), J = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              Jn.Tr,
              {
                style: ae ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(
                    sf,
                    {
                      checked: X,
                      disabled: ae,
                      onChange: () => l?.(y.id, !X)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    Q && /* @__PURE__ */ k.jsx(
                      oa,
                      {
                        src: Q,
                        alt: y.title,
                        className: io.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.title }),
                      ae && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${V} ${T}` }) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(
                    nt,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ae || J <= 1,
                      name: F,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: J,
                        tabIndex: 0
                      }
                    },
                    `${F}-${m.watch(F)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${U} ${T}` }) }),
                  !r && /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    nr,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const B = u.filter(
                          (O, q) => q !== w
                        );
                        m.setValue("lineItems", B), X && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${w}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, bS = ({
  previousOrderStatus: e
} = {}) => {
  const n = Lr();
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Wk.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Wk.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(dt.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, xS = () => {
  const e = Lr();
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Kk.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Kk.map((n) => /* @__PURE__ */ k.jsx(dt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, m3 = "_modal_1mprq_1", p3 = {
  modal: m3
}, Hu = "create-shopify-order-form", f3 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = fn(), { track: l } = _n(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, g = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Wr.Pending,
    fulfillmentStatus: void 0
  }, [C, S] = se([]), N = St({
    mode: "all",
    defaultValues: g
  }), w = N.watch("lineItems").length > 0, y = () => {
    N.reset(g), S([]), i(!1);
  };
  Le(() => {
    C.length > 0 && N.setValue("tags", C, { shouldDirty: !0 });
  }, [C, N]);
  const [V, { error: T }] = o(
    gS,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [F, { error: $ }] = o(
    xz,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), U = (X) => {
    const ae = X.lineItems.map((O) => ({
      productId: O.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: O.priceRangeV2.maxVariantPrice.amount,
          currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: O.quantity
    }));
    m(!0);
    const J = Bi(X?.billingAddress), B = Bi(
      X?.shippingAddress
    );
    V({
      variables: {
        order: {
          lineItems: ae,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: X.customNote,
          tags: X.tags,
          financialStatus: X.financialStatus,
          fulfillmentStatus: X.fulfillmentStatus,
          shippingAddress: B,
          billingAddress: J
        }
      }
    });
  }, Q = (X) => {
    const ae = X.lineItems.map((O) => ({
      title: O.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: O.priceRangeV2.maxVariantPrice.amount,
        currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: O.quantity
    }));
    f(!0);
    const J = Bi(X?.billingAddress), B = Bi(
      X?.shippingAddress
    );
    F({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: X.customNote,
          tags: X.tags,
          lineItems: ae,
          shippingAddress: B,
          billingAddress: J
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: y,
      className: p3.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx($t, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(ip, { ...N, children: /* @__PURE__ */ k.jsx("form", { id: Hu, children: /* @__PURE__ */ k.jsxs(ht, { children: [
            /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(Wp, {}) }),
            /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
              Wt,
              {
                name: "tags",
                render: ({ fieldState: { error: X } }) => /* @__PURE__ */ k.jsx(
                  hn,
                  {
                    label: "Tags",
                    meta: {
                      error: X?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ae) => {
                          ae.key === "Enter" && (ae.preventDefault(), ae.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          qs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: C,
                            onChange: (ae) => {
                              S(ae);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(we, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(bS, {}),
              /* @__PURE__ */ k.jsx(xS, {}),
              /* @__PURE__ */ k.jsx(
                nt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(we, { span: 2, children: /* @__PURE__ */ k.jsx(hn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ot.boxWrapper,
                children: /* @__PURE__ */ k.jsx(qp, {})
              }
            ) }) })
          ] }) }) }),
          (T || $) && /* @__PURE__ */ k.jsx(Fn, { error: T || $ })
        ] }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              type: "submit",
              form: Hu,
              disabled: !w || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: N.handleSubmit(U),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                N.handleSubmit(Q)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Hu,
                disabled: !w || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, h3 = "_modal_al73g_1", y3 = {
  modal: h3
}, Xk = [
  {
    label: "Customer",
    value: pi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: pi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: pi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: pi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: pi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: pi.Staff,
    description: "Staff made an error."
  }
], g3 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = _n(), { useMutation: d, showNotification: m } = fn(), [u, f] = se([]), h = u.length > 0, g = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, C = St({
    defaultValues: g
  }), [S, { error: N, reset: w }] = d(gz, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (T) => {
      const F = T.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (F.length > 0)
        o(!1), f(F), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const $ = T.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, $ ? 0 : 4e3), m({
          title: "Success",
          text: `${$ ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = ot(
    (T) => {
      T.reason != null && (o(!0), S({
        variables: {
          orderId: T.orderId,
          reason: T.reason,
          refundMethod: T.refundMethod,
          restock: T.restock,
          notifyCustomer: T.notifyCustomer,
          staffNote: T.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), V = () => {
    i(!1), w(), f([]), C.reset(g);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: n, onClose: V, className: y3.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: `Cancel order ${r}`, onClose: V }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(ht, { children: [
      /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: C.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (T, F) => T === F,
            getItemTitleByValue: (T) => {
              if (!T)
                return "";
              const F = Xk.find(
                ($) => $.value === T
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: F.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: F.description })
              ] });
            }
          },
          children: Xk.map((T) => /* @__PURE__ */ k.jsx(dt.Item, { value: T.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: T.description })
          ] }) }, T.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(hn, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        at,
        {
          control: C.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(hn, { label: "Restock items", children: /* @__PURE__ */ k.jsx(at, { control: C.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(hn, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(at, { control: C.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
        nt,
        {
          name: "staffNote",
          label: "Staff note",
          control: C.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map((T) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(me, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              T.field?.join(","),
              ") ",
              T.message
            ] })
          ]
        },
        T.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          disabled: !(C.formState.isValid && C.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
        },
        confirmOnClick: C.handleSubmit(y),
        cancelOnClick: V,
        confirmName: N ? "Close" : "Cancel order",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, v3 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          me,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Ot.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      g3,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, k3 = "_modal_1mprq_1", b3 = {
  modal: k3
}, x3 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = fn(), { track: m } = _n(), [u, f] = se(!1), [h, g] = se(e?.tags || []), C = "duplicate-shopify-order-form", S = (B) => ({
    firstName: B?.firstName,
    lastName: B?.lastName,
    company: B?.company,
    address1: B?.address1,
    address2: B?.address2,
    city: B?.city,
    provinceCode: B?.provinceCode,
    zip: B?.zip,
    countryCode: B?.countryCodeV2,
    phone: B?.phone
  }), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: S(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: S(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, w = St({
    mode: "all",
    defaultValues: N
  }), y = w.watch("lineItems").length > 0, V = Bn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), T = Bn(
    () => kS(V),
    [V]
  ), {
    data: F,
    loading: $,
    error: U
  } = d(Mp, {
    skip: !T,
    variables: {
      query: T,
      productCount: V.length,
      mediaCount: 1
    }
  });
  Le(() => {
    U && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [U, l]), Le(() => {
    if (!r || $ || !F || w.getValues("lineItems")?.length)
      return;
    const B = F?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const ee = B.find(
        (ve) => ve.id === q.product?.id
      );
      ee && O.push({
        ...ee,
        quantity: q.quantity || 1,
        sku: q.sku,
        discountedUnitPrice: q.discountedUnitPriceSet?.shopMoney
      });
    }), O.length > 0 && w.setValue("lineItems", O, { shouldDirty: !0 });
  }, [r, F, $, e, w]), Le(() => {
    (h.length > 0 || (w.getValues("tags") || []).length > 0) && w.setValue("tags", h, { shouldDirty: !0 });
  }, [h, w]);
  const [Q, { error: X }] = s(
    gS,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), J();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), J();
      }
    }
  ), ae = (B) => {
    const O = B.lineItems.map((ee) => ({
      productId: ee.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ee.discountedUnitPrice?.amount ?? ee.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ee.discountedUnitPrice?.currencyCode ?? ee.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ee.quantity,
      sku: ee.sku
    })), q = (e?.shippingLines ?? []).map(
      (ee) => ({
        title: ee.title,
        code: ee.code,
        source: ee.source,
        priceSet: {
          shopMoney: {
            amount: ee.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ee.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), Q({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: O,
          shippingLines: q,
          note: B.customNote,
          tags: B.tags,
          financialStatus: B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          shippingAddress: Bi(B?.shippingAddress),
          billingAddress: Bi(B?.billingAddress)
        }
      }
    });
  }, J = () => {
    w.reset(N), g(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: r,
      onClose: J,
      className: b3.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx($t, { title: `Duplicate order ${n}`, onClose: J }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(ip, { ...w, children: /* @__PURE__ */ k.jsx("form", { id: C, children: /* @__PURE__ */ k.jsxs(ht, { children: [
            /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(Wp, { loading: $ }) }),
            /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
              Wt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ k.jsx(
                  hn,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (O) => {
                          O.key === "Enter" && (O.preventDefault(), O.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          qs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (O) => {
                              g(O);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(we, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                bS,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(xS, {}),
              /* @__PURE__ */ k.jsx(
                nt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(we, { span: 2, children: /* @__PURE__ */ k.jsx(hn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ot.boxWrapper,
                children: /* @__PURE__ */ k.jsx(qp, {})
              }
            ) }) })
          ] }) }) }),
          X && /* @__PURE__ */ k.jsx(Fn, { error: X })
        ] }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              type: "submit",
              form: C,
              disabled: !y || u || $,
              isLoading: u || $,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: w.handleSubmit(ae)
          }
        )
      ]
    }
  );
}, _3 = "_copyIcon_1dlzg_1", S3 = {
  copyIcon: _3
}, N3 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Pr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (l) => l > 0
  ), s = n.map(
    ({ title: l, quantity: d, variantTitle: m }) => m ? `${d}x ${l} (${m})` : `${d}x ${l}`
  ).join(`
`);
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(me, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ k.jsx(We, { content: "Copy line items", children: /* @__PURE__ */ k.jsx(
            me,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(s),
              className: S3.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(An, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Ye, { children: n.map(({ id: l, title: d, quantity: m, variantTitle: u, image: f }) => {
      const h = r[l], g = h > 0, C = h > 1 ? `Refunded (${h} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: m }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            d,
            " ",
            u && `(${u})`,
            g && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: C })
          ] }),
          contentRight: f?.url && /* @__PURE__ */ k.jsx(oa, { src: `${f?.url}&height=48`, alt: d })
        },
        `list-${e}-${l}`
      );
    }) })
  ] });
}, j3 = Ws`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, w3 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, _S = (e) => {
  const n = {}, r = w3(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, C3 = "_modal_21e62_1", F3 = {
  modal: C3
}, Zk = "partial-refund-shopify-order-form", I3 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = fn(), { track: l } = _n(), { useQuery: d } = fn(), [m, u] = se(!1), [f, h] = se([]), g = Bn(
    () => e?.refunds ? _S(e) : {},
    [e]
  ), C = Bn(
    () => (e?.lineItems || []).filter((B) => (g[B.id] || 0) >= (B.quantity || 0)).map((B) => B.product?.id).filter((B) => !!B),
    [e, g]
  ), S = Bn(() => {
    const B = {};
    return (e?.lineItems || []).forEach((O) => {
      if (O.product?.id) {
        const q = g[O.id] || 0, ee = Math.max(
          0,
          (O.quantity || 0) - q
        );
        B[O.product.id] = ee;
      }
    }), B;
  }, [e, g]), N = Bn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), w = Bn(
    () => kS(N),
    [N]
  ), {
    data: y,
    loading: V,
    error: T
  } = d(Mp, {
    skip: !w,
    variables: {
      query: w,
      productCount: N.length,
      mediaCount: 1
    }
  });
  Le(() => {
    T && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [T, s]);
  const F = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, $ = St({
    mode: "all",
    defaultValues: F
  }), U = f.length > 0, [Q, { error: X }] = o(
    j3,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), J();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), J();
      }
    }
  );
  Le(() => {
    if (!r || V || !y || $.getValues("lineItems")?.length)
      return;
    const B = y?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const ee = B.find(
        (ve) => ve.id === q.product?.id
      );
      if (ee) {
        const ve = g[q.id] || 0, de = (q.quantity || 1) - ve;
        O.push({
          ...ee,
          quantity: de > 0 ? de : q.quantity || 1
        });
      }
    }), O.length > 0 && ($.setValue("lineItems", O, { shouldDirty: !0 }), h([]));
  }, [
    r,
    y,
    V,
    e,
    $,
    g
  ]);
  const ae = (B) => {
    u(!0);
    const O = (B.lineItems || []).filter(
      (q) => f.includes(q.id)
    ).map((q) => {
      const ee = e?.lineItems?.find(
        (pe) => pe.product?.id === q.id
      ), ve = g[ee?.id || ""] || 0, de = (ee?.quantity || 0) - ve, le = Math.max(
        0,
        Math.min(de, q.quantity || 0)
      );
      return ee && le > 0 ? { lineItemId: ee.id, quantity: le } : void 0;
    }).filter((q) => !!q);
    Q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: O,
          note: B.customNote || void 0,
          notify: !0
        }
      }
    });
  }, J = () => {
    $.reset(F), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: r, onClose: J, className: F3.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: `Refund order ${n}`, onClose: J }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(ip, { ...$, children: /* @__PURE__ */ k.jsx("form", { id: Zk, children: /* @__PURE__ */ k.jsxs(ht, { children: [
        /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
          Wp,
          {
            loading: V,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: C,
            maxQuantities: S,
            onToggleSelect: (B, O) => {
              h((q) => O ? Array.from(/* @__PURE__ */ new Set([...q, B])) : q.filter((ee) => ee !== B));
            },
            onToggleSelectAll: (B) => {
              const O = ($.getValues("lineItems") || []).map((q) => q.id).filter((q) => !C.includes(q));
              h(B ? O : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(we, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          nt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(we, { span: 2, children: /* @__PURE__ */ k.jsx(hn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Ot.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              qp,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      X && /* @__PURE__ */ k.jsx(Fn, { error: X })
    ] }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          type: "submit",
          form: Zk,
          disabled: !U || m || V,
          isLoading: m || V,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: $.handleSubmit(ae)
      }
    )
  ] });
}, E3 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = fn(), { track: l } = _n(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, h = parseFloat(String(d?.amount)), g = !isNaN(h) && h > 0, [C] = a(yz, {
    onError: (w) => {
      setTimeout(() => N(w), 500);
    },
    onCompleted: (w) => {
      const y = w.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? N(
        new Xb({
          graphQLErrors: y.map((V) => ({
            message: V.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), S = ot(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: w, ...y } = d;
    s(g ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        w,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), C({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    g,
    s,
    C,
    l
  ]), N = ot(
    (w) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(Fn, { error: w }),
          /* @__PURE__ */ k.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Kn,
    {
      variant: "secondary",
      onClick: S,
      disabled: d?.refundLineItems?.length === 0 || !g,
      slotStart: /* @__PURE__ */ k.jsx(me, { size: 14, name: "undo" }),
      className: Ot.fullWidth,
      children: "Full refund"
    }
  ) });
}, T3 = "_modal_al73g_1", $3 = {
  modal: T3
}, D3 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = _n(), { useMutation: s, showNotification: l } = fn(), [d, m] = se(n), [u, f] = se(!1), h = St({
    defaultValues: {
      tags: n
    }
  });
  Le(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [g, { error: C, reset: S }] = s(vz, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), N = ot(
    (y) => {
      f(!0), g({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((V) => {
        const T = V.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: T });
      });
    },
    [e, h, g]
  ), w = () => {
    i(!1), S();
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: r, onClose: w, className: $3.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: "Manage tags for order", onClose: w }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(ht, { children: /* @__PURE__ */ k.jsx(we, { children: /* @__PURE__ */ k.jsx(
        Wt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            hn,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                qs,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (V) => m(V)
                }
              )
            }
          )
        }
      ) }) }),
      C && /* @__PURE__ */ k.jsx(Fn, { error: C })
    ] }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(N),
        cancelOnClick: w,
        confirmName: C ? "Close" : "Save",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, R3 = "_editIcon_1yp2k_1", O3 = "_copyIcon_1yp2k_2", eb = {
  editIcon: R3,
  copyIcon: O3
}, P3 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), { isCopied: o, copy: s } = Pr(), l = 14, d = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !d && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            d && n.map((m, u) => /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "primary", children: m }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(We, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: l,
            name: "pen",
            className: eb.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        d && /* @__PURE__ */ k.jsx(We, { content: "Copy tags", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: l,
            name: o ? "done" : "copy",
            className: eb.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      D3,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, A3 = "_icon_cddi1_1", L3 = "_link_cddi1_6", nb = {
  icon: A3,
  link: L3
}, V3 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Pr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: nb.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(We, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        me,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: nb.icon
        }
      ) })
    }
  );
}, z3 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(me, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Ye, { children: e.map((n) => /* @__PURE__ */ k.jsx(V3, { trackingInfo: n }, n.number)) })
] }), U3 = "_copyIcon_yc0fe_1", M3 = "_order_yc0fe_6", B3 = "_orderIsOpen_yc0fe_14", q3 = "_orderHeader_yc0fe_17", Pi = {
  copyIcon: U3,
  order: M3,
  orderIsOpen: B3,
  orderHeader: q3
}, H3 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = _n(), { isCopied: h, copy: g } = Pr(), { isCopied: C, copy: S } = Pr(), { isCopied: N, copy: w } = Pr(), [y, V] = se(!1), [T, F] = se(!1), [$, U] = se(r), {
    id: Q,
    name: X,
    createdAt: ae,
    status: J,
    currentTotalPriceSet: B,
    currencyCode: O,
    lineItems: q,
    billingAddress: ee,
    shippingAddress: ve,
    trackingInfos: de,
    tags: le
  } = e, pe = !!ve, W = Bp(Q), be = `https://${l}/admin/orders/${W ?? ""}`, Ie = B?.shopMoney?.amount ?? 0, G = J.includes("cancelled"), He = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: O
  }).format(Ie), qe = e?.refunds ? _S(e) : {}, Oe = !!q?.length && q.every((Be) => (qe[Be.id] || 0) >= (Be.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: rt(Pi.order, {
        [Pi.orderIsOpen]: $
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Pi.orderHeader,
            onClick: () => U(!$),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                ae && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: Ln(ae).format(Tm) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  X
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: $ ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        $ && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(me, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: X.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(We, { content: "Copy order number", children: /* @__PURE__ */ k.jsx(
                  me,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => g(X.replace("#", "")),
                    className: Pi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(me, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: J })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(We, { content: "Copy order status", children: /* @__PURE__ */ k.jsx(
                  me,
                  {
                    size: 14,
                    name: N ? "done" : "copy",
                    onClick: () => w(J),
                    className: Pi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(me, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: He })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(We, { content: "Copy order value", children: /* @__PURE__ */ k.jsx(
                  me,
                  {
                    size: 14,
                    name: C ? "done" : "copy",
                    onClick: () => S(Ie),
                    className: Pi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsx(
            P3,
            {
              orderId: Q,
              tags: le,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            $m,
            {
              openByDefault: !pe,
              labelText: "Billing address",
              address: ee,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            $m,
            {
              openByDefault: pe,
              shopifyId: n,
              orderId: Q,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ve,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            N3,
            {
              orderId: Q,
              lineItems: q,
              refundedQuantities: qe
            }
          ),
          /* @__PURE__ */ k.jsx(z3, { trackingInfos: de }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              E3,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: be
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => F(!0),
                className: Ot.fullWidth,
                disabled: G || Oe,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => V(!0),
                className: Ot.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              v3,
              {
                orderId: Q,
                orderName: X,
                disabled: G,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(be, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: Q
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        y && /* @__PURE__ */ k.jsx(
          x3,
          {
            order: e,
            shopifyId: n,
            orderName: X,
            isOpen: y,
            setIsOpen: V,
            refetchOrders: u
          }
        ),
        T && /* @__PURE__ */ k.jsx(
          I3,
          {
            order: e,
            orderName: X,
            isOpen: T,
            setIsOpen: F,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, W3 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = _n(), [f, h] = se([]), [g, C] = se(!1), S = Bp(m?.id), N = `https://${n}/admin/orders?customer_id=${S ?? ""}`, {
    getCustomerOrders: w,
    isCustomerOrdersLoading: y,
    customerOrdersError: V,
    customerOrders: T,
    refetchCustomerOrders: F
  } = Sz();
  return Le(() => {
    !y && S && w({
      variables: {
        query: `customer_id:${S}`
      }
    });
  }, [S]), Le(() => {
    const $ = T?.Shopify?.orders?.edges;
    $ && h(Zz({ ordersData: $ }));
  }, [T]), m ? V ? /* @__PURE__ */ k.jsx(Fn, { error: V }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(Pn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => C(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map(($, U) => /* @__PURE__ */ k.jsx(
        H3,
        {
          order: $,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: F,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${$.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        Et,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(N, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      f3,
      {
        isOpen: g,
        setIsOpen: C,
        shopifyCustomer: m,
        refetchCustomerOrders: F,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, K3 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Ye, { className: Ot.list, children: [
      /* @__PURE__ */ k.jsx(Ye.Text, { variant: "dense", className: Ot.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { variant: "dense", className: Ot.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, G3 = "_segmentName_1dkhk_1", Y3 = {
  segmentName: G3
}, Q3 = 100, ns = 10, J3 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = fn(), [i, a] = se([]), [o, s] = se(ns), [l, d] = se(!1), m = Bn(
    () => i.filter((S) => S.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    mz,
    {
      skip: !e,
      variables: {
        first: Q3
      },
      onCompleted: (S) => {
        const N = S?.Shopify?.segments?.edges;
        if (N && N.length > 0) {
          const w = N.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, V) => y.name.localeCompare(V.name));
          a(w), h({
            variables: {
              customerId: e,
              segmentIds: w.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: g, error: C }
  ] = r(pz, {
    onCompleted: (S) => {
      const N = S?.Shopify?.customerSegmentMembership?.memberships;
      if (N && N.length > 0) {
        const w = i.map((y) => {
          const V = N.find(
            (T) => T.segmentId === y.id
          );
          return {
            ...y,
            ...V?.isMember && { isMember: V.isMember }
          };
        }).sort(
          (y, V) => y.isMember === V.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(w);
      }
    }
  });
  return Le(() => {
    s(l ? i.length : ns);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(Pn, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(Fn, { error: f }),
    C && /* @__PURE__ */ k.jsx(Fn, { error: C }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(Ye, { className: Ot.list, children: [
      i.slice(0, o).map(({ id: S, name: N, isMember: w }) => /* @__PURE__ */ k.jsx(Ye.Text, { className: Ot.listItem, children: /* @__PURE__ */ k.jsx(
        We,
        {
          content: `${w ? "Member of" : "Not a member of"} ${N}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: Y3.segmentName, children: N }),
            g && /* @__PURE__ */ k.jsx(dn, { size: 12 }),
            !g && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              me,
              {
                color: w ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, S)),
      i.length > ns && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Kn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - ns} more`
        }
      ) })
    ] })
  ] }) : null;
}, X3 = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = _z({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, g = n.displayCancelOrder ?? !1, C = n.enableEditShippingAddress ?? !1, S = n.displayEmailMarketingConsent ?? !1, N = n.displayOrdersOverview ?? !1, w = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, V = n.displayDiscountCodes ?? !1, T = n.displayCreateOrder ?? !1, F = n.displayDuplicateOrder ?? !1, $ = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (Le(() => {
    const Q = a?.Shopify?.customers?.edges[0]?.node;
    Q && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(Q)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(Fn, { error: i, retry: o });
  if (!r && !i && !l) {
    const Q = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              Tz,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              Et,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Q, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== er.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(dn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          Rz,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        N && /* @__PURE__ */ k.jsx(
          K3,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        w && /* @__PURE__ */ k.jsx(J3, { shopifyId: l?.id }),
        S && /* @__PURE__ */ k.jsx(Xz, { customer: l }),
        V && /* @__PURE__ */ k.jsx(
          Jz,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ k.jsx(
          W3,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: g,
            displayCreateOrder: T,
            displayCreateDraftOrder: $,
            enableEditShippingAddress: C,
            customerCountryCodes: m,
            displayDuplicateOrder: F,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, wt = [];
for (let e = 0; e < 256; ++e)
  wt.push((e + 256).toString(16).slice(1));
function Z3(e, n = 0) {
  return (wt[e[n + 0]] + wt[e[n + 1]] + wt[e[n + 2]] + wt[e[n + 3]] + "-" + wt[e[n + 4]] + wt[e[n + 5]] + "-" + wt[e[n + 6]] + wt[e[n + 7]] + "-" + wt[e[n + 8]] + wt[e[n + 9]] + "-" + wt[e[n + 10]] + wt[e[n + 11]] + wt[e[n + 12]] + wt[e[n + 13]] + wt[e[n + 14]] + wt[e[n + 15]]).toLowerCase();
}
const eU = new Uint8Array(16);
function nU() {
  return crypto.getRandomValues(eU);
}
function tU(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : rU(e);
}
function rU(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? nU();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Z3(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Wu = { exports: {} }, Ba = {}, tb;
function iU() {
  if (tb) return Ba;
  tb = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ba.Fragment = r, Ba.jsx = s, Ba.jsxs = s, Ba;
}
var ts = {}, rb;
function aU() {
  return rb || (rb = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ts.Fragment = i, ts.jsx = Rn, ts.jsxs = Mn;
  })()), ts;
}
var ib;
function oU() {
  return ib || (ib = 1, process.env.NODE_ENV === "production" ? Wu.exports = iU() : Wu.exports = aU()), Wu.exports;
}
var M = oU(), SS = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(SS || {}), Dm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Dm || {});
const sU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, lU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, cU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, dU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, uU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, mU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, pU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, fU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, hU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, yU = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": sU,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": lU,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": cU,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": dU,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": uU,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": mU,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": pU,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": fU,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": hU
};
function Jr(e) {
  return yU[e] ?? {};
}
const gU = Jr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), vU = Jr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), kU = Jr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), bU = Jr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), xU = Jr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), _U = Jr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), SU = Jr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), NU = Jr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), jU = Jr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), wU = ({
  contactId: e
}) => {
  const { useQuery: n } = fn(), { track: r } = _n(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(gU, {
    skip: !e,
    variables: { contactId: e }
  });
  return Le(() => {
    const g = f?.Voyado?.ContactsV_GetContactById;
    !m && g && typeof g == "object" && ("id" in g && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in g && a(g.attributes), "preferences" in g && s(g.preferences), "consents" in g && d(
      g?.consents?.filter(
        (C) => C !== null
      ) || void 0
    )), !m && (!g || typeof g != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Bn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function ks(e = !1, n) {
  const [r, i] = se(e);
  return Le(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const CU = {
  count: 0,
  items: []
}, FU = ({
  contactId: e
}) => {
  const { useQuery: n } = fn(), { track: r } = _n(), [i, a] = se(CU), {
    loading: o,
    error: s,
    data: l
  } = n(bU, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Le(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, IU = {
  count: 0,
  totalCount: 0,
  items: []
}, EU = ({
  contactId: e
}) => {
  const { useQuery: n } = fn(), { track: r } = _n(), [i, a] = se(
    IU
  ), {
    loading: o,
    error: s,
    data: l
  } = n(xU, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Le(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, TU = ({
  conversationContext: e
}) => {
  const { useQuery: n } = fn(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(kU, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Le(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, $U = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = fn(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(vU, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Le(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Bn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, DU = "_pointer_ls8kj_48", RU = "_list_ls8kj_53", OU = "_listItem_ls8kj_63", tt = {
  pointer: DU,
  list: RU,
  listItem: OU
};
var Fo = (e) => e.type === "checkbox", yi = (e) => e instanceof Date, qt = (e) => e == null;
const NS = (e) => typeof e == "object";
var mt = (e) => !qt(e) && !Array.isArray(e) && NS(e) && !yi(e), jS = (e) => mt(e) && e.target ? Fo(e.target) ? e.target.checked : e.target.value : e, PU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, wS = (e, n) => e.has(PU(n)), AU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return mt(n) && n.hasOwnProperty("isPrototypeOf");
}, Kp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ft(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Kp && (e instanceof Blob || i)) && (r || mt(e)))
    if (n = r ? [] : {}, !r && !AU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ft(e[a]));
  else
    return e;
  return n;
}
var ul = (e) => Array.isArray(e) ? e.filter(Boolean) : [], lt = (e) => e === void 0, Xe = (e, n, r) => {
  if (!n || !mt(e))
    return r;
  const i = ul(n.split(/[,[\].]+?/)).reduce((a, o) => qt(a) ? a : a[o], e);
  return lt(i) || i === e ? lt(e[n]) ? r : e[n] : i;
}, ir = (e) => typeof e == "boolean", Gp = (e) => /^\w*$/.test(e), CS = (e) => ul(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = Gp(n) ? [n] : CS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = mt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Ps = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, br = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, qr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, LU = Fe.createContext(null), Yp = () => Fe.useContext(LU);
var FS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== br.all && (n._proxyFormState[s] = !i || br.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function VU(e) {
  const n = Yp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Fe.useState(r._formState), d = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Fe.useRef(a);
  return m.current = a, Fe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Fe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Fe.useMemo(() => FS(s, r, d.current, !1), [s, r]);
}
var Rr = (e) => typeof e == "string", IS = (e, n, r, i, a) => Rr(e) ? (i && n.watch.add(e), Xe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Xe(r, o))) : (i && (n.watchAll = !0), r);
function ES(e) {
  const n = Yp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Fe.useRef(i), d = Fe.useRef(a);
  l.current = i, Fe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(IS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Fe.useState(r._getWatch(i, a));
  return Fe.useEffect(() => r._removeUnmounted()), m;
}
function zU(e) {
  const n = Yp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = wS(a._names.array, r), l = ES({
    control: a,
    name: r,
    defaultValue: Xe(a._formValues, r, Xe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = VU({
    control: a,
    name: r,
    exact: !0
  }), m = Fe.useRef(e), u = Fe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...ir(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Fe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Xe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Xe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Xe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Xe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Xe(d.errors, r)
    }
  }), [d, r]), h = Fe.useCallback((N) => u.current.onChange({
    target: {
      value: jS(N),
      name: r
    },
    type: Ps.CHANGE
  }), [r]), g = Fe.useCallback(() => u.current.onBlur({
    target: {
      value: Xe(a._formValues, r),
      name: r
    },
    type: Ps.BLUR
  }), [r, a._formValues]), C = Fe.useCallback((N) => {
    const w = Xe(a._fields, r);
    w && N && (w._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = Fe.useMemo(() => ({
    name: r,
    value: l,
    ...ir(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: g,
    ref: C
  }), [r, i, d.disabled, h, g, C, l]);
  return Fe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...ir(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (y, V) => {
      const T = Xe(a._fields, y);
      T && T._f && (T._f.mount = V);
    };
    if (w(r, !0), N) {
      const y = Ft(Xe(a._options.defaultValues, r));
      Yn(a._defaultValues, r, y), lt(Xe(a._formValues, r)) && Yn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : w(r, !1);
    };
  }, [r, a, s, o]), Fe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Fe.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const ab = (e) => e.render(zU(e));
var UU = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, ao = (e) => Array.isArray(e) ? e : [e], ob = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Rm = (e) => qt(e) || !NS(e);
function ri(e, n) {
  if (Rm(e) || Rm(n))
    return e === n;
  if (yi(e) && yi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (yi(o) && yi(s) || mt(o) && mt(s) || Array.isArray(o) && Array.isArray(s) ? !ri(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Ut = (e) => mt(e) && !Object.keys(e).length, Qp = (e) => e.type === "file", xr = (e) => typeof e == "function", As = (e) => {
  if (!Kp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, TS = (e) => e.type === "select-multiple", Jp = (e) => e.type === "radio", MU = (e) => Jp(e) || Fo(e), Ku = (e) => As(e) && e.isConnected;
function BU(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = lt(e) ? i++ : e[n[i++]];
  return e;
}
function qU(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !lt(e[n]))
      return !1;
  return !0;
}
function kt(e, n) {
  const r = Array.isArray(n) ? n : Gp(n) ? [n] : CS(n), i = r.length === 1 ? e : BU(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (mt(i) && Ut(i) || Array.isArray(i) && qU(i)) && kt(e, r.slice(0, -1)), e;
}
var $S = (e) => {
  for (const n in e)
    if (xr(e[n]))
      return !0;
  return !1;
};
function Ls(e, n = {}) {
  const r = Array.isArray(e);
  if (mt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || mt(e[i]) && !$S(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ls(e[i], n[i])) : qt(e[i]) || (n[i] = !0);
  return n;
}
function DS(e, n, r) {
  const i = Array.isArray(e);
  if (mt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || mt(e[a]) && !$S(e[a]) ? lt(n) || Rm(r[a]) ? r[a] = Array.isArray(e[a]) ? Ls(e[a], []) : { ...Ls(e[a]) } : DS(e[a], qt(n) ? {} : n[a], r[a]) : r[a] = !ri(e[a], n[a]);
  return r;
}
var qa = (e, n) => DS(e, n, Ls(n));
const sb = {
  value: !1,
  isValid: !1
}, lb = { value: !0, isValid: !0 };
var RS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !lt(e[0].attributes.value) ? lt(e[0].value) || e[0].value === "" ? lb : { value: e[0].value, isValid: !0 } : lb
    ) : sb;
  }
  return sb;
}, OS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => lt(e) ? e : n ? e === "" ? NaN : e && +e : r && Rr(e) ? new Date(e) : i ? i(e) : e;
const cb = {
  isValid: !1,
  value: null
};
var PS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, cb) : cb;
function db(e) {
  const n = e.ref;
  return Qp(n) ? n.files : Jp(n) ? PS(e.refs).value : TS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Fo(n) ? RS(e.refs).value : OS(lt(n.value) ? e.ref.value : n.value, e);
}
var HU = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Xe(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Vs = (e) => e instanceof RegExp, Ha = (e) => lt(e) ? e : Vs(e) ? e.source : mt(e) ? Vs(e.value) ? e.value.source : e.value : e, ub = (e) => ({
  isOnSubmit: !e || e === br.onSubmit,
  isOnBlur: e === br.onBlur,
  isOnChange: e === br.onChange,
  isOnAll: e === br.all,
  isOnTouch: e === br.onTouched
});
const mb = "AsyncFunction";
var WU = (e) => !!e && !!e.validate && !!(xr(e.validate) && e.validate.constructor.name === mb || mt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === mb)), KU = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), pb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const oo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Xe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (oo(l, n))
          break;
      } else if (mt(l) && oo(l, n))
        break;
    }
  }
};
function fb(e, n, r) {
  const i = Xe(e, r);
  if (i || Gp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Xe(n, o), l = Xe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var GU = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Ut(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || br.all));
}, YU = (e, n, r) => !e || !n || e === n || ao(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), QU = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, JU = (e, n) => !ul(Xe(e, n)).length && kt(e, n), XU = (e, n, r) => {
  const i = ao(Xe(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, bs = (e) => Rr(e);
function hb(e, n, r = "validate") {
  if (bs(e) || Array.isArray(e) && e.every(bs) || ir(e) && !e)
    return {
      type: r,
      message: bs(e) ? e : "",
      ref: n
    };
}
var Ai = (e) => mt(e) && !Vs(e) ? e : {
  value: e,
  message: ""
}, yb = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: g, validate: C, name: S, valueAsNumber: N, mount: w } = e._f, y = Xe(r, S);
  if (!w || n.has(S))
    return {};
  const V = l ? l[0] : s, T = (B) => {
    a && V.reportValidity && (V.setCustomValidity(ir(B) ? "" : B || ""), V.reportValidity());
  }, F = {}, $ = Jp(s), U = Fo(s), Q = $ || U, X = (N || Qp(s)) && lt(s.value) && lt(y) || As(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = UU.bind(null, S, i, F), J = (B, O, q, ee = qr.maxLength, ve = qr.minLength) => {
    const de = B ? O : q;
    F[S] = {
      type: B ? ee : ve,
      message: de,
      ref: s,
      ...ae(B ? ee : ve, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Q && (X || qt(y)) || ir(y) && !y || U && !RS(l).isValid || $ && !PS(l).isValid)) {
    const { value: B, message: O } = bs(d) ? { value: !!d, message: d } : Ai(d);
    if (B && (F[S] = {
      type: qr.required,
      message: O,
      ref: V,
      ...ae(qr.required, O)
    }, !i))
      return T(O), F;
  }
  if (!X && (!qt(f) || !qt(h))) {
    let B, O;
    const q = Ai(h), ee = Ai(f);
    if (!qt(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      qt(q.value) || (B = ve > q.value), qt(ee.value) || (O = ve < ee.value);
    } else {
      const ve = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      Rr(q.value) && y && (B = le ? de(y) > de(q.value) : pe ? y > q.value : ve > new Date(q.value)), Rr(ee.value) && y && (O = le ? de(y) < de(ee.value) : pe ? y < ee.value : ve < new Date(ee.value));
    }
    if ((B || O) && (J(!!B, q.message, ee.message, qr.max, qr.min), !i))
      return T(F[S].message), F;
  }
  if ((m || u) && !X && (Rr(y) || o && Array.isArray(y))) {
    const B = Ai(m), O = Ai(u), q = !qt(B.value) && y.length > +B.value, ee = !qt(O.value) && y.length < +O.value;
    if ((q || ee) && (J(q, B.message, O.message), !i))
      return T(F[S].message), F;
  }
  if (g && !X && Rr(y)) {
    const { value: B, message: O } = Ai(g);
    if (Vs(B) && !y.match(B) && (F[S] = {
      type: qr.pattern,
      message: O,
      ref: s,
      ...ae(qr.pattern, O)
    }, !i))
      return T(O), F;
  }
  if (C) {
    if (xr(C)) {
      const B = await C(y, r), O = hb(B, V);
      if (O && (F[S] = {
        ...O,
        ...ae(qr.validate, O.message)
      }, !i))
        return T(O.message), F;
    } else if (mt(C)) {
      let B = {};
      for (const O in C) {
        if (!Ut(B) && !i)
          break;
        const q = hb(await C[O](y, r), V, O);
        q && (B = {
          ...q,
          ...ae(O, q.message)
        }, T(q.message), i && (F[S] = B));
      }
      if (!Ut(B) && (F[S] = {
        ref: V,
        ...B
      }, !i))
        return F;
    }
  }
  return T(!0), F;
};
const ZU = {
  mode: br.onSubmit,
  reValidateMode: br.onChange,
  shouldFocusError: !0
};
function eM(e = {}) {
  let n = {
    ...ZU,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: xr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = mt(n.defaultValues) || mt(n.values) ? Ft(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ft(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: ob(),
    state: ob()
  }, g = ub(n.mode), C = ub(n.reValidateMode), S = n.criteriaMode === br.all, N = (E) => (x) => {
    clearTimeout(m), m = setTimeout(E, x);
  }, w = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const x = n.resolver ? Ut((await X()).errors) : await J(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (E, x) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((D) => {
      D && (x ? Yn(r.validatingFields, D, x) : kt(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Ut(r.validatingFields)
    }));
  }, V = (E, x = [], D, H, Y = !0, R = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Xe(i, E))) {
        const z = D(Xe(i, E), H.argA, H.argB);
        Y && Yn(i, E, z);
      }
      if (R && Array.isArray(Xe(r.errors, E))) {
        const z = D(Xe(r.errors, E), H.argA, H.argB);
        Y && Yn(r.errors, E, z), JU(r.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Xe(r.touchedFields, E))) {
        const z = D(Xe(r.touchedFields, E), H.argA, H.argB);
        Y && Yn(r.touchedFields, E, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = qa(a, o)), h.state.next({
        name: E,
        isDirty: O(E, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, E, x);
  }, T = (E, x) => {
    Yn(r.errors, E, x), h.state.next({
      errors: r.errors
    });
  }, F = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (E, x, D, H) => {
    const Y = Xe(i, E);
    if (Y) {
      const R = Xe(o, E, lt(D) ? Xe(a, E) : D);
      lt(R) || H && H.defaultChecked || x ? Yn(o, E, x ? R : db(Y._f)) : ve(E, R), s.mount && w();
    }
  }, U = (E, x, D, H, Y) => {
    let R = !1, z = !1;
    const ie = {
      name: E
    };
    if (!n.disabled) {
      if (!D || H) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = ie.isDirty = O(), R = z !== ie.isDirty);
        const ue = ri(Xe(a, E), x);
        z = !!Xe(r.dirtyFields, E), ue ? kt(r.dirtyFields, E) : Yn(r.dirtyFields, E, !0), ie.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && z !== !ue;
      }
      if (D) {
        const ue = Xe(r.touchedFields, E);
        ue || (Yn(r.touchedFields, E, D), ie.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && ue !== D);
      }
      R && Y && h.state.next(ie);
    }
    return R ? ie : {};
  }, Q = (E, x, D, H) => {
    const Y = Xe(r.errors, E), R = (u.isValid || f.isValid) && ir(x) && r.isValid !== x;
    if (n.delayError && D ? (d = N(() => T(E, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Yn(r.errors, E, D) : kt(r.errors, E)), (D ? !ri(Y, D) : Y) || !Ut(H) || R) {
      const z = {
        ...H,
        ...R && ir(x) ? { isValid: x } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, X = async (E) => {
    y(E, !0);
    const x = await n.resolver(o, n.context, HU(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(E), x;
  }, ae = async (E) => {
    const { errors: x } = await X(E);
    if (E)
      for (const D of E) {
        const H = Xe(x, D);
        H ? Yn(r.errors, D, H) : kt(r.errors, D);
      }
    else
      r.errors = x;
    return x;
  }, J = async (E, x, D = {
    valid: !0
  }) => {
    for (const H in E) {
      const Y = E[H];
      if (Y) {
        const { _f: R, ...z } = Y;
        if (R) {
          const ie = l.array.has(R.name), ue = Y._f && WU(Y._f);
          ue && u.validatingFields && y([H], !0);
          const Se = await yb(Y, l.disabled, o, S, n.shouldUseNativeValidation && !x, ie);
          if (ue && u.validatingFields && y([H]), Se[R.name] && (D.valid = !1, x))
            break;
          !x && (Xe(Se, R.name) ? ie ? XU(r.errors, Se, R.name) : Yn(r.errors, R.name, Se[R.name]) : kt(r.errors, R.name));
        }
        !Ut(z) && await J(z, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const E of l.unMount) {
      const x = Xe(i, E);
      x && (x._f.refs ? x._f.refs.every((D) => !Ku(D)) : !Ku(x._f.ref)) && Ue(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (E, x) => !n.disabled && (E && x && Yn(o, E, x), !ri(Ie(), a)), q = (E, x, D) => IS(E, l, {
    ...s.mount ? o : lt(x) ? a : Rr(E) ? { [E]: x } : x
  }, D, x), ee = (E) => ul(Xe(s.mount ? o : a, E, n.shouldUnregister ? Xe(a, E, []) : [])), ve = (E, x, D = {}) => {
    const H = Xe(i, E);
    let Y = x;
    if (H) {
      const R = H._f;
      R && (!R.disabled && Yn(o, E, OS(x, R)), Y = As(R.ref) && qt(x) ? "" : x, TS(R.ref) ? [...R.ref.options].forEach((z) => z.selected = Y.includes(z.value)) : R.refs ? Fo(R.ref) ? R.refs.length > 1 ? R.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(Y) ? !!Y.find((ie) => ie === z.value) : Y === z.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((z) => z.checked = z.value === Y) : Qp(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: E,
        values: Ft(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(E, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && be(E);
  }, de = (E, x, D) => {
    for (const H in x) {
      const Y = x[H], R = `${E}.${H}`, z = Xe(i, R);
      (l.array.has(E) || mt(Y) || z && !z._f) && !yi(Y) ? de(R, Y, D) : ve(R, Y, D);
    }
  }, le = (E, x, D = {}) => {
    const H = Xe(i, E), Y = l.array.has(E), R = Ft(x);
    Yn(o, E, R), Y ? (h.array.next({
      name: E,
      values: Ft(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: E,
      dirtyFields: qa(a, o),
      isDirty: O(E, R)
    })) : H && !H._f && !qt(R) ? de(E, R, D) : ve(E, R, D), pb(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: Ft(o)
    });
  }, pe = async (E) => {
    s.mount = !0;
    const x = E.target;
    let D = x.name, H = !0;
    const Y = Xe(i, D), R = (z) => {
      H = Number.isNaN(z) || yi(z) && isNaN(z.getTime()) || ri(z, Xe(o, D, z));
    };
    if (Y) {
      let z, ie;
      const ue = x.type ? db(Y._f) : jS(E), Se = E.type === Ps.BLUR || E.type === Ps.FOCUS_OUT, nn = !KU(Y._f) && !n.resolver && !Xe(r.errors, D) && !Y._f.deps || QU(Se, Xe(r.touchedFields, D), r.isSubmitted, C, g), pn = pb(D, l, Se);
      Yn(o, D, ue), Se ? (Y._f.onBlur && Y._f.onBlur(E), d && d(0)) : Y._f.onChange && Y._f.onChange(E);
      const tn = U(D, ue, Se), ln = !Ut(tn) || pn;
      if (!Se && h.state.next({
        name: D,
        type: E.type,
        values: Ft(o)
      }), nn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Se && w() : Se || w()), ln && h.state.next({ name: D, ...pn ? {} : tn });
      if (!Se && pn && h.state.next({ ...r }), n.resolver) {
        const { errors: mn } = await X([D]);
        if (R(ue), H) {
          const cn = fb(r.errors, i, D), xn = fb(mn, i, cn.name || D);
          z = xn.error, D = xn.name, ie = Ut(mn);
        }
      } else
        y([D], !0), z = (await yb(Y, l.disabled, o, S, n.shouldUseNativeValidation))[D], y([D]), R(ue), H && (z ? ie = !1 : (u.isValid || f.isValid) && (ie = await J(i, !0)));
      H && (Y._f.deps && be(Y._f.deps), Q(D, ie, z, tn));
    }
  }, W = (E, x) => {
    if (Xe(r.errors, x) && E.focus)
      return E.focus(), 1;
  }, be = async (E, x = {}) => {
    let D, H;
    const Y = ao(E);
    if (n.resolver) {
      const R = await ae(lt(E) ? E : Y);
      D = Ut(R), H = E ? !Y.some((z) => Xe(R, z)) : D;
    } else E ? (H = (await Promise.all(Y.map(async (R) => {
      const z = Xe(i, R);
      return await J(z && z._f ? { [R]: z } : z);
    }))).every(Boolean), !(!H && !r.isValid) && w()) : H = D = await J(i);
    return h.state.next({
      ...!Rr(E) || (u.isValid || f.isValid) && D !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: D } : {},
      errors: r.errors
    }), x.shouldFocus && !H && oo(i, W, E ? Y : l.mount), H;
  }, Ie = (E) => {
    const x = {
      ...s.mount ? o : a
    };
    return lt(E) ? x : Rr(E) ? Xe(x, E) : E.map((D) => Xe(x, D));
  }, G = (E, x) => ({
    invalid: !!Xe((x || r).errors, E),
    isDirty: !!Xe((x || r).dirtyFields, E),
    error: Xe((x || r).errors, E),
    isValidating: !!Xe(r.validatingFields, E),
    isTouched: !!Xe((x || r).touchedFields, E)
  }), He = (E) => {
    E && ao(E).forEach((x) => kt(r.errors, x)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, qe = (E, x, D) => {
    const H = (Xe(i, E, { _f: {} })._f || {}).ref, Y = Xe(r.errors, E) || {}, { ref: R, message: z, type: ie, ...ue } = Y;
    Yn(r.errors, E, {
      ...ue,
      ...x,
      ref: H
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, Oe = (E, x) => xr(E) ? h.state.subscribe({
    next: (D) => E(q(void 0, x), D)
  }) : q(E, x, !0), Be = (E) => h.state.subscribe({
    next: (x) => {
      YU(E.name, x.name, E.exact) && GU(x, E.formState || u, Pe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, $e = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Be({
    ...E,
    formState: f
  })), Ue = (E, x = {}) => {
    for (const D of E ? ao(E) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (kt(i, D), kt(o, D)), !x.keepError && kt(r.errors, D), !x.keepDirty && kt(r.dirtyFields, D), !x.keepTouched && kt(r.touchedFields, D), !x.keepIsValidating && kt(r.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && kt(a, D);
    h.state.next({
      values: Ft(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: O() } : {}
    }), !x.keepIsValid && w();
  }, Re = ({ disabled: E, name: x }) => {
    (ir(E) && s.mount || E || l.disabled.has(x)) && (E ? l.disabled.add(x) : l.disabled.delete(x));
  }, an = (E, x = {}) => {
    let D = Xe(i, E);
    const H = ir(x.disabled) || ir(n.disabled);
    return Yn(i, E, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...x
      }
    }), l.mount.add(E), D ? Re({
      disabled: ir(x.disabled) ? x.disabled : n.disabled,
      name: E
    }) : $(E, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: Ha(x.min),
        max: Ha(x.max),
        minLength: Ha(x.minLength),
        maxLength: Ha(x.maxLength),
        pattern: Ha(x.pattern)
      } : {},
      name: E,
      onChange: pe,
      onBlur: pe,
      ref: (Y) => {
        if (Y) {
          an(E, x), D = Xe(i, E);
          const R = lt(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, z = MU(R), ie = D._f.refs || [];
          if (z ? ie.find((ue) => ue === R) : R === D._f.ref)
            return;
          Yn(i, E, {
            _f: {
              ...D._f,
              ...z ? {
                refs: [
                  ...ie.filter(Ku),
                  R,
                  ...Array.isArray(Xe(a, E)) ? [{}] : []
                ],
                ref: { type: R.type, name: E }
              } : { ref: R }
            }
          }), $(E, !1, void 0, R);
        } else
          D = Xe(i, E, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(wS(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && oo(i, W, l.mount), Ke = (E) => {
    ir(E) && (h.state.next({ disabled: E }), oo(i, (x, D) => {
      const H = Xe(i, D);
      H && (x.disabled = H._f.disabled || E, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || E;
      }));
    }, 0, !1));
  }, Qe = (E, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = Ft(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: z } = await X();
      r.errors = R, Y = z;
    } else
      await J(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Yn(Y, R, void 0);
    if (kt(r.errors, "root"), Ut(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(Y, D);
      } catch (R) {
        H = R;
      }
    } else
      x && await x({ ...r.errors }, D), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ut(r.errors) && !H,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), H)
      throw H;
  }, fe = (E, x = {}) => {
    Xe(i, E) && (lt(x.defaultValue) ? le(E, Ft(Xe(a, E))) : (le(E, x.defaultValue), Yn(a, E, Ft(x.defaultValue))), x.keepTouched || kt(r.touchedFields, E), x.keepDirty || (kt(r.dirtyFields, E), r.isDirty = x.defaultValue ? O(E, Ft(Xe(a, E))) : O()), x.keepError || (kt(r.errors, E), u.isValid && w()), h.state.next({ ...r }));
  }, ye = (E, x = {}) => {
    const D = E ? Ft(E) : a, H = Ft(D), Y = Ut(E), R = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(qa(a, o))
        ]);
        for (const ie of Array.from(z))
          Xe(r.dirtyFields, ie) ? Yn(R, ie, Xe(o, ie)) : le(ie, Xe(R, ie));
      } else {
        if (Kp && lt(E))
          for (const z of l.mount) {
            const ie = Xe(i, z);
            if (ie && ie._f) {
              const ue = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (As(ue)) {
                const Se = ue.closest("form");
                if (Se) {
                  Se.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Xe(R, z));
      }
      o = Ft(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !ri(E, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? qa(a, o) : r.dirtyFields : x.keepDefaultValues && E ? qa(a, E) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, De = (E, x) => ye(xr(E) ? E(o) : E, x), Ve = (E, x = {}) => {
    const D = Xe(i, E), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && xr(Y.select) && Y.select());
    }
  }, Pe = (E) => {
    r = {
      ...r,
      ...E
    };
  }, un = {
    control: {
      register: an,
      unregister: Ue,
      getFieldState: G,
      handleSubmit: Qe,
      setError: qe,
      _subscribe: Be,
      _runSchema: X,
      _getWatch: q,
      _getDirty: O,
      _setValid: w,
      _setFieldArray: V,
      _setDisabledField: Re,
      _setErrors: F,
      _getFieldArray: ee,
      _reset: ye,
      _resetDefaultValues: () => xr(n.defaultValues) && n.defaultValues().then((E) => {
        De(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ke,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: $e,
    trigger: be,
    register: an,
    handleSubmit: Qe,
    watch: Oe,
    setValue: le,
    getValues: Ie,
    reset: De,
    resetField: fe,
    clearErrors: He,
    unregister: Ue,
    setError: qe,
    setFocus: Ve,
    getFieldState: G
  };
  return {
    ...un,
    formControl: un
  };
}
function nM(e = {}) {
  const n = Fe.useRef(void 0), r = Fe.useRef(void 0), [i, a] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: xr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: xr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : eM(e),
    formState: i
  }, e.formControl && e.defaultValues && !xr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Fe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Fe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Fe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Fe.useEffect(() => {
    e.values && !ri(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Fe.useEffect(() => {
    e.errors && !Ut(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Fe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Fe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = FS(i, o), n.current;
}
const tM = "_modalBody_1clhs_1", rM = {
  modalBody: tM
}, iM = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = fn(), { track: l } = _n(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: g } = nM({
    defaultValues: u,
    mode: "onChange"
  }), C = ES({ control: f }), S = parseInt(C?.balance ?? "0", 10), N = m === S, w = N ? "Change the value to update the points" : "", y = S < 0, V = y ? "Points can not be negative" : "", T = C.description === "", F = T ? "Description can not be empty" : "";
  Le(() => {
    S > m ? h(
      "transactionType",
      Dm.Addition
    ) : S < m && h(
      "transactionType",
      Dm.Deduction
    );
  }, [m, S, h]);
  const [$, { loading: U, error: Q, reset: X }] = o(jU, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ae = () => {
    if (d) {
      const B = tU();
      $({
        variables: {
          input: {
            accountId: d,
            transactionId: B,
            amount: Math.abs(S - m),
            transactionType: C.transactionType,
            description: C.description,
            source: SS.UpdateBalance
          }
        }
      }).then(async (O) => {
        O?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), J());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, J = () => {
    g(u), X(), n();
  };
  return /* @__PURE__ */ M.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: J,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ M.jsx($t, { title: "Update points balance", onClose: J }),
        /* @__PURE__ */ M.jsxs(Dt, { className: rM.modalBody, children: [
          /* @__PURE__ */ M.jsxs(ht, { children: [
            /* @__PURE__ */ M.jsx(we, { span: 6, children: /* @__PURE__ */ M.jsx(
              ab,
              {
                name: "balance",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ M.jsx(
                  pr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: w || V
                    },
                    input: {
                      ...B,
                      value: B.value.toString(),
                      onChange: (O) => B.onChange(O)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ M.jsx(we, { span: 6, children: /* @__PURE__ */ M.jsx(
              ab,
              {
                name: "description",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ M.jsx(
                  pr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: B,
                    meta: {
                      warning: F
                    }
                  }
                )
              }
            ) })
          ] }),
          Q && /* @__PURE__ */ M.jsx(Fn, { error: Q })
        ] }),
        /* @__PURE__ */ M.jsx(
          Pt,
          {
            confirmName: "Save",
            confirmOnClick: () => ae(),
            confirmProps: {
              isLoading: U,
              disabled: N || y || T,
              loadingIndicator: /* @__PURE__ */ M.jsx(dn, { size: 16 })
            },
            cancelOnClick: J
          }
        )
      ]
    }
  );
}, aM = "_wrapper_1ge6c_1", oM = "_block_1ge6c_12", gb = {
  wrapper: aM,
  block: oM
}, sM = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = fn(), { isCopied: i, copy: a } = ks(), { isCopied: o, copy: s } = ks(), { isCopied: l, copy: d } = ks(), [m, u] = se(!1), [f, h] = se(), [g, C] = se(!1), {
    loading: S,
    data: N,
    refetch: w
  } = r(SU, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Le(() => {
    if (N) {
      const ee = N?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [N]);
  const y = !!f?.id, V = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: T,
    lastName: F,
    street: $,
    zipCode: U,
    city: Q,
    country: X,
    isRegistrationCompleted: ae,
    email: J,
    mobilePhone: B
  } = e, O = 14, q = `${T || ""} ${F || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", className: gb.wrapper, children: [
    /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: gb.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: q }),
          S && /* @__PURE__ */ M.jsx(dn, { size: 12 }),
          y && !S && /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ M.jsxs(Pn, { size: "small", variant: "warning", children: [
              V,
              " points"
            ] }),
            /* @__PURE__ */ M.jsx(We, { content: "Update points balance", children: /* @__PURE__ */ M.jsx(
              me,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: tt.pointer
              }
            ) }),
            g && /* @__PURE__ */ M.jsx(We, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ M.jsx(
              me,
              {
                name: "info",
                size: 12,
                className: tt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    ($ || Q || U || X || B || J) && /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
      B && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: O, name: "phone" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: B })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: O,
            name: o ? "done" : "copy",
            onClick: () => s(B),
            className: tt.pointer
          }
        )
      ] }),
      J && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: O, name: "mail" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: J })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: O,
            name: i ? "done" : "copy",
            onClick: () => a(J),
            className: tt.pointer
          }
        )
      ] }),
      ($ || Q || U || X) && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(me, { size: O, name: "home" }),
          /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ M.jsx(Zn, { children: $ }),
            /* @__PURE__ */ M.jsxs(Zn, { children: [
              U,
              " ",
              Q
            ] }),
            /* @__PURE__ */ M.jsx(Zn, { children: X })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: O,
            name: l ? "done" : "copy",
            onClick: () => d(`${$}, ${U} ${Q}, ${X}`),
            className: tt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: O, name: "sign-in" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            name: ae ? "check-circle-filled" : "close-circle-filled",
            color: ae ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ M.jsx(
      iM,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: C,
        refetchPointsQuery: w
      }
    )
  ] });
}, lM = "_list_yud4a_7", cM = "_listItem_yud4a_11", dM = "_listItemTooltip_yud4a_15", uM = "_listItemTimestamp_yud4a_18", rs = {
  list: lM,
  listItem: cM,
  listItemTooltip: dM,
  listItemTimestamp: uM
}, mM = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ M.jsx(Ye, { className: rs.list, children: e.map((n, r) => /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rs.listItem, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ M.jsx(We, { content: n?.comment, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: rt({
          [rs.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { className: rs.listItemTimestamp, children: Ln(n.date).format(xt) }),
          n?.comment && /* @__PURE__ */ M.jsx(me, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ M.jsx(
      me,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), pM = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Ln(e.latestChange).format(xt) : null, o = e?.expires ? `${Ln(e.expires).fromNow()} (${Ln(e.expires).format(xt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ M.jsx(We, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ M.jsx(
        me,
        {
          name: "question",
          size: 14,
          className: tt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsxs(Ye, { className: tt.list, children: [
      s && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ M.jsx(Pn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ M.jsx(Pn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ M.jsx(Pn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, fM = "_tagHover_kzbzk_1", hM = "_channelUnsubscribed_kzbzk_6", vb = {
  tagHover: fM,
  channelUnsubscribed: hM
}, Gu = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = _n(), { useMutation: l } = fn(), [d, m] = se(!1), [u, { loading: f }] = l(NU), h = async ({
    newPreference: C,
    isSubscribed: S,
    channelType: N
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...C
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? S ? s("voyado:channel:unsubscribe:succeeded", { channel: N }) : s("voyado:channel:subscribe:succeeded", { channel: N }) : S ? s("voyado:channel:unsubscribe:failed", { channel: N }) : s("voyado:channel:subscribe:failed", { channel: N }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, g = d || f;
  return /* @__PURE__ */ M.jsx(We, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ M.jsx(
    An,
    {
      className: vb.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ M.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: rt({
            [vb.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            g ? /* @__PURE__ */ M.jsx(dn, { size: 16 }) : /* @__PURE__ */ M.jsx(me, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, yM = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        Gu,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Gu,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Gu,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, gM = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = wU({ contactId: e }), {
    isLoading: g,
    error: C,
    memberLevel: S
  } = $U({ contactId: e, skip: !s }), N = g || l, w = Bn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return d || C ? yo({
    errors: d?.graphQLErrors || C?.graphQLErrors || []
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: d || C }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : N ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    r && /* @__PURE__ */ M.jsx(
      sM,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ M.jsx(pM, { memberLevel: S }),
    i && /* @__PURE__ */ M.jsx(
      yM,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ M.jsx(mM, { contactConsents: w })
  ] });
}, Om = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, vM = "_list_zu4s7_1", kM = "_listItem_zu4s7_4", bM = "_listSum_zu4s7_7", is = {
  list: vM,
  listItem: kM,
  listSum: bM
}, xM = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ M.jsxs(Ye, { className: is.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: is.listItem, children: /* @__PURE__ */ M.jsx(We, { content: s, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ M.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flex: "auto", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ M.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Om(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ M.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: rt(is.listItem, is.listSum),
      children: /* @__PURE__ */ M.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: Om(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), _M = "_transaction_1kr8d_1", SM = "_transactionIsOpen_1kr8d_9", NM = "_transactionHeader_1kr8d_12", jM = "_transactionHeaderSubLine_1kr8d_15", wM = "_transactionHeaderAlignItemRight_1kr8d_19", Li = {
  transaction: _M,
  transactionIsOpen: SM,
  transactionHeader: NM,
  transactionHeaderSubLine: jM,
  transactionHeaderAlignItemRight: wM
}, CM = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", g = f ?? 0, C = m?.length ? m : [];
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: rt(Li.transaction, {
        [Li.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Li.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ M.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: Ln(o).format(xt) }),
                  /* @__PURE__ */ M.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: Li.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Li.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-4", children: Om(g, h) }),
                      /* @__PURE__ */ M.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: Li.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ M.jsx(Mm, {}),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ M.jsx(
                  xM,
                  {
                    lineItems: C,
                    localCurrency: h,
                    localNetPriceSum: g
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, FM = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = EU({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ M.jsx(Fn, { error: r }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          s === 0 && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ M.jsx(
            CM,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, IM = "_message_unsvt_48", EM = "_messageIsOpen_unsvt_56", TM = "_messageHeader_unsvt_60", $M = "_messageText_unsvt_64", DM = "_buttonLink_unsvt_86", Wa = {
  message: IM,
  messageIsOpen: EM,
  messageHeader: TM,
  messageText: $M,
  buttonLink: DM
}, Yu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Qu = (e, n) => n && e in Yu && n in Yu[e] ? Yu[e][n] : null, RM = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = _n();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, g = l ? Qu("type", l) : null, C = d ? Qu("source", d) : null, S = u ? Qu("status", u) : null, N = l?.replace("Message", "");
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: rt(Wa.message, {
        [Wa.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Wa.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
                  g && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                    /* @__PURE__ */ M.jsx(me, { name: g, size: 16 }),
                    " ",
                    N
                  ] }),
                  s && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: Ln(s).format(xt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ M.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ M.jsx(Mm, {}),
          /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            S && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: S }),
              " ",
              u
            ] }) }),
            C && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: C }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", className: Wa.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ M.jsx(
            Et,
            {
              slotEnd: /* @__PURE__ */ M.jsx(me, { name: "external-link" }),
              variant: "tertiary",
              className: Wa.buttonLink,
              navigate: () => {
                N && a("voyado:message:external-link:opened", {
                  channel: N.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, OM = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = FU({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ M.jsx(Fn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ M.jsx(Pn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ M.jsx(
        RM,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, ml = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, kb = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = ks(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = ot(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(me, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ M.jsx(We, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: tt.pointer
      }
    ) })
  ] });
}, PM = "_order_19t4p_1", AM = "_orderIsOpen_19t4p_9", LM = "_orderHeader_19t4p_12", VM = "_orderIconColor_19t4p_15", Er = {
  order: PM,
  orderIsOpen: AM,
  orderHeader: LM,
  orderIconColor: VM
}, zM = "_delivery_1m9nb_1", UM = "_deliveryCode_1m9nb_4", Ju = {
  delivery: zM,
  deliveryCode: UM
}, MM = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = or();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: "eye",
        className: Er.orderIconColor
      }
    ),
    /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ M.jsx(
        We,
        {
          content: /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Ln(s).format(xt)
          ] }),
          children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ M.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Ju.delivery,
                    children: [
                      /* @__PURE__ */ M.jsx(me, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ M.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: rt(Ju.delivery, Ju.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ M.jsx(We, { content: "Copy tracking code", children: /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: tt.pointer
      }
    ) })
  ] });
}, BM = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "file-text",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ M.jsx(Ye, { className: tt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(Ye.Item, { className: tt.listItem, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ M.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ M.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: tt.listItemAlignRight,
              children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: ml({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, qM = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "tag",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ M.jsx(Ye, { className: tt.list, children: r?.map((i) => /* @__PURE__ */ M.jsx(
      Ye.Item,
      {
        className: tt.listItem,
        contentLeft: /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ M.jsx(
          We,
          {
            content: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ M.jsx(b, { children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: ml({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ M.jsx(
          oa,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, HM = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "credit-card",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ M.jsx(Ye, { className: tt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(
      Ye.Item,
      {
        className: tt.listItem,
        children: /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ M.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: tt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: Ln(i?.paidAt).format(xt) }),
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: ml({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, WM = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: g,
    totalPrice: C
  } = e, S = 14;
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: rt(Er.order, {
        [Er.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Er.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Ln(m).format(xt) }) }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ M.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: S,
                name: "activity",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ M.jsx(We, { content: "Internal status", children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ M.jsx(We, { content: "External status", children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: s }) }) }),
                /* @__PURE__ */ M.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ M.jsx(A.Paragraph, { as: "span", variant: "5", children: Ln(u).format(xt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: S,
                name: "chart-bar",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: ml({
                value: C,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: S,
                name: "channels",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(kb, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ M.jsx(
            kb,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: g
            }
          ),
          /* @__PURE__ */ M.jsx(MM, { delivery: e.delivery }),
          /* @__PURE__ */ M.jsx(qM, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ M.jsx(BM, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ M.jsx(
            HM,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, KM = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || yo({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: e }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: r }), GM = ({
  contactId: e
}) => {
  const { useQuery: n } = fn(), [r, i] = se([]), { track: a } = _n(), {
    loading: o,
    error: s,
    data: l
  } = n(_U, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Le(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsx(KM, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ M.jsx(
      WM,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, YM = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = TU({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: g,
    showOrders: C
  } = n;
  return s ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? yo({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: o }) : !d && !m && !u && !f && !h && !g ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ M.jsx(gM, { contactId: i, settings: n }),
        h && /* @__PURE__ */ M.jsx(OM, { contactId: i }),
        g && /* @__PURE__ */ M.jsx(FM, { contactId: i }),
        C && /* @__PURE__ */ M.jsx(GM, { contactId: i }),
        !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, QM = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_11mz1_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_11mz1_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_11mz1_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_11mz1_63:last-child{box-shadow:none}._listItemHighlighted_11mz1_72{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Xu = { exports: {} }, Ka = {}, bb;
function JM() {
  if (bb) return Ka;
  bb = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ka.Fragment = r, Ka.jsx = s, Ka.jsxs = s, Ka;
}
var as = {}, xb;
function XM() {
  return xb || (xb = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        V("error", t, p);
      }
    }
    function V(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, F = !1, $ = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || T || F || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, de, le, pe, W, be, Ie;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function He() {
      {
        if (ee === 0) {
          ve = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, be = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Be;
    function $e(t, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Be = v && v[1] || "";
          }
        return `
` + Be + t;
      }
    }
    var Ue = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || Ue)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      Ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, He();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              v = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), K = j.length - 1, _ = te.length - 1; K >= 1 && _ >= 0 && j[K] !== te[_]; )
            _--;
          for (; K >= 1 && _ >= 0; K--, _--)
            if (j[K] !== te[_]) {
              if (K !== 1 || _ !== 1)
                do
                  if (K--, _--, _ < 0 || j[K] !== te[_]) {
                    var Z = `
` + j[K].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (K >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, Oe.current = L, qe(), Error.prepareStackTrace = P;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? $e(ce) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Ke(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var v = t, P = v._payload, L = v._init;
            try {
              return fe(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, De = {}, Ve = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function un(t, c, p, v, P) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              j = K;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, I, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ue, Se;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function ln(t, c) {
      {
        var p = function() {
          ue || (ue = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          Se || (Se = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, v, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, P) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), pn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var K = t.defaultProps;
          for (L in K)
            I[L] === void 0 && (I[L] = K[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && ln(I, _), te && mn(I, _);
        }
        return cn(t, j, te, P, v, z.current, I);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = N(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && gn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          un(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var K;
          t === null ? K = "null" : x(t) ? K = "array" : t !== void 0 && t.$$typeof === n ? (K = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : K = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, j);
        }
        var _ = xn(t, c, p, P, L);
        if (_ == null)
          return _;
        if (I) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var ce = 0; ce < Z.length; ce++)
                  Cn(Z[ce], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ge = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[_e + Ge]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, _e, $n, _e), Sn[_e + Ge] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    as.Fragment = i, as.jsx = Rn, as.jsxs = Mn;
  })()), as;
}
var _b;
function ZM() {
  return _b || (_b = 1, process.env.NODE_ENV === "production" ? Xu.exports = JM() : Xu.exports = XM()), Xu.exports;
}
var Te = ZM();
const e4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, n4 = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": e4
};
function t4(e) {
  return n4[e] ?? {};
}
const r4 = t4(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), i4 = "_copyIcon_11mz1_48", a4 = "_list_11mz1_53", o4 = "_listItem_11mz1_63", s4 = "_listItemHighlighted_11mz1_72", Zi = {
  copyIcon: i4,
  list: a4,
  listItem: o4,
  listItemHighlighted: s4
}, l4 = "_wrapper_1xucg_1", c4 = "_externalLink_1xucg_7", Zu = {
  wrapper: l4,
  externalLink: c4
}, d4 = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = or(), { isCopied: i, copy: a } = or();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Te.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Te.jsxs(b, { className: Zu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Zu.block,
        alignItems: "center",
        children: /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: Ln(m).format(xt) })
    ] }),
    l && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(me, { size: u, name: "mail" }),
        /* @__PURE__ */ Te.jsx("span", { className: Zu.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Te.jsx(We, { content: "Copy email", children: /* @__PURE__ */ Te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Te.jsx(
        me,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: Zi.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(me, { size: u, name: "phone" }),
        /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Te.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ Te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Te.jsx(
        me,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: Zi.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Wn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = _0(n);
  return /* @__PURE__ */ Te.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: rt(Zi.listItem, {
        [Zi.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Te.jsx(We, { content: r, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: e }),
        a ? n : uo(n)
      ] }) })
    }
  );
}, u4 = ({
  loyalty: e
}) => /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Te.jsxs(Ye, { className: Zi.list, children: [
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), m4 = 0.8, p4 = 0.4, Sb = (e) => {
  if (e != null)
    return e >= m4 ? /* @__PURE__ */ Te.jsx(Pn, { variant: "success", size: "small", children: "Positive" }) : e <= p4 ? /* @__PURE__ */ Te.jsx(Pn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Te.jsx(Pn, { variant: "warning", size: "small", children: "Neutral" });
}, f4 = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Te.jsxs(Ye, { className: Zi.list, children: [
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: Sb(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: Sb(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Ln(e.last_review_date).format(
          xt
        )
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Te.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Te.jsx(Pn, { variant: "info", size: "small", children: /* @__PURE__ */ Te.jsx(Te.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), h4 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = fn(), { track: i } = _n(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, g = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, S = n?.displaySubscriptions ?? !1, N = !f, w = !h && !g && !C && !S, {
    loading: y,
    error: V,
    data: T
  } = r(r4, {
    skip: u || N,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (Le(() => {
    const F = T?.Yotpo?.getCustomers?.customers?.[0];
    F ? (o(F), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [T?.Yotpo, y]), N)
    return /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(
      Fn,
      {
        error: new Xb({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (w)
    return /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (y)
    return /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Te.jsx(dn, {}) });
  if (s)
    return /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (V) {
    const F = V.graphQLErrors;
    return Am({ errors: F }) ? /* @__PURE__ */ Te.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Lm({ errors: F }) ? /* @__PURE__ */ Te.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Te.jsx(Fn, { error: V });
  }
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Te.jsx(d4, { customerDetails: a }),
        g && /* @__PURE__ */ Te.jsx(
          f4,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ Te.jsx(u4, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var Io = (e) => e.type === "checkbox", gi = (e) => e instanceof Date, Ht = (e) => e == null;
const AS = (e) => typeof e == "object";
var pt = (e) => !Ht(e) && !Array.isArray(e) && AS(e) && !gi(e), LS = (e) => pt(e) && e.target ? Io(e.target) ? e.target.checked : e.target.value : e, y4 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, VS = (e, n) => e.has(y4(n)), g4 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return pt(n) && n.hasOwnProperty("isPrototypeOf");
}, Xp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function It(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Xp && (e instanceof Blob || i)) && (r || pt(e)))
    if (n = r ? [] : {}, !r && !g4(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = It(e[a]));
  else
    return e;
  return n;
}
var pl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ct = (e) => e === void 0, Ze = (e, n, r) => {
  if (!n || !pt(e))
    return r;
  const i = pl(n.split(/[,[\].]+?/)).reduce((a, o) => Ht(a) ? a : a[o], e);
  return ct(i) || i === e ? ct(e[n]) ? r : e[n] : i;
}, ar = (e) => typeof e == "boolean", Zp = (e) => /^\w*$/.test(e), zS = (e) => pl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Qn = (e, n, r) => {
  let i = -1;
  const a = Zp(n) ? [n] : zS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = pt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const zs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, _r = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Hr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, v4 = Fe.createContext(null), ef = () => Fe.useContext(v4);
var US = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== _r.all && (n._proxyFormState[s] = !i || _r.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function k4(e) {
  const n = ef(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Fe.useState(r._formState), d = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Fe.useRef(a);
  return m.current = a, Fe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Fe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Fe.useMemo(() => US(s, r, d.current, !1), [s, r]);
}
var Or = (e) => typeof e == "string", MS = (e, n, r, i, a) => Or(e) ? (i && n.watch.add(e), Ze(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ze(r, o))) : (i && (n.watchAll = !0), r);
function BS(e) {
  const n = ef(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Fe.useRef(i), d = Fe.useRef(a);
  l.current = i, Fe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(MS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Fe.useState(r._getWatch(i, a));
  return Fe.useEffect(() => r._removeUnmounted()), m;
}
function b4(e) {
  const n = ef(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = VS(a._names.array, r), l = BS({
    control: a,
    name: r,
    defaultValue: Ze(a._formValues, r, Ze(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = k4({
    control: a,
    name: r,
    exact: !0
  }), m = Fe.useRef(e), u = Fe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...ar(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Fe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ze(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ze(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ze(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ze(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ze(d.errors, r)
    }
  }), [d, r]), h = Fe.useCallback((N) => u.current.onChange({
    target: {
      value: LS(N),
      name: r
    },
    type: zs.CHANGE
  }), [r]), g = Fe.useCallback(() => u.current.onBlur({
    target: {
      value: Ze(a._formValues, r),
      name: r
    },
    type: zs.BLUR
  }), [r, a._formValues]), C = Fe.useCallback((N) => {
    const w = Ze(a._fields, r);
    w && N && (w._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = Fe.useMemo(() => ({
    name: r,
    value: l,
    ...ar(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: g,
    ref: C
  }), [r, i, d.disabled, h, g, C, l]);
  return Fe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...ar(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (y, V) => {
      const T = Ze(a._fields, y);
      T && T._f && (T._f.mount = V);
    };
    if (w(r, !0), N) {
      const y = It(Ze(a._options.defaultValues, r));
      Qn(a._defaultValues, r, y), ct(Ze(a._formValues, r)) && Qn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : w(r, !1);
    };
  }, [r, a, s, o]), Fe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Fe.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Nb = (e) => e.render(b4(e));
var x4 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, so = (e) => Array.isArray(e) ? e : [e], jb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Pm = (e) => Ht(e) || !AS(e);
function ii(e, n) {
  if (Pm(e) || Pm(n))
    return e === n;
  if (gi(e) && gi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (gi(o) && gi(s) || pt(o) && pt(s) || Array.isArray(o) && Array.isArray(s) ? !ii(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Mt = (e) => pt(e) && !Object.keys(e).length, nf = (e) => e.type === "file", Sr = (e) => typeof e == "function", Us = (e) => {
  if (!Xp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, qS = (e) => e.type === "select-multiple", tf = (e) => e.type === "radio", _4 = (e) => tf(e) || Io(e), em = (e) => Us(e) && e.isConnected;
function S4(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ct(e) ? i++ : e[n[i++]];
  return e;
}
function N4(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ct(e[n]))
      return !1;
  return !0;
}
function bt(e, n) {
  const r = Array.isArray(n) ? n : Zp(n) ? [n] : zS(n), i = r.length === 1 ? e : S4(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (pt(i) && Mt(i) || Array.isArray(i) && N4(i)) && bt(e, r.slice(0, -1)), e;
}
var HS = (e) => {
  for (const n in e)
    if (Sr(e[n]))
      return !0;
  return !1;
};
function Ms(e, n = {}) {
  const r = Array.isArray(e);
  if (pt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || pt(e[i]) && !HS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ms(e[i], n[i])) : Ht(e[i]) || (n[i] = !0);
  return n;
}
function WS(e, n, r) {
  const i = Array.isArray(e);
  if (pt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || pt(e[a]) && !HS(e[a]) ? ct(n) || Pm(r[a]) ? r[a] = Array.isArray(e[a]) ? Ms(e[a], []) : { ...Ms(e[a]) } : WS(e[a], Ht(n) ? {} : n[a], r[a]) : r[a] = !ii(e[a], n[a]);
  return r;
}
var Ga = (e, n) => WS(e, n, Ms(n));
const wb = {
  value: !1,
  isValid: !1
}, Cb = { value: !0, isValid: !0 };
var KS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ct(e[0].attributes.value) ? ct(e[0].value) || e[0].value === "" ? Cb : { value: e[0].value, isValid: !0 } : Cb
    ) : wb;
  }
  return wb;
}, GS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ct(e) ? e : n ? e === "" ? NaN : e && +e : r && Or(e) ? new Date(e) : i ? i(e) : e;
const Fb = {
  isValid: !1,
  value: null
};
var YS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Fb) : Fb;
function Ib(e) {
  const n = e.ref;
  return nf(n) ? n.files : tf(n) ? YS(e.refs).value : qS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Io(n) ? KS(e.refs).value : GS(ct(n.value) ? e.ref.value : n.value, e);
}
var j4 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ze(n, o);
    s && Qn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Bs = (e) => e instanceof RegExp, Ya = (e) => ct(e) ? e : Bs(e) ? e.source : pt(e) ? Bs(e.value) ? e.value.source : e.value : e, Eb = (e) => ({
  isOnSubmit: !e || e === _r.onSubmit,
  isOnBlur: e === _r.onBlur,
  isOnChange: e === _r.onChange,
  isOnAll: e === _r.all,
  isOnTouch: e === _r.onTouched
});
const Tb = "AsyncFunction";
var w4 = (e) => !!e && !!e.validate && !!(Sr(e.validate) && e.validate.constructor.name === Tb || pt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Tb)), C4 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), $b = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const lo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ze(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (lo(l, n))
          break;
      } else if (pt(l) && lo(l, n))
        break;
    }
  }
};
function Db(e, n, r) {
  const i = Ze(e, r);
  if (i || Zp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ze(n, o), l = Ze(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var F4 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Mt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || _r.all));
}, I4 = (e, n, r) => !e || !n || e === n || so(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), E4 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, T4 = (e, n) => !pl(Ze(e, n)).length && bt(e, n), $4 = (e, n, r) => {
  const i = so(Ze(e, r));
  return Qn(i, "root", n[r]), Qn(e, r, i), e;
}, xs = (e) => Or(e);
function Rb(e, n, r = "validate") {
  if (xs(e) || Array.isArray(e) && e.every(xs) || ar(e) && !e)
    return {
      type: r,
      message: xs(e) ? e : "",
      ref: n
    };
}
var Vi = (e) => pt(e) && !Bs(e) ? e : {
  value: e,
  message: ""
}, Ob = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: g, validate: C, name: S, valueAsNumber: N, mount: w } = e._f, y = Ze(r, S);
  if (!w || n.has(S))
    return {};
  const V = l ? l[0] : s, T = (B) => {
    a && V.reportValidity && (V.setCustomValidity(ar(B) ? "" : B || ""), V.reportValidity());
  }, F = {}, $ = tf(s), U = Io(s), Q = $ || U, X = (N || nf(s)) && ct(s.value) && ct(y) || Us(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = x4.bind(null, S, i, F), J = (B, O, q, ee = Hr.maxLength, ve = Hr.minLength) => {
    const de = B ? O : q;
    F[S] = {
      type: B ? ee : ve,
      message: de,
      ref: s,
      ...ae(B ? ee : ve, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Q && (X || Ht(y)) || ar(y) && !y || U && !KS(l).isValid || $ && !YS(l).isValid)) {
    const { value: B, message: O } = xs(d) ? { value: !!d, message: d } : Vi(d);
    if (B && (F[S] = {
      type: Hr.required,
      message: O,
      ref: V,
      ...ae(Hr.required, O)
    }, !i))
      return T(O), F;
  }
  if (!X && (!Ht(f) || !Ht(h))) {
    let B, O;
    const q = Vi(h), ee = Vi(f);
    if (!Ht(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      Ht(q.value) || (B = ve > q.value), Ht(ee.value) || (O = ve < ee.value);
    } else {
      const ve = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      Or(q.value) && y && (B = le ? de(y) > de(q.value) : pe ? y > q.value : ve > new Date(q.value)), Or(ee.value) && y && (O = le ? de(y) < de(ee.value) : pe ? y < ee.value : ve < new Date(ee.value));
    }
    if ((B || O) && (J(!!B, q.message, ee.message, Hr.max, Hr.min), !i))
      return T(F[S].message), F;
  }
  if ((m || u) && !X && (Or(y) || o && Array.isArray(y))) {
    const B = Vi(m), O = Vi(u), q = !Ht(B.value) && y.length > +B.value, ee = !Ht(O.value) && y.length < +O.value;
    if ((q || ee) && (J(q, B.message, O.message), !i))
      return T(F[S].message), F;
  }
  if (g && !X && Or(y)) {
    const { value: B, message: O } = Vi(g);
    if (Bs(B) && !y.match(B) && (F[S] = {
      type: Hr.pattern,
      message: O,
      ref: s,
      ...ae(Hr.pattern, O)
    }, !i))
      return T(O), F;
  }
  if (C) {
    if (Sr(C)) {
      const B = await C(y, r), O = Rb(B, V);
      if (O && (F[S] = {
        ...O,
        ...ae(Hr.validate, O.message)
      }, !i))
        return T(O.message), F;
    } else if (pt(C)) {
      let B = {};
      for (const O in C) {
        if (!Mt(B) && !i)
          break;
        const q = Rb(await C[O](y, r), V, O);
        q && (B = {
          ...q,
          ...ae(O, q.message)
        }, T(q.message), i && (F[S] = B));
      }
      if (!Mt(B) && (F[S] = {
        ref: V,
        ...B
      }, !i))
        return F;
    }
  }
  return T(!0), F;
};
const D4 = {
  mode: _r.onSubmit,
  reValidateMode: _r.onChange,
  shouldFocusError: !0
};
function R4(e = {}) {
  let n = {
    ...D4,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Sr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = pt(n.defaultValues) || pt(n.values) ? It(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : It(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: jb(),
    state: jb()
  }, g = Eb(n.mode), C = Eb(n.reValidateMode), S = n.criteriaMode === _r.all, N = (E) => (x) => {
    clearTimeout(m), m = setTimeout(E, x);
  }, w = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const x = n.resolver ? Mt((await X()).errors) : await J(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (E, x) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((D) => {
      D && (x ? Qn(r.validatingFields, D, x) : bt(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Mt(r.validatingFields)
    }));
  }, V = (E, x = [], D, H, Y = !0, R = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Ze(i, E))) {
        const z = D(Ze(i, E), H.argA, H.argB);
        Y && Qn(i, E, z);
      }
      if (R && Array.isArray(Ze(r.errors, E))) {
        const z = D(Ze(r.errors, E), H.argA, H.argB);
        Y && Qn(r.errors, E, z), T4(r.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Ze(r.touchedFields, E))) {
        const z = D(Ze(r.touchedFields, E), H.argA, H.argB);
        Y && Qn(r.touchedFields, E, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Ga(a, o)), h.state.next({
        name: E,
        isDirty: O(E, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Qn(o, E, x);
  }, T = (E, x) => {
    Qn(r.errors, E, x), h.state.next({
      errors: r.errors
    });
  }, F = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (E, x, D, H) => {
    const Y = Ze(i, E);
    if (Y) {
      const R = Ze(o, E, ct(D) ? Ze(a, E) : D);
      ct(R) || H && H.defaultChecked || x ? Qn(o, E, x ? R : Ib(Y._f)) : ve(E, R), s.mount && w();
    }
  }, U = (E, x, D, H, Y) => {
    let R = !1, z = !1;
    const ie = {
      name: E
    };
    if (!n.disabled) {
      if (!D || H) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = ie.isDirty = O(), R = z !== ie.isDirty);
        const ue = ii(Ze(a, E), x);
        z = !!Ze(r.dirtyFields, E), ue ? bt(r.dirtyFields, E) : Qn(r.dirtyFields, E, !0), ie.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && z !== !ue;
      }
      if (D) {
        const ue = Ze(r.touchedFields, E);
        ue || (Qn(r.touchedFields, E, D), ie.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && ue !== D);
      }
      R && Y && h.state.next(ie);
    }
    return R ? ie : {};
  }, Q = (E, x, D, H) => {
    const Y = Ze(r.errors, E), R = (u.isValid || f.isValid) && ar(x) && r.isValid !== x;
    if (n.delayError && D ? (d = N(() => T(E, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Qn(r.errors, E, D) : bt(r.errors, E)), (D ? !ii(Y, D) : Y) || !Mt(H) || R) {
      const z = {
        ...H,
        ...R && ar(x) ? { isValid: x } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, X = async (E) => {
    y(E, !0);
    const x = await n.resolver(o, n.context, j4(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(E), x;
  }, ae = async (E) => {
    const { errors: x } = await X(E);
    if (E)
      for (const D of E) {
        const H = Ze(x, D);
        H ? Qn(r.errors, D, H) : bt(r.errors, D);
      }
    else
      r.errors = x;
    return x;
  }, J = async (E, x, D = {
    valid: !0
  }) => {
    for (const H in E) {
      const Y = E[H];
      if (Y) {
        const { _f: R, ...z } = Y;
        if (R) {
          const ie = l.array.has(R.name), ue = Y._f && w4(Y._f);
          ue && u.validatingFields && y([H], !0);
          const Se = await Ob(Y, l.disabled, o, S, n.shouldUseNativeValidation && !x, ie);
          if (ue && u.validatingFields && y([H]), Se[R.name] && (D.valid = !1, x))
            break;
          !x && (Ze(Se, R.name) ? ie ? $4(r.errors, Se, R.name) : Qn(r.errors, R.name, Se[R.name]) : bt(r.errors, R.name));
        }
        !Mt(z) && await J(z, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const E of l.unMount) {
      const x = Ze(i, E);
      x && (x._f.refs ? x._f.refs.every((D) => !em(D)) : !em(x._f.ref)) && Ue(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (E, x) => !n.disabled && (E && x && Qn(o, E, x), !ii(Ie(), a)), q = (E, x, D) => MS(E, l, {
    ...s.mount ? o : ct(x) ? a : Or(E) ? { [E]: x } : x
  }, D, x), ee = (E) => pl(Ze(s.mount ? o : a, E, n.shouldUnregister ? Ze(a, E, []) : [])), ve = (E, x, D = {}) => {
    const H = Ze(i, E);
    let Y = x;
    if (H) {
      const R = H._f;
      R && (!R.disabled && Qn(o, E, GS(x, R)), Y = Us(R.ref) && Ht(x) ? "" : x, qS(R.ref) ? [...R.ref.options].forEach((z) => z.selected = Y.includes(z.value)) : R.refs ? Io(R.ref) ? R.refs.length > 1 ? R.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(Y) ? !!Y.find((ie) => ie === z.value) : Y === z.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((z) => z.checked = z.value === Y) : nf(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: E,
        values: It(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(E, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && be(E);
  }, de = (E, x, D) => {
    for (const H in x) {
      const Y = x[H], R = `${E}.${H}`, z = Ze(i, R);
      (l.array.has(E) || pt(Y) || z && !z._f) && !gi(Y) ? de(R, Y, D) : ve(R, Y, D);
    }
  }, le = (E, x, D = {}) => {
    const H = Ze(i, E), Y = l.array.has(E), R = It(x);
    Qn(o, E, R), Y ? (h.array.next({
      name: E,
      values: It(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: E,
      dirtyFields: Ga(a, o),
      isDirty: O(E, R)
    })) : H && !H._f && !Ht(R) ? de(E, R, D) : ve(E, R, D), $b(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: It(o)
    });
  }, pe = async (E) => {
    s.mount = !0;
    const x = E.target;
    let D = x.name, H = !0;
    const Y = Ze(i, D), R = (z) => {
      H = Number.isNaN(z) || gi(z) && isNaN(z.getTime()) || ii(z, Ze(o, D, z));
    };
    if (Y) {
      let z, ie;
      const ue = x.type ? Ib(Y._f) : LS(E), Se = E.type === zs.BLUR || E.type === zs.FOCUS_OUT, nn = !C4(Y._f) && !n.resolver && !Ze(r.errors, D) && !Y._f.deps || E4(Se, Ze(r.touchedFields, D), r.isSubmitted, C, g), pn = $b(D, l, Se);
      Qn(o, D, ue), Se ? (Y._f.onBlur && Y._f.onBlur(E), d && d(0)) : Y._f.onChange && Y._f.onChange(E);
      const tn = U(D, ue, Se), ln = !Mt(tn) || pn;
      if (!Se && h.state.next({
        name: D,
        type: E.type,
        values: It(o)
      }), nn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Se && w() : Se || w()), ln && h.state.next({ name: D, ...pn ? {} : tn });
      if (!Se && pn && h.state.next({ ...r }), n.resolver) {
        const { errors: mn } = await X([D]);
        if (R(ue), H) {
          const cn = Db(r.errors, i, D), xn = Db(mn, i, cn.name || D);
          z = xn.error, D = xn.name, ie = Mt(mn);
        }
      } else
        y([D], !0), z = (await Ob(Y, l.disabled, o, S, n.shouldUseNativeValidation))[D], y([D]), R(ue), H && (z ? ie = !1 : (u.isValid || f.isValid) && (ie = await J(i, !0)));
      H && (Y._f.deps && be(Y._f.deps), Q(D, ie, z, tn));
    }
  }, W = (E, x) => {
    if (Ze(r.errors, x) && E.focus)
      return E.focus(), 1;
  }, be = async (E, x = {}) => {
    let D, H;
    const Y = so(E);
    if (n.resolver) {
      const R = await ae(ct(E) ? E : Y);
      D = Mt(R), H = E ? !Y.some((z) => Ze(R, z)) : D;
    } else E ? (H = (await Promise.all(Y.map(async (R) => {
      const z = Ze(i, R);
      return await J(z && z._f ? { [R]: z } : z);
    }))).every(Boolean), !(!H && !r.isValid) && w()) : H = D = await J(i);
    return h.state.next({
      ...!Or(E) || (u.isValid || f.isValid) && D !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: D } : {},
      errors: r.errors
    }), x.shouldFocus && !H && lo(i, W, E ? Y : l.mount), H;
  }, Ie = (E) => {
    const x = {
      ...s.mount ? o : a
    };
    return ct(E) ? x : Or(E) ? Ze(x, E) : E.map((D) => Ze(x, D));
  }, G = (E, x) => ({
    invalid: !!Ze((x || r).errors, E),
    isDirty: !!Ze((x || r).dirtyFields, E),
    error: Ze((x || r).errors, E),
    isValidating: !!Ze(r.validatingFields, E),
    isTouched: !!Ze((x || r).touchedFields, E)
  }), He = (E) => {
    E && so(E).forEach((x) => bt(r.errors, x)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, qe = (E, x, D) => {
    const H = (Ze(i, E, { _f: {} })._f || {}).ref, Y = Ze(r.errors, E) || {}, { ref: R, message: z, type: ie, ...ue } = Y;
    Qn(r.errors, E, {
      ...ue,
      ...x,
      ref: H
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, Oe = (E, x) => Sr(E) ? h.state.subscribe({
    next: (D) => E(q(void 0, x), D)
  }) : q(E, x, !0), Be = (E) => h.state.subscribe({
    next: (x) => {
      I4(E.name, x.name, E.exact) && F4(x, E.formState || u, Pe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, $e = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Be({
    ...E,
    formState: f
  })), Ue = (E, x = {}) => {
    for (const D of E ? so(E) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (bt(i, D), bt(o, D)), !x.keepError && bt(r.errors, D), !x.keepDirty && bt(r.dirtyFields, D), !x.keepTouched && bt(r.touchedFields, D), !x.keepIsValidating && bt(r.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && bt(a, D);
    h.state.next({
      values: It(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: O() } : {}
    }), !x.keepIsValid && w();
  }, Re = ({ disabled: E, name: x }) => {
    (ar(E) && s.mount || E || l.disabled.has(x)) && (E ? l.disabled.add(x) : l.disabled.delete(x));
  }, an = (E, x = {}) => {
    let D = Ze(i, E);
    const H = ar(x.disabled) || ar(n.disabled);
    return Qn(i, E, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...x
      }
    }), l.mount.add(E), D ? Re({
      disabled: ar(x.disabled) ? x.disabled : n.disabled,
      name: E
    }) : $(E, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: Ya(x.min),
        max: Ya(x.max),
        minLength: Ya(x.minLength),
        maxLength: Ya(x.maxLength),
        pattern: Ya(x.pattern)
      } : {},
      name: E,
      onChange: pe,
      onBlur: pe,
      ref: (Y) => {
        if (Y) {
          an(E, x), D = Ze(i, E);
          const R = ct(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, z = _4(R), ie = D._f.refs || [];
          if (z ? ie.find((ue) => ue === R) : R === D._f.ref)
            return;
          Qn(i, E, {
            _f: {
              ...D._f,
              ...z ? {
                refs: [
                  ...ie.filter(em),
                  R,
                  ...Array.isArray(Ze(a, E)) ? [{}] : []
                ],
                ref: { type: R.type, name: E }
              } : { ref: R }
            }
          }), $(E, !1, void 0, R);
        } else
          D = Ze(i, E, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(VS(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && lo(i, W, l.mount), Ke = (E) => {
    ar(E) && (h.state.next({ disabled: E }), lo(i, (x, D) => {
      const H = Ze(i, D);
      H && (x.disabled = H._f.disabled || E, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || E;
      }));
    }, 0, !1));
  }, Qe = (E, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = It(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: z } = await X();
      r.errors = R, Y = z;
    } else
      await J(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Qn(Y, R, void 0);
    if (bt(r.errors, "root"), Mt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(Y, D);
      } catch (R) {
        H = R;
      }
    } else
      x && await x({ ...r.errors }, D), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Mt(r.errors) && !H,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), H)
      throw H;
  }, fe = (E, x = {}) => {
    Ze(i, E) && (ct(x.defaultValue) ? le(E, It(Ze(a, E))) : (le(E, x.defaultValue), Qn(a, E, It(x.defaultValue))), x.keepTouched || bt(r.touchedFields, E), x.keepDirty || (bt(r.dirtyFields, E), r.isDirty = x.defaultValue ? O(E, It(Ze(a, E))) : O()), x.keepError || (bt(r.errors, E), u.isValid && w()), h.state.next({ ...r }));
  }, ye = (E, x = {}) => {
    const D = E ? It(E) : a, H = It(D), Y = Mt(E), R = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Ga(a, o))
        ]);
        for (const ie of Array.from(z))
          Ze(r.dirtyFields, ie) ? Qn(R, ie, Ze(o, ie)) : le(ie, Ze(R, ie));
      } else {
        if (Xp && ct(E))
          for (const z of l.mount) {
            const ie = Ze(i, z);
            if (ie && ie._f) {
              const ue = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (Us(ue)) {
                const Se = ue.closest("form");
                if (Se) {
                  Se.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Ze(R, z));
      }
      o = It(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !ii(E, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? Ga(a, o) : r.dirtyFields : x.keepDefaultValues && E ? Ga(a, E) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, De = (E, x) => ye(Sr(E) ? E(o) : E, x), Ve = (E, x = {}) => {
    const D = Ze(i, E), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && Sr(Y.select) && Y.select());
    }
  }, Pe = (E) => {
    r = {
      ...r,
      ...E
    };
  }, un = {
    control: {
      register: an,
      unregister: Ue,
      getFieldState: G,
      handleSubmit: Qe,
      setError: qe,
      _subscribe: Be,
      _runSchema: X,
      _getWatch: q,
      _getDirty: O,
      _setValid: w,
      _setFieldArray: V,
      _setDisabledField: Re,
      _setErrors: F,
      _getFieldArray: ee,
      _reset: ye,
      _resetDefaultValues: () => Sr(n.defaultValues) && n.defaultValues().then((E) => {
        De(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ke,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: $e,
    trigger: be,
    register: an,
    handleSubmit: Qe,
    watch: Oe,
    setValue: le,
    getValues: Ie,
    reset: De,
    resetField: fe,
    clearErrors: He,
    unregister: Ue,
    setError: qe,
    setFocus: Ve,
    getFieldState: G
  };
  return {
    ...un,
    formControl: un
  };
}
function O4(e = {}) {
  const n = Fe.useRef(void 0), r = Fe.useRef(void 0), [i, a] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Sr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Sr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : R4(e),
    formState: i
  }, e.formControl && e.defaultValues && !Sr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Fe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Fe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Fe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Fe.useEffect(() => {
    e.values && !ii(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Fe.useEffect(() => {
    e.errors && !Mt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Fe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Fe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = US(i, o), n.current;
}
const P4 = "_settingsWrapper_1ycvy_1", A4 = "_settingsWrapperHeader_1ycvy_6", L4 = "_settingsWrapperContent_1ycvy_10", V4 = "_settingsWrapperContentCode_1ycvy_18", z4 = "_settingsWrapperContentCURL_1ycvy_26", Qa = {
  settingsWrapper: P4,
  settingsWrapperHeader: A4,
  settingsWrapperContent: L4,
  settingsWrapperContentCode: V4,
  settingsWrapperContentCURL: z4
}, U4 = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = or(), { control: o } = O4({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = BS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = ot(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Te.jsx(Te.Fragment, { children: /* @__PURE__ */ Te.jsx(we, { span: 6, children: /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", className: Qa.settingsWrapper, children: [
    /* @__PURE__ */ Te.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Qa.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Te.jsx(me, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Te.jsxs(
      b,
      {
        flexDirection: "column",
        className: Qa.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Te.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Te.jsx(
            Hs,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Te.jsxs("ol", { children: [
                /* @__PURE__ */ Te.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Te.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Te.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Te.jsx("span", { className: Qa.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Te.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Te.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Te.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Te.jsx(
            Nb,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Te.jsx(
                pr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Te.jsx(
            Nb,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Te.jsx(
                pr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
            /* @__PURE__ */ Te.jsx(hn, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Te.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Qa.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Te.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Te.jsx(
              We,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Te.jsx(
                  Kn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, M4 = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], B4 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Yr
  }
], q4 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: U4
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], H4 = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, W4 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, K4 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: HV,
  featureSettings: []
} : n ? {
  authSettings: WV,
  featureSettings: [...fS]
} : e ? {
  authSettings: [
    ...Lk,
    ...BV
  ],
  featureSettings: [...Vk]
} : {
  authSettings: [
    ...Lk,
    ...qV
  ],
  featureSettings: [...Vk]
}, QS = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, G4 = QS(
  B4,
  q4
), Y4 = QS(
  eD,
  nD
), JS = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = W4(a?.value, r), s = i !== void 0 ? i : H4(
    r
  );
  return o !== void 0 ? o : s;
}, rf = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = K4(n), s = G4(r), l = Y4(i);
  return {
    SHOPIFY: {
      widget: X3,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: ET,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...lv ? [...lv] : []
      ]
    },
    GITHUB: {
      widget: EI,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [...TI],
      WidgetSettings: DI
    },
    MIUROS: {
      widget: eV,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...nV],
      WidgetSettings: rV
    },
    KLAVIYO: {
      widget: X$,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...Z$]
    },
    LINEAR: {
      widget: w2,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...C2],
      WidgetSettings: I2
    },
    VOYADO: {
      widget: YM,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...QM]
    },
    LOYALTYLION: {
      widget: oL,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...sL],
      WidgetSettings: cL
    },
    RECHARGE: {
      widget: FV,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...IV],
      WidgetSettings: TV
    },
    BRAZE: {
      widget: Ww,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...Kw]
    },
    YOTPO: {
      widget: h4,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...M4]
    },
    INGRID: {
      widget: oE,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...sE],
      WidgetSettings: cE
    }
  };
}, Q4 = (e) => {
  const n = rf();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: d
    }) => {
      const u = n[i], { settingsConfiguration: f } = u, h = f?.filter(({ secret: g }) => !g)?.map(
        ({
          key: g,
          type: C,
          defaultValue: S
        }) => ({
          key: g,
          value: JS({
            key: g,
            configuration: o,
            settingType: C,
            settingDefault: S
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: h,
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: d
      };
    }
  );
}, HB = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: u
}) => {
  const f = vi(
    {}
  ), h = ($) => (f.current[$] || (f.current[$] = { current: null }), f.current[$]), { track: g } = _n(), C = Bn(
    () => Q4(e),
    [e]
  ), S = {
    headline: "",
    text: "",
    onConfirm: () => F(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [N, w] = se(S), [y, V] = se(!1), T = ($) => {
    V(!0), w($);
  }, F = () => {
    V(!1), w(S);
  };
  return /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    C.map(
      ({
        id: $,
        name: U,
        type: Q,
        widget: X,
        settings: ae,
        misconfigured: J,
        renderConditions: B,
        icon: O,
        iconColors: q,
        integrationKey: ee
      }, ve) => {
        const de = `partner-integration-${Q}`, le = u?.get($) === !1, pe = /* @__PURE__ */ ze.jsx(Bm, { icon: O, color: q }), W = ae?.reduce(
          (be, Ie) => (be[Ie.key] = Ie.value, be),
          {}
        );
        return s ? /* @__PURE__ */ ze.jsx("div", { className: "icon-holder", children: pe }, `partner-icon-${$}`) : /* @__PURE__ */ ze.jsxs(
          mr,
          {
            onToggle: () => {
              g(
                o(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: $,
                  widgetType: Q.toLowerCase()
                }
              ), a(ee);
            },
            isOpen: o(ee),
            className: de,
            containerRef: (be) => {
              h(ee).current = be;
            },
            children: [
              /* @__PURE__ */ ze.jsx(
                mr.Header,
                {
                  className: rt({
                    [vw.unmatchedHeader]: le
                  }),
                  wrap: "normal",
                  avatar: pe,
                  slotBeforeTitle: d?.(
                    ee,
                    ve,
                    h(ee)
                  ),
                  slotAfterTitle: /* @__PURE__ */ ze.jsx(ze.Fragment, { children: l?.(ee) }),
                  children: /* @__PURE__ */ ze.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    U,
                    m?.(
                      B ?? [],
                      $
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ ze.jsx(mr.Content, { children: J ? /* @__PURE__ */ ze.jsx(Fn, { isMisconfigured: !0 }) : /* @__PURE__ */ ze.jsx(
                Gb.Provider,
                {
                  value: {
                    onError: (be, Ie) => console.warn(
                      `Something went wrong with a partner widget of type '${Q}' and id '${$}'`,
                      be,
                      Ie
                    )
                  },
                  children: /* @__PURE__ */ ze.jsx(
                    Fx,
                    {
                      integrationId: $,
                      type: Q,
                      configuration: n,
                      showNotification: i,
                      showModal: T,
                      children: S0(X, {
                        conversationContext: r,
                        settings: W
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ ze.jsx(
      Wb,
      {
        isOpen: y,
        setIsOpen: V,
        headline: N.headline,
        text: N.text,
        confirmLabel: N.confirmLabel,
        confirmVariant: N.confirmVariant,
        cancelLabel: N.cancelLabel,
        cancelVariant: N.cancelVariant,
        onConfirm: N.onConfirm ? () => {
          try {
            N.onConfirm && N.onConfirm();
          } finally {
            V(!1), w(S);
          }
        } : void 0,
        onCancel: N.onCancel ? () => {
          try {
            N.onCancel && N.onCancel();
          } finally {
            V(!1), w(S);
          }
        } : void 0,
        children: N.children
      }
    )
  ] });
}, J4 = Ws`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function WB(e, { skip: n = !1 } = {}) {
  const [r, i] = se([]), [a, o] = se(!1);
  return Le(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Cx(e).query({
      query: J4
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const X4 = ({
  widgetConfiguration: e
}) => {
  const n = Bn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Bn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, Z4 = "FULL_ACCESS", eB = "2", nB = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [Z4],
        version: eB
      })
    }).then((l) => l.json())
  };
}, tB = "dixaApiToken", af = "dixaApiTokenId", XS = "dixaApiTokenName", Pb = (e) => [af, XS].every(
  (r) => e.find((i) => i?.key === r)
);
function rB({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = iB(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const iB = (e) => [
  {
    key: tB,
    value: e.value,
    secret: !0
  },
  {
    key: af,
    value: e.id,
    secret: !1
  },
  {
    key: XS,
    value: e.name,
    secret: !1
  }
], aB = "_wrapper_1lmim_1", oB = "_wrapperBox_1lmim_4", sB = "_wrapperBoxErrorBorder_1lmim_9", nm = {
  wrapper: aB,
  wrapperBox: oB,
  wrapperBoxErrorBorder: sB
}, lB = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (V) => V.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: g } = f, C = `Insert your ${h.label.toLowerCase()}`, S = `Insert your ${g.label.toLowerCase()}`, [N, w] = se({
    username: "",
    password: ""
  }), y = ot(
    (V) => {
      m({
        target: {
          name: s,
          value: V
        }
      });
    },
    [s, m]
  );
  return Le(() => {
    y(
      N.username !== "" && N.password !== "" ? window.btoa(`${N.username}:${N.password}`) : ""
    );
  }, [N]), /* @__PURE__ */ ze.jsx(
    hn,
    {
      required: e,
      label: a,
      meta: l,
      className: nm.wrapper,
      children: /* @__PURE__ */ ze.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: rt(nm.wrapperBox, {
            [nm.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ ze.jsx(
              pr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: C,
                input: {
                  name: s,
                  value: N.username,
                  onChange: (V) => w({
                    username: V?.target.value ?? "",
                    password: N.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ ze.jsx(
              pr,
              {
                noAlert: !0,
                required: e,
                label: g.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: N.password,
                  onChange: (V) => w({
                    username: N.username,
                    password: V?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function Ab({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: g,
  isCreationMode: C,
  prefix: S,
  integrationId: N,
  integrationType: w,
  configuration: y,
  settings: V,
  otherProps: T
}) {
  const F = g === "custom" && T?.component, $ = u(n)?.value;
  return F ? /* @__PURE__ */ ze.jsx(
    F,
    {
      configuration: y,
      integrationId: N,
      integrationType: w,
      label: r,
      settings: V,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    /* @__PURE__ */ ze.jsx(we, { span: 3, children: /* @__PURE__ */ ze.jsx(
      cB,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: C,
        children: g === "input" ? /* @__PURE__ */ ze.jsx(
          pr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: $,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: S,
            ...e && !C && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : g === "basicAuthInput" ? /* @__PURE__ */ ze.jsx(
          lB,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: C,
            label: r,
            widgetSettingsKey: n,
            settings: V,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : g === "switch" ? /* @__PURE__ */ ze.jsx(hn, { label: r, children: /* @__PURE__ */ ze.jsx(
          Yb,
          {
            input: {
              name: n,
              value: "",
              checked: $,
              onChange: l
            }
          }
        ) }) : g === "select" ? /* @__PURE__ */ ze.jsx(hn, { label: r, children: /* @__PURE__ */ ze.jsx(
          ni,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => d(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ ze.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {}),
            value: $ ? [
              {
                label: (T?.selectItems || []).find(
                  (U) => U.value === $
                )?.label,
                value: $
              }
            ] : [],
            equalityFn: (U, Q) => U.value === Q.value,
            children: (T?.selectItems || []).map((U) => /* @__PURE__ */ ze.jsx(dt.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ ze.jsx(we, { span: 3 })
  ] });
}
function cB({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ ze.jsx(hn, { label: n, children: /* @__PURE__ */ ze.jsxs(
    Kn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const co = "partner-integrations-widget-name-form-field", Lb = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: JS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), dB = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = (T) => i(T), l = (T) => !T || T === "", d = (T) => {
    const { [T]: F, ...$ } = a;
    o($);
  }, m = (T) => ({
    ...T,
    settings: T.settings.filter(({ isEditing: F }) => F).map(({ key: F, value: $, secret: U }) => ({
      key: F,
      value: $,
      secret: U
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (T) => {
    if (!T)
      return;
    const {
      target: { name: F, value: $ }
    } = T;
    a[F] && !l($) && d(F), i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === F ? { ...U, value: $ } : U
      )
    });
  }, h = (T) => {
    if (!T)
      return;
    const {
      target: { name: F, checked: $ }
    } = T;
    i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === F ? { ...U, value: $ } : U
      )
    });
  }, g = (T, F) => {
    if (!F)
      return;
    const { selectedValues: $ } = F, U = $?.[0];
    if (U) {
      const Q = r.settings.map(
        (X) => X.key === T ? { ...X, value: U?.value } : X
      );
      i({
        ...r,
        settings: Q
      });
    } else {
      const Q = r.settings.filter(
        (X) => X.key !== T
      );
      i({
        ...r,
        settings: Q
      });
    }
  }, C = (T) => {
    i({
      ...r,
      enabled: T
    });
  }, S = (T) => {
    if (!T)
      return;
    const {
      target: { value: F }
    } = T;
    a[co] && !l(F) && d(co), i({
      ...r,
      name: F
    });
  }, N = (T, F) => {
    const { settings: $ } = r, U = $.map((Q) => Q.key === F ? {
      ...Q,
      isEditing: T,
      ...!T && { value: "" }
    } : Q);
    a[F] && !T && d(F), i({
      ...r,
      settings: U
    });
  }, w = (T) => r.settings.find(
    (F) => F.key === T
  ), y = async (T) => {
    T.preventDefault(), V() && n(m(r));
  }, V = () => {
    const T = {}, { name: F, settings: $ } = r;
    return l(F) && (T[co] = u.input), $.forEach(
      ({ key: U, value: Q, required: X, isEditing: ae, type: J, customValidation: B }) => {
        if (X && ae)
          if (B) {
            const O = B(Q);
            typeof O == "string" && (T[U] = O);
          } else
            typeof Q == "string" && l(Q) && (T[U] = u[J]);
      }
    ), o(T), !Object.keys(T)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: C,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: g,
    handleEditSecret: N,
    handleChangeName: S,
    handleSubmit: y,
    getSettingValueByKey: w,
    initializeFormData: s,
    validate: V
  };
}, uB = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], Vb = "The configuration of the integration is not correct. Please check the settings.", mB = (e) => {
  const n = rf()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ ze.jsx(n, { ...e }) : /* @__PURE__ */ ze.jsx(pB, { ...e });
}, pB = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = _n(), { deleteDixaApiToken: d, createDixaApiToken: m } = nB({
    type: n,
    baseUrl: a.baseUrl
  }), f = U0().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, g = uB.includes(n), [C, S] = se(), [N, w] = se(!1), [y, V] = se(!1), [T, F] = se(!1), [$, U] = se(null), [Q, X] = se(), [ae, J] = se(h ? [] : null);
  Le(() => {
    J(h ? [] : null);
  }, [e, h]), Le(() => {
    Q && ae === null && J(Q.renderConditions ?? []);
  }, [Q, ae]);
  const { isInboundOAuth: B } = h0(), O = B && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: q,
    isShopifyMarketplaceApp: ee,
    initialValuesForShopify: ve
  } = X4({
    featureFlags: a.featureFlags,
    widgetConfiguration: Q
  }), de = n === "YOTPO" && !!Q?.additionalProperties?.isUsingOAuth, le = n === "KLAVIYO" && !!Q?.additionalProperties?.isUsingOAuth, pe = h && n === "SHOPIFY", Ie = rf({
    SHOPIFY: {
      hasShopifyOAuth: q,
      isShopifyMarketplaceApp: ee,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: de,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: le,
      isCreationMode: h
    }
  })[n].settingsConfiguration, G = Ie.filter(({ type: H }) => H !== "hidden").filter(({ hideOnCreate: H }) => h ? !H : !0), He = G.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm === !0
  ), qe = G.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm !== !0
  ), {
    error: Oe,
    loading: Be,
    refetch: $e
  } = L0(y0, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (H) => {
      if (Object.keys(H).length === 0)
        F(!0);
      else {
        F(!1);
        const Y = H?.Management?.widgetConfigurations?.[0];
        Y && X({
          ...Y,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${Y.id}`,
          additionalProperties: Y.additionalProperties ?? void 0
        });
      }
    }
  }), [Ue, { error: Re }] = lf(
    h ? g0 : v0,
    {
      onError: (H) => {
        S(H), w(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (H) => {
        if (w(!1), Object.keys(H).length !== 0) {
          if (h && r(
            H.Management?.createWidgetConfiguration?.id
          ), !h) {
            const R = H.Management?.updateWidgetConfiguration;
            R?.misconfigured ? U(
              R.misconfigurationCause ?? Vb
            ) : U(null);
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [an] = lf(k0, {
    onError: (H) => {
      S(H), w(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      w(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ee,
    handleIsEnabled: Ke,
    errors: Qe,
    handleChangeText: fe,
    handleChangeBoolean: ye,
    handleChangeSelect: De,
    handleEditSecret: Ve,
    handleChangeName: Pe,
    handleSubmit: un,
    getSettingValueByKey: E,
    initializeFormData: x
  } = dB({
    onSubmit: async (H) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), w(!0);
      const Y = H.settings.map(
        (ue) => typeof ue.value == "boolean" ? { ...ue, value: ue.value.toString() } : ue
      ), R = Pb(Y) && h;
      let z = [];
      if (R) {
        const ue = await m().catch(
          (Se) => {
            w(!1), console.warn("API-Token (creation) error resonse", Se), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        ue?.data && (z = rB({
          token: ue.data,
          settings: Y
        }));
      }
      const ie = {
        ...H,
        settings: [
          ...z.length > 0 ? z : Y
        ]
      };
      (R && z.length > 1 || !R && z.length === 0) && (Ue({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...ie,
          ...(h || !!s) && ae !== null && { renderConditions: ae }
        }
      }), Y.forEach(
        (Se) => Se.secret && Ve(!1, Se.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: Lb({
          settingsFromBackend: ve,
          settingsConfiguration: Ie,
          creating: !0
        })
      }
    }
  });
  Le(() => {
    if (Q) {
      const H = Lb({
        settingsFromBackend: Q.settings,
        settingsConfiguration: Ie
      });
      x({
        enabled: !!Q.enabled,
        name: Q.name,
        settings: H
      }), Q.misconfigured ? U(
        Q?.misconfigurationCause ?? Vb
      ) : U(null);
    }
  }, [Q]);
  const D = Bn(() => o ? !o.isCoupled : !0, [o]);
  return Oe || Re || C ? /* @__PURE__ */ ze.jsx(
    Fn,
    {
      error: Oe || C,
      retry: Oe ? $e : void 0
    }
  ) : N || Be ? /* @__PURE__ */ ze.jsx(dn, { "data-testid": "widget-settings-loading" }) : T ? /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ ze.jsx(An, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ ze.jsxs("form", { children: [
    $ && /* @__PURE__ */ ze.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ze.jsx(
      Hs,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ ze.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ ze.jsx(A.Paragraph, { children: $ }),
          /* @__PURE__ */ ze.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ ze.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ ze.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ ze.jsxs(
      ht,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          He.map(
            ({ key: H, label: Y, ...R }) => /* @__PURE__ */ ze.jsx(
              Ab,
              {
                widgetSettingsKey: H,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: E,
                isSecret: !1,
                label: Y,
                placeholder: "",
                required: !1,
                errors: Qe,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: Ie,
                otherProps: R
              },
              H
            )
          ),
          !pe && /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
            /* @__PURE__ */ ze.jsx(we, { children: /* @__PURE__ */ ze.jsx(hn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ze.jsx(
              Yb,
              {
                input: {
                  name: "enabled",
                  checked: Ee.enabled,
                  value: "dummy",
                  onChange: (H) => Ke(H.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ ze.jsx(we, { span: 3, children: /* @__PURE__ */ ze.jsx(
              pr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: co,
                  value: Ee.name,
                  onChange: Pe
                },
                meta: {
                  error: Qe[co]
                }
              }
            ) }),
            /* @__PURE__ */ ze.jsx(we, { span: 3 })
          ] }),
          !pe && s && ae !== null && /* @__PURE__ */ ze.jsx(we, { children: s({
            value: ae,
            onChange: J,
            configurationKey: Q?.id
          }) }),
          qe?.map(
            ({
              key: H,
              secret: Y,
              label: R,
              placeholder: z = "",
              required: ie = !1,
              type: ue,
              prefix: Se,
              readOnly: nn,
              ...pn
            }) => {
              const { settings: tn } = Ee, ln = tn.find(
                (mn) => mn.key === H
              );
              return /* @__PURE__ */ ze.jsx(N0, { children: /* @__PURE__ */ ze.jsx(
                Ab,
                {
                  widgetSettingsKey: H,
                  isEditingField: !!ln?.isEditing,
                  handleEditSecret: Ve,
                  handleChangeText: fe,
                  handleChangeBoolean: ye,
                  handleChangeSelect: De,
                  getValueByKey: E,
                  isSecret: Y,
                  label: R,
                  placeholder: z,
                  required: ie,
                  errors: Qe,
                  type: ue,
                  isCreationMode: h,
                  prefix: Se,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: nn,
                  settings: Ie,
                  otherProps: pn
                }
              ) }, H);
            }
          )
        ]
      }
    ),
    !pe && /* @__PURE__ */ ze.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ ze.jsx(Kn, { onClick: un, children: O }),
      !h && /* @__PURE__ */ ze.jsx(
        We,
        {
          content: "The widget is used in automations",
          disabled: D,
          children: /* @__PURE__ */ ze.jsx(
            Kn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), V(!0);
              },
              disabled: !D,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ ze.jsx(
      Wb,
      {
        isOpen: y,
        setIsOpen: V,
        confirmVariant: g ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), Pb(Ee.settings)) {
            const H = Ee.settings.find(
              ({ key: Y }) => Y === af
            )?.value;
            H && d(H).catch((Y) => {
              console.warn("API-Token (deletion) error response", Y), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          an({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ ze.jsx(b, { children: g ? /* @__PURE__ */ ze.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ ze.jsx(
            me,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ ze.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ ze.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ee.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ee.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, KB = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ ze.jsx(
  Gb.Provider,
  {
    value: {
      onError: (l, d) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        l,
        d
      )
    },
    children: /* @__PURE__ */ ze.jsx(
      Fx,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ ze.jsx(
          mB,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), zb = "__PairingContext__", ZS = globalThis[zb] ?? (() => {
  const e = Kb({});
  return globalThis[zb] = e, e;
})(), GB = () => Um(ZS), YB = ({
  value: e,
  children: n
}) => /* @__PURE__ */ ze.jsx(ZS.Provider, { value: e, children: n });
var os = { exports: {} }, Ub;
function fB() {
  if (Ub) return os.exports;
  Ub = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(F, $, U) {
    return Function.prototype.apply.call(F, $, U);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(F) {
    return Object.getOwnPropertyNames(F).concat(Object.getOwnPropertySymbols(F));
  } : r = function(F) {
    return Object.getOwnPropertyNames(F);
  };
  function i(T) {
    console && console.warn && console.warn(T);
  }
  var a = Number.isNaN || function(F) {
    return F !== F;
  };
  function o() {
    o.init.call(this);
  }
  os.exports = o, os.exports.once = w, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(T) {
    if (typeof T != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(T) {
      if (typeof T != "number" || T < 0 || a(T))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
      s = T;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(F) {
    if (typeof F != "number" || F < 0 || a(F))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + F + ".");
    return this._maxListeners = F, this;
  };
  function d(T) {
    return T._maxListeners === void 0 ? o.defaultMaxListeners : T._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(F) {
    for (var $ = [], U = 1; U < arguments.length; U++) $.push(arguments[U]);
    var Q = F === "error", X = this._events;
    if (X !== void 0)
      Q = Q && X.error === void 0;
    else if (!Q)
      return !1;
    if (Q) {
      var ae;
      if ($.length > 0 && (ae = $[0]), ae instanceof Error)
        throw ae;
      var J = new Error("Unhandled error." + (ae ? " (" + ae.message + ")" : ""));
      throw J.context = ae, J;
    }
    var B = X[F];
    if (B === void 0)
      return !1;
    if (typeof B == "function")
      n(B, this, $);
    else
      for (var O = B.length, q = C(B, O), U = 0; U < O; ++U)
        n(q[U], this, $);
    return !0;
  };
  function m(T, F, $, U) {
    var Q, X, ae;
    if (l($), X = T._events, X === void 0 ? (X = T._events = /* @__PURE__ */ Object.create(null), T._eventsCount = 0) : (X.newListener !== void 0 && (T.emit(
      "newListener",
      F,
      $.listener ? $.listener : $
    ), X = T._events), ae = X[F]), ae === void 0)
      ae = X[F] = $, ++T._eventsCount;
    else if (typeof ae == "function" ? ae = X[F] = U ? [$, ae] : [ae, $] : U ? ae.unshift($) : ae.push($), Q = d(T), Q > 0 && ae.length > Q && !ae.warned) {
      ae.warned = !0;
      var J = new Error("Possible EventEmitter memory leak detected. " + ae.length + " " + String(F) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      J.name = "MaxListenersExceededWarning", J.emitter = T, J.type = F, J.count = ae.length, i(J);
    }
    return T;
  }
  o.prototype.addListener = function(F, $) {
    return m(this, F, $, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(F, $) {
    return m(this, F, $, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(T, F, $) {
    var U = { fired: !1, wrapFn: void 0, target: T, type: F, listener: $ }, Q = u.bind(U);
    return Q.listener = $, U.wrapFn = Q, Q;
  }
  o.prototype.once = function(F, $) {
    return l($), this.on(F, f(this, F, $)), this;
  }, o.prototype.prependOnceListener = function(F, $) {
    return l($), this.prependListener(F, f(this, F, $)), this;
  }, o.prototype.removeListener = function(F, $) {
    var U, Q, X, ae, J;
    if (l($), Q = this._events, Q === void 0)
      return this;
    if (U = Q[F], U === void 0)
      return this;
    if (U === $ || U.listener === $)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Q[F], Q.removeListener && this.emit("removeListener", F, U.listener || $));
    else if (typeof U != "function") {
      for (X = -1, ae = U.length - 1; ae >= 0; ae--)
        if (U[ae] === $ || U[ae].listener === $) {
          J = U[ae].listener, X = ae;
          break;
        }
      if (X < 0)
        return this;
      X === 0 ? U.shift() : S(U, X), U.length === 1 && (Q[F] = U[0]), Q.removeListener !== void 0 && this.emit("removeListener", F, J || $);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(F) {
    var $, U, Q;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[F] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[F]), this;
    if (arguments.length === 0) {
      var X = Object.keys(U), ae;
      for (Q = 0; Q < X.length; ++Q)
        ae = X[Q], ae !== "removeListener" && this.removeAllListeners(ae);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if ($ = U[F], typeof $ == "function")
      this.removeListener(F, $);
    else if ($ !== void 0)
      for (Q = $.length - 1; Q >= 0; Q--)
        this.removeListener(F, $[Q]);
    return this;
  };
  function h(T, F, $) {
    var U = T._events;
    if (U === void 0)
      return [];
    var Q = U[F];
    return Q === void 0 ? [] : typeof Q == "function" ? $ ? [Q.listener || Q] : [Q] : $ ? N(Q) : C(Q, Q.length);
  }
  o.prototype.listeners = function(F) {
    return h(this, F, !0);
  }, o.prototype.rawListeners = function(F) {
    return h(this, F, !1);
  }, o.listenerCount = function(T, F) {
    return typeof T.listenerCount == "function" ? T.listenerCount(F) : g.call(T, F);
  }, o.prototype.listenerCount = g;
  function g(T) {
    var F = this._events;
    if (F !== void 0) {
      var $ = F[T];
      if (typeof $ == "function")
        return 1;
      if ($ !== void 0)
        return $.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function C(T, F) {
    for (var $ = new Array(F), U = 0; U < F; ++U)
      $[U] = T[U];
    return $;
  }
  function S(T, F) {
    for (; F + 1 < T.length; F++)
      T[F] = T[F + 1];
    T.pop();
  }
  function N(T) {
    for (var F = new Array(T.length), $ = 0; $ < F.length; ++$)
      F[$] = T[$].listener || T[$];
    return F;
  }
  function w(T, F) {
    return new Promise(function($, U) {
      function Q(ae) {
        T.removeListener(F, X), U(ae);
      }
      function X() {
        typeof T.removeListener == "function" && T.removeListener("error", Q), $([].slice.call(arguments));
      }
      V(T, F, X, { once: !0 }), F !== "error" && y(T, Q, { once: !0 });
    });
  }
  function y(T, F, $) {
    typeof T.on == "function" && V(T, "error", F, $);
  }
  function V(T, F, $, U) {
    if (typeof T.on == "function")
      U.once ? T.once(F, $) : T.on(F, $);
    else if (typeof T.addEventListener == "function")
      T.addEventListener(F, function Q(X) {
        U.once && T.removeEventListener(F, Q), $(X);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
  }
  return os.exports;
}
var hB = fB();
function QB() {
  const e = new hB.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  pw as GraphQLClientProvider,
  ZS as PairingContext,
  YB as PairingProvider,
  HB as PartnerIntegrations,
  KB as PartnerIntegrationsSettings,
  rf as getWidgetDefinitions,
  QB as initializePartnerEventEmitter,
  GB as usePairing,
  WB as usePartnerIntegrationWidgetConfigurations,
  X4 as useShopifyConfiguration
};
